// FROZEN, HAND-MAINTAINED. DO NOT REGENERATE.
// The Hasura GraphQL codegen pipeline has been removed, so this file is no longer
// generated. It retains only the generated types still imported across the app (enums,
// *Query result types, fragments, and a few table/input types); all operation Document
// constants and otherwise-unused types have been dead-code-eliminated.
// The remaining types are pending migration off Hasura-generated types; see the project
// memory note project_scripts_hasura_cleanup.md. Do not add to this file; prefer Kysely
// or locally-defined types instead.

import { type OverrideTypes } from '@omnea-app/packages/backend/db/schema-overrides'
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  _uuid: { input: string; output: string; }
  address: { input: OverrideTypes["Address"]; output: OverrideTypes["Address"]; }
  agreementTermType: { input: OverrideTypes["AgreementTermType"]; output: OverrideTypes["AgreementTermType"]; }
  availableDateFormat: { input: OverrideTypes["AvailableDateFormat"]; output: OverrideTypes["AvailableDateFormat"]; }
  availableLocale: { input: OverrideTypes["AvailableLocale"]; output: OverrideTypes["AvailableLocale"]; }
  budgetStatus: { input: OverrideTypes["BudgetStatus"]; output: OverrideTypes["BudgetStatus"]; }
  currencyCode: { input: OverrideTypes["CurrencyCode"]; output: OverrideTypes["CurrencyCode"]; }
  customFieldsCoreDataExternalSourceType: { input: OverrideTypes["CustomFieldCoreDataSourceType"]; output: OverrideTypes["CustomFieldCoreDataSourceType"]; }
  customFieldsEntityType: { input: OverrideTypes["CustomFieldsEntityType"]; output: OverrideTypes["CustomFieldsEntityType"]; }
  customFieldsType: { input: OverrideTypes["CustomFieldsType"]; output: OverrideTypes["CustomFieldsType"]; }
  date: { input: any; output: any; }
  filterModel: { input: OverrideTypes["FilterModel"]; output: OverrideTypes["FilterModel"]; }
  float8: { input: number; output: number; }
  formConfig: { input: OverrideTypes["FormConfig"]; output: OverrideTypes["FormConfig"]; }
  globalIntegration: { input: OverrideTypes["GlobalIntegration"]; output: OverrideTypes["GlobalIntegration"]; }
  integration: { input: OverrideTypes["Integration"]; output: OverrideTypes["Integration"]; }
  internalContactsRole: { input: OverrideTypes["InternalContactRole"]; output: OverrideTypes["InternalContactRole"]; }
  interval: { input: string; output: string; }
  jsonb: { input: any; output: any; }
  kebabCoreDataType: { input: OverrideTypes["KebabCoreDataType"]; output: OverrideTypes["KebabCoreDataType"]; }
  kebabDependencyType: { input: OverrideTypes["KebabDependencyType"]; output: OverrideTypes["KebabDependencyType"]; }
  kebabSyncStatusType: { input: OverrideTypes["KebabSyncStatusType"]; output: OverrideTypes["KebabSyncStatusType"]; }
  lquery: { input: string; output: string; }
  ltree: { input: string; output: string; }
  ltxtquery: { input: string; output: string; }
  numeric: { input: number | string; output: number; }
  organisationFxRateCode: { input: OverrideTypes["CurrencyCode"]; output: OverrideTypes["CurrencyCode"]; }
  requestDocumentSource: { input: OverrideTypes["RequestDocumentSource"]; output: OverrideTypes["RequestDocumentSource"]; }
  requestFormSubmissionResponse: { input: OverrideTypes["FormResponsePayload"]; output: OverrideTypes["FormResponsePayload"]; }
  requestModel: { input: OverrideTypes["RequestModel"]; output: OverrideTypes["RequestModel"]; }
  requestStepGraphNode: { input: OverrideTypes["RequestStepGraphNode"]; output: OverrideTypes["RequestStepGraphNode"]; }
  riskScoreMethodology: { input: OverrideTypes["RiskScoreMethodology"]; output: OverrideTypes["RiskScoreMethodology"]; }
  submissionSource: { input: OverrideTypes["SubmissionSource"]; output: OverrideTypes["SubmissionSource"]; }
  timestamptz: { input: string; output: string; }
  uploadedFileItem: { input: OverrideTypes["UploadedFileItem"]; output: OverrideTypes["UploadedFileItem"]; }
  uuid: { input: string; output: string; }
  vector: { input: string; output: string; }
  workflowCanvasModel: { input: OverrideTypes["WorkflowCanvasModel"]; output: OverrideTypes["WorkflowCanvasModel"]; }
  workflowConditionGroupsCondition: { input: OverrideTypes["WorkflowConditionGroupCondition"]; output: OverrideTypes["WorkflowConditionGroupCondition"]; }
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type BooleanComparisonExp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type IntComparisonExp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringArrayComparisonExp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']['input']>>;
  _eq?: InputMaybe<Array<Scalars['String']['input']>>;
  _gt?: InputMaybe<Array<Scalars['String']['input']>>;
  _gte?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['String']['input']>>;
  _lte?: InputMaybe<Array<Scalars['String']['input']>>;
  _neq?: InputMaybe<Array<Scalars['String']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringComparisonExp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "addresses" */
export type Addresses = {
  __typename?: 'addresses';
  addressLine1: Maybe<Scalars['String']['output']>;
  addressLine2: Maybe<Scalars['String']['output']>;
  archivedBy: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  bank_details: Array<BankDetails>;
  /** An aggregate relationship */
  bank_details_aggregate: BankDetailsAggregate;
  city: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  coreData: CoreData;
  coreDataId: Scalars['uuid']['output'];
  country: Maybe<Scalars['String']['output']>;
  county: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Maybe<Scalars['String']['output']>;
  organisationId: Scalars['uuid']['output'];
  postalCode: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "addresses". All fields are combined with a logical 'AND'. */
export type AddressesBoolExp = {
  _and?: InputMaybe<Array<AddressesBoolExp>>;
  _not?: InputMaybe<AddressesBoolExp>;
  _or?: InputMaybe<Array<AddressesBoolExp>>;
  addressLine1?: InputMaybe<StringComparisonExp>;
  addressLine2?: InputMaybe<StringComparisonExp>;
  archivedBy?: InputMaybe<StringComparisonExp>;
  bank_details?: InputMaybe<BankDetailsBoolExp>;
  bank_details_aggregate?: InputMaybe<BankDetailsAggregateBoolExp>;
  city?: InputMaybe<StringComparisonExp>;
  coreData?: InputMaybe<CoreDataBoolExp>;
  coreDataId?: InputMaybe<UuidComparisonExp>;
  country?: InputMaybe<StringComparisonExp>;
  county?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isArchived?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  postalCode?: InputMaybe<StringComparisonExp>;
  remoteId?: InputMaybe<StringComparisonExp>;
  state?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "addresses" */
export enum AddressesConstraint {
  /** unique or primary key constraint on columns "id" */
  ADDRESSES_PKEY = 'addresses_pkey',
  /** unique or primary key constraint on columns "remote_id", "organisation_id" */
  ADDRESSES_REMOTE_ID_ORGANISATION_ID_KEY = 'addresses_remote_id_organisation_id_key'
}

/** input type for inserting data into table "addresses" */
export type AddressesInsertInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  archivedBy?: InputMaybe<Scalars['String']['input']>;
  bank_details?: InputMaybe<BankDetailsArrRelInsertInput>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting object relation for remote table "addresses" */
export type AddressesObjRelInsertInput = {
  data: AddressesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<AddressesOnConflict>;
};

/** on_conflict condition type for table "addresses" */
export type AddressesOnConflict = {
  constraint: AddressesConstraint;
  update_columns: Array<AddressesUpdateColumn>;
  where?: InputMaybe<AddressesBoolExp>;
};

/** update columns of table "addresses" */
export enum AddressesUpdateColumn {
  /** column name */
  ADDRESSLINE1 = 'addressLine1',
  /** column name */
  ADDRESSLINE2 = 'addressLine2',
  /** column name */
  ARCHIVEDBY = 'archivedBy',
  /** column name */
  CITY = 'city',
  /** column name */
  COUNTRY = 'country',
  /** column name */
  COUNTY = 'county',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  NAME = 'name',
  /** column name */
  POSTALCODE = 'postalCode',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  STATE = 'state'
}

/** columns and relationships of "agreement_additional_owners" */
export type AgreementAdditionalOwners = {
  __typename?: 'agreement_additional_owners';
  /** An object relationship */
  agreement: Agreements;
  agreementId: Scalars['uuid']['output'];
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** input type for inserting array relation for remote table "agreement_additional_owners" */
export type AgreementAdditionalOwnersArrRelInsertInput = {
  data: Array<AgreementAdditionalOwnersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AgreementAdditionalOwnersOnConflict>;
};

/** Boolean expression to filter rows from the table "agreement_additional_owners". All fields are combined with a logical 'AND'. */
export type AgreementAdditionalOwnersBoolExp = {
  _and?: InputMaybe<Array<AgreementAdditionalOwnersBoolExp>>;
  _not?: InputMaybe<AgreementAdditionalOwnersBoolExp>;
  _or?: InputMaybe<Array<AgreementAdditionalOwnersBoolExp>>;
  agreement?: InputMaybe<AgreementsBoolExp>;
  agreementId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "agreement_additional_owners" */
export enum AgreementAdditionalOwnersConstraint {
  /** unique or primary key constraint on columns "id" */
  AGREEMENT_ADDITIONAL_OWNERS_PKEY = 'agreement_additional_owners_pkey',
  /** unique or primary key constraint on columns "user_id", "agreement_id" */
  AGREEMENT_ID_USER_ID_KEY = 'agreement_id_user_id_key'
}

/** input type for inserting data into table "agreement_additional_owners" */
export type AgreementAdditionalOwnersInsertInput = {
  agreement?: InputMaybe<AgreementsObjRelInsertInput>;
  agreementId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** on_conflict condition type for table "agreement_additional_owners" */
export type AgreementAdditionalOwnersOnConflict = {
  constraint: AgreementAdditionalOwnersConstraint;
  update_columns: Array<AgreementAdditionalOwnersUpdateColumn>;
  where?: InputMaybe<AgreementAdditionalOwnersBoolExp>;
};

/** update columns of table "agreement_additional_owners" */
export enum AgreementAdditionalOwnersUpdateColumn {
  /** column name */
  AGREEMENTID = 'agreementId',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId'
}

/** Pivot table connecting agreements and documents */
export type AgreementDocuments = {
  __typename?: 'agreement_documents';
  /** An object relationship */
  agreement: Agreements;
  agreementId: Scalars['uuid']['output'];
  agreementTermId: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  document: Documents;
  documentId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** input type for inserting array relation for remote table "agreement_documents" */
export type AgreementDocumentsArrRelInsertInput = {
  data: Array<AgreementDocumentsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AgreementDocumentsOnConflict>;
};

/** Boolean expression to filter rows from the table "agreement_documents". All fields are combined with a logical 'AND'. */
export type AgreementDocumentsBoolExp = {
  _and?: InputMaybe<Array<AgreementDocumentsBoolExp>>;
  _not?: InputMaybe<AgreementDocumentsBoolExp>;
  _or?: InputMaybe<Array<AgreementDocumentsBoolExp>>;
  agreement?: InputMaybe<AgreementsBoolExp>;
  agreementId?: InputMaybe<UuidComparisonExp>;
  agreementTermId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  document?: InputMaybe<DocumentsBoolExp>;
  documentId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "agreement_documents" */
export enum AgreementDocumentsConstraint {
  /** unique or primary key constraint on columns "agreement_id", "document_id", "agreement_term_id" */
  AGREEMENT_DOCUMENTS_DOCUMENT_ID_AGREEMENT_ID_AGREEMENT_TERM_KEY = 'agreement_documents_document_id_agreement_id_agreement_term_key',
  /** unique or primary key constraint on columns "id" */
  AGREEMENT_DOCUMENTS_PKEY = 'agreement_documents_pkey'
}

/** input type for inserting data into table "agreement_documents" */
export type AgreementDocumentsInsertInput = {
  agreement?: InputMaybe<AgreementsObjRelInsertInput>;
  agreementId?: InputMaybe<Scalars['uuid']['input']>;
  agreementTermId?: InputMaybe<Scalars['uuid']['input']>;
  document?: InputMaybe<DocumentsObjRelInsertInput>;
  documentId?: InputMaybe<Scalars['uuid']['input']>;
};

/** on_conflict condition type for table "agreement_documents" */
export type AgreementDocumentsOnConflict = {
  constraint: AgreementDocumentsConstraint;
  update_columns: Array<AgreementDocumentsUpdateColumn>;
  where?: InputMaybe<AgreementDocumentsBoolExp>;
};

/** update columns of table "agreement_documents" */
export enum AgreementDocumentsUpdateColumn {
  /** column name */
  AGREEMENTID = 'agreementId',
  /** column name */
  AGREEMENTTERMID = 'agreementTermId',
  /** column name */
  DOCUMENTID = 'documentId'
}

/** Tags for Agreements */
export type AgreementTags = {
  __typename?: 'agreement_tags';
  /** An object relationship */
  agreement: Agreements;
  agreementId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  tag: Tags;
  tagId: Scalars['uuid']['output'];
};

/** input type for inserting array relation for remote table "agreement_tags" */
export type AgreementTagsArrRelInsertInput = {
  data: Array<AgreementTagsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AgreementTagsOnConflict>;
};

/** Boolean expression to filter rows from the table "agreement_tags". All fields are combined with a logical 'AND'. */
export type AgreementTagsBoolExp = {
  _and?: InputMaybe<Array<AgreementTagsBoolExp>>;
  _not?: InputMaybe<AgreementTagsBoolExp>;
  _or?: InputMaybe<Array<AgreementTagsBoolExp>>;
  agreement?: InputMaybe<AgreementsBoolExp>;
  agreementId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  tag?: InputMaybe<TagsBoolExp>;
  tagId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "agreement_tags" */
export enum AgreementTagsConstraint {
  /** unique or primary key constraint on columns "agreement_id", "tag_id" */
  AGREEMENT_TAGS_AGREEMENT_ID_TAG_ID_KEY = 'agreement_tags_agreement_id_tag_id_key',
  /** unique or primary key constraint on columns "id" */
  AGREEMENT_TAGS_PKEY = 'agreement_tags_pkey'
}

/** input type for inserting data into table "agreement_tags" */
export type AgreementTagsInsertInput = {
  agreement?: InputMaybe<AgreementsObjRelInsertInput>;
  agreementId?: InputMaybe<Scalars['uuid']['input']>;
  tag?: InputMaybe<TagsObjRelInsertInput>;
  tagId?: InputMaybe<Scalars['uuid']['input']>;
};

/** on_conflict condition type for table "agreement_tags" */
export type AgreementTagsOnConflict = {
  constraint: AgreementTagsConstraint;
  update_columns: Array<AgreementTagsUpdateColumn>;
  where?: InputMaybe<AgreementTagsBoolExp>;
};

/** update columns of table "agreement_tags" */
export enum AgreementTagsUpdateColumn {
  /** column name */
  TAGID = 'tagId'
}

/** Link table between agreement terms and organisation products */
export type AgreementTermProducts = {
  __typename?: 'agreement_term_products';
  agreementTermId: Scalars['uuid']['output'];
  /** An object relationship */
  agreement_term: AgreementTerms;
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  organisationProductId: Scalars['uuid']['output'];
  /** An object relationship */
  organisation_products_and_service: OrganisationProductsAndServices;
};

/** input type for inserting array relation for remote table "agreement_term_products" */
export type AgreementTermProductsArrRelInsertInput = {
  data: Array<AgreementTermProductsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AgreementTermProductsOnConflict>;
};

/** Boolean expression to filter rows from the table "agreement_term_products". All fields are combined with a logical 'AND'. */
export type AgreementTermProductsBoolExp = {
  _and?: InputMaybe<Array<AgreementTermProductsBoolExp>>;
  _not?: InputMaybe<AgreementTermProductsBoolExp>;
  _or?: InputMaybe<Array<AgreementTermProductsBoolExp>>;
  agreementTermId?: InputMaybe<UuidComparisonExp>;
  agreement_term?: InputMaybe<AgreementTermsBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisationProductId?: InputMaybe<UuidComparisonExp>;
  organisation_products_and_service?: InputMaybe<OrganisationProductsAndServicesBoolExp>;
};

/** unique or primary key constraints on table "agreement_term_products" */
export enum AgreementTermProductsConstraint {
  /** unique or primary key constraint on columns "id" */
  AGREEMENT_TERM_PRODUCTS_PKEY = 'agreement_term_products_pkey',
  /** unique or primary key constraint on columns "deleted_at", "organisation_product_id", "agreement_term_id" */
  UNIQUE_PER_TERM_PRODUCT_DELETED_AT = 'unique_per_term_product_deleted_at'
}

/** input type for inserting data into table "agreement_term_products" */
export type AgreementTermProductsInsertInput = {
  agreementTermId?: InputMaybe<Scalars['uuid']['input']>;
  agreement_term?: InputMaybe<AgreementTermsObjRelInsertInput>;
  organisationProductId?: InputMaybe<Scalars['uuid']['input']>;
  organisation_products_and_service?: InputMaybe<OrganisationProductsAndServicesObjRelInsertInput>;
};

/** on_conflict condition type for table "agreement_term_products" */
export type AgreementTermProductsOnConflict = {
  constraint: AgreementTermProductsConstraint;
  update_columns: Array<AgreementTermProductsUpdateColumn>;
  where?: InputMaybe<AgreementTermProductsBoolExp>;
};

/** update columns of table "agreement_term_products" */
export enum AgreementTermProductsUpdateColumn {
  /** column name */
  DELETEDAT = 'deletedAt'
}

/** columns and relationships of "agreement_term_revisions" */
export type AgreementTermRevisions = {
  __typename?: 'agreement_term_revisions';
  /** An object relationship */
  agreementTerm: AgreementTerms;
  agreementTermId: Scalars['uuid']['output'];
  config: Maybe<Scalars['formConfig']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  requestFormSubmission: Maybe<RequestFormSubmissions>;
  requestFormSubmissionId: Maybe<Scalars['uuid']['output']>;
  response: Maybe<Scalars['requestFormSubmissionResponse']['output']>;
  submissionSource: Maybe<Scalars['submissionSource']['output']>;
  submittedBy: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Maybe<Users>;
};

/** input type for inserting array relation for remote table "agreement_term_revisions" */
export type AgreementTermRevisionsArrRelInsertInput = {
  data: Array<AgreementTermRevisionsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AgreementTermRevisionsOnConflict>;
};

/** Boolean expression to filter rows from the table "agreement_term_revisions". All fields are combined with a logical 'AND'. */
export type AgreementTermRevisionsBoolExp = {
  _and?: InputMaybe<Array<AgreementTermRevisionsBoolExp>>;
  _not?: InputMaybe<AgreementTermRevisionsBoolExp>;
  _or?: InputMaybe<Array<AgreementTermRevisionsBoolExp>>;
  agreementTerm?: InputMaybe<AgreementTermsBoolExp>;
  agreementTermId?: InputMaybe<UuidComparisonExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  requestFormSubmission?: InputMaybe<RequestFormSubmissionsBoolExp>;
  requestFormSubmissionId?: InputMaybe<UuidComparisonExp>;
  response?: InputMaybe<JsonbComparisonExp>;
  submissionSource?: InputMaybe<StringComparisonExp>;
  submittedBy?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "agreement_term_revisions" */
export enum AgreementTermRevisionsConstraint {
  /** unique or primary key constraint on columns "id" */
  AGREEMENT_TERM_REVISIONS_PKEY = 'agreement_term_revisions_pkey'
}

/** input type for inserting data into table "agreement_term_revisions" */
export type AgreementTermRevisionsInsertInput = {
  agreementTerm?: InputMaybe<AgreementTermsObjRelInsertInput>;
  agreementTermId?: InputMaybe<Scalars['uuid']['input']>;
  config?: InputMaybe<Scalars['jsonb']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  requestFormSubmission?: InputMaybe<RequestFormSubmissionsObjRelInsertInput>;
  requestFormSubmissionId?: InputMaybe<Scalars['uuid']['input']>;
  response?: InputMaybe<Scalars['jsonb']['input']>;
  submissionSource?: InputMaybe<Scalars['String']['input']>;
  submittedBy?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
};

/** on_conflict condition type for table "agreement_term_revisions" */
export type AgreementTermRevisionsOnConflict = {
  constraint: AgreementTermRevisionsConstraint;
  update_columns: Array<AgreementTermRevisionsUpdateColumn>;
  where?: InputMaybe<AgreementTermRevisionsBoolExp>;
};

/** update columns of table "agreement_term_revisions" */
export enum AgreementTermRevisionsUpdateColumn {
  /** column name */
  DELETEDAT = 'deletedAt'
}

/** For tracking granular spend lines on agreement terms */
export type AgreementTermSpendItems = {
  __typename?: 'agreement_term_spend_items';
  /** An object relationship */
  agreementTerm: AgreementTerms;
  agreementTermId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  currencyCode: Scalars['currencyCode']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  description: Scalars['String']['output'];
  endDate: Maybe<Scalars['date']['output']>;
  frequency: PaymentIntervalEnum;
  fxRate: Scalars['numeric']['output'];
  fxTime: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  paymentInterval: PaymentInterval;
  /** An object relationship */
  paymentMethod: Maybe<PaymentMethods>;
  paymentMethodId: Maybe<Scalars['uuid']['output']>;
  quantity: Scalars['numeric']['output'];
  rate: Scalars['numeric']['output'];
  startDate: Scalars['date']['output'];
  totalAmount: Scalars['numeric']['output'];
  totalAmountInDefaultCurrency: Maybe<Scalars['numeric']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** input type for inserting array relation for remote table "agreement_term_spend_items" */
export type AgreementTermSpendItemsArrRelInsertInput = {
  data: Array<AgreementTermSpendItemsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AgreementTermSpendItemsOnConflict>;
};

/** Boolean expression to filter rows from the table "agreement_term_spend_items". All fields are combined with a logical 'AND'. */
export type AgreementTermSpendItemsBoolExp = {
  _and?: InputMaybe<Array<AgreementTermSpendItemsBoolExp>>;
  _not?: InputMaybe<AgreementTermSpendItemsBoolExp>;
  _or?: InputMaybe<Array<AgreementTermSpendItemsBoolExp>>;
  agreementTerm?: InputMaybe<AgreementTermsBoolExp>;
  agreementTermId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currencyCode?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  endDate?: InputMaybe<DateComparisonExp>;
  frequency?: InputMaybe<PaymentIntervalEnumComparisonExp>;
  fxRate?: InputMaybe<NumericComparisonExp>;
  fxTime?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  paymentInterval?: InputMaybe<PaymentIntervalBoolExp>;
  paymentMethod?: InputMaybe<PaymentMethodsBoolExp>;
  paymentMethodId?: InputMaybe<UuidComparisonExp>;
  quantity?: InputMaybe<NumericComparisonExp>;
  rate?: InputMaybe<NumericComparisonExp>;
  startDate?: InputMaybe<DateComparisonExp>;
  totalAmount?: InputMaybe<NumericComparisonExp>;
  totalAmountInDefaultCurrency?: InputMaybe<NumericComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "agreement_term_spend_items" */
export enum AgreementTermSpendItemsConstraint {
  /** unique or primary key constraint on columns "id" */
  AGREEMENT_TERM_SPEND_ITEMS_PKEY = 'agreement_term_spend_items_pkey'
}

/** input type for inserting data into table "agreement_term_spend_items" */
export type AgreementTermSpendItemsInsertInput = {
  agreementTerm?: InputMaybe<AgreementTermsObjRelInsertInput>;
  agreementTermId?: InputMaybe<Scalars['uuid']['input']>;
  currencyCode: Scalars['currencyCode']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['date']['input']>;
  frequency?: InputMaybe<PaymentIntervalEnum>;
  fxRate?: InputMaybe<Scalars['numeric']['input']>;
  fxTime?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  paymentMethod?: InputMaybe<PaymentMethodsObjRelInsertInput>;
  paymentMethodId?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  rate?: InputMaybe<Scalars['numeric']['input']>;
  startDate?: InputMaybe<Scalars['date']['input']>;
  totalAmount?: InputMaybe<Scalars['numeric']['input']>;
};

/** on_conflict condition type for table "agreement_term_spend_items" */
export type AgreementTermSpendItemsOnConflict = {
  constraint: AgreementTermSpendItemsConstraint;
  update_columns: Array<AgreementTermSpendItemsUpdateColumn>;
  where?: InputMaybe<AgreementTermSpendItemsBoolExp>;
};

/** update columns of table "agreement_term_spend_items" */
export enum AgreementTermSpendItemsUpdateColumn {
  /** column name */
  CURRENCYCODE = 'currencyCode',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  ENDDATE = 'endDate',
  /** column name */
  FREQUENCY = 'frequency',
  /** column name */
  FXRATE = 'fxRate',
  /** column name */
  FXTIME = 'fxTime',
  /** column name */
  PAYMENTMETHODID = 'paymentMethodId',
  /** column name */
  QUANTITY = 'quantity',
  /** column name */
  RATE = 'rate',
  /** column name */
  STARTDATE = 'startDate',
  /** column name */
  TOTALAMOUNT = 'totalAmount'
}

/** columns and relationships of "agreement_terms" */
export type AgreementTerms = {
  __typename?: 'agreement_terms';
  /** An object relationship */
  agreement: Agreements;
  agreementId: Scalars['uuid']['output'];
  /** An array relationship */
  agreement_term_revisions: Array<AgreementTermRevisions>;
  autoRenew: Scalars['Boolean']['output'];
  cancelByDate: Maybe<Scalars['date']['output']>;
  cancellationNoticeDayCount: Maybe<Scalars['Int']['output']>;
  cancelledAt: Maybe<Scalars['date']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  currencyCode: Maybe<Scalars['currencyCode']['output']>;
  /** An array relationship */
  custom_field_values: Array<CustomFieldValues>;
  /** An aggregate relationship */
  custom_field_values_aggregate: CustomFieldValuesAggregate;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  endDate: Maybe<Scalars['date']['output']>;
  /** An array relationship */
  futureRenewal: Array<Renewals>;
  /** An aggregate relationship */
  futureRenewal_aggregate: RenewalsAggregate;
  fxRate: Maybe<Scalars['numeric']['output']>;
  fxTime: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An array relationship */
  originRenewal: Array<Renewals>;
  /** An aggregate relationship */
  originRenewal_aggregate: RenewalsAggregate;
  /** An object relationship */
  primaryDepartment: Maybe<Departments>;
  primaryDepartmentId: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  products: Array<AgreementTermProducts>;
  /** An array relationship */
  spendItems: Array<AgreementTermSpendItems>;
  startDate: Scalars['date']['output'];
  termType: Scalars['agreementTermType']['output'];
  totalAmount: Maybe<Scalars['numeric']['output']>;
  totalAmountInDefaultCurrency: Maybe<Scalars['numeric']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "agreement_terms" */
export type AgreementTermsAggregate = {
  __typename?: 'agreement_terms_aggregate';
  aggregate: Maybe<AgreementTermsAggregateFields>;
  nodes: Array<AgreementTerms>;
};

export type AgreementTermsAggregateBoolExp = {
  bool_and?: InputMaybe<AgreementTermsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<AgreementTermsAggregateBoolExpBoolOr>;
  count?: InputMaybe<AgreementTermsAggregateBoolExpCount>;
};

export type AgreementTermsAggregateBoolExpBoolAnd = {
  arguments: AgreementTermsSelectColumnAgreementTermsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AgreementTermsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AgreementTermsAggregateBoolExpBoolOr = {
  arguments: AgreementTermsSelectColumnAgreementTermsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AgreementTermsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AgreementTermsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AgreementTermsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AgreementTermsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "agreement_terms" */
export type AgreementTermsAggregateFields = {
  __typename?: 'agreement_terms_aggregate_fields';
  avg: Maybe<AgreementTermsAvgFields>;
  count: Scalars['Int']['output'];
  max: Maybe<AgreementTermsMaxFields>;
  min: Maybe<AgreementTermsMinFields>;
  stddev: Maybe<AgreementTermsStddevFields>;
  stddev_pop: Maybe<AgreementTermsStddevPopFields>;
  stddev_samp: Maybe<AgreementTermsStddevSampFields>;
  sum: Maybe<AgreementTermsSumFields>;
  var_pop: Maybe<AgreementTermsVarPopFields>;
  var_samp: Maybe<AgreementTermsVarSampFields>;
  variance: Maybe<AgreementTermsVarianceFields>;
};

/** input type for inserting array relation for remote table "agreement_terms" */
export type AgreementTermsArrRelInsertInput = {
  data: Array<AgreementTermsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AgreementTermsOnConflict>;
};

/** aggregate avg on columns */
export type AgreementTermsAvgFields = {
  __typename?: 'agreement_terms_avg_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Float']['output']>;
  fxRate: Maybe<Scalars['Float']['output']>;
  totalAmount: Maybe<Scalars['Float']['output']>;
  totalAmountInDefaultCurrency: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "agreement_terms". All fields are combined with a logical 'AND'. */
export type AgreementTermsBoolExp = {
  _and?: InputMaybe<Array<AgreementTermsBoolExp>>;
  _not?: InputMaybe<AgreementTermsBoolExp>;
  _or?: InputMaybe<Array<AgreementTermsBoolExp>>;
  agreement?: InputMaybe<AgreementsBoolExp>;
  agreementId?: InputMaybe<UuidComparisonExp>;
  agreement_term_revisions?: InputMaybe<AgreementTermRevisionsBoolExp>;
  autoRenew?: InputMaybe<BooleanComparisonExp>;
  cancelByDate?: InputMaybe<DateComparisonExp>;
  cancellationNoticeDayCount?: InputMaybe<IntComparisonExp>;
  cancelledAt?: InputMaybe<DateComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currencyCode?: InputMaybe<StringComparisonExp>;
  custom_field_values?: InputMaybe<CustomFieldValuesBoolExp>;
  custom_field_values_aggregate?: InputMaybe<CustomFieldValuesAggregateBoolExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  endDate?: InputMaybe<DateComparisonExp>;
  futureRenewal?: InputMaybe<RenewalsBoolExp>;
  futureRenewal_aggregate?: InputMaybe<RenewalsAggregateBoolExp>;
  fxRate?: InputMaybe<NumericComparisonExp>;
  fxTime?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  originRenewal?: InputMaybe<RenewalsBoolExp>;
  originRenewal_aggregate?: InputMaybe<RenewalsAggregateBoolExp>;
  primaryDepartment?: InputMaybe<DepartmentsBoolExp>;
  primaryDepartmentId?: InputMaybe<UuidComparisonExp>;
  products?: InputMaybe<AgreementTermProductsBoolExp>;
  spendItems?: InputMaybe<AgreementTermSpendItemsBoolExp>;
  startDate?: InputMaybe<DateComparisonExp>;
  termType?: InputMaybe<StringComparisonExp>;
  totalAmount?: InputMaybe<NumericComparisonExp>;
  totalAmountInDefaultCurrency?: InputMaybe<NumericComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "agreement_terms" */
export enum AgreementTermsConstraint {
  /** unique or primary key constraint on columns "id" */
  AGREEMENT_TERMS_PKEY = 'agreement_terms_pkey',
  /** unique or primary key constraint on columns "request_task_id" */
  AGREEMENT_TERMS_REQUEST_TASK_ID_UQ = 'agreement_terms_request_task_id_uq'
}

/** input type for inserting data into table "agreement_terms" */
export type AgreementTermsInsertInput = {
  agreement?: InputMaybe<AgreementsObjRelInsertInput>;
  agreementId?: InputMaybe<Scalars['uuid']['input']>;
  agreement_term_revisions?: InputMaybe<AgreementTermRevisionsArrRelInsertInput>;
  autoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  cancellationNoticeDayCount?: InputMaybe<Scalars['Int']['input']>;
  cancelledAt?: InputMaybe<Scalars['date']['input']>;
  currencyCode?: InputMaybe<Scalars['currencyCode']['input']>;
  custom_field_values?: InputMaybe<CustomFieldValuesArrRelInsertInput>;
  endDate?: InputMaybe<Scalars['date']['input']>;
  futureRenewal?: InputMaybe<RenewalsArrRelInsertInput>;
  fxRate?: InputMaybe<Scalars['numeric']['input']>;
  fxTime?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  originRenewal?: InputMaybe<RenewalsArrRelInsertInput>;
  primaryDepartment?: InputMaybe<DepartmentsObjRelInsertInput>;
  primaryDepartmentId?: InputMaybe<Scalars['uuid']['input']>;
  products?: InputMaybe<AgreementTermProductsArrRelInsertInput>;
  spendItems?: InputMaybe<AgreementTermSpendItemsArrRelInsertInput>;
  startDate?: InputMaybe<Scalars['date']['input']>;
  termType: Scalars['agreementTermType']['input'];
  totalAmount?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type AgreementTermsMaxFields = {
  __typename?: 'agreement_terms_max_fields';
  agreementId: Maybe<Scalars['uuid']['output']>;
  cancelByDate: Maybe<Scalars['date']['output']>;
  cancellationNoticeDayCount: Maybe<Scalars['Int']['output']>;
  cancelledAt: Maybe<Scalars['date']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  currencyCode: Maybe<Scalars['String']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  endDate: Maybe<Scalars['date']['output']>;
  fxRate: Maybe<Scalars['numeric']['output']>;
  fxTime: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  primaryDepartmentId: Maybe<Scalars['uuid']['output']>;
  startDate: Maybe<Scalars['date']['output']>;
  termType: Maybe<Scalars['String']['output']>;
  totalAmount: Maybe<Scalars['numeric']['output']>;
  totalAmountInDefaultCurrency: Maybe<Scalars['numeric']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type AgreementTermsMinFields = {
  __typename?: 'agreement_terms_min_fields';
  agreementId: Maybe<Scalars['uuid']['output']>;
  cancelByDate: Maybe<Scalars['date']['output']>;
  cancellationNoticeDayCount: Maybe<Scalars['Int']['output']>;
  cancelledAt: Maybe<Scalars['date']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  currencyCode: Maybe<Scalars['String']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  endDate: Maybe<Scalars['date']['output']>;
  fxRate: Maybe<Scalars['numeric']['output']>;
  fxTime: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  primaryDepartmentId: Maybe<Scalars['uuid']['output']>;
  startDate: Maybe<Scalars['date']['output']>;
  termType: Maybe<Scalars['String']['output']>;
  totalAmount: Maybe<Scalars['numeric']['output']>;
  totalAmountInDefaultCurrency: Maybe<Scalars['numeric']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** input type for inserting object relation for remote table "agreement_terms" */
export type AgreementTermsObjRelInsertInput = {
  data: AgreementTermsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<AgreementTermsOnConflict>;
};

/** on_conflict condition type for table "agreement_terms" */
export type AgreementTermsOnConflict = {
  constraint: AgreementTermsConstraint;
  update_columns: Array<AgreementTermsUpdateColumn>;
  where?: InputMaybe<AgreementTermsBoolExp>;
};

/** select columns of table "agreement_terms" */
export enum AgreementTermsSelectColumn {
  /** column name */
  AGREEMENTID = 'agreementId',
  /** column name */
  AUTORENEW = 'autoRenew',
  /** column name */
  CANCELBYDATE = 'cancelByDate',
  /** column name */
  CANCELLATIONNOTICEDAYCOUNT = 'cancellationNoticeDayCount',
  /** column name */
  CANCELLEDAT = 'cancelledAt',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CURRENCYCODE = 'currencyCode',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ENDDATE = 'endDate',
  /** column name */
  FXRATE = 'fxRate',
  /** column name */
  FXTIME = 'fxTime',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  PRIMARYDEPARTMENTID = 'primaryDepartmentId',
  /** column name */
  STARTDATE = 'startDate',
  /** column name */
  TERMTYPE = 'termType',
  /** column name */
  TOTALAMOUNT = 'totalAmount',
  /** column name */
  TOTALAMOUNTINDEFAULTCURRENCY = 'totalAmountInDefaultCurrency',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** select "agreement_terms_aggregate_bool_exp_bool_and_arguments_columns" columns of table "agreement_terms" */
export enum AgreementTermsSelectColumnAgreementTermsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  AUTORENEW = 'autoRenew'
}

/** select "agreement_terms_aggregate_bool_exp_bool_or_arguments_columns" columns of table "agreement_terms" */
export enum AgreementTermsSelectColumnAgreementTermsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  AUTORENEW = 'autoRenew'
}

/** aggregate stddev on columns */
export type AgreementTermsStddevFields = {
  __typename?: 'agreement_terms_stddev_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Float']['output']>;
  fxRate: Maybe<Scalars['Float']['output']>;
  totalAmount: Maybe<Scalars['Float']['output']>;
  totalAmountInDefaultCurrency: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type AgreementTermsStddevPopFields = {
  __typename?: 'agreement_terms_stddev_pop_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Float']['output']>;
  fxRate: Maybe<Scalars['Float']['output']>;
  totalAmount: Maybe<Scalars['Float']['output']>;
  totalAmountInDefaultCurrency: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type AgreementTermsStddevSampFields = {
  __typename?: 'agreement_terms_stddev_samp_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Float']['output']>;
  fxRate: Maybe<Scalars['Float']['output']>;
  totalAmount: Maybe<Scalars['Float']['output']>;
  totalAmountInDefaultCurrency: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type AgreementTermsSumFields = {
  __typename?: 'agreement_terms_sum_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Int']['output']>;
  fxRate: Maybe<Scalars['numeric']['output']>;
  totalAmount: Maybe<Scalars['numeric']['output']>;
  totalAmountInDefaultCurrency: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "agreement_terms" */
export enum AgreementTermsUpdateColumn {
  /** column name */
  AUTORENEW = 'autoRenew',
  /** column name */
  CANCELLATIONNOTICEDAYCOUNT = 'cancellationNoticeDayCount',
  /** column name */
  CANCELLEDAT = 'cancelledAt',
  /** column name */
  CURRENCYCODE = 'currencyCode',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ENDDATE = 'endDate',
  /** column name */
  FXRATE = 'fxRate',
  /** column name */
  FXTIME = 'fxTime',
  /** column name */
  NAME = 'name',
  /** column name */
  PRIMARYDEPARTMENTID = 'primaryDepartmentId',
  /** column name */
  STARTDATE = 'startDate',
  /** column name */
  TERMTYPE = 'termType',
  /** column name */
  TOTALAMOUNT = 'totalAmount'
}

/** aggregate var_pop on columns */
export type AgreementTermsVarPopFields = {
  __typename?: 'agreement_terms_var_pop_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Float']['output']>;
  fxRate: Maybe<Scalars['Float']['output']>;
  totalAmount: Maybe<Scalars['Float']['output']>;
  totalAmountInDefaultCurrency: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type AgreementTermsVarSampFields = {
  __typename?: 'agreement_terms_var_samp_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Float']['output']>;
  fxRate: Maybe<Scalars['Float']['output']>;
  totalAmount: Maybe<Scalars['Float']['output']>;
  totalAmountInDefaultCurrency: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type AgreementTermsVarianceFields = {
  __typename?: 'agreement_terms_variance_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Float']['output']>;
  fxRate: Maybe<Scalars['Float']['output']>;
  totalAmount: Maybe<Scalars['Float']['output']>;
  totalAmountInDefaultCurrency: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "agreements" */
export type Agreements = {
  __typename?: 'agreements';
  /** An array relationship */
  additionalOwners: Array<AgreementAdditionalOwners>;
  /** An array relationship */
  agreement_documents: Array<AgreementDocuments>;
  /** An array relationship */
  agreement_terms: Array<AgreementTerms>;
  /** An aggregate relationship */
  agreement_terms_aggregate: AgreementTermsAggregate;
  /** An array relationship */
  children: Array<Agreements>;
  /** An aggregate relationship */
  children_aggregate: AgreementsAggregate;
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  /** A description of the agreement */
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  owner: Maybe<Users>;
  ownerId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  parent: Maybe<Agreements>;
  parentId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  paymentMethod: Maybe<PaymentMethods>;
  paymentMethodId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  paymentTerm: Maybe<PaymentTerms>;
  paymentTermId: Maybe<Scalars['uuid']['output']>;
  publicId: Scalars['Int']['output'];
  refreshPricesAt: Maybe<Scalars['timestamptz']['output']>;
  /** Any ID or reference from external systems */
  remoteId: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  subsidiary: Maybe<Subsidiaries>;
  subsidiaryId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  supplier: OrganisationSuppliers;
  supplierId: Scalars['uuid']['output'];
  /** An array relationship */
  tags: Array<AgreementTags>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "agreements" */
export type AgreementsAggregate = {
  __typename?: 'agreements_aggregate';
  aggregate: Maybe<AgreementsAggregateFields>;
  nodes: Array<Agreements>;
};

export type AgreementsAggregateBoolExp = {
  count?: InputMaybe<AgreementsAggregateBoolExpCount>;
};

export type AgreementsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AgreementsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AgreementsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "agreements" */
export type AgreementsAggregateFields = {
  __typename?: 'agreements_aggregate_fields';
  avg: Maybe<AgreementsAvgFields>;
  count: Scalars['Int']['output'];
  max: Maybe<AgreementsMaxFields>;
  min: Maybe<AgreementsMinFields>;
  stddev: Maybe<AgreementsStddevFields>;
  stddev_pop: Maybe<AgreementsStddevPopFields>;
  stddev_samp: Maybe<AgreementsStddevSampFields>;
  sum: Maybe<AgreementsSumFields>;
  var_pop: Maybe<AgreementsVarPopFields>;
  var_samp: Maybe<AgreementsVarSampFields>;
  variance: Maybe<AgreementsVarianceFields>;
};

/** input type for inserting array relation for remote table "agreements" */
export type AgreementsArrRelInsertInput = {
  data: Array<AgreementsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AgreementsOnConflict>;
};

/** aggregate avg on columns */
export type AgreementsAvgFields = {
  __typename?: 'agreements_avg_fields';
  publicId: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "agreements". All fields are combined with a logical 'AND'. */
export type AgreementsBoolExp = {
  _and?: InputMaybe<Array<AgreementsBoolExp>>;
  _not?: InputMaybe<AgreementsBoolExp>;
  _or?: InputMaybe<Array<AgreementsBoolExp>>;
  additionalOwners?: InputMaybe<AgreementAdditionalOwnersBoolExp>;
  agreement_documents?: InputMaybe<AgreementDocumentsBoolExp>;
  agreement_terms?: InputMaybe<AgreementTermsBoolExp>;
  agreement_terms_aggregate?: InputMaybe<AgreementTermsAggregateBoolExp>;
  children?: InputMaybe<AgreementsBoolExp>;
  children_aggregate?: InputMaybe<AgreementsAggregateBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  owner?: InputMaybe<UsersBoolExp>;
  ownerId?: InputMaybe<UuidComparisonExp>;
  parent?: InputMaybe<AgreementsBoolExp>;
  parentId?: InputMaybe<UuidComparisonExp>;
  paymentMethod?: InputMaybe<PaymentMethodsBoolExp>;
  paymentMethodId?: InputMaybe<UuidComparisonExp>;
  paymentTerm?: InputMaybe<PaymentTermsBoolExp>;
  paymentTermId?: InputMaybe<UuidComparisonExp>;
  publicId?: InputMaybe<IntComparisonExp>;
  refreshPricesAt?: InputMaybe<TimestamptzComparisonExp>;
  remoteId?: InputMaybe<StringComparisonExp>;
  subsidiary?: InputMaybe<SubsidiariesBoolExp>;
  subsidiaryId?: InputMaybe<UuidComparisonExp>;
  supplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  supplierId?: InputMaybe<UuidComparisonExp>;
  tags?: InputMaybe<AgreementTagsBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "agreements" */
export enum AgreementsConstraint {
  /** unique or primary key constraint on columns "id" */
  AGREEMENTS_PKEY = 'agreements_pkey',
  /** unique or primary key constraint on columns "organisation_id", "public_id" */
  AGREEMENTS_PUBLIC_ID_ORGANISATION_ID_KEY = 'agreements_public_id_organisation_id_key',
  /** unique or primary key constraint on columns "remote_id", "organisation_id" */
  AGREEMENTS_REMOTE_ID_ORGANISATION_ID_ACTIVE_UNIQUE = 'agreements_remote_id_organisation_id_active_unique'
}

/** input type for inserting data into table "agreements" */
export type AgreementsInsertInput = {
  additionalOwners?: InputMaybe<AgreementAdditionalOwnersArrRelInsertInput>;
  agreement_documents?: InputMaybe<AgreementDocumentsArrRelInsertInput>;
  agreement_terms?: InputMaybe<AgreementTermsArrRelInsertInput>;
  children?: InputMaybe<AgreementsArrRelInsertInput>;
  /** A description of the agreement */
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<UsersObjRelInsertInput>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  parent?: InputMaybe<AgreementsObjRelInsertInput>;
  parentId?: InputMaybe<Scalars['uuid']['input']>;
  paymentMethod?: InputMaybe<PaymentMethodsObjRelInsertInput>;
  paymentMethodId?: InputMaybe<Scalars['uuid']['input']>;
  paymentTerm?: InputMaybe<PaymentTermsObjRelInsertInput>;
  paymentTermId?: InputMaybe<Scalars['uuid']['input']>;
  refreshPricesAt?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Any ID or reference from external systems */
  remoteId?: InputMaybe<Scalars['String']['input']>;
  subsidiary?: InputMaybe<SubsidiariesObjRelInsertInput>;
  subsidiaryId?: InputMaybe<Scalars['uuid']['input']>;
  supplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  supplierId?: InputMaybe<Scalars['uuid']['input']>;
  tags?: InputMaybe<AgreementTagsArrRelInsertInput>;
};

/** aggregate max on columns */
export type AgreementsMaxFields = {
  __typename?: 'agreements_max_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  /** A description of the agreement */
  description: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  ownerId: Maybe<Scalars['uuid']['output']>;
  parentId: Maybe<Scalars['uuid']['output']>;
  paymentMethodId: Maybe<Scalars['uuid']['output']>;
  paymentTermId: Maybe<Scalars['uuid']['output']>;
  publicId: Maybe<Scalars['Int']['output']>;
  refreshPricesAt: Maybe<Scalars['timestamptz']['output']>;
  /** Any ID or reference from external systems */
  remoteId: Maybe<Scalars['String']['output']>;
  subsidiaryId: Maybe<Scalars['uuid']['output']>;
  supplierId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type AgreementsMinFields = {
  __typename?: 'agreements_min_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  /** A description of the agreement */
  description: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  ownerId: Maybe<Scalars['uuid']['output']>;
  parentId: Maybe<Scalars['uuid']['output']>;
  paymentMethodId: Maybe<Scalars['uuid']['output']>;
  paymentTermId: Maybe<Scalars['uuid']['output']>;
  publicId: Maybe<Scalars['Int']['output']>;
  refreshPricesAt: Maybe<Scalars['timestamptz']['output']>;
  /** Any ID or reference from external systems */
  remoteId: Maybe<Scalars['String']['output']>;
  subsidiaryId: Maybe<Scalars['uuid']['output']>;
  supplierId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** input type for inserting object relation for remote table "agreements" */
export type AgreementsObjRelInsertInput = {
  data: AgreementsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<AgreementsOnConflict>;
};

/** on_conflict condition type for table "agreements" */
export type AgreementsOnConflict = {
  constraint: AgreementsConstraint;
  update_columns: Array<AgreementsUpdateColumn>;
  where?: InputMaybe<AgreementsBoolExp>;
};

/** select columns of table "agreements" */
export enum AgreementsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  OWNERID = 'ownerId',
  /** column name */
  PARENTID = 'parentId',
  /** column name */
  PAYMENTMETHODID = 'paymentMethodId',
  /** column name */
  PAYMENTTERMID = 'paymentTermId',
  /** column name */
  PUBLICID = 'publicId',
  /** column name */
  REFRESHPRICESAT = 'refreshPricesAt',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  SUBSIDIARYID = 'subsidiaryId',
  /** column name */
  SUPPLIERID = 'supplierId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** aggregate stddev on columns */
export type AgreementsStddevFields = {
  __typename?: 'agreements_stddev_fields';
  publicId: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type AgreementsStddevPopFields = {
  __typename?: 'agreements_stddev_pop_fields';
  publicId: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type AgreementsStddevSampFields = {
  __typename?: 'agreements_stddev_samp_fields';
  publicId: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type AgreementsSumFields = {
  __typename?: 'agreements_sum_fields';
  publicId: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "agreements" */
export enum AgreementsUpdateColumn {
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  NAME = 'name',
  /** column name */
  OWNERID = 'ownerId',
  /** column name */
  PARENTID = 'parentId',
  /** column name */
  PAYMENTMETHODID = 'paymentMethodId',
  /** column name */
  PAYMENTTERMID = 'paymentTermId',
  /** column name */
  REFRESHPRICESAT = 'refreshPricesAt',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  SUBSIDIARYID = 'subsidiaryId',
  /** column name */
  SUPPLIERID = 'supplierId'
}

/** aggregate var_pop on columns */
export type AgreementsVarPopFields = {
  __typename?: 'agreements_var_pop_fields';
  publicId: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type AgreementsVarSampFields = {
  __typename?: 'agreements_var_samp_fields';
  publicId: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type AgreementsVarianceFields = {
  __typename?: 'agreements_variance_fields';
  publicId: Maybe<Scalars['Float']['output']>;
};

/** Store group respondents for assessments */
export type AssessmentAdditionalGroups = {
  __typename?: 'assessment_additional_groups';
  /** An object relationship */
  assessment: Assessments;
  assessmentId: Scalars['uuid']['output'];
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  group: Groups;
  groupId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** input type for inserting array relation for remote table "assessment_additional_groups" */
export type AssessmentAdditionalGroupsArrRelInsertInput = {
  data: Array<AssessmentAdditionalGroupsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AssessmentAdditionalGroupsOnConflict>;
};

/** Boolean expression to filter rows from the table "assessment_additional_groups". All fields are combined with a logical 'AND'. */
export type AssessmentAdditionalGroupsBoolExp = {
  _and?: InputMaybe<Array<AssessmentAdditionalGroupsBoolExp>>;
  _not?: InputMaybe<AssessmentAdditionalGroupsBoolExp>;
  _or?: InputMaybe<Array<AssessmentAdditionalGroupsBoolExp>>;
  assessment?: InputMaybe<AssessmentsBoolExp>;
  assessmentId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  group?: InputMaybe<GroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "assessment_additional_groups" */
export enum AssessmentAdditionalGroupsConstraint {
  /** unique or primary key constraint on columns "assessment_id", "group_id" */
  ASSESSMENT_ADDITIONAL_GROUPS_GROUP_ID_ASSESSMENT_ID_KEY = 'assessment_additional_groups_group_id_assessment_id_key',
  /** unique or primary key constraint on columns "id" */
  ASSESSMENT_ADDITIONAL_GROUPS_PKEY = 'assessment_additional_groups_pkey'
}

/** input type for inserting data into table "assessment_additional_groups" */
export type AssessmentAdditionalGroupsInsertInput = {
  assessment?: InputMaybe<AssessmentsObjRelInsertInput>;
  assessmentId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  group?: InputMaybe<GroupsObjRelInsertInput>;
  groupId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** on_conflict condition type for table "assessment_additional_groups" */
export type AssessmentAdditionalGroupsOnConflict = {
  constraint: AssessmentAdditionalGroupsConstraint;
  update_columns: Array<AssessmentAdditionalGroupsUpdateColumn>;
  where?: InputMaybe<AssessmentAdditionalGroupsBoolExp>;
};

/** update columns of table "assessment_additional_groups" */
export enum AssessmentAdditionalGroupsUpdateColumn {
  /** column name */
  ASSESSMENTID = 'assessmentId',
  /** column name */
  GROUPID = 'groupId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** columns and relationships of "assessment_additional_users" */
export type AssessmentAdditionalUsers = {
  __typename?: 'assessment_additional_users';
  /** An object relationship */
  assessment: Assessments;
  assessmentId: Scalars['uuid']['output'];
  created_at: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  updated_at: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** input type for inserting array relation for remote table "assessment_additional_users" */
export type AssessmentAdditionalUsersArrRelInsertInput = {
  data: Array<AssessmentAdditionalUsersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AssessmentAdditionalUsersOnConflict>;
};

/** Boolean expression to filter rows from the table "assessment_additional_users". All fields are combined with a logical 'AND'. */
export type AssessmentAdditionalUsersBoolExp = {
  _and?: InputMaybe<Array<AssessmentAdditionalUsersBoolExp>>;
  _not?: InputMaybe<AssessmentAdditionalUsersBoolExp>;
  _or?: InputMaybe<Array<AssessmentAdditionalUsersBoolExp>>;
  assessment?: InputMaybe<AssessmentsBoolExp>;
  assessmentId?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "assessment_additional_users" */
export enum AssessmentAdditionalUsersConstraint {
  /** unique or primary key constraint on columns "id" */
  ASSESSMENT_ADDITIONAL_USERS_PKEY = 'assessment_additional_users_pkey',
  /** unique or primary key constraint on columns "user_id", "assessment_id" */
  ASSESSMENT_ID_USER_ID_KEY = 'assessment_id_user_id_key'
}

/** input type for inserting data into table "assessment_additional_users" */
export type AssessmentAdditionalUsersInsertInput = {
  assessment?: InputMaybe<AssessmentsObjRelInsertInput>;
  assessmentId?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** on_conflict condition type for table "assessment_additional_users" */
export type AssessmentAdditionalUsersOnConflict = {
  constraint: AssessmentAdditionalUsersConstraint;
  update_columns: Array<AssessmentAdditionalUsersUpdateColumn>;
  where?: InputMaybe<AssessmentAdditionalUsersBoolExp>;
};

/** update columns of table "assessment_additional_users" */
export enum AssessmentAdditionalUsersUpdateColumn {
  /** column name */
  ASSESSMENTID = 'assessmentId',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USERID = 'userId'
}

/** columns and relationships of "assessment_frequency" */
export type AssessmentFrequency = {
  __typename?: 'assessment_frequency';
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "assessment_frequency". All fields are combined with a logical 'AND'. */
export type AssessmentFrequencyBoolExp = {
  _and?: InputMaybe<Array<AssessmentFrequencyBoolExp>>;
  _not?: InputMaybe<AssessmentFrequencyBoolExp>;
  _or?: InputMaybe<Array<AssessmentFrequencyBoolExp>>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum AssessmentFrequencyEnum {
  ANNUAL = 'ANNUAL',
  EVERY_EIGHTEEN_MONTHS = 'EVERY_EIGHTEEN_MONTHS',
  EVERY_FIVE_YEARS = 'EVERY_FIVE_YEARS',
  EVERY_SIX_MONTHS = 'EVERY_SIX_MONTHS',
  EVERY_THREE_YEARS = 'EVERY_THREE_YEARS',
  EVERY_TWO_YEARS = 'EVERY_TWO_YEARS',
  MONTHLY = 'MONTHLY',
  ONE_OFF = 'ONE_OFF',
  QUARTERLY = 'QUARTERLY'
}

/** Boolean expression to compare columns of type "assessment_frequency_enum". All fields are combined with logical 'AND'. */
export type AssessmentFrequencyEnumComparisonExp = {
  _eq?: InputMaybe<AssessmentFrequencyEnum>;
  _in?: InputMaybe<Array<AssessmentFrequencyEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<AssessmentFrequencyEnum>;
  _nin?: InputMaybe<Array<AssessmentFrequencyEnum>>;
};

/** columns and relationships of "assessment_tags" */
export type AssessmentTags = {
  __typename?: 'assessment_tags';
  /** An object relationship */
  assessment: Assessments;
  assessmentId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  tag: Tags;
  tagId: Scalars['uuid']['output'];
};

/** input type for inserting array relation for remote table "assessment_tags" */
export type AssessmentTagsArrRelInsertInput = {
  data: Array<AssessmentTagsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AssessmentTagsOnConflict>;
};

/** Boolean expression to filter rows from the table "assessment_tags". All fields are combined with a logical 'AND'. */
export type AssessmentTagsBoolExp = {
  _and?: InputMaybe<Array<AssessmentTagsBoolExp>>;
  _not?: InputMaybe<AssessmentTagsBoolExp>;
  _or?: InputMaybe<Array<AssessmentTagsBoolExp>>;
  assessment?: InputMaybe<AssessmentsBoolExp>;
  assessmentId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  tag?: InputMaybe<TagsBoolExp>;
  tagId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "assessment_tags" */
export enum AssessmentTagsConstraint {
  /** unique or primary key constraint on columns "tag_id", "assessment_id" */
  ASSESSMENT_TAGS_ASSESSMENT_ID_TAG_ID_KEY = 'assessment_tags_assessment_id_tag_id_key',
  /** unique or primary key constraint on columns "id" */
  ASSESSMENT_TAGS_PKEY = 'assessment_tags_pkey'
}

/** input type for inserting data into table "assessment_tags" */
export type AssessmentTagsInsertInput = {
  assessment?: InputMaybe<AssessmentsObjRelInsertInput>;
  assessmentId?: InputMaybe<Scalars['uuid']['input']>;
  tag?: InputMaybe<TagsObjRelInsertInput>;
  tagId?: InputMaybe<Scalars['uuid']['input']>;
};

/** on_conflict condition type for table "assessment_tags" */
export type AssessmentTagsOnConflict = {
  constraint: AssessmentTagsConstraint;
  update_columns: Array<AssessmentTagsUpdateColumn>;
  where?: InputMaybe<AssessmentTagsBoolExp>;
};

/** placeholder for update columns of table "assessment_tags" (current role has no relevant permissions) */
export enum AssessmentTagsUpdateColumn {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

/** columns and relationships of "assessments" */
export type Assessments = {
  __typename?: 'assessments';
  /** An array relationship */
  additionalGroups: Array<AssessmentAdditionalGroups>;
  /** An array relationship */
  additionalUsers: Array<AssessmentAdditionalUsers>;
  /** An object relationship */
  agreement: Maybe<Agreements>;
  agreementId: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  assessmentTags: Array<AssessmentTags>;
  /** An object relationship */
  assessment_frequency: AssessmentFrequency;
  autoStartEnabled: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  businessOwnerUser: Users;
  businessOwnerUserId: Scalars['uuid']['output'];
  completedAt: Maybe<Scalars['timestamptz']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  externalRespondents: Maybe<Scalars['jsonb']['output']>;
  frequency: AssessmentFrequencyEnum;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  organisationProductId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  organisation_supplier: Maybe<OrganisationSuppliers>;
  /** An object relationship */
  product: Maybe<OrganisationProductsAndServices>;
  /** An object relationship */
  request: Maybe<Requests>;
  requestId: Maybe<Scalars['uuid']['output']>;
  sendDate: Maybe<Scalars['timestamptz']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  workflow: Workflows;
  workflowId: Scalars['uuid']['output'];
};

/** aggregated selection of "assessments" */
export type AssessmentsAggregate = {
  __typename?: 'assessments_aggregate';
  aggregate: Maybe<AssessmentsAggregateFields>;
  nodes: Array<Assessments>;
};

export type AssessmentsAggregateBoolExp = {
  bool_and?: InputMaybe<AssessmentsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<AssessmentsAggregateBoolExpBoolOr>;
  count?: InputMaybe<AssessmentsAggregateBoolExpCount>;
};

export type AssessmentsAggregateBoolExpBoolAnd = {
  arguments: AssessmentsSelectColumnAssessmentsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AssessmentsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AssessmentsAggregateBoolExpBoolOr = {
  arguments: AssessmentsSelectColumnAssessmentsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AssessmentsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AssessmentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AssessmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AssessmentsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "assessments" */
export type AssessmentsAggregateFields = {
  __typename?: 'assessments_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<AssessmentsMaxFields>;
  min: Maybe<AssessmentsMinFields>;
};

/** input type for inserting array relation for remote table "assessments" */
export type AssessmentsArrRelInsertInput = {
  data: Array<AssessmentsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AssessmentsOnConflict>;
};

/** Boolean expression to filter rows from the table "assessments". All fields are combined with a logical 'AND'. */
export type AssessmentsBoolExp = {
  _and?: InputMaybe<Array<AssessmentsBoolExp>>;
  _not?: InputMaybe<AssessmentsBoolExp>;
  _or?: InputMaybe<Array<AssessmentsBoolExp>>;
  additionalGroups?: InputMaybe<AssessmentAdditionalGroupsBoolExp>;
  additionalUsers?: InputMaybe<AssessmentAdditionalUsersBoolExp>;
  agreement?: InputMaybe<AgreementsBoolExp>;
  agreementId?: InputMaybe<UuidComparisonExp>;
  assessmentTags?: InputMaybe<AssessmentTagsBoolExp>;
  assessment_frequency?: InputMaybe<AssessmentFrequencyBoolExp>;
  autoStartEnabled?: InputMaybe<BooleanComparisonExp>;
  businessOwnerUser?: InputMaybe<UsersBoolExp>;
  businessOwnerUserId?: InputMaybe<UuidComparisonExp>;
  completedAt?: InputMaybe<TimestamptzComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  externalRespondents?: InputMaybe<JsonbComparisonExp>;
  frequency?: InputMaybe<AssessmentFrequencyEnumComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisationProductId?: InputMaybe<UuidComparisonExp>;
  organisationSupplierId?: InputMaybe<UuidComparisonExp>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  product?: InputMaybe<OrganisationProductsAndServicesBoolExp>;
  request?: InputMaybe<RequestsBoolExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  sendDate?: InputMaybe<TimestamptzComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  workflow?: InputMaybe<WorkflowsBoolExp>;
  workflowId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "assessments" */
export enum AssessmentsConstraint {
  /** unique or primary key constraint on columns "id" */
  ASSESSMENTS_PKEY = 'assessments_pkey'
}

/** input type for inserting data into table "assessments" */
export type AssessmentsInsertInput = {
  additionalGroups?: InputMaybe<AssessmentAdditionalGroupsArrRelInsertInput>;
  additionalUsers?: InputMaybe<AssessmentAdditionalUsersArrRelInsertInput>;
  agreement?: InputMaybe<AgreementsObjRelInsertInput>;
  agreementId?: InputMaybe<Scalars['uuid']['input']>;
  assessmentTags?: InputMaybe<AssessmentTagsArrRelInsertInput>;
  autoStartEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  businessOwnerUser?: InputMaybe<UsersObjRelInsertInput>;
  businessOwnerUserId?: InputMaybe<Scalars['uuid']['input']>;
  completedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  externalRespondents?: InputMaybe<Scalars['jsonb']['input']>;
  frequency?: InputMaybe<AssessmentFrequencyEnum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationProductId?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  product?: InputMaybe<OrganisationProductsAndServicesObjRelInsertInput>;
  request?: InputMaybe<RequestsObjRelInsertInput>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  sendDate?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  workflow?: InputMaybe<WorkflowsObjRelInsertInput>;
  workflowId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type AssessmentsMaxFields = {
  __typename?: 'assessments_max_fields';
  agreementId: Maybe<Scalars['uuid']['output']>;
  businessOwnerUserId: Maybe<Scalars['uuid']['output']>;
  completedAt: Maybe<Scalars['timestamptz']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  organisationProductId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  sendDate: Maybe<Scalars['timestamptz']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  workflowId: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type AssessmentsMinFields = {
  __typename?: 'assessments_min_fields';
  agreementId: Maybe<Scalars['uuid']['output']>;
  businessOwnerUserId: Maybe<Scalars['uuid']['output']>;
  completedAt: Maybe<Scalars['timestamptz']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  organisationProductId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  sendDate: Maybe<Scalars['timestamptz']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  workflowId: Maybe<Scalars['uuid']['output']>;
};

/** input type for inserting object relation for remote table "assessments" */
export type AssessmentsObjRelInsertInput = {
  data: AssessmentsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<AssessmentsOnConflict>;
};

/** on_conflict condition type for table "assessments" */
export type AssessmentsOnConflict = {
  constraint: AssessmentsConstraint;
  update_columns: Array<AssessmentsUpdateColumn>;
  where?: InputMaybe<AssessmentsBoolExp>;
};

/** select columns of table "assessments" */
export enum AssessmentsSelectColumn {
  /** column name */
  AGREEMENTID = 'agreementId',
  /** column name */
  AUTOSTARTENABLED = 'autoStartEnabled',
  /** column name */
  BUSINESSOWNERUSERID = 'businessOwnerUserId',
  /** column name */
  COMPLETEDAT = 'completedAt',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  EXTERNALRESPONDENTS = 'externalRespondents',
  /** column name */
  FREQUENCY = 'frequency',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  ORGANISATIONPRODUCTID = 'organisationProductId',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  SENDDATE = 'sendDate',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  WORKFLOWID = 'workflowId'
}

/** select "assessments_aggregate_bool_exp_bool_and_arguments_columns" columns of table "assessments" */
export enum AssessmentsSelectColumnAssessmentsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  AUTOSTARTENABLED = 'autoStartEnabled'
}

/** select "assessments_aggregate_bool_exp_bool_or_arguments_columns" columns of table "assessments" */
export enum AssessmentsSelectColumnAssessmentsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  AUTOSTARTENABLED = 'autoStartEnabled'
}

/** update columns of table "assessments" */
export enum AssessmentsUpdateColumn {
  /** column name */
  AGREEMENTID = 'agreementId',
  /** column name */
  AUTOSTARTENABLED = 'autoStartEnabled',
  /** column name */
  BUSINESSOWNERUSERID = 'businessOwnerUserId',
  /** column name */
  COMPLETEDAT = 'completedAt',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  EXTERNALRESPONDENTS = 'externalRespondents',
  /** column name */
  FREQUENCY = 'frequency',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONPRODUCTID = 'organisationProductId',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  SENDDATE = 'sendDate',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  WORKFLOWID = 'workflowId'
}

/** columns and relationships of "assignee_type" */
export type AssigneeType = {
  __typename?: 'assignee_type';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "assignee_type". All fields are combined with a logical 'AND'. */
export type AssigneeTypeBoolExp = {
  _and?: InputMaybe<Array<AssigneeTypeBoolExp>>;
  _not?: InputMaybe<AssigneeTypeBoolExp>;
  _or?: InputMaybe<Array<AssigneeTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum AssigneeTypeEnum {
  /** EMAIL */
  EMAIL = 'EMAIL',
  /** GROUP */
  GROUP = 'GROUP',
  /** USER */
  USER = 'USER',
  /** VARIABLE */
  VARIABLE = 'VARIABLE'
}

/** Boolean expression to compare columns of type "assignee_type_enum". All fields are combined with logical 'AND'. */
export type AssigneeTypeEnumComparisonExp = {
  _eq?: InputMaybe<AssigneeTypeEnum>;
  _in?: InputMaybe<Array<AssigneeTypeEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<AssigneeTypeEnum>;
  _nin?: InputMaybe<Array<AssigneeTypeEnum>>;
};

/** columns and relationships of "bank_details" */
export type BankDetails = {
  __typename?: 'bank_details';
  accountName: Maybe<Scalars['String']['output']>;
  accountNumber: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  address: Maybe<Addresses>;
  addressId: Maybe<Scalars['uuid']['output']>;
  bankName: Maybe<Scalars['String']['output']>;
  code: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  currency: Maybe<OrganisationFxRates>;
  currencyId: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  customFieldValues: Array<CustomFieldValues>;
  /** An aggregate relationship */
  customFieldValues_aggregate: CustomFieldValuesAggregate;
  deleted_at: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  entityBankDetails: Array<EntityBankDetails>;
  /** An aggregate relationship */
  entityBankDetails_aggregate: EntityBankDetailsAggregate;
  iban: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  isActive: Scalars['Boolean']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  remoteId: Maybe<Scalars['String']['output']>;
  sortCode: Maybe<Scalars['String']['output']>;
  swiftCode: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "bank_details" */
export type BankDetailsAggregate = {
  __typename?: 'bank_details_aggregate';
  aggregate: Maybe<BankDetailsAggregateFields>;
  nodes: Array<BankDetails>;
};

export type BankDetailsAggregateBoolExp = {
  bool_and?: InputMaybe<BankDetailsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<BankDetailsAggregateBoolExpBoolOr>;
  count?: InputMaybe<BankDetailsAggregateBoolExpCount>;
};

export type BankDetailsAggregateBoolExpBoolAnd = {
  arguments: BankDetailsSelectColumnBankDetailsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BankDetailsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type BankDetailsAggregateBoolExpBoolOr = {
  arguments: BankDetailsSelectColumnBankDetailsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BankDetailsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type BankDetailsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BankDetailsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BankDetailsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "bank_details" */
export type BankDetailsAggregateFields = {
  __typename?: 'bank_details_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<BankDetailsMaxFields>;
  min: Maybe<BankDetailsMinFields>;
};

/** input type for inserting array relation for remote table "bank_details" */
export type BankDetailsArrRelInsertInput = {
  data: Array<BankDetailsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<BankDetailsOnConflict>;
};

/** Boolean expression to filter rows from the table "bank_details". All fields are combined with a logical 'AND'. */
export type BankDetailsBoolExp = {
  _and?: InputMaybe<Array<BankDetailsBoolExp>>;
  _not?: InputMaybe<BankDetailsBoolExp>;
  _or?: InputMaybe<Array<BankDetailsBoolExp>>;
  accountName?: InputMaybe<StringComparisonExp>;
  accountNumber?: InputMaybe<StringComparisonExp>;
  address?: InputMaybe<AddressesBoolExp>;
  addressId?: InputMaybe<UuidComparisonExp>;
  bankName?: InputMaybe<StringComparisonExp>;
  code?: InputMaybe<StringComparisonExp>;
  country?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<OrganisationFxRatesBoolExp>;
  currencyId?: InputMaybe<UuidComparisonExp>;
  customFieldValues?: InputMaybe<CustomFieldValuesBoolExp>;
  customFieldValues_aggregate?: InputMaybe<CustomFieldValuesAggregateBoolExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  entityBankDetails?: InputMaybe<EntityBankDetailsBoolExp>;
  entityBankDetails_aggregate?: InputMaybe<EntityBankDetailsAggregateBoolExp>;
  iban?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isActive?: InputMaybe<BooleanComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  remoteId?: InputMaybe<StringComparisonExp>;
  sortCode?: InputMaybe<StringComparisonExp>;
  swiftCode?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "bank_details" */
export enum BankDetailsConstraint {
  /** unique or primary key constraint on columns "id" */
  BANK_DETAILS_PKEY = 'bank_details_pkey',
  /** unique or primary key constraint on columns "remote_id", "organisation_id" */
  BANK_DETAILS_REMOTE_ID_ORGANISATION_ID_KEY = 'bank_details_remote_id_organisation_id_key'
}

/** input type for inserting data into table "bank_details" */
export type BankDetailsInsertInput = {
  accountName?: InputMaybe<Scalars['String']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<AddressesObjRelInsertInput>;
  addressId?: InputMaybe<Scalars['uuid']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<OrganisationFxRatesObjRelInsertInput>;
  currencyId?: InputMaybe<Scalars['uuid']['input']>;
  customFieldValues?: InputMaybe<CustomFieldValuesArrRelInsertInput>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entityBankDetails?: InputMaybe<EntityBankDetailsArrRelInsertInput>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  sortCode?: InputMaybe<Scalars['String']['input']>;
  swiftCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type BankDetailsMaxFields = {
  __typename?: 'bank_details_max_fields';
  accountName: Maybe<Scalars['String']['output']>;
  accountNumber: Maybe<Scalars['String']['output']>;
  addressId: Maybe<Scalars['uuid']['output']>;
  bankName: Maybe<Scalars['String']['output']>;
  code: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  currencyId: Maybe<Scalars['uuid']['output']>;
  deleted_at: Maybe<Scalars['timestamptz']['output']>;
  iban: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  sortCode: Maybe<Scalars['String']['output']>;
  swiftCode: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type BankDetailsMinFields = {
  __typename?: 'bank_details_min_fields';
  accountName: Maybe<Scalars['String']['output']>;
  accountNumber: Maybe<Scalars['String']['output']>;
  addressId: Maybe<Scalars['uuid']['output']>;
  bankName: Maybe<Scalars['String']['output']>;
  code: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  currencyId: Maybe<Scalars['uuid']['output']>;
  deleted_at: Maybe<Scalars['timestamptz']['output']>;
  iban: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  sortCode: Maybe<Scalars['String']['output']>;
  swiftCode: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** input type for inserting object relation for remote table "bank_details" */
export type BankDetailsObjRelInsertInput = {
  data: BankDetailsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<BankDetailsOnConflict>;
};

/** on_conflict condition type for table "bank_details" */
export type BankDetailsOnConflict = {
  constraint: BankDetailsConstraint;
  update_columns: Array<BankDetailsUpdateColumn>;
  where?: InputMaybe<BankDetailsBoolExp>;
};

/** select columns of table "bank_details" */
export enum BankDetailsSelectColumn {
  /** column name */
  ACCOUNTNAME = 'accountName',
  /** column name */
  ACCOUNTNUMBER = 'accountNumber',
  /** column name */
  ADDRESSID = 'addressId',
  /** column name */
  BANKNAME = 'bankName',
  /** column name */
  CODE = 'code',
  /** column name */
  COUNTRY = 'country',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CURRENCYID = 'currencyId',
  /** column name */
  DELETED_AT = 'deleted_at',
  /** column name */
  IBAN = 'iban',
  /** column name */
  ID = 'id',
  /** column name */
  ISACTIVE = 'isActive',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  SORTCODE = 'sortCode',
  /** column name */
  SWIFTCODE = 'swiftCode',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** select "bank_details_aggregate_bool_exp_bool_and_arguments_columns" columns of table "bank_details" */
export enum BankDetailsSelectColumnBankDetailsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  ISACTIVE = 'isActive'
}

/** select "bank_details_aggregate_bool_exp_bool_or_arguments_columns" columns of table "bank_details" */
export enum BankDetailsSelectColumnBankDetailsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  ISACTIVE = 'isActive'
}

/** update columns of table "bank_details" */
export enum BankDetailsUpdateColumn {
  /** column name */
  ACCOUNTNAME = 'accountName',
  /** column name */
  ACCOUNTNUMBER = 'accountNumber',
  /** column name */
  ADDRESSID = 'addressId',
  /** column name */
  BANKNAME = 'bankName',
  /** column name */
  CODE = 'code',
  /** column name */
  COUNTRY = 'country',
  /** column name */
  CURRENCYID = 'currencyId',
  /** column name */
  IBAN = 'iban',
  /** column name */
  ISACTIVE = 'isActive',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  SORTCODE = 'sortCode',
  /** column name */
  SWIFTCODE = 'swiftCode'
}

/** columns and relationships of "budget_approval_group" */
export type BudgetApprovalGroup = {
  __typename?: 'budget_approval_group';
  /** An array relationship */
  assignees: Array<BudgetApprovalGroupAssignees>;
  created_at: Scalars['timestamptz']['output'];
  deleted_at: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  organisationId: Scalars['uuid']['output'];
  /** An array relationship */
  selected_custom_core_data: Array<BudgetApprovalGroupSelectedCustomCoreData>;
};

/** columns and relationships of "budget_approval_group_assignees" */
export type BudgetApprovalGroupAssignees = {
  __typename?: 'budget_approval_group_assignees';
  /** An array relationship */
  assignees: Array<BudgetApprovalGroupAssigneesAssignees>;
  budgetApprovalGroupId: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  custom_core_data_options: Array<BudgetApprovalGroupAssigneesCustomCoreDataOptions>;
  /** An object relationship */
  department: Maybe<Departments>;
  departmentId: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  lineItem: Maybe<LineItemTypes>;
  lineItemId: Maybe<Scalars['uuid']['output']>;
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  subsidiary: Maybe<Subsidiaries>;
  subsidiaryId: Maybe<Scalars['uuid']['output']>;
};

/** columns and relationships of "budget_approval_group_assignees_assignees" */
export type BudgetApprovalGroupAssigneesAssignees = {
  __typename?: 'budget_approval_group_assignees_assignees';
  budgetApprovalGroupAssigneesId: Scalars['uuid']['output'];
  /** An object relationship */
  group: Maybe<Groups>;
  groupId: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  user: Maybe<Users>;
  userId: Maybe<Scalars['uuid']['output']>;
};

/** columns and relationships of "budget_approval_group_assignees_custom_core_data_options" */
export type BudgetApprovalGroupAssigneesCustomCoreDataOptions = {
  __typename?: 'budget_approval_group_assignees_custom_core_data_options';
  budget_approval_group_assignees_id: Scalars['uuid']['output'];
  /** An object relationship */
  custom_core_data: CustomCoreData;
  custom_core_data_id: Scalars['uuid']['output'];
  /** An object relationship */
  custom_core_data_option: CustomCoreDataOptions;
  custom_core_data_option_id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisation_id: Scalars['uuid']['output'];
};

/** columns and relationships of "budget_approval_group_selected_custom_core_data" */
export type BudgetApprovalGroupSelectedCustomCoreData = {
  __typename?: 'budget_approval_group_selected_custom_core_data';
  budget_approval_group_id: Scalars['uuid']['output'];
  /** An object relationship */
  custom_core_data: CustomCoreData;
  custom_core_data_id: Scalars['uuid']['output'];
};

/** columns and relationships of "budget_approval_threshold" */
export type BudgetApprovalThreshold = {
  __typename?: 'budget_approval_threshold';
  /** An array relationship */
  budget_approval_threshold_groups: Array<BudgetApprovalThresholdGroup>;
  created_at: Scalars['timestamptz']['output'];
  deleted_at: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  departments: Array<BudgetApprovalThresholdDepartment>;
  id: Scalars['uuid']['output'];
  inBudget: Maybe<Scalars['Boolean']['output']>;
  maxValue: Maybe<Scalars['float8']['output']>;
  minValue: Scalars['float8']['output'];
  name: Scalars['String']['output'];
  organisationId: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** columns and relationships of "budget_approval_threshold_department" */
export type BudgetApprovalThresholdDepartment = {
  __typename?: 'budget_approval_threshold_department';
  /** An object relationship */
  department: Departments;
  departmentId: Scalars['uuid']['output'];
  /** An object relationship */
  threshold: BudgetApprovalThreshold;
  thresholdId: Scalars['uuid']['output'];
};

/** columns and relationships of "budget_approval_threshold_group" */
export type BudgetApprovalThresholdGroup = {
  __typename?: 'budget_approval_threshold_group';
  approvalGroupId: Scalars['uuid']['output'];
  /** An object relationship */
  budget_approval_group: BudgetApprovalGroup;
  id: Scalars['uuid']['output'];
  isApproval: Scalars['Boolean']['output'];
  organisationId: Scalars['uuid']['output'];
  thresholdId: Scalars['uuid']['output'];
};

/** columns and relationships of "budgets" */
export type Budgets = {
  __typename?: 'budgets';
  amount: Scalars['numeric']['output'];
  /** An object relationship */
  budgets_organisation_fx_rate: OrganisationFxRates;
  /** An array relationship */
  budgets_requests: Array<Requests>;
  /** An aggregate relationship */
  budgets_requests_aggregate: RequestsAggregate;
  createdAt: Scalars['timestamptz']['output'];
  currency_id: Scalars['uuid']['output'];
  externalId: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organisationId: Scalars['uuid']['output'];
  status: Scalars['budgetStatus']['output'];
};

/** Boolean expression to filter rows from the table "budgets". All fields are combined with a logical 'AND'. */
export type BudgetsBoolExp = {
  _and?: InputMaybe<Array<BudgetsBoolExp>>;
  _not?: InputMaybe<BudgetsBoolExp>;
  _or?: InputMaybe<Array<BudgetsBoolExp>>;
  amount?: InputMaybe<NumericComparisonExp>;
  budgets_organisation_fx_rate?: InputMaybe<OrganisationFxRatesBoolExp>;
  budgets_requests?: InputMaybe<RequestsBoolExp>;
  budgets_requests_aggregate?: InputMaybe<RequestsAggregateBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency_id?: InputMaybe<UuidComparisonExp>;
  externalId?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isArchived?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "budgets" */
export enum BudgetsConstraint {
  /** unique or primary key constraint on columns "id" */
  BUDGETS_PKEY = 'budgets_pkey'
}

/** input type for inserting data into table "budgets" */
export type BudgetsInsertInput = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  budgets_organisation_fx_rate?: InputMaybe<OrganisationFxRatesObjRelInsertInput>;
  budgets_requests?: InputMaybe<RequestsArrRelInsertInput>;
  currency_id?: InputMaybe<Scalars['uuid']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting object relation for remote table "budgets" */
export type BudgetsObjRelInsertInput = {
  data: BudgetsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<BudgetsOnConflict>;
};

/** on_conflict condition type for table "budgets" */
export type BudgetsOnConflict = {
  constraint: BudgetsConstraint;
  update_columns: Array<BudgetsUpdateColumn>;
  where?: InputMaybe<BudgetsBoolExp>;
};

/** update columns of table "budgets" */
export enum BudgetsUpdateColumn {
  /** column name */
  AMOUNT = 'amount',
  /** column name */
  CURRENCY_ID = 'currency_id',
  /** column name */
  EXTERNALID = 'externalId',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  NAME = 'name',
  /** column name */
  STATUS = 'status'
}

/** columns and relationships of "categories" */
export type Categories = {
  __typename?: 'categories';
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  parent: Maybe<Categories>;
  parentId: Maybe<Scalars['uuid']['output']>;
  pathLevel: Scalars['Int']['output'];
};

/** Boolean expression to filter rows from the table "categories". All fields are combined with a logical 'AND'. */
export type CategoriesBoolExp = {
  _and?: InputMaybe<Array<CategoriesBoolExp>>;
  _not?: InputMaybe<CategoriesBoolExp>;
  _or?: InputMaybe<Array<CategoriesBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  parent?: InputMaybe<CategoriesBoolExp>;
  parentId?: InputMaybe<UuidComparisonExp>;
  pathLevel?: InputMaybe<IntComparisonExp>;
};

export enum CategoryEnum {
  /** Consulting / Professional Services */
  CONSULTING_OR_PROFESSIONAL_SERVICES = 'CONSULTING_OR_PROFESSIONAL_SERVICES',
  /** Hardware / Equipment */
  HARDWARE_OR_EQUIPMENT = 'HARDWARE_OR_EQUIPMENT',
  /** Other */
  OTHER = 'OTHER',
  /** Software */
  SOFTWARE = 'SOFTWARE'
}

/** Boolean expression to compare columns of type "category_enum". All fields are combined with logical 'AND'. */
export type CategoryEnumComparisonExp = {
  _eq?: InputMaybe<CategoryEnum>;
  _in?: InputMaybe<Array<CategoryEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<CategoryEnum>;
  _nin?: InputMaybe<Array<CategoryEnum>>;
};

/** columns and relationships of "core_data" */
export type CoreData = {
  __typename?: 'core_data';
  /** An object relationship */
  address: Maybe<Addresses>;
  /** An array relationship */
  coreDataDependencies: Array<CoreDataDependencies>;
  /** An aggregate relationship */
  coreDataDependencies_aggregate: CoreDataDependenciesAggregate;
  /** An array relationship */
  coreDataExternalReferences: Array<CoreDataExternalReferences>;
  /** An aggregate relationship */
  coreDataExternalReferences_aggregate: CoreDataExternalReferencesAggregate;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  currency: Maybe<OrganisationFxRates>;
  /** An object relationship */
  customCoreDataOption: Maybe<CustomCoreDataOptions>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  department: Maybe<Departments>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  lineItemType: Maybe<LineItemTypes>;
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  paymentMethod: Maybe<PaymentMethods>;
  /** An object relationship */
  paymentTerm: Maybe<PaymentTerms>;
  /** An object relationship */
  subsidiary: Maybe<Subsidiaries>;
  type: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "core_data". All fields are combined with a logical 'AND'. */
export type CoreDataBoolExp = {
  _and?: InputMaybe<Array<CoreDataBoolExp>>;
  _not?: InputMaybe<CoreDataBoolExp>;
  _or?: InputMaybe<Array<CoreDataBoolExp>>;
  address?: InputMaybe<AddressesBoolExp>;
  coreDataDependencies?: InputMaybe<CoreDataDependenciesBoolExp>;
  coreDataDependencies_aggregate?: InputMaybe<CoreDataDependenciesAggregateBoolExp>;
  coreDataExternalReferences?: InputMaybe<CoreDataExternalReferencesBoolExp>;
  coreDataExternalReferences_aggregate?: InputMaybe<CoreDataExternalReferencesAggregateBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<OrganisationFxRatesBoolExp>;
  customCoreDataOption?: InputMaybe<CustomCoreDataOptionsBoolExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  department?: InputMaybe<DepartmentsBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lineItemType?: InputMaybe<LineItemTypesBoolExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  paymentMethod?: InputMaybe<PaymentMethodsBoolExp>;
  paymentTerm?: InputMaybe<PaymentTermsBoolExp>;
  subsidiary?: InputMaybe<SubsidiariesBoolExp>;
  type?: InputMaybe<StringComparisonExp>;
};

/** columns and relationships of "core_data_dependencies" */
export type CoreDataDependencies = {
  __typename?: 'core_data_dependencies';
  /** An object relationship */
  coreData: CoreData;
  coreDataId: Scalars['uuid']['output'];
  coreDataType: Scalars['String']['output'];
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  dependencyCoreData: Maybe<CoreData>;
  dependencyCoreDataId: Maybe<Scalars['uuid']['output']>;
  dependencyCoreDataType: Scalars['String']['output'];
  /** An object relationship */
  dependencySupplierProfile: Maybe<OrganisationSupplierProfiles>;
  dependencySupplierProfileId: Maybe<Scalars['uuid']['output']>;
  dependencyType: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  isAll: Maybe<Scalars['Boolean']['output']>;
  organisationCoreDataDependencyId: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
};

/** aggregated selection of "core_data_dependencies" */
export type CoreDataDependenciesAggregate = {
  __typename?: 'core_data_dependencies_aggregate';
  aggregate: Maybe<CoreDataDependenciesAggregateFields>;
  nodes: Array<CoreDataDependencies>;
};

export type CoreDataDependenciesAggregateBoolExp = {
  bool_and?: InputMaybe<CoreDataDependenciesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<CoreDataDependenciesAggregateBoolExpBoolOr>;
  count?: InputMaybe<CoreDataDependenciesAggregateBoolExpCount>;
};

export type CoreDataDependenciesAggregateBoolExpBoolAnd = {
  arguments: CoreDataDependenciesSelectColumnCoreDataDependenciesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CoreDataDependenciesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CoreDataDependenciesAggregateBoolExpBoolOr = {
  arguments: CoreDataDependenciesSelectColumnCoreDataDependenciesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CoreDataDependenciesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CoreDataDependenciesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CoreDataDependenciesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CoreDataDependenciesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "core_data_dependencies" */
export type CoreDataDependenciesAggregateFields = {
  __typename?: 'core_data_dependencies_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<CoreDataDependenciesMaxFields>;
  min: Maybe<CoreDataDependenciesMinFields>;
};

/** Boolean expression to filter rows from the table "core_data_dependencies". All fields are combined with a logical 'AND'. */
export type CoreDataDependenciesBoolExp = {
  _and?: InputMaybe<Array<CoreDataDependenciesBoolExp>>;
  _not?: InputMaybe<CoreDataDependenciesBoolExp>;
  _or?: InputMaybe<Array<CoreDataDependenciesBoolExp>>;
  coreData?: InputMaybe<CoreDataBoolExp>;
  coreDataId?: InputMaybe<UuidComparisonExp>;
  coreDataType?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  dependencyCoreData?: InputMaybe<CoreDataBoolExp>;
  dependencyCoreDataId?: InputMaybe<UuidComparisonExp>;
  dependencyCoreDataType?: InputMaybe<StringComparisonExp>;
  dependencySupplierProfile?: InputMaybe<OrganisationSupplierProfilesBoolExp>;
  dependencySupplierProfileId?: InputMaybe<UuidComparisonExp>;
  dependencyType?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isAll?: InputMaybe<BooleanComparisonExp>;
  organisationCoreDataDependencyId?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
};

/** aggregate max on columns */
export type CoreDataDependenciesMaxFields = {
  __typename?: 'core_data_dependencies_max_fields';
  coreDataId: Maybe<Scalars['uuid']['output']>;
  coreDataType: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  dependencyCoreDataId: Maybe<Scalars['uuid']['output']>;
  dependencyCoreDataType: Maybe<Scalars['String']['output']>;
  dependencySupplierProfileId: Maybe<Scalars['uuid']['output']>;
  dependencyType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationCoreDataDependencyId: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type CoreDataDependenciesMinFields = {
  __typename?: 'core_data_dependencies_min_fields';
  coreDataId: Maybe<Scalars['uuid']['output']>;
  coreDataType: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  dependencyCoreDataId: Maybe<Scalars['uuid']['output']>;
  dependencyCoreDataType: Maybe<Scalars['String']['output']>;
  dependencySupplierProfileId: Maybe<Scalars['uuid']['output']>;
  dependencyType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationCoreDataDependencyId: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
};

/** select columns of table "core_data_dependencies" */
export enum CoreDataDependenciesSelectColumn {
  /** column name */
  COREDATAID = 'coreDataId',
  /** column name */
  COREDATATYPE = 'coreDataType',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DEPENDENCYCOREDATAID = 'dependencyCoreDataId',
  /** column name */
  DEPENDENCYCOREDATATYPE = 'dependencyCoreDataType',
  /** column name */
  DEPENDENCYSUPPLIERPROFILEID = 'dependencySupplierProfileId',
  /** column name */
  DEPENDENCYTYPE = 'dependencyType',
  /** column name */
  ID = 'id',
  /** column name */
  ISALL = 'isAll',
  /** column name */
  ORGANISATIONCOREDATADEPENDENCYID = 'organisationCoreDataDependencyId',
  /** column name */
  ORGANISATIONID = 'organisationId'
}

/** select "core_data_dependencies_aggregate_bool_exp_bool_and_arguments_columns" columns of table "core_data_dependencies" */
export enum CoreDataDependenciesSelectColumnCoreDataDependenciesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  ISALL = 'isAll'
}

/** select "core_data_dependencies_aggregate_bool_exp_bool_or_arguments_columns" columns of table "core_data_dependencies" */
export enum CoreDataDependenciesSelectColumnCoreDataDependenciesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  ISALL = 'isAll'
}

/** columns and relationships of "core_data_external_references" */
export type CoreDataExternalReferences = {
  __typename?: 'core_data_external_references';
  /** An object relationship */
  coreData: CoreData;
  coreDataId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  customCoreData: Maybe<CustomCoreData>;
  customCoreDataId: Maybe<Scalars['uuid']['output']>;
  entityType: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  integration: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  organisationIntegration: Maybe<OrganisationIntegrations>;
  organisationIntegrationId: Maybe<Scalars['uuid']['output']>;
  referenceId: Scalars['String']['output'];
  remoteId: Scalars['String']['output'];
};

/** aggregated selection of "core_data_external_references" */
export type CoreDataExternalReferencesAggregate = {
  __typename?: 'core_data_external_references_aggregate';
  aggregate: Maybe<CoreDataExternalReferencesAggregateFields>;
  nodes: Array<CoreDataExternalReferences>;
};

export type CoreDataExternalReferencesAggregateBoolExp = {
  count?: InputMaybe<CoreDataExternalReferencesAggregateBoolExpCount>;
};

export type CoreDataExternalReferencesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CoreDataExternalReferencesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CoreDataExternalReferencesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "core_data_external_references" */
export type CoreDataExternalReferencesAggregateFields = {
  __typename?: 'core_data_external_references_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<CoreDataExternalReferencesMaxFields>;
  min: Maybe<CoreDataExternalReferencesMinFields>;
};

/** Boolean expression to filter rows from the table "core_data_external_references". All fields are combined with a logical 'AND'. */
export type CoreDataExternalReferencesBoolExp = {
  _and?: InputMaybe<Array<CoreDataExternalReferencesBoolExp>>;
  _not?: InputMaybe<CoreDataExternalReferencesBoolExp>;
  _or?: InputMaybe<Array<CoreDataExternalReferencesBoolExp>>;
  coreData?: InputMaybe<CoreDataBoolExp>;
  coreDataId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customCoreData?: InputMaybe<CustomCoreDataBoolExp>;
  customCoreDataId?: InputMaybe<UuidComparisonExp>;
  entityType?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  integration?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsBoolExp>;
  organisationIntegrationId?: InputMaybe<UuidComparisonExp>;
  referenceId?: InputMaybe<StringComparisonExp>;
  remoteId?: InputMaybe<StringComparisonExp>;
};

/** aggregate max on columns */
export type CoreDataExternalReferencesMaxFields = {
  __typename?: 'core_data_external_references_max_fields';
  coreDataId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  customCoreDataId: Maybe<Scalars['uuid']['output']>;
  entityType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  integration: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  organisationIntegrationId: Maybe<Scalars['uuid']['output']>;
  referenceId: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type CoreDataExternalReferencesMinFields = {
  __typename?: 'core_data_external_references_min_fields';
  coreDataId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  customCoreDataId: Maybe<Scalars['uuid']['output']>;
  entityType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  integration: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  organisationIntegrationId: Maybe<Scalars['uuid']['output']>;
  referenceId: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
};

/** select columns of table "core_data_external_references" */
export enum CoreDataExternalReferencesSelectColumn {
  /** column name */
  COREDATAID = 'coreDataId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CUSTOMCOREDATAID = 'customCoreDataId',
  /** column name */
  ENTITYTYPE = 'entityType',
  /** column name */
  ID = 'id',
  /** column name */
  INTEGRATION = 'integration',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  ORGANISATIONINTEGRATIONID = 'organisationIntegrationId',
  /** column name */
  REFERENCEID = 'referenceId',
  /** column name */
  REMOTEID = 'remoteId'
}

/** columns and relationships of "custom_core_data" */
export type CustomCoreData = {
  __typename?: 'custom_core_data';
  archivedAt: Maybe<Scalars['timestamptz']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  custom_core_data_options: Array<CustomCoreDataOptions>;
  /** An aggregate relationship */
  custom_core_data_options_aggregate: CustomCoreDataOptionsAggregate;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  organisationIntegration: Maybe<OrganisationIntegrations>;
  organisationIntegrationId: Maybe<Scalars['uuid']['output']>;
  pathLevels: Maybe<Array<Scalars['String']['output']>>;
  slug: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "custom_core_data". All fields are combined with a logical 'AND'. */
export type CustomCoreDataBoolExp = {
  _and?: InputMaybe<Array<CustomCoreDataBoolExp>>;
  _not?: InputMaybe<CustomCoreDataBoolExp>;
  _or?: InputMaybe<Array<CustomCoreDataBoolExp>>;
  archivedAt?: InputMaybe<TimestamptzComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  custom_core_data_options?: InputMaybe<CustomCoreDataOptionsBoolExp>;
  custom_core_data_options_aggregate?: InputMaybe<CustomCoreDataOptionsAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsBoolExp>;
  organisationIntegrationId?: InputMaybe<UuidComparisonExp>;
  pathLevels?: InputMaybe<StringArrayComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "custom_core_data" */
export enum CustomCoreDataConstraint {
  /** unique or primary key constraint on columns "archived_at", "organisation_id", "name" */
  CUSTOM_CORE_DATA_NAME_ORGANISATION_ID_KEY = 'custom_core_data_name_organisation_id_key',
  /** unique or primary key constraint on columns "id" */
  CUSTOM_CORE_DATA_PKEY = 'custom_core_data_pkey',
  /** unique or primary key constraint on columns "organisation_id", "slug" */
  CUSTOM_CORE_DATA_SLUG_ORGANISATION_ID_ACTIVE_UNIQUE = 'custom_core_data_slug_organisation_id_active_unique'
}

/** input type for inserting data into table "custom_core_data" */
export type CustomCoreDataInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  custom_core_data_options?: InputMaybe<CustomCoreDataOptionsArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsObjRelInsertInput>;
  organisationIntegrationId?: InputMaybe<Scalars['uuid']['input']>;
  pathLevels?: InputMaybe<Array<Scalars['String']['input']>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** input type for inserting object relation for remote table "custom_core_data" */
export type CustomCoreDataObjRelInsertInput = {
  data: CustomCoreDataInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CustomCoreDataOnConflict>;
};

/** on_conflict condition type for table "custom_core_data" */
export type CustomCoreDataOnConflict = {
  constraint: CustomCoreDataConstraint;
  update_columns: Array<CustomCoreDataUpdateColumn>;
  where?: InputMaybe<CustomCoreDataBoolExp>;
};

/** columns and relationships of "custom_core_data_options" */
export type CustomCoreDataOptions = {
  __typename?: 'custom_core_data_options';
  organisationId: Scalars['uuid']['output'];
  archivedBy: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  coreData: CoreData;
  coreDataId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  customCoreDataId: Scalars['uuid']['output'];
  /** An object relationship */
  custom_core_data: CustomCoreData;
  id: Scalars['uuid']['output'];
  isArchived: Scalars['Boolean']['output'];
  isTerminal: Scalars['Boolean']['output'];
  /** An object relationship */
  parent: Maybe<CustomCoreDataOptions>;
  parentId: Maybe<Scalars['uuid']['output']>;
  path: Scalars['ltree']['output'];
  remoteId: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "custom_core_data_options" */
export type CustomCoreDataOptionsAggregate = {
  __typename?: 'custom_core_data_options_aggregate';
  aggregate: Maybe<CustomCoreDataOptionsAggregateFields>;
  nodes: Array<CustomCoreDataOptions>;
};

export type CustomCoreDataOptionsAggregateBoolExp = {
  bool_and?: InputMaybe<CustomCoreDataOptionsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<CustomCoreDataOptionsAggregateBoolExpBoolOr>;
  count?: InputMaybe<CustomCoreDataOptionsAggregateBoolExpCount>;
};

export type CustomCoreDataOptionsAggregateBoolExpBoolAnd = {
  arguments: CustomCoreDataOptionsSelectColumnCustomCoreDataOptionsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CustomCoreDataOptionsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CustomCoreDataOptionsAggregateBoolExpBoolOr = {
  arguments: CustomCoreDataOptionsSelectColumnCustomCoreDataOptionsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CustomCoreDataOptionsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CustomCoreDataOptionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CustomCoreDataOptionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CustomCoreDataOptionsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "custom_core_data_options" */
export type CustomCoreDataOptionsAggregateFields = {
  __typename?: 'custom_core_data_options_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<CustomCoreDataOptionsMaxFields>;
  min: Maybe<CustomCoreDataOptionsMinFields>;
};

/** input type for inserting array relation for remote table "custom_core_data_options" */
export type CustomCoreDataOptionsArrRelInsertInput = {
  data: Array<CustomCoreDataOptionsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<CustomCoreDataOptionsOnConflict>;
};

/** Boolean expression to filter rows from the table "custom_core_data_options". All fields are combined with a logical 'AND'. */
export type CustomCoreDataOptionsBoolExp = {
  _and?: InputMaybe<Array<CustomCoreDataOptionsBoolExp>>;
  _not?: InputMaybe<CustomCoreDataOptionsBoolExp>;
  _or?: InputMaybe<Array<CustomCoreDataOptionsBoolExp>>;
  archivedBy?: InputMaybe<StringComparisonExp>;
  coreData?: InputMaybe<CoreDataBoolExp>;
  coreDataId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customCoreDataId?: InputMaybe<UuidComparisonExp>;
  custom_core_data?: InputMaybe<CustomCoreDataBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isArchived?: InputMaybe<BooleanComparisonExp>;
  isTerminal?: InputMaybe<BooleanComparisonExp>;
  parent?: InputMaybe<CustomCoreDataOptionsBoolExp>;
  parentId?: InputMaybe<UuidComparisonExp>;
  path?: InputMaybe<LtreeComparisonExp>;
  remoteId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "custom_core_data_options" */
export enum CustomCoreDataOptionsConstraint {
  /** unique or primary key constraint on columns "value", "parent_id", "custom_core_data_id" */
  CUSTOM_CORE_DATA_OPTIONS_PARENT_ID_CUSTOM_FIELD_ID_VALUE_KEY = 'custom_core_data_options_parent_id_custom_field_id_value_key',
  /** unique or primary key constraint on columns "id" */
  CUSTOM_CORE_DATA_OPTIONS_PKEY = 'custom_core_data_options_pkey',
  /** unique or primary key constraint on columns "remote_id", "organisation_id", "custom_core_data_id" */
  CUSTOM_CORE_DATA_OPTIONS_REMOTE_CUSTOM_CORE_ORGANISATION_ID_KEY = 'custom_core_data_options_remote_custom_core_organisation_id_key'
}

/** input type for inserting data into table "custom_core_data_options" */
export type CustomCoreDataOptionsInsertInput = {
  archivedBy?: InputMaybe<Scalars['String']['input']>;
  coreDataId?: InputMaybe<Scalars['uuid']['input']>;
  customCoreDataId?: InputMaybe<Scalars['uuid']['input']>;
  custom_core_data?: InputMaybe<CustomCoreDataObjRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isTerminal?: InputMaybe<Scalars['Boolean']['input']>;
  parent?: InputMaybe<CustomCoreDataOptionsObjRelInsertInput>;
  parentId?: InputMaybe<Scalars['uuid']['input']>;
  path?: InputMaybe<Scalars['ltree']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type CustomCoreDataOptionsMaxFields = {
  __typename?: 'custom_core_data_options_max_fields';
  archivedBy: Maybe<Scalars['String']['output']>;
  coreDataId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  customCoreDataId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  parentId: Maybe<Scalars['uuid']['output']>;
  path: Maybe<Scalars['ltree']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type CustomCoreDataOptionsMinFields = {
  __typename?: 'custom_core_data_options_min_fields';
  archivedBy: Maybe<Scalars['String']['output']>;
  coreDataId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  customCoreDataId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  parentId: Maybe<Scalars['uuid']['output']>;
  path: Maybe<Scalars['ltree']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

/** input type for inserting object relation for remote table "custom_core_data_options" */
export type CustomCoreDataOptionsObjRelInsertInput = {
  data: CustomCoreDataOptionsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CustomCoreDataOptionsOnConflict>;
};

/** on_conflict condition type for table "custom_core_data_options" */
export type CustomCoreDataOptionsOnConflict = {
  constraint: CustomCoreDataOptionsConstraint;
  update_columns: Array<CustomCoreDataOptionsUpdateColumn>;
  where?: InputMaybe<CustomCoreDataOptionsBoolExp>;
};

/** select columns of table "custom_core_data_options" */
export enum CustomCoreDataOptionsSelectColumn {
  /** column name */
  ARCHIVEDBY = 'archivedBy',
  /** column name */
  COREDATAID = 'coreDataId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CUSTOMCOREDATAID = 'customCoreDataId',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  ISTERMINAL = 'isTerminal',
  /** column name */
  PARENTID = 'parentId',
  /** column name */
  PATH = 'path',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  VALUE = 'value'
}

/** select "custom_core_data_options_aggregate_bool_exp_bool_and_arguments_columns" columns of table "custom_core_data_options" */
export enum CustomCoreDataOptionsSelectColumnCustomCoreDataOptionsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  ISTERMINAL = 'isTerminal'
}

/** select "custom_core_data_options_aggregate_bool_exp_bool_or_arguments_columns" columns of table "custom_core_data_options" */
export enum CustomCoreDataOptionsSelectColumnCustomCoreDataOptionsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  ISTERMINAL = 'isTerminal'
}

/** update columns of table "custom_core_data_options" */
export enum CustomCoreDataOptionsUpdateColumn {
  /** column name */
  ARCHIVEDBY = 'archivedBy',
  /** column name */
  CUSTOMCOREDATAID = 'customCoreDataId',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  ISTERMINAL = 'isTerminal',
  /** column name */
  PARENTID = 'parentId',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  VALUE = 'value'
}

/** update columns of table "custom_core_data" */
export enum CustomCoreDataUpdateColumn {
  /** column name */
  ARCHIVEDAT = 'archivedAt',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONINTEGRATIONID = 'organisationIntegrationId',
  /** column name */
  PATHLEVELS = 'pathLevels'
}

/** columns and relationships of "custom_document_types" */
export type CustomDocumentTypes = {
  __typename?: 'custom_document_types';
  id: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "custom_document_types". All fields are combined with a logical 'AND'. */
export type CustomDocumentTypesBoolExp = {
  _and?: InputMaybe<Array<CustomDocumentTypesBoolExp>>;
  _not?: InputMaybe<CustomDocumentTypesBoolExp>;
  _or?: InputMaybe<Array<CustomDocumentTypesBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "custom_document_types" */
export enum CustomDocumentTypesConstraint {
  /** unique or primary key constraint on columns "organisation_id", "value" */
  CUSTOM_DOCUMENT_TYPES_ORGANISATION_ID_VALUE_KEY = 'custom_document_types_organisation_id_value_key',
  /** unique or primary key constraint on columns "id" */
  CUSTOM_DOCUMENT_TYPES_PKEY = 'custom_document_types_pkey'
}

/** input type for inserting data into table "custom_document_types" */
export type CustomDocumentTypesInsertInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting object relation for remote table "custom_document_types" */
export type CustomDocumentTypesObjRelInsertInput = {
  data: CustomDocumentTypesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CustomDocumentTypesOnConflict>;
};

/** on_conflict condition type for table "custom_document_types" */
export type CustomDocumentTypesOnConflict = {
  constraint: CustomDocumentTypesConstraint;
  update_columns: Array<CustomDocumentTypesUpdateColumn>;
  where?: InputMaybe<CustomDocumentTypesBoolExp>;
};

/** placeholder for update columns of table "custom_document_types" (current role has no relevant permissions) */
export enum CustomDocumentTypesUpdateColumn {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

/** Choices of custom fields to be used for select and multi-select types */
export type CustomFieldChoices = {
  __typename?: 'custom_field_choices';
  customFieldId: Scalars['uuid']['output'];
  /** An object relationship */
  custom_field: CustomFields;
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
  organisation_id: Scalars['uuid']['output'];
  precedence: Scalars['Int']['output'];
};

/** input type for inserting array relation for remote table "custom_field_choices" */
export type CustomFieldChoicesArrRelInsertInput = {
  data: Array<CustomFieldChoicesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<CustomFieldChoicesOnConflict>;
};

/** Boolean expression to filter rows from the table "custom_field_choices". All fields are combined with a logical 'AND'. */
export type CustomFieldChoicesBoolExp = {
  _and?: InputMaybe<Array<CustomFieldChoicesBoolExp>>;
  _not?: InputMaybe<CustomFieldChoicesBoolExp>;
  _or?: InputMaybe<Array<CustomFieldChoicesBoolExp>>;
  customFieldId?: InputMaybe<UuidComparisonExp>;
  custom_field?: InputMaybe<CustomFieldsBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  label?: InputMaybe<StringComparisonExp>;
  organisation_id?: InputMaybe<UuidComparisonExp>;
  precedence?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "custom_field_choices" */
export enum CustomFieldChoicesConstraint {
  /** unique or primary key constraint on columns "label", "custom_field_id" */
  CUSTOM_FIELD_CHOICES_LABEL_CUSTOM_FIELD_ID_KEY = 'custom_field_choices_label_custom_field_id_key',
  /** unique or primary key constraint on columns "id" */
  CUSTOM_FIELD_CHOICES_PKEY = 'custom_field_choices_pkey'
}

/** input type for inserting data into table "custom_field_choices" */
export type CustomFieldChoicesInsertInput = {
  customFieldId?: InputMaybe<Scalars['uuid']['input']>;
  custom_field?: InputMaybe<CustomFieldsObjRelInsertInput>;
  label?: InputMaybe<Scalars['String']['input']>;
  precedence?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting object relation for remote table "custom_field_choices" */
export type CustomFieldChoicesObjRelInsertInput = {
  data: CustomFieldChoicesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CustomFieldChoicesOnConflict>;
};

/** on_conflict condition type for table "custom_field_choices" */
export type CustomFieldChoicesOnConflict = {
  constraint: CustomFieldChoicesConstraint;
  update_columns: Array<CustomFieldChoicesUpdateColumn>;
  where?: InputMaybe<CustomFieldChoicesBoolExp>;
};

/** update columns of table "custom_field_choices" */
export enum CustomFieldChoicesUpdateColumn {
  /** column name */
  LABEL = 'label',
  /** column name */
  PRECEDENCE = 'precedence'
}

/** Linking custom field values to core data */
export type CustomFieldCoreData = {
  __typename?: 'custom_field_core_data';
  /** An object relationship */
  address: Maybe<Addresses>;
  address_id: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  currency: Maybe<OrganisationFxRates>;
  currency_id: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  customCoreDataOption: Maybe<CustomCoreDataOptions>;
  custom_core_data_option_id: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  department: Maybe<Departments>;
  department_id: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  lineItemType: Maybe<LineItemTypes>;
  line_item_type_id: Maybe<Scalars['uuid']['output']>;
  organisation_id: Scalars['uuid']['output'];
  /** An object relationship */
  paymentMethod: Maybe<PaymentMethods>;
  /** An object relationship */
  paymentTerm: Maybe<PaymentTerms>;
  payment_method_id: Maybe<Scalars['uuid']['output']>;
  payment_term_id: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  subsidiary: Maybe<Subsidiaries>;
  subsidiary_id: Maybe<Scalars['uuid']['output']>;
};

/** Boolean expression to filter rows from the table "custom_field_core_data". All fields are combined with a logical 'AND'. */
export type CustomFieldCoreDataBoolExp = {
  _and?: InputMaybe<Array<CustomFieldCoreDataBoolExp>>;
  _not?: InputMaybe<CustomFieldCoreDataBoolExp>;
  _or?: InputMaybe<Array<CustomFieldCoreDataBoolExp>>;
  address?: InputMaybe<AddressesBoolExp>;
  address_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<OrganisationFxRatesBoolExp>;
  currency_id?: InputMaybe<UuidComparisonExp>;
  customCoreDataOption?: InputMaybe<CustomCoreDataOptionsBoolExp>;
  custom_core_data_option_id?: InputMaybe<UuidComparisonExp>;
  department?: InputMaybe<DepartmentsBoolExp>;
  department_id?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lineItemType?: InputMaybe<LineItemTypesBoolExp>;
  line_item_type_id?: InputMaybe<UuidComparisonExp>;
  organisation_id?: InputMaybe<UuidComparisonExp>;
  paymentMethod?: InputMaybe<PaymentMethodsBoolExp>;
  paymentTerm?: InputMaybe<PaymentTermsBoolExp>;
  payment_method_id?: InputMaybe<UuidComparisonExp>;
  payment_term_id?: InputMaybe<UuidComparisonExp>;
  subsidiary?: InputMaybe<SubsidiariesBoolExp>;
  subsidiary_id?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "custom_field_core_data" */
export enum CustomFieldCoreDataConstraint {
  /** unique or primary key constraint on columns "id" */
  CUSTOM_FIELD_CORE_DATA_PKEY = 'custom_field_core_data_pkey'
}

/** input type for inserting data into table "custom_field_core_data" */
export type CustomFieldCoreDataInsertInput = {
  address?: InputMaybe<AddressesObjRelInsertInput>;
  address_id?: InputMaybe<Scalars['uuid']['input']>;
  currency?: InputMaybe<OrganisationFxRatesObjRelInsertInput>;
  currency_id?: InputMaybe<Scalars['uuid']['input']>;
  customCoreDataOption?: InputMaybe<CustomCoreDataOptionsObjRelInsertInput>;
  custom_core_data_option_id?: InputMaybe<Scalars['uuid']['input']>;
  department?: InputMaybe<DepartmentsObjRelInsertInput>;
  department_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lineItemType?: InputMaybe<LineItemTypesObjRelInsertInput>;
  line_item_type_id?: InputMaybe<Scalars['uuid']['input']>;
  paymentMethod?: InputMaybe<PaymentMethodsObjRelInsertInput>;
  paymentTerm?: InputMaybe<PaymentTermsObjRelInsertInput>;
  payment_method_id?: InputMaybe<Scalars['uuid']['input']>;
  payment_term_id?: InputMaybe<Scalars['uuid']['input']>;
  subsidiary?: InputMaybe<SubsidiariesObjRelInsertInput>;
  subsidiary_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** input type for inserting object relation for remote table "custom_field_core_data" */
export type CustomFieldCoreDataObjRelInsertInput = {
  data: CustomFieldCoreDataInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CustomFieldCoreDataOnConflict>;
};

/** on_conflict condition type for table "custom_field_core_data" */
export type CustomFieldCoreDataOnConflict = {
  constraint: CustomFieldCoreDataConstraint;
  update_columns: Array<CustomFieldCoreDataUpdateColumn>;
  where?: InputMaybe<CustomFieldCoreDataBoolExp>;
};

/** update columns of table "custom_field_core_data" */
export enum CustomFieldCoreDataUpdateColumn {
  /** column name */
  ADDRESS_ID = 'address_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CURRENCY_ID = 'currency_id',
  /** column name */
  CUSTOM_CORE_DATA_OPTION_ID = 'custom_core_data_option_id',
  /** column name */
  DELETED_AT = 'deleted_at',
  /** column name */
  DEPARTMENT_ID = 'department_id',
  /** column name */
  LINE_ITEM_TYPE_ID = 'line_item_type_id',
  /** column name */
  PAYMENT_METHOD_ID = 'payment_method_id',
  /** column name */
  PAYMENT_TERM_ID = 'payment_term_id',
  /** column name */
  SUBSIDIARY_ID = 'subsidiary_id'
}

/** A value of a custom field. Links to both an entity and a custom field */
export type CustomFieldValues = {
  __typename?: 'custom_field_values';
  booleanValue: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  choice: Maybe<CustomFieldChoices>;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  customField: CustomFields;
  customFieldChoiceId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  customFieldCoreData: Maybe<CustomFieldCoreData>;
  customFieldCoreDataId: Maybe<Scalars['uuid']['output']>;
  customFieldId: Scalars['uuid']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  entityId: Scalars['uuid']['output'];
  /** An object relationship */
  file: Maybe<RequestDocuments>;
  fileId: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  numberValue: Maybe<Scalars['float8']['output']>;
  organisationId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Maybe<Users>;
  userId: Maybe<Scalars['uuid']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "custom_field_values" */
export type CustomFieldValuesAggregate = {
  __typename?: 'custom_field_values_aggregate';
  aggregate: Maybe<CustomFieldValuesAggregateFields>;
  nodes: Array<CustomFieldValues>;
};

export type CustomFieldValuesAggregateBoolExp = {
  avg?: InputMaybe<CustomFieldValuesAggregateBoolExpAvg>;
  bool_and?: InputMaybe<CustomFieldValuesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<CustomFieldValuesAggregateBoolExpBoolOr>;
  corr?: InputMaybe<CustomFieldValuesAggregateBoolExpCorr>;
  count?: InputMaybe<CustomFieldValuesAggregateBoolExpCount>;
  covar_samp?: InputMaybe<CustomFieldValuesAggregateBoolExpCovarSamp>;
  max?: InputMaybe<CustomFieldValuesAggregateBoolExpMax>;
  min?: InputMaybe<CustomFieldValuesAggregateBoolExpMin>;
  stddev_samp?: InputMaybe<CustomFieldValuesAggregateBoolExpStddevSamp>;
  sum?: InputMaybe<CustomFieldValuesAggregateBoolExpSum>;
  var_samp?: InputMaybe<CustomFieldValuesAggregateBoolExpVarSamp>;
};

export type CustomFieldValuesAggregateBoolExpAvg = {
  arguments: CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpAvgArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CustomFieldValuesBoolExp>;
  predicate: Float8ComparisonExp;
};

export type CustomFieldValuesAggregateBoolExpBoolAnd = {
  arguments: CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CustomFieldValuesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CustomFieldValuesAggregateBoolExpBoolOr = {
  arguments: CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CustomFieldValuesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CustomFieldValuesAggregateBoolExpCorr = {
  arguments: CustomFieldValuesAggregateBoolExpCorrArguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CustomFieldValuesBoolExp>;
  predicate: Float8ComparisonExp;
};

export type CustomFieldValuesAggregateBoolExpCorrArguments = {
  X: CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpCorrArgumentsColumns;
  Y: CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpCorrArgumentsColumns;
};

export type CustomFieldValuesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CustomFieldValuesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CustomFieldValuesBoolExp>;
  predicate: IntComparisonExp;
};

export type CustomFieldValuesAggregateBoolExpCovarSamp = {
  arguments: CustomFieldValuesAggregateBoolExpCovarSampArguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CustomFieldValuesBoolExp>;
  predicate: Float8ComparisonExp;
};

export type CustomFieldValuesAggregateBoolExpCovarSampArguments = {
  X: CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpCovarSampArgumentsColumns;
  Y: CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpCovarSampArgumentsColumns;
};

export type CustomFieldValuesAggregateBoolExpMax = {
  arguments: CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpMaxArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CustomFieldValuesBoolExp>;
  predicate: Float8ComparisonExp;
};

export type CustomFieldValuesAggregateBoolExpMin = {
  arguments: CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpMinArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CustomFieldValuesBoolExp>;
  predicate: Float8ComparisonExp;
};

export type CustomFieldValuesAggregateBoolExpStddevSamp = {
  arguments: CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpStddevSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CustomFieldValuesBoolExp>;
  predicate: Float8ComparisonExp;
};

export type CustomFieldValuesAggregateBoolExpSum = {
  arguments: CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpSumArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CustomFieldValuesBoolExp>;
  predicate: Float8ComparisonExp;
};

export type CustomFieldValuesAggregateBoolExpVarSamp = {
  arguments: CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpVarSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CustomFieldValuesBoolExp>;
  predicate: Float8ComparisonExp;
};

/** aggregate fields of "custom_field_values" */
export type CustomFieldValuesAggregateFields = {
  __typename?: 'custom_field_values_aggregate_fields';
  avg: Maybe<CustomFieldValuesAvgFields>;
  count: Scalars['Int']['output'];
  max: Maybe<CustomFieldValuesMaxFields>;
  min: Maybe<CustomFieldValuesMinFields>;
  stddev: Maybe<CustomFieldValuesStddevFields>;
  stddev_pop: Maybe<CustomFieldValuesStddevPopFields>;
  stddev_samp: Maybe<CustomFieldValuesStddevSampFields>;
  sum: Maybe<CustomFieldValuesSumFields>;
  var_pop: Maybe<CustomFieldValuesVarPopFields>;
  var_samp: Maybe<CustomFieldValuesVarSampFields>;
  variance: Maybe<CustomFieldValuesVarianceFields>;
};

/** input type for inserting array relation for remote table "custom_field_values" */
export type CustomFieldValuesArrRelInsertInput = {
  data: Array<CustomFieldValuesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<CustomFieldValuesOnConflict>;
};

/** aggregate avg on columns */
export type CustomFieldValuesAvgFields = {
  __typename?: 'custom_field_values_avg_fields';
  numberValue: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "custom_field_values". All fields are combined with a logical 'AND'. */
export type CustomFieldValuesBoolExp = {
  _and?: InputMaybe<Array<CustomFieldValuesBoolExp>>;
  _not?: InputMaybe<CustomFieldValuesBoolExp>;
  _or?: InputMaybe<Array<CustomFieldValuesBoolExp>>;
  booleanValue?: InputMaybe<BooleanComparisonExp>;
  choice?: InputMaybe<CustomFieldChoicesBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customField?: InputMaybe<CustomFieldsBoolExp>;
  customFieldChoiceId?: InputMaybe<UuidComparisonExp>;
  customFieldCoreData?: InputMaybe<CustomFieldCoreDataBoolExp>;
  customFieldCoreDataId?: InputMaybe<UuidComparisonExp>;
  customFieldId?: InputMaybe<UuidComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  entityId?: InputMaybe<UuidComparisonExp>;
  file?: InputMaybe<RequestDocumentsBoolExp>;
  fileId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  numberValue?: InputMaybe<Float8ComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "custom_field_values" */
export enum CustomFieldValuesConstraint {
  /** unique or primary key constraint on columns "id" */
  ORGANISATION_CUSTOM_FIELD_VALUES_PKEY = 'organisation_custom_field_values_pkey'
}

/** input type for inserting data into table "custom_field_values" */
export type CustomFieldValuesInsertInput = {
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  choice?: InputMaybe<CustomFieldChoicesObjRelInsertInput>;
  customField?: InputMaybe<CustomFieldsObjRelInsertInput>;
  customFieldChoiceId?: InputMaybe<Scalars['uuid']['input']>;
  customFieldCoreData?: InputMaybe<CustomFieldCoreDataObjRelInsertInput>;
  customFieldCoreDataId?: InputMaybe<Scalars['uuid']['input']>;
  customFieldId?: InputMaybe<Scalars['uuid']['input']>;
  entityId?: InputMaybe<Scalars['uuid']['input']>;
  file?: InputMaybe<RequestDocumentsObjRelInsertInput>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  numberValue?: InputMaybe<Scalars['float8']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type CustomFieldValuesMaxFields = {
  __typename?: 'custom_field_values_max_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  customFieldChoiceId: Maybe<Scalars['uuid']['output']>;
  customFieldCoreDataId: Maybe<Scalars['uuid']['output']>;
  customFieldId: Maybe<Scalars['uuid']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  entityId: Maybe<Scalars['uuid']['output']>;
  fileId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  numberValue: Maybe<Scalars['float8']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  userId: Maybe<Scalars['uuid']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type CustomFieldValuesMinFields = {
  __typename?: 'custom_field_values_min_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  customFieldChoiceId: Maybe<Scalars['uuid']['output']>;
  customFieldCoreDataId: Maybe<Scalars['uuid']['output']>;
  customFieldId: Maybe<Scalars['uuid']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  entityId: Maybe<Scalars['uuid']['output']>;
  fileId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  numberValue: Maybe<Scalars['float8']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  userId: Maybe<Scalars['uuid']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

/** on_conflict condition type for table "custom_field_values" */
export type CustomFieldValuesOnConflict = {
  constraint: CustomFieldValuesConstraint;
  update_columns: Array<CustomFieldValuesUpdateColumn>;
  where?: InputMaybe<CustomFieldValuesBoolExp>;
};

/** select columns of table "custom_field_values" */
export enum CustomFieldValuesSelectColumn {
  /** column name */
  BOOLEANVALUE = 'booleanValue',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CUSTOMFIELDCHOICEID = 'customFieldChoiceId',
  /** column name */
  CUSTOMFIELDCOREDATAID = 'customFieldCoreDataId',
  /** column name */
  CUSTOMFIELDID = 'customFieldId',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ENTITYID = 'entityId',
  /** column name */
  FILEID = 'fileId',
  /** column name */
  ID = 'id',
  /** column name */
  NUMBERVALUE = 'numberValue',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId',
  /** column name */
  VALUE = 'value'
}

/** select "custom_field_values_aggregate_bool_exp_avg_arguments_columns" columns of table "custom_field_values" */
export enum CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpAvgArgumentsColumns {
  /** column name */
  NUMBERVALUE = 'numberValue'
}

/** select "custom_field_values_aggregate_bool_exp_bool_and_arguments_columns" columns of table "custom_field_values" */
export enum CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  BOOLEANVALUE = 'booleanValue'
}

/** select "custom_field_values_aggregate_bool_exp_bool_or_arguments_columns" columns of table "custom_field_values" */
export enum CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  BOOLEANVALUE = 'booleanValue'
}

/** select "custom_field_values_aggregate_bool_exp_corr_arguments_columns" columns of table "custom_field_values" */
export enum CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpCorrArgumentsColumns {
  /** column name */
  NUMBERVALUE = 'numberValue'
}

/** select "custom_field_values_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "custom_field_values" */
export enum CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpCovarSampArgumentsColumns {
  /** column name */
  NUMBERVALUE = 'numberValue'
}

/** select "custom_field_values_aggregate_bool_exp_max_arguments_columns" columns of table "custom_field_values" */
export enum CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpMaxArgumentsColumns {
  /** column name */
  NUMBERVALUE = 'numberValue'
}

/** select "custom_field_values_aggregate_bool_exp_min_arguments_columns" columns of table "custom_field_values" */
export enum CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpMinArgumentsColumns {
  /** column name */
  NUMBERVALUE = 'numberValue'
}

/** select "custom_field_values_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "custom_field_values" */
export enum CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpStddevSampArgumentsColumns {
  /** column name */
  NUMBERVALUE = 'numberValue'
}

/** select "custom_field_values_aggregate_bool_exp_sum_arguments_columns" columns of table "custom_field_values" */
export enum CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpSumArgumentsColumns {
  /** column name */
  NUMBERVALUE = 'numberValue'
}

/** select "custom_field_values_aggregate_bool_exp_var_samp_arguments_columns" columns of table "custom_field_values" */
export enum CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpVarSampArgumentsColumns {
  /** column name */
  NUMBERVALUE = 'numberValue'
}

/** aggregate stddev on columns */
export type CustomFieldValuesStddevFields = {
  __typename?: 'custom_field_values_stddev_fields';
  numberValue: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type CustomFieldValuesStddevPopFields = {
  __typename?: 'custom_field_values_stddev_pop_fields';
  numberValue: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type CustomFieldValuesStddevSampFields = {
  __typename?: 'custom_field_values_stddev_samp_fields';
  numberValue: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type CustomFieldValuesSumFields = {
  __typename?: 'custom_field_values_sum_fields';
  numberValue: Maybe<Scalars['float8']['output']>;
};

/** update columns of table "custom_field_values" */
export enum CustomFieldValuesUpdateColumn {
  /** column name */
  BOOLEANVALUE = 'booleanValue',
  /** column name */
  CUSTOMFIELDCHOICEID = 'customFieldChoiceId',
  /** column name */
  CUSTOMFIELDCOREDATAID = 'customFieldCoreDataId',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  FILEID = 'fileId',
  /** column name */
  NUMBERVALUE = 'numberValue',
  /** column name */
  USERID = 'userId',
  /** column name */
  VALUE = 'value'
}

/** aggregate var_pop on columns */
export type CustomFieldValuesVarPopFields = {
  __typename?: 'custom_field_values_var_pop_fields';
  numberValue: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type CustomFieldValuesVarSampFields = {
  __typename?: 'custom_field_values_var_samp_fields';
  numberValue: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type CustomFieldValuesVarianceFields = {
  __typename?: 'custom_field_values_variance_fields';
  numberValue: Maybe<Scalars['Float']['output']>;
};

/** Custom fields config that is shared across all suppliers in an organisation */
export type CustomFields = {
  __typename?: 'custom_fields';
  allowUserToAddCustomOptions: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  choices: Array<CustomFieldChoices>;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  customCoreData: Maybe<CustomCoreData>;
  customCoreDataId: Maybe<Scalars['uuid']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  dependentCustomFields: Array<CustomFields>;
  /** An object relationship */
  dependsOnCustomField: Maybe<CustomFields>;
  dependsOnCustomFieldId: Maybe<Scalars['uuid']['output']>;
  entityType: Scalars['customFieldsEntityType']['output'];
  externalSource: Maybe<Scalars['customFieldsCoreDataExternalSourceType']['output']>;
  id: Scalars['uuid']['output'];
  isRequired: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  organisationIntegration: Maybe<OrganisationIntegrations>;
  organisationIntegrationId: Maybe<Scalars['uuid']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['customFieldsType']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  values: Array<CustomFieldValues>;
  /** An aggregate relationship */
  values_aggregate: CustomFieldValuesAggregate;
};

/** input type for inserting array relation for remote table "custom_fields" */
export type CustomFieldsArrRelInsertInput = {
  data: Array<CustomFieldsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<CustomFieldsOnConflict>;
};

/** Boolean expression to filter rows from the table "custom_fields". All fields are combined with a logical 'AND'. */
export type CustomFieldsBoolExp = {
  _and?: InputMaybe<Array<CustomFieldsBoolExp>>;
  _not?: InputMaybe<CustomFieldsBoolExp>;
  _or?: InputMaybe<Array<CustomFieldsBoolExp>>;
  allowUserToAddCustomOptions?: InputMaybe<BooleanComparisonExp>;
  choices?: InputMaybe<CustomFieldChoicesBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customCoreData?: InputMaybe<CustomCoreDataBoolExp>;
  customCoreDataId?: InputMaybe<UuidComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  dependentCustomFields?: InputMaybe<CustomFieldsBoolExp>;
  dependsOnCustomField?: InputMaybe<CustomFieldsBoolExp>;
  dependsOnCustomFieldId?: InputMaybe<UuidComparisonExp>;
  entityType?: InputMaybe<StringComparisonExp>;
  externalSource?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isRequired?: InputMaybe<BooleanComparisonExp>;
  key?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsBoolExp>;
  organisationIntegrationId?: InputMaybe<UuidComparisonExp>;
  remoteId?: InputMaybe<StringComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  values?: InputMaybe<CustomFieldValuesBoolExp>;
  values_aggregate?: InputMaybe<CustomFieldValuesAggregateBoolExp>;
};

/** unique or primary key constraints on table "custom_fields" */
export enum CustomFieldsConstraint {
  /** unique or primary key constraint on columns "entity_type", "deleted_at", "key", "organisation_id" */
  CUSTOM_FIELDS_KEY_ORGANISATION_ID_DELETED_AT_ENTITY_TYPE_KEY = 'custom_fields_key_organisation_id_deleted_at_entity_type_key',
  /** unique or primary key constraint on columns "entity_type", "remote_id", "organisation_integration_id" */
  CUSTOM_FIELDS_REMOTE_ID_ORG_INTEGRATION_ENTITY_TYPE_ACTIVE_UNIQ = 'custom_fields_remote_id_org_integration_entity_type_active_uniq',
  /** unique or primary key constraint on columns "entity_type", "remote_id", "organisation_id" */
  CUSTOM_FIELDS_REMOTE_ID_ORGANISATION_ID_ENTITY_TYPE_ACTIVE_UNIQ = 'custom_fields_remote_id_organisation_id_entity_type_active_uniq',
  /** unique or primary key constraint on columns "id" */
  ORGANISATION_CUSTOM_FIELDS_PKEY = 'organisation_custom_fields_pkey',
  /** unique or primary key constraint on columns "entity_type", "key", "organisation_id" */
  UNIQUE_CUSTOM_FIELD_KEY_PER_ORGANISATION_AND_DELETED_AT = 'unique_custom_field_key_per_organisation_and_deleted_at',
  /** unique or primary key constraint on columns "entity_type", "deleted_at", "organisation_id", "title" */
  UNIQUE_CUSTOM_FIELD_TITLE_PER_ORGANISATION_AND_DELETED_AT = 'unique_custom_field_title_per_organisation_and_deleted_at'
}

/** input type for inserting data into table "custom_fields" */
export type CustomFieldsInsertInput = {
  allowUserToAddCustomOptions?: InputMaybe<Scalars['Boolean']['input']>;
  choices?: InputMaybe<CustomFieldChoicesArrRelInsertInput>;
  customCoreData?: InputMaybe<CustomCoreDataObjRelInsertInput>;
  customCoreDataId?: InputMaybe<Scalars['uuid']['input']>;
  dependentCustomFields?: InputMaybe<CustomFieldsArrRelInsertInput>;
  dependsOnCustomField?: InputMaybe<CustomFieldsObjRelInsertInput>;
  entityType: Scalars['customFieldsEntityType']['input'];
  externalSource?: InputMaybe<Scalars['customFieldsCoreDataExternalSourceType']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsObjRelInsertInput>;
  organisationIntegrationId?: InputMaybe<Scalars['uuid']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['customFieldsType']['input'];
  values?: InputMaybe<CustomFieldValuesArrRelInsertInput>;
};

/** input type for inserting object relation for remote table "custom_fields" */
export type CustomFieldsObjRelInsertInput = {
  data: CustomFieldsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CustomFieldsOnConflict>;
};

/** on_conflict condition type for table "custom_fields" */
export type CustomFieldsOnConflict = {
  constraint: CustomFieldsConstraint;
  update_columns: Array<CustomFieldsUpdateColumn>;
  where?: InputMaybe<CustomFieldsBoolExp>;
};

/** update columns of table "custom_fields" */
export enum CustomFieldsUpdateColumn {
  /** column name */
  ALLOWUSERTOADDCUSTOMOPTIONS = 'allowUserToAddCustomOptions',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ISREQUIRED = 'isRequired',
  /** column name */
  ORGANISATIONINTEGRATIONID = 'organisationIntegrationId',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  TITLE = 'title'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type DateComparisonExp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** columns and relationships of "departments" */
export type Departments = {
  __typename?: 'departments';
  archivedBy: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  coreData: CoreData;
  coreDataId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organisationId: Scalars['uuid']['output'];
  remoteId: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "departments". All fields are combined with a logical 'AND'. */
export type DepartmentsBoolExp = {
  _and?: InputMaybe<Array<DepartmentsBoolExp>>;
  _not?: InputMaybe<DepartmentsBoolExp>;
  _or?: InputMaybe<Array<DepartmentsBoolExp>>;
  archivedBy?: InputMaybe<StringComparisonExp>;
  coreData?: InputMaybe<CoreDataBoolExp>;
  coreDataId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isArchived?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  remoteId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "departments" */
export enum DepartmentsConstraint {
  /** unique or primary key constraint on columns "id" */
  DEPARTMENTS_PKEY = 'departments_pkey',
  /** unique or primary key constraint on columns "remote_id", "organisation_id" */
  DEPARTMENTS_REMOTE_ID_ORGANISATION_ID_KEY = 'departments_remote_id_organisation_id_key'
}

/** input type for inserting data into table "departments" */
export type DepartmentsInsertInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting object relation for remote table "departments" */
export type DepartmentsObjRelInsertInput = {
  data: DepartmentsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<DepartmentsOnConflict>;
};

/** on_conflict condition type for table "departments" */
export type DepartmentsOnConflict = {
  constraint: DepartmentsConstraint;
  update_columns: Array<DepartmentsUpdateColumn>;
  where?: InputMaybe<DepartmentsBoolExp>;
};

/** update columns of table "departments" */
export enum DepartmentsUpdateColumn {
  /** column name */
  ARCHIVEDBY = 'archivedBy',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  NAME = 'name',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** columns and relationships of "document_types" */
export type DocumentTypes = {
  __typename?: 'document_types';
  attributes: Scalars['jsonb']['output'];
  createdAt: Scalars['timestamptz']['output'];
  description: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** columns and relationships of "documents" */
export type Documents = {
  __typename?: 'documents';
  /** An array relationship */
  agreement_documents: Array<AgreementDocuments>;
  createdAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  customFieldValues: Array<CustomFieldValues>;
  /** An aggregate relationship */
  customFieldValues_aggregate: CustomFieldValuesAggregate;
  customType: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  customTypeValue: Maybe<CustomDocumentTypes>;
  fileName: Scalars['String']['output'];
  filestoreId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  organisationProductId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  product: Maybe<OrganisationProductsAndServices>;
  requestDocumentsId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  sourceRequestDocument: Maybe<RequestDocuments>;
  /** An object relationship */
  supplier: Maybe<OrganisationSuppliers>;
  updatedAt: Scalars['timestamptz']['output'];
  uploadedBy: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  uploadedByUser: Maybe<Users>;
};

/** aggregated selection of "documents" */
export type DocumentsAggregate = {
  __typename?: 'documents_aggregate';
  aggregate: Maybe<DocumentsAggregateFields>;
  nodes: Array<Documents>;
};

export type DocumentsAggregateBoolExp = {
  count?: InputMaybe<DocumentsAggregateBoolExpCount>;
};

export type DocumentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<DocumentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<DocumentsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "documents" */
export type DocumentsAggregateFields = {
  __typename?: 'documents_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<DocumentsMaxFields>;
  min: Maybe<DocumentsMinFields>;
};

/** input type for inserting array relation for remote table "documents" */
export type DocumentsArrRelInsertInput = {
  data: Array<DocumentsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<DocumentsOnConflict>;
};

/** Boolean expression to filter rows from the table "documents". All fields are combined with a logical 'AND'. */
export type DocumentsBoolExp = {
  _and?: InputMaybe<Array<DocumentsBoolExp>>;
  _not?: InputMaybe<DocumentsBoolExp>;
  _or?: InputMaybe<Array<DocumentsBoolExp>>;
  agreement_documents?: InputMaybe<AgreementDocumentsBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customFieldValues?: InputMaybe<CustomFieldValuesBoolExp>;
  customFieldValues_aggregate?: InputMaybe<CustomFieldValuesAggregateBoolExp>;
  customType?: InputMaybe<UuidComparisonExp>;
  customTypeValue?: InputMaybe<CustomDocumentTypesBoolExp>;
  fileName?: InputMaybe<StringComparisonExp>;
  filestoreId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisationProductId?: InputMaybe<UuidComparisonExp>;
  organisationSupplierId?: InputMaybe<UuidComparisonExp>;
  product?: InputMaybe<OrganisationProductsAndServicesBoolExp>;
  requestDocumentsId?: InputMaybe<UuidComparisonExp>;
  sourceRequestDocument?: InputMaybe<RequestDocumentsBoolExp>;
  supplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  uploadedBy?: InputMaybe<UuidComparisonExp>;
  uploadedByUser?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "documents" */
export enum DocumentsConstraint {
  /** unique or primary key constraint on columns "filestore_id" */
  DOCUMENTS_FILESTORE_ID_KEY = 'documents_filestore_id_key',
  /** unique or primary key constraint on columns "id" */
  DOCUMENTS_PKEY = 'documents_pkey'
}

/** input type for inserting data into table "documents" */
export type DocumentsInsertInput = {
  agreement_documents?: InputMaybe<AgreementDocumentsArrRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customFieldValues?: InputMaybe<CustomFieldValuesArrRelInsertInput>;
  customType?: InputMaybe<Scalars['uuid']['input']>;
  customTypeValue?: InputMaybe<CustomDocumentTypesObjRelInsertInput>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  filestoreId?: InputMaybe<Scalars['uuid']['input']>;
  organisationProductId?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  product?: InputMaybe<OrganisationProductsAndServicesObjRelInsertInput>;
  requestDocumentsId?: InputMaybe<Scalars['uuid']['input']>;
  sourceRequestDocument?: InputMaybe<RequestDocumentsObjRelInsertInput>;
  supplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  uploadedBy?: InputMaybe<Scalars['uuid']['input']>;
  uploadedByUser?: InputMaybe<UsersObjRelInsertInput>;
};

/** aggregate max on columns */
export type DocumentsMaxFields = {
  __typename?: 'documents_max_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  customType: Maybe<Scalars['uuid']['output']>;
  fileName: Maybe<Scalars['String']['output']>;
  filestoreId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  organisationProductId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  requestDocumentsId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  uploadedBy: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type DocumentsMinFields = {
  __typename?: 'documents_min_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  customType: Maybe<Scalars['uuid']['output']>;
  fileName: Maybe<Scalars['String']['output']>;
  filestoreId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  organisationProductId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  requestDocumentsId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  uploadedBy: Maybe<Scalars['uuid']['output']>;
};

/** input type for inserting object relation for remote table "documents" */
export type DocumentsObjRelInsertInput = {
  data: DocumentsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<DocumentsOnConflict>;
};

/** on_conflict condition type for table "documents" */
export type DocumentsOnConflict = {
  constraint: DocumentsConstraint;
  update_columns: Array<DocumentsUpdateColumn>;
  where?: InputMaybe<DocumentsBoolExp>;
};

/** select columns of table "documents" */
export enum DocumentsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CUSTOMTYPE = 'customType',
  /** column name */
  FILENAME = 'fileName',
  /** column name */
  FILESTOREID = 'filestoreId',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  ORGANISATIONPRODUCTID = 'organisationProductId',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  REQUESTDOCUMENTSID = 'requestDocumentsId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  UPLOADEDBY = 'uploadedBy'
}

/** update columns of table "documents" */
export enum DocumentsUpdateColumn {
  /** column name */
  CUSTOMTYPE = 'customType',
  /** column name */
  FILENAME = 'fileName',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** columns and relationships of "engagements" */
export type Engagements = {
  __typename?: 'engagements';
  buyerLegalEntity: Maybe<Scalars['String']['output']>;
  category: Maybe<CategoryEnum>;
  created_at: Maybe<Scalars['timestamptz']['output']>;
  customFields: Maybe<Scalars['jsonb']['output']>;
  deleted_at: Maybe<Scalars['timestamptz']['output']>;
  department: Maybe<Scalars['String']['output']>;
  departmentId: Maybe<Scalars['uuid']['output']>;
  description: Maybe<Scalars['String']['output']>;
  externalLink: Maybe<Scalars['String']['output']>;
  files: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  financial: Maybe<Financials>;
  financialsId: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  internal_contacts: Array<InternalContacts>;
  name: Scalars['String']['output'];
  netsuiteExternalId: Maybe<Scalars['Int']['output']>;
  note: Maybe<Scalars['String']['output']>;
  organisationProductOrServiceId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Scalars['uuid']['output'];
  /** An object relationship */
  organisation_products_and_service: Maybe<OrganisationProductsAndServices>;
  /** An object relationship */
  organisation_supplier: OrganisationSuppliers;
  purchaseOrderNumber: Maybe<Scalars['String']['output']>;
  subsidiaryId: Maybe<Scalars['uuid']['output']>;
  supplierLegalEntity: Maybe<Scalars['String']['output']>;
  tags: Maybe<Scalars['jsonb']['output']>;
  updated_at: Maybe<Scalars['timestamptz']['output']>;
  website: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "engagements" */
export type EngagementsAggregate = {
  __typename?: 'engagements_aggregate';
  aggregate: Maybe<EngagementsAggregateFields>;
  nodes: Array<Engagements>;
};

export type EngagementsAggregateBoolExp = {
  count?: InputMaybe<EngagementsAggregateBoolExpCount>;
};

export type EngagementsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EngagementsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EngagementsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "engagements" */
export type EngagementsAggregateFields = {
  __typename?: 'engagements_aggregate_fields';
  avg: Maybe<EngagementsAvgFields>;
  count: Scalars['Int']['output'];
  max: Maybe<EngagementsMaxFields>;
  min: Maybe<EngagementsMinFields>;
  stddev: Maybe<EngagementsStddevFields>;
  stddev_pop: Maybe<EngagementsStddevPopFields>;
  stddev_samp: Maybe<EngagementsStddevSampFields>;
  sum: Maybe<EngagementsSumFields>;
  var_pop: Maybe<EngagementsVarPopFields>;
  var_samp: Maybe<EngagementsVarSampFields>;
  variance: Maybe<EngagementsVarianceFields>;
};

/** input type for inserting array relation for remote table "engagements" */
export type EngagementsArrRelInsertInput = {
  data: Array<EngagementsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<EngagementsOnConflict>;
};

/** aggregate avg on columns */
export type EngagementsAvgFields = {
  __typename?: 'engagements_avg_fields';
  netsuiteExternalId: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "engagements". All fields are combined with a logical 'AND'. */
export type EngagementsBoolExp = {
  _and?: InputMaybe<Array<EngagementsBoolExp>>;
  _not?: InputMaybe<EngagementsBoolExp>;
  _or?: InputMaybe<Array<EngagementsBoolExp>>;
  buyerLegalEntity?: InputMaybe<StringComparisonExp>;
  category?: InputMaybe<CategoryEnumComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  customFields?: InputMaybe<JsonbComparisonExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  department?: InputMaybe<StringComparisonExp>;
  departmentId?: InputMaybe<UuidComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  externalLink?: InputMaybe<StringComparisonExp>;
  files?: InputMaybe<JsonbComparisonExp>;
  financial?: InputMaybe<FinancialsBoolExp>;
  financialsId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  internal_contacts?: InputMaybe<InternalContactsBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  netsuiteExternalId?: InputMaybe<IntComparisonExp>;
  note?: InputMaybe<StringComparisonExp>;
  organisationProductOrServiceId?: InputMaybe<UuidComparisonExp>;
  organisationSupplierId?: InputMaybe<UuidComparisonExp>;
  organisation_products_and_service?: InputMaybe<OrganisationProductsAndServicesBoolExp>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  purchaseOrderNumber?: InputMaybe<StringComparisonExp>;
  subsidiaryId?: InputMaybe<UuidComparisonExp>;
  supplierLegalEntity?: InputMaybe<StringComparisonExp>;
  tags?: InputMaybe<JsonbComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  website?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "engagements" */
export enum EngagementsConstraint {
  /** unique or primary key constraint on columns "financials_id" */
  ENGAGEMENTS_FINANCIALS_ID_KEY = 'engagements_financials_id_key',
  /** unique or primary key constraint on columns "id" */
  ENGAGEMENTS_PKEY = 'engagements_pkey'
}

/** input type for inserting data into table "engagements" */
export type EngagementsInsertInput = {
  buyerLegalEntity?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<CategoryEnum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  customFields?: InputMaybe<Scalars['jsonb']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  departmentId?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Scalars['jsonb']['input']>;
  financial?: InputMaybe<FinancialsObjRelInsertInput>;
  financialsId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internal_contacts?: InputMaybe<InternalContactsArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  netsuiteExternalId?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  organisationProductOrServiceId?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  organisation_products_and_service?: InputMaybe<OrganisationProductsAndServicesObjRelInsertInput>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  subsidiaryId?: InputMaybe<Scalars['uuid']['input']>;
  supplierLegalEntity?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type EngagementsMaxFields = {
  __typename?: 'engagements_max_fields';
  buyerLegalEntity: Maybe<Scalars['String']['output']>;
  created_at: Maybe<Scalars['timestamptz']['output']>;
  deleted_at: Maybe<Scalars['timestamptz']['output']>;
  department: Maybe<Scalars['String']['output']>;
  departmentId: Maybe<Scalars['uuid']['output']>;
  description: Maybe<Scalars['String']['output']>;
  externalLink: Maybe<Scalars['String']['output']>;
  financialsId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  netsuiteExternalId: Maybe<Scalars['Int']['output']>;
  note: Maybe<Scalars['String']['output']>;
  organisationProductOrServiceId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  purchaseOrderNumber: Maybe<Scalars['String']['output']>;
  subsidiaryId: Maybe<Scalars['uuid']['output']>;
  supplierLegalEntity: Maybe<Scalars['String']['output']>;
  updated_at: Maybe<Scalars['timestamptz']['output']>;
  website: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type EngagementsMinFields = {
  __typename?: 'engagements_min_fields';
  buyerLegalEntity: Maybe<Scalars['String']['output']>;
  created_at: Maybe<Scalars['timestamptz']['output']>;
  deleted_at: Maybe<Scalars['timestamptz']['output']>;
  department: Maybe<Scalars['String']['output']>;
  departmentId: Maybe<Scalars['uuid']['output']>;
  description: Maybe<Scalars['String']['output']>;
  externalLink: Maybe<Scalars['String']['output']>;
  financialsId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  netsuiteExternalId: Maybe<Scalars['Int']['output']>;
  note: Maybe<Scalars['String']['output']>;
  organisationProductOrServiceId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  purchaseOrderNumber: Maybe<Scalars['String']['output']>;
  subsidiaryId: Maybe<Scalars['uuid']['output']>;
  supplierLegalEntity: Maybe<Scalars['String']['output']>;
  updated_at: Maybe<Scalars['timestamptz']['output']>;
  website: Maybe<Scalars['String']['output']>;
};

/** input type for inserting object relation for remote table "engagements" */
export type EngagementsObjRelInsertInput = {
  data: EngagementsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<EngagementsOnConflict>;
};

/** on_conflict condition type for table "engagements" */
export type EngagementsOnConflict = {
  constraint: EngagementsConstraint;
  update_columns: Array<EngagementsUpdateColumn>;
  where?: InputMaybe<EngagementsBoolExp>;
};

/** select columns of table "engagements" */
export enum EngagementsSelectColumn {
  /** column name */
  BUYERLEGALENTITY = 'buyerLegalEntity',
  /** column name */
  CATEGORY = 'category',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CUSTOMFIELDS = 'customFields',
  /** column name */
  DELETED_AT = 'deleted_at',
  /** column name */
  DEPARTMENT = 'department',
  /** column name */
  DEPARTMENTID = 'departmentId',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  EXTERNALLINK = 'externalLink',
  /** column name */
  FILES = 'files',
  /** column name */
  FINANCIALSID = 'financialsId',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  NETSUITEEXTERNALID = 'netsuiteExternalId',
  /** column name */
  NOTE = 'note',
  /** column name */
  ORGANISATIONPRODUCTORSERVICEID = 'organisationProductOrServiceId',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  PURCHASEORDERNUMBER = 'purchaseOrderNumber',
  /** column name */
  SUBSIDIARYID = 'subsidiaryId',
  /** column name */
  SUPPLIERLEGALENTITY = 'supplierLegalEntity',
  /** column name */
  TAGS = 'tags',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  WEBSITE = 'website'
}

/** aggregate stddev on columns */
export type EngagementsStddevFields = {
  __typename?: 'engagements_stddev_fields';
  netsuiteExternalId: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type EngagementsStddevPopFields = {
  __typename?: 'engagements_stddev_pop_fields';
  netsuiteExternalId: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type EngagementsStddevSampFields = {
  __typename?: 'engagements_stddev_samp_fields';
  netsuiteExternalId: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type EngagementsSumFields = {
  __typename?: 'engagements_sum_fields';
  netsuiteExternalId: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "engagements" */
export enum EngagementsUpdateColumn {
  /** column name */
  BUYERLEGALENTITY = 'buyerLegalEntity',
  /** column name */
  CATEGORY = 'category',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CUSTOMFIELDS = 'customFields',
  /** column name */
  DELETED_AT = 'deleted_at',
  /** column name */
  DEPARTMENT = 'department',
  /** column name */
  DEPARTMENTID = 'departmentId',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  EXTERNALLINK = 'externalLink',
  /** column name */
  FILES = 'files',
  /** column name */
  FINANCIALSID = 'financialsId',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  NETSUITEEXTERNALID = 'netsuiteExternalId',
  /** column name */
  NOTE = 'note',
  /** column name */
  ORGANISATIONPRODUCTORSERVICEID = 'organisationProductOrServiceId',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  PURCHASEORDERNUMBER = 'purchaseOrderNumber',
  /** column name */
  SUBSIDIARYID = 'subsidiaryId',
  /** column name */
  SUPPLIERLEGALENTITY = 'supplierLegalEntity',
  /** column name */
  TAGS = 'tags',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  WEBSITE = 'website'
}

/** aggregate var_pop on columns */
export type EngagementsVarPopFields = {
  __typename?: 'engagements_var_pop_fields';
  netsuiteExternalId: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type EngagementsVarSampFields = {
  __typename?: 'engagements_var_samp_fields';
  netsuiteExternalId: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type EngagementsVarianceFields = {
  __typename?: 'engagements_variance_fields';
  netsuiteExternalId: Maybe<Scalars['Float']['output']>;
};

/** Junction table between bank_details, suppliers, supplier_profiles */
export type EntityBankDetails = {
  __typename?: 'entity_bank_details';
  /** An object relationship */
  bankDetails: BankDetails;
  bankDetailsId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  isPrimary: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  organisationSupplier: Maybe<OrganisationSuppliers>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  organisationSupplierProfile: Maybe<OrganisationSupplierProfiles>;
  organisationSupplierProfileId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "entity_bank_details" */
export type EntityBankDetailsAggregate = {
  __typename?: 'entity_bank_details_aggregate';
  aggregate: Maybe<EntityBankDetailsAggregateFields>;
  nodes: Array<EntityBankDetails>;
};

export type EntityBankDetailsAggregateBoolExp = {
  bool_and?: InputMaybe<EntityBankDetailsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<EntityBankDetailsAggregateBoolExpBoolOr>;
  count?: InputMaybe<EntityBankDetailsAggregateBoolExpCount>;
};

export type EntityBankDetailsAggregateBoolExpBoolAnd = {
  arguments: EntityBankDetailsSelectColumnEntityBankDetailsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EntityBankDetailsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type EntityBankDetailsAggregateBoolExpBoolOr = {
  arguments: EntityBankDetailsSelectColumnEntityBankDetailsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EntityBankDetailsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type EntityBankDetailsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EntityBankDetailsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EntityBankDetailsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "entity_bank_details" */
export type EntityBankDetailsAggregateFields = {
  __typename?: 'entity_bank_details_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<EntityBankDetailsMaxFields>;
  min: Maybe<EntityBankDetailsMinFields>;
};

/** input type for inserting array relation for remote table "entity_bank_details" */
export type EntityBankDetailsArrRelInsertInput = {
  data: Array<EntityBankDetailsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<EntityBankDetailsOnConflict>;
};

/** Boolean expression to filter rows from the table "entity_bank_details". All fields are combined with a logical 'AND'. */
export type EntityBankDetailsBoolExp = {
  _and?: InputMaybe<Array<EntityBankDetailsBoolExp>>;
  _not?: InputMaybe<EntityBankDetailsBoolExp>;
  _or?: InputMaybe<Array<EntityBankDetailsBoolExp>>;
  bankDetails?: InputMaybe<BankDetailsBoolExp>;
  bankDetailsId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isPrimary?: InputMaybe<BooleanComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisationSupplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  organisationSupplierId?: InputMaybe<UuidComparisonExp>;
  organisationSupplierProfile?: InputMaybe<OrganisationSupplierProfilesBoolExp>;
  organisationSupplierProfileId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "entity_bank_details" */
export enum EntityBankDetailsConstraint {
  /** unique or primary key constraint on columns "id" */
  ENTITY_BANK_DETAILS_PKEY = 'entity_bank_details_pkey',
  /** unique or primary key constraint on columns "organisation_supplier_profile_id" */
  IDX_PRIMARY_BANK_ACCOUNT_PER_PROFILE = 'idx_primary_bank_account_per_profile',
  /** unique or primary key constraint on columns "organisation_supplier_id" */
  IDX_PRIMARY_BANK_ACCOUNT_PER_SUPPLIER = 'idx_primary_bank_account_per_supplier',
  /** unique or primary key constraint on columns "bank_details_id", "organisation_supplier_id" */
  UNIQUE_BANK_DETAILS_SUPPLIER = 'unique_bank_details_supplier',
  /** unique or primary key constraint on columns "organisation_supplier_profile_id", "bank_details_id" */
  UNIQUE_BANK_DETAILS_SUPPLIER_PROFILE = 'unique_bank_details_supplier_profile'
}

/** input type for inserting data into table "entity_bank_details" */
export type EntityBankDetailsInsertInput = {
  bankDetails?: InputMaybe<BankDetailsObjRelInsertInput>;
  bankDetailsId?: InputMaybe<Scalars['uuid']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  organisationSupplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierProfile?: InputMaybe<OrganisationSupplierProfilesObjRelInsertInput>;
  organisationSupplierProfileId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type EntityBankDetailsMaxFields = {
  __typename?: 'entity_bank_details_max_fields';
  bankDetailsId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierProfileId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type EntityBankDetailsMinFields = {
  __typename?: 'entity_bank_details_min_fields';
  bankDetailsId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierProfileId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** on_conflict condition type for table "entity_bank_details" */
export type EntityBankDetailsOnConflict = {
  constraint: EntityBankDetailsConstraint;
  update_columns: Array<EntityBankDetailsUpdateColumn>;
  where?: InputMaybe<EntityBankDetailsBoolExp>;
};

/** select columns of table "entity_bank_details" */
export enum EntityBankDetailsSelectColumn {
  /** column name */
  BANKDETAILSID = 'bankDetailsId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ISPRIMARY = 'isPrimary',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  ORGANISATIONSUPPLIERPROFILEID = 'organisationSupplierProfileId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** select "entity_bank_details_aggregate_bool_exp_bool_and_arguments_columns" columns of table "entity_bank_details" */
export enum EntityBankDetailsSelectColumnEntityBankDetailsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  ISPRIMARY = 'isPrimary'
}

/** select "entity_bank_details_aggregate_bool_exp_bool_or_arguments_columns" columns of table "entity_bank_details" */
export enum EntityBankDetailsSelectColumnEntityBankDetailsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  ISPRIMARY = 'isPrimary'
}

/** update columns of table "entity_bank_details" */
export enum EntityBankDetailsUpdateColumn {
  /** column name */
  ISPRIMARY = 'isPrimary'
}

/** columns and relationships of "external_contacts" */
export type ExternalContacts = {
  __typename?: 'external_contacts';
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  email: Scalars['String']['output'];
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  isPrimary: Scalars['Boolean']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  organisation_id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation_supplier: OrganisationSuppliers;
  phoneNumber: Maybe<Scalars['String']['output']>;
  supplierId: Scalars['uuid']['output'];
  title: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Maybe<Users>;
  userId: Maybe<Scalars['uuid']['output']>;
};

/** input type for inserting array relation for remote table "external_contacts" */
export type ExternalContactsArrRelInsertInput = {
  data: Array<ExternalContactsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<ExternalContactsOnConflict>;
};

/** Boolean expression to filter rows from the table "external_contacts". All fields are combined with a logical 'AND'. */
export type ExternalContactsBoolExp = {
  _and?: InputMaybe<Array<ExternalContactsBoolExp>>;
  _not?: InputMaybe<ExternalContactsBoolExp>;
  _or?: InputMaybe<Array<ExternalContactsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  firstName?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isPrimary?: InputMaybe<BooleanComparisonExp>;
  lastName?: InputMaybe<StringComparisonExp>;
  organisation_id?: InputMaybe<UuidComparisonExp>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  phoneNumber?: InputMaybe<StringComparisonExp>;
  supplierId?: InputMaybe<UuidComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "external_contacts" */
export enum ExternalContactsConstraint {
  /** unique or primary key constraint on columns "id" */
  EXTERNAL_CONTACTS_PKEY = 'external_contacts_pkey',
  /** unique or primary key constraint on columns "supplier_id" */
  UNIQUE_NON_DELETED_PRIMARY_CONTACT_PER_SUPPLIER = 'unique_non_deleted_primary_contact_per_supplier'
}

/** input type for inserting data into table "external_contacts" */
export type ExternalContactsInsertInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** input type for inserting object relation for remote table "external_contacts" */
export type ExternalContactsObjRelInsertInput = {
  data: ExternalContactsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<ExternalContactsOnConflict>;
};

/** on_conflict condition type for table "external_contacts" */
export type ExternalContactsOnConflict = {
  constraint: ExternalContactsConstraint;
  update_columns: Array<ExternalContactsUpdateColumn>;
  where?: InputMaybe<ExternalContactsBoolExp>;
};

/** update columns of table "external_contacts" */
export enum ExternalContactsUpdateColumn {
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  EMAIL = 'email',
  /** column name */
  FIRSTNAME = 'firstName',
  /** column name */
  ISPRIMARY = 'isPrimary',
  /** column name */
  LASTNAME = 'lastName',
  /** column name */
  PHONENUMBER = 'phoneNumber',
  /** column name */
  SUPPLIERID = 'supplierId',
  /** column name */
  TITLE = 'title',
  /** column name */
  USERID = 'userId'
}

/** columns and relationships of "external_risk_scores" */
export type ExternalRiskScores = {
  __typename?: 'external_risk_scores';
  date: Scalars['date']['output'];
  externalProvider: Scalars['integration']['output'];
  files: Maybe<Array<Scalars['uploadedFileItem']['output']>>;
  id: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  organisationSupplierId: Scalars['uuid']['output'];
  requestId: Scalars['uuid']['output'];
  riskScore: Scalars['numeric']['output'];
};

/** Boolean expression to filter rows from the table "external_risk_scores". All fields are combined with a logical 'AND'. */
export type ExternalRiskScoresBoolExp = {
  _and?: InputMaybe<Array<ExternalRiskScoresBoolExp>>;
  _not?: InputMaybe<ExternalRiskScoresBoolExp>;
  _or?: InputMaybe<Array<ExternalRiskScoresBoolExp>>;
  date?: InputMaybe<DateComparisonExp>;
  externalProvider?: InputMaybe<StringComparisonExp>;
  files?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisationSupplierId?: InputMaybe<UuidComparisonExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  riskScore?: InputMaybe<NumericComparisonExp>;
};

/** unique or primary key constraints on table "external_risk_scores" */
export enum ExternalRiskScoresConstraint {
  /** unique or primary key constraint on columns "organisation_supplier_id" */
  EXTERNAL_RISK_SCORES_ORGANISATION_SUPPLIER_ID_KEY = 'external_risk_scores_organisation_supplier_id_key',
  /** unique or primary key constraint on columns "id" */
  EXTERNAL_RISK_SCORES_PKEY = 'external_risk_scores_pkey'
}

/** input type for inserting data into table "external_risk_scores" */
export type ExternalRiskScoresInsertInput = {
  date?: InputMaybe<Scalars['date']['input']>;
  externalProvider: Scalars['integration']['input'];
  files?: InputMaybe<Array<Scalars['uploadedFileItem']['input']>>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  riskScore?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting object relation for remote table "external_risk_scores" */
export type ExternalRiskScoresObjRelInsertInput = {
  data: ExternalRiskScoresInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<ExternalRiskScoresOnConflict>;
};

/** on_conflict condition type for table "external_risk_scores" */
export type ExternalRiskScoresOnConflict = {
  constraint: ExternalRiskScoresConstraint;
  update_columns: Array<ExternalRiskScoresUpdateColumn>;
  where?: InputMaybe<ExternalRiskScoresBoolExp>;
};

/** update columns of table "external_risk_scores" */
export enum ExternalRiskScoresUpdateColumn {
  /** column name */
  DATE = 'date',
  /** column name */
  EXTERNALPROVIDER = 'externalProvider',
  /** column name */
  FILES = 'files',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  RISKSCORE = 'riskScore'
}

/** columns and relationships of "favourite_table_filters" */
export type FavouriteTableFilters = {
  __typename?: 'favourite_table_filters';
  /** An object relationship */
  tableFilter: TableFilters;
  table_filter_id: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** input type for inserting array relation for remote table "favourite_table_filters" */
export type FavouriteTableFiltersArrRelInsertInput = {
  data: Array<FavouriteTableFiltersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<FavouriteTableFiltersOnConflict>;
};

/** Boolean expression to filter rows from the table "favourite_table_filters". All fields are combined with a logical 'AND'. */
export type FavouriteTableFiltersBoolExp = {
  _and?: InputMaybe<Array<FavouriteTableFiltersBoolExp>>;
  _not?: InputMaybe<FavouriteTableFiltersBoolExp>;
  _or?: InputMaybe<Array<FavouriteTableFiltersBoolExp>>;
  tableFilter?: InputMaybe<TableFiltersBoolExp>;
  table_filter_id?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  user_id?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "favourite_table_filters" */
export enum FavouriteTableFiltersConstraint {
  /** unique or primary key constraint on columns "user_id", "table_filter_id" */
  FAVOURITE_TABLE_FILTERS_PKEY = 'favourite_table_filters_pkey'
}

/** input type for inserting data into table "favourite_table_filters" */
export type FavouriteTableFiltersInsertInput = {
  tableFilter?: InputMaybe<TableFiltersObjRelInsertInput>;
  table_filter_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** on_conflict condition type for table "favourite_table_filters" */
export type FavouriteTableFiltersOnConflict = {
  constraint: FavouriteTableFiltersConstraint;
  update_columns: Array<FavouriteTableFiltersUpdateColumn>;
  where?: InputMaybe<FavouriteTableFiltersBoolExp>;
};

/** placeholder for update columns of table "favourite_table_filters" (current role has no relevant permissions) */
export enum FavouriteTableFiltersUpdateColumn {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

export { FeatureFlagsEnum } from '@omnea-app/packages/universal/feature-flags/featureFlags'

/** columns and relationships of "financials" */
export type Financials = {
  __typename?: 'financials';
  amount: Maybe<Scalars['numeric']['output']>;
  autoRenewal: Maybe<Scalars['Boolean']['output']>;
  budgetedValue: Maybe<Scalars['numeric']['output']>;
  cancellationNoticeDays: Maybe<Scalars['Int']['output']>;
  contractEnd: Maybe<Scalars['date']['output']>;
  contractPeriodEnd: Maybe<Scalars['date']['output']>;
  contractPeriodStart: Maybe<Scalars['date']['output']>;
  costCenter: Maybe<Scalars['String']['output']>;
  currency: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  engagement: Maybe<Engagements>;
  fxRate: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  note: Maybe<Scalars['String']['output']>;
  paymentInterval: Maybe<PaymentIntervalEnum>;
  /** An object relationship */
  paymentIntervalByPaymentInterval: Maybe<PaymentInterval>;
  paymentMethod: Maybe<Scalars['String']['output']>;
  paymentMethodId: Maybe<Scalars['uuid']['output']>;
  paymentType: Maybe<Scalars['String']['output']>;
  pricingModel: Maybe<Scalars['String']['output']>;
  purchaseDate: Maybe<Scalars['date']['output']>;
  purchaseType: Maybe<PurchaseTypeEnum>;
  /** An object relationship */
  purchaseTypeByPurchaseType: Maybe<PurchaseType>;
  renewalDate: Maybe<Scalars['date']['output']>;
  subscriptionStart: Maybe<Scalars['date']['output']>;
};

/** Boolean expression to filter rows from the table "financials". All fields are combined with a logical 'AND'. */
export type FinancialsBoolExp = {
  _and?: InputMaybe<Array<FinancialsBoolExp>>;
  _not?: InputMaybe<FinancialsBoolExp>;
  _or?: InputMaybe<Array<FinancialsBoolExp>>;
  amount?: InputMaybe<NumericComparisonExp>;
  autoRenewal?: InputMaybe<BooleanComparisonExp>;
  budgetedValue?: InputMaybe<NumericComparisonExp>;
  cancellationNoticeDays?: InputMaybe<IntComparisonExp>;
  contractEnd?: InputMaybe<DateComparisonExp>;
  contractPeriodEnd?: InputMaybe<DateComparisonExp>;
  contractPeriodStart?: InputMaybe<DateComparisonExp>;
  costCenter?: InputMaybe<StringComparisonExp>;
  currency?: InputMaybe<StringComparisonExp>;
  engagement?: InputMaybe<EngagementsBoolExp>;
  fxRate?: InputMaybe<NumericComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  note?: InputMaybe<StringComparisonExp>;
  paymentInterval?: InputMaybe<PaymentIntervalEnumComparisonExp>;
  paymentIntervalByPaymentInterval?: InputMaybe<PaymentIntervalBoolExp>;
  paymentMethod?: InputMaybe<StringComparisonExp>;
  paymentMethodId?: InputMaybe<UuidComparisonExp>;
  paymentType?: InputMaybe<StringComparisonExp>;
  pricingModel?: InputMaybe<StringComparisonExp>;
  purchaseDate?: InputMaybe<DateComparisonExp>;
  purchaseType?: InputMaybe<PurchaseTypeEnumComparisonExp>;
  purchaseTypeByPurchaseType?: InputMaybe<PurchaseTypeBoolExp>;
  renewalDate?: InputMaybe<DateComparisonExp>;
  subscriptionStart?: InputMaybe<DateComparisonExp>;
};

/** unique or primary key constraints on table "financials" */
export enum FinancialsConstraint {
  /** unique or primary key constraint on columns "id" */
  FINANCIALS_PKEY = 'financials_pkey'
}

/** input type for inserting data into table "financials" */
export type FinancialsInsertInput = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  autoRenewal?: InputMaybe<Scalars['Boolean']['input']>;
  budgetedValue?: InputMaybe<Scalars['numeric']['input']>;
  cancellationNoticeDays?: InputMaybe<Scalars['Int']['input']>;
  contractEnd?: InputMaybe<Scalars['date']['input']>;
  contractPeriodEnd?: InputMaybe<Scalars['date']['input']>;
  contractPeriodStart?: InputMaybe<Scalars['date']['input']>;
  costCenter?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  engagement?: InputMaybe<EngagementsObjRelInsertInput>;
  fxRate?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  paymentInterval?: InputMaybe<PaymentIntervalEnum>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['uuid']['input']>;
  paymentType?: InputMaybe<Scalars['String']['input']>;
  pricingModel?: InputMaybe<Scalars['String']['input']>;
  purchaseDate?: InputMaybe<Scalars['date']['input']>;
  purchaseType?: InputMaybe<PurchaseTypeEnum>;
  renewalDate?: InputMaybe<Scalars['date']['input']>;
  subscriptionStart?: InputMaybe<Scalars['date']['input']>;
};

/** input type for inserting object relation for remote table "financials" */
export type FinancialsObjRelInsertInput = {
  data: FinancialsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<FinancialsOnConflict>;
};

/** on_conflict condition type for table "financials" */
export type FinancialsOnConflict = {
  constraint: FinancialsConstraint;
  update_columns: Array<FinancialsUpdateColumn>;
  where?: InputMaybe<FinancialsBoolExp>;
};

/** update columns of table "financials" */
export enum FinancialsUpdateColumn {
  /** column name */
  AMOUNT = 'amount',
  /** column name */
  AUTORENEWAL = 'autoRenewal',
  /** column name */
  BUDGETEDVALUE = 'budgetedValue',
  /** column name */
  CANCELLATIONNOTICEDAYS = 'cancellationNoticeDays',
  /** column name */
  CONTRACTEND = 'contractEnd',
  /** column name */
  CONTRACTPERIODEND = 'contractPeriodEnd',
  /** column name */
  CONTRACTPERIODSTART = 'contractPeriodStart',
  /** column name */
  COSTCENTER = 'costCenter',
  /** column name */
  CURRENCY = 'currency',
  /** column name */
  FXRATE = 'fxRate',
  /** column name */
  ID = 'id',
  /** column name */
  NOTE = 'note',
  /** column name */
  PAYMENTINTERVAL = 'paymentInterval',
  /** column name */
  PAYMENTMETHOD = 'paymentMethod',
  /** column name */
  PAYMENTMETHODID = 'paymentMethodId',
  /** column name */
  PAYMENTTYPE = 'paymentType',
  /** column name */
  PRICINGMODEL = 'pricingModel',
  /** column name */
  PURCHASEDATE = 'purchaseDate',
  /** column name */
  PURCHASETYPE = 'purchaseType',
  /** column name */
  RENEWALDATE = 'renewalDate',
  /** column name */
  SUBSCRIPTIONSTART = 'subscriptionStart'
}

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8ComparisonExp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

/** columns and relationships of "form_template_question_insights" */
export type FormTemplateQuestionInsights = {
  __typename?: 'form_template_question_insights';
  category: Scalars['String']['output'];
  createdAt: Scalars['timestamptz']['output'];
  description: Scalars['String']['output'];
  /** An object relationship */
  formTemplate: Maybe<FormTemplates>;
  formTemplateId: Maybe<Scalars['uuid']['output']>;
  generationData: Scalars['jsonb']['output'];
  id: Scalars['uuid']['output'];
  questionName: Scalars['String']['output'];
  source: Scalars['String']['output'];
  status: Scalars['String']['output'];
  suggestion: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  updatedBy: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  updatedByUser: Maybe<Users>;
};

/** aggregated selection of "form_template_question_insights" */
export type FormTemplateQuestionInsightsAggregate = {
  __typename?: 'form_template_question_insights_aggregate';
  aggregate: Maybe<FormTemplateQuestionInsightsAggregateFields>;
  nodes: Array<FormTemplateQuestionInsights>;
};

export type FormTemplateQuestionInsightsAggregateBoolExp = {
  count?: InputMaybe<FormTemplateQuestionInsightsAggregateBoolExpCount>;
};

export type FormTemplateQuestionInsightsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<FormTemplateQuestionInsightsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<FormTemplateQuestionInsightsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "form_template_question_insights" */
export type FormTemplateQuestionInsightsAggregateFields = {
  __typename?: 'form_template_question_insights_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<FormTemplateQuestionInsightsMaxFields>;
  min: Maybe<FormTemplateQuestionInsightsMinFields>;
};

/** input type for inserting array relation for remote table "form_template_question_insights" */
export type FormTemplateQuestionInsightsArrRelInsertInput = {
  data: Array<FormTemplateQuestionInsightsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<FormTemplateQuestionInsightsOnConflict>;
};

/** Boolean expression to filter rows from the table "form_template_question_insights". All fields are combined with a logical 'AND'. */
export type FormTemplateQuestionInsightsBoolExp = {
  _and?: InputMaybe<Array<FormTemplateQuestionInsightsBoolExp>>;
  _not?: InputMaybe<FormTemplateQuestionInsightsBoolExp>;
  _or?: InputMaybe<Array<FormTemplateQuestionInsightsBoolExp>>;
  category?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  formTemplate?: InputMaybe<FormTemplatesBoolExp>;
  formTemplateId?: InputMaybe<UuidComparisonExp>;
  generationData?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  questionName?: InputMaybe<StringComparisonExp>;
  source?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  suggestion?: InputMaybe<StringComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedBy?: InputMaybe<UuidComparisonExp>;
  updatedByUser?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "form_template_question_insights" */
export enum FormTemplateQuestionInsightsConstraint {
  /** unique or primary key constraint on columns "id" */
  FORM_TEMPLATE_QUESTION_INSIGHTS_PKEY = 'form_template_question_insights_pkey'
}

/** input type for inserting data into table "form_template_question_insights" */
export type FormTemplateQuestionInsightsInsertInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  formTemplate?: InputMaybe<FormTemplatesObjRelInsertInput>;
  formTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  generationData?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  questionName?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  suggestion?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
  updatedByUser?: InputMaybe<UsersObjRelInsertInput>;
};

/** aggregate max on columns */
export type FormTemplateQuestionInsightsMaxFields = {
  __typename?: 'form_template_question_insights_max_fields';
  category: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  description: Maybe<Scalars['String']['output']>;
  formTemplateId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  questionName: Maybe<Scalars['String']['output']>;
  source: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  suggestion: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  updatedBy: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type FormTemplateQuestionInsightsMinFields = {
  __typename?: 'form_template_question_insights_min_fields';
  category: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  description: Maybe<Scalars['String']['output']>;
  formTemplateId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  questionName: Maybe<Scalars['String']['output']>;
  source: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  suggestion: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  updatedBy: Maybe<Scalars['uuid']['output']>;
};

/** on_conflict condition type for table "form_template_question_insights" */
export type FormTemplateQuestionInsightsOnConflict = {
  constraint: FormTemplateQuestionInsightsConstraint;
  update_columns: Array<FormTemplateQuestionInsightsUpdateColumn>;
  where?: InputMaybe<FormTemplateQuestionInsightsBoolExp>;
};

/** select columns of table "form_template_question_insights" */
export enum FormTemplateQuestionInsightsSelectColumn {
  /** column name */
  CATEGORY = 'category',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  FORMTEMPLATEID = 'formTemplateId',
  /** column name */
  GENERATIONDATA = 'generationData',
  /** column name */
  ID = 'id',
  /** column name */
  QUESTIONNAME = 'questionName',
  /** column name */
  SOURCE = 'source',
  /** column name */
  STATUS = 'status',
  /** column name */
  SUGGESTION = 'suggestion',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  UPDATEDBY = 'updatedBy'
}

/** update columns of table "form_template_question_insights" */
export enum FormTemplateQuestionInsightsUpdateColumn {
  /** column name */
  CATEGORY = 'category',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  FORMTEMPLATEID = 'formTemplateId',
  /** column name */
  GENERATIONDATA = 'generationData',
  /** column name */
  ID = 'id',
  /** column name */
  QUESTIONNAME = 'questionName',
  /** column name */
  SOURCE = 'source',
  /** column name */
  STATUS = 'status',
  /** column name */
  SUGGESTION = 'suggestion',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  UPDATEDBY = 'updatedBy'
}

export enum FormTemplateStateEnum {
  /** Archived */
  ARCHIVED = 'ARCHIVED',
  /** Draft */
  DRAFT = 'DRAFT',
  /** Published */
  PUBLISHED = 'PUBLISHED'
}

/** Boolean expression to compare columns of type "form_template_state_enum". All fields are combined with logical 'AND'. */
export type FormTemplateStateEnumComparisonExp = {
  _eq?: InputMaybe<FormTemplateStateEnum>;
  _in?: InputMaybe<Array<FormTemplateStateEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<FormTemplateStateEnum>;
  _nin?: InputMaybe<Array<FormTemplateStateEnum>>;
};

/** columns and relationships of "form_templates" */
export type FormTemplates = {
  __typename?: 'form_templates';
  config: Scalars['formConfig']['output'];
  createdAt: Scalars['timestamptz']['output'];
  createdBy: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  created_by_user: Maybe<Users>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  description: Scalars['String']['output'];
  externalTitle: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  integration: Maybe<Scalars['integration']['output']>;
  internalId: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organisation: Maybe<Organisations>;
  organisationId: Scalars['uuid']['output'];
  /** An array relationship */
  questionInsights: Array<FormTemplateQuestionInsights>;
  /** An aggregate relationship */
  questionInsights_aggregate: FormTemplateQuestionInsightsAggregate;
  /** An array relationship */
  request_forms: Array<RequestForms>;
  state: FormTemplateStateEnum;
  title: Scalars['String']['output'];
  type: FormTypeEnum;
  updatedAt: Scalars['timestamptz']['output'];
  updatedBy: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  updated_by_user: Maybe<Users>;
  /** An object relationship */
  user: Maybe<Users>;
};

/** Boolean expression to filter rows from the table "form_templates". All fields are combined with a logical 'AND'. */
export type FormTemplatesBoolExp = {
  _and?: InputMaybe<Array<FormTemplatesBoolExp>>;
  _not?: InputMaybe<FormTemplatesBoolExp>;
  _or?: InputMaybe<Array<FormTemplatesBoolExp>>;
  config?: InputMaybe<JsonbComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdBy?: InputMaybe<UuidComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  externalTitle?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  integration?: InputMaybe<StringComparisonExp>;
  internalId?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  questionInsights?: InputMaybe<FormTemplateQuestionInsightsBoolExp>;
  questionInsights_aggregate?: InputMaybe<FormTemplateQuestionInsightsAggregateBoolExp>;
  request_forms?: InputMaybe<RequestFormsBoolExp>;
  state?: InputMaybe<FormTemplateStateEnumComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<FormTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedBy?: InputMaybe<UuidComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  user?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "form_templates" */
export enum FormTemplatesConstraint {
  /** unique or primary key constraint on columns "organisation_id", "internal_id" */
  FORM_TEMPLATES_INTERNAL_ID_ORGANISATION_ID_KEY = 'form_templates_internal_id_organisation_id_key',
  /** unique or primary key constraint on columns "id" */
  FORM_TEMPLATES_PKEY = 'form_templates_pkey'
}

/** input type for inserting data into table "form_templates" */
export type FormTemplatesInsertInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  created_by_user?: InputMaybe<UsersObjRelInsertInput>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalTitle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  integration?: InputMaybe<Scalars['String']['input']>;
  internalId?: InputMaybe<Scalars['String']['input']>;
  questionInsights?: InputMaybe<FormTemplateQuestionInsightsArrRelInsertInput>;
  request_forms?: InputMaybe<RequestFormsArrRelInsertInput>;
  state?: InputMaybe<FormTemplateStateEnum>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FormTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
  updated_by_user?: InputMaybe<UsersObjRelInsertInput>;
  user?: InputMaybe<UsersObjRelInsertInput>;
};

/** input type for inserting object relation for remote table "form_templates" */
export type FormTemplatesObjRelInsertInput = {
  data: FormTemplatesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<FormTemplatesOnConflict>;
};

/** on_conflict condition type for table "form_templates" */
export type FormTemplatesOnConflict = {
  constraint: FormTemplatesConstraint;
  update_columns: Array<FormTemplatesUpdateColumn>;
  where?: InputMaybe<FormTemplatesBoolExp>;
};

/** update columns of table "form_templates" */
export enum FormTemplatesUpdateColumn {
  /** column name */
  CONFIG = 'config',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CREATEDBY = 'createdBy',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  EXTERNALTITLE = 'externalTitle',
  /** column name */
  ID = 'id',
  /** column name */
  STATE = 'state',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  UPDATEDBY = 'updatedBy'
}

/** columns and relationships of "form_type" */
export type FormType = {
  __typename?: 'form_type';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "form_type". All fields are combined with a logical 'AND'. */
export type FormTypeBoolExp = {
  _and?: InputMaybe<Array<FormTypeBoolExp>>;
  _not?: InputMaybe<FormTypeBoolExp>;
  _or?: InputMaybe<Array<FormTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum FormTypeEnum {
  /** Access request forms */
  ACCESS_REQUEST = 'ACCESS_REQUEST',
  /** Cancel Agreement Forms */
  CANCEL_AGREEMENT = 'CANCEL_AGREEMENT',
  /** Catalogue purchase forms */
  CATALOGUE_PURCHASE = 'CATALOGUE_PURCHASE',
  /** Details to commit to the supplier  */
  COMMIT_SUPPLIER_DATA = 'COMMIT_SUPPLIER_DATA',
  /** Agreement details  */
  CREATE_AGREEMENT = 'CREATE_AGREEMENT',
  /** Create Assessment Form */
  CREATE_ASSESSMENT = 'CREATE_ASSESSMENT',
  /** CREATE_ENGAGEMENT */
  CREATE_ENGAGEMENT = 'CREATE_ENGAGEMENT',
  /** Details to create a purchase order */
  CREATE_PURCHASE_ORDER = 'CREATE_PURCHASE_ORDER',
  /** Used as a base to create a renewal. Currently a hard coded form we clone when the task needs to be created. */
  CREATE_RENEWAL = 'CREATE_RENEWAL',
  /** External operation output forms */
  EXTERNAL_OPERATION = 'EXTERNAL_OPERATION',
  /** Intake Forms */
  INTAKE = 'INTAKE',
  /** Other */
  OTHER = 'OTHER',
  /** Renewal Assessment */
  RENEWAL_ASSESSMENT = 'RENEWAL_ASSESSMENT',
  /** RFx form */
  RFX = 'RFX',
  /** Supplier Onboarding Form */
  SUPPLIER_ONBOARDING = 'SUPPLIER_ONBOARDING'
}

/** Boolean expression to compare columns of type "form_type_enum". All fields are combined with logical 'AND'. */
export type FormTypeEnumComparisonExp = {
  _eq?: InputMaybe<FormTypeEnum>;
  _in?: InputMaybe<Array<FormTypeEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<FormTypeEnum>;
  _nin?: InputMaybe<Array<FormTypeEnum>>;
};

/** Keep track of group user assignments for a given request */
export type GroupUserAssignments = {
  __typename?: 'group_user_assignments';
  createdAt: Scalars['timestamptz']['output'];
  groupId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  method: Scalars['String']['output'];
  organisationId: Scalars['uuid']['output'];
  requestId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "group_user_assignments" */
export type GroupUserAssignmentsAggregate = {
  __typename?: 'group_user_assignments_aggregate';
  aggregate: Maybe<GroupUserAssignmentsAggregateFields>;
  nodes: Array<GroupUserAssignments>;
};

export type GroupUserAssignmentsAggregateBoolExp = {
  count?: InputMaybe<GroupUserAssignmentsAggregateBoolExpCount>;
};

export type GroupUserAssignmentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<GroupUserAssignmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<GroupUserAssignmentsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "group_user_assignments" */
export type GroupUserAssignmentsAggregateFields = {
  __typename?: 'group_user_assignments_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<GroupUserAssignmentsMaxFields>;
  min: Maybe<GroupUserAssignmentsMinFields>;
};

/** input type for inserting array relation for remote table "group_user_assignments" */
export type GroupUserAssignmentsArrRelInsertInput = {
  data: Array<GroupUserAssignmentsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<GroupUserAssignmentsOnConflict>;
};

/** Boolean expression to filter rows from the table "group_user_assignments". All fields are combined with a logical 'AND'. */
export type GroupUserAssignmentsBoolExp = {
  _and?: InputMaybe<Array<GroupUserAssignmentsBoolExp>>;
  _not?: InputMaybe<GroupUserAssignmentsBoolExp>;
  _or?: InputMaybe<Array<GroupUserAssignmentsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  method?: InputMaybe<StringComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "group_user_assignments" */
export enum GroupUserAssignmentsConstraint {
  /** unique or primary key constraint on columns "id" */
  GROUP_USER_ASSIGNMENTS_PKEY = 'group_user_assignments_pkey'
}

/** input type for inserting data into table "group_user_assignments" */
export type GroupUserAssignmentsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  groupId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  method?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type GroupUserAssignmentsMaxFields = {
  __typename?: 'group_user_assignments_max_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  groupId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  method: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  userId: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type GroupUserAssignmentsMinFields = {
  __typename?: 'group_user_assignments_min_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  groupId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  method: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  userId: Maybe<Scalars['uuid']['output']>;
};

/** on_conflict condition type for table "group_user_assignments" */
export type GroupUserAssignmentsOnConflict = {
  constraint: GroupUserAssignmentsConstraint;
  update_columns: Array<GroupUserAssignmentsUpdateColumn>;
  where?: InputMaybe<GroupUserAssignmentsBoolExp>;
};

/** select columns of table "group_user_assignments" */
export enum GroupUserAssignmentsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  GROUPID = 'groupId',
  /** column name */
  ID = 'id',
  /** column name */
  METHOD = 'method',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId'
}

/** update columns of table "group_user_assignments" */
export enum GroupUserAssignmentsUpdateColumn {
  /** column name */
  GROUPID = 'groupId',
  /** column name */
  ID = 'id',
  /** column name */
  METHOD = 'method',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  USERID = 'userId'
}

/** columns and relationships of "group_users" */
export type GroupUsers = {
  __typename?: 'group_users';
  /** An array relationship */
  assignments: Array<GroupUserAssignments>;
  /** An aggregate relationship */
  assignments_aggregate: GroupUserAssignmentsAggregate;
  /** An object relationship */
  group: Groups;
  groupId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** input type for inserting array relation for remote table "group_users" */
export type GroupUsersArrRelInsertInput = {
  data: Array<GroupUsersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<GroupUsersOnConflict>;
};

/** Boolean expression to filter rows from the table "group_users". All fields are combined with a logical 'AND'. */
export type GroupUsersBoolExp = {
  _and?: InputMaybe<Array<GroupUsersBoolExp>>;
  _not?: InputMaybe<GroupUsersBoolExp>;
  _or?: InputMaybe<Array<GroupUsersBoolExp>>;
  assignments?: InputMaybe<GroupUserAssignmentsBoolExp>;
  assignments_aggregate?: InputMaybe<GroupUserAssignmentsAggregateBoolExp>;
  group?: InputMaybe<GroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "group_users" */
export enum GroupUsersConstraint {
  /** unique or primary key constraint on columns "id" */
  GROUP_USERS_PKEY = 'group_users_pkey',
  /** unique or primary key constraint on columns "user_id", "group_id" */
  GROUP_USERS_USER_ID_GROUP_ID_KEY = 'group_users_user_id_group_id_key'
}

/** input type for inserting data into table "group_users" */
export type GroupUsersInsertInput = {
  assignments?: InputMaybe<GroupUserAssignmentsArrRelInsertInput>;
  group?: InputMaybe<GroupsObjRelInsertInput>;
  groupId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** on_conflict condition type for table "group_users" */
export type GroupUsersOnConflict = {
  constraint: GroupUsersConstraint;
  update_columns: Array<GroupUsersUpdateColumn>;
  where?: InputMaybe<GroupUsersBoolExp>;
};

/** update columns of table "group_users" */
export enum GroupUsersUpdateColumn {
  /** column name */
  GROUPID = 'groupId',
  /** column name */
  ID = 'id',
  /** column name */
  USERID = 'userId'
}

/** columns and relationships of "groups" */
export type Groups = {
  __typename?: 'groups';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  group_users: Array<GroupUsers>;
  id: Scalars['uuid']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  rawAttributes: Maybe<Scalars['jsonb']['output']>;
  /** An array relationship */
  request_groups: Array<RequestGroups>;
  /** An array relationship */
  request_step_groups: Array<RequestStepGroups>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** Boolean expression to filter rows from the table "groups". All fields are combined with a logical 'AND'. */
export type GroupsBoolExp = {
  _and?: InputMaybe<Array<GroupsBoolExp>>;
  _not?: InputMaybe<GroupsBoolExp>;
  _or?: InputMaybe<Array<GroupsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  group_users?: InputMaybe<GroupUsersBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isArchived?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  rawAttributes?: InputMaybe<JsonbComparisonExp>;
  request_groups?: InputMaybe<RequestGroupsBoolExp>;
  request_step_groups?: InputMaybe<RequestStepGroupsBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "groups" */
export enum GroupsConstraint {
  /** unique or primary key constraint on columns "id" */
  GROUPS_PKEY = 'groups_pkey'
}

/** input type for inserting data into table "groups" */
export type GroupsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  group_users?: InputMaybe<GroupUsersArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rawAttributes?: InputMaybe<Scalars['jsonb']['input']>;
  request_groups?: InputMaybe<RequestGroupsArrRelInsertInput>;
  request_step_groups?: InputMaybe<RequestStepGroupsArrRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** input type for inserting object relation for remote table "groups" */
export type GroupsObjRelInsertInput = {
  data: GroupsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<GroupsOnConflict>;
};

/** on_conflict condition type for table "groups" */
export type GroupsOnConflict = {
  constraint: GroupsConstraint;
  update_columns: Array<GroupsUpdateColumn>;
  where?: InputMaybe<GroupsBoolExp>;
};

/** update columns of table "groups" */
export enum GroupsUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  NAME = 'name',
  /** column name */
  RAWATTRIBUTES = 'rawAttributes',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** Supplier contacts that are linked to an org user */
export type InternalContacts = {
  __typename?: 'internal_contacts';
  agreementId: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  deleted_at: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  engagement: Maybe<Engagements>;
  engagementId: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  organisation_id: Scalars['uuid']['output'];
  /** An object relationship */
  product: Maybe<OrganisationProductsAndServices>;
  productId: Maybe<Scalars['uuid']['output']>;
  role: Scalars['internalContactsRole']['output'];
  /** An object relationship */
  supplier: OrganisationSuppliers;
  supplierId: Scalars['uuid']['output'];
  title: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** input type for inserting array relation for remote table "internal_contacts" */
export type InternalContactsArrRelInsertInput = {
  data: Array<InternalContactsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<InternalContactsOnConflict>;
};

/** Boolean expression to filter rows from the table "internal_contacts". All fields are combined with a logical 'AND'. */
export type InternalContactsBoolExp = {
  _and?: InputMaybe<Array<InternalContactsBoolExp>>;
  _not?: InputMaybe<InternalContactsBoolExp>;
  _or?: InputMaybe<Array<InternalContactsBoolExp>>;
  agreementId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  engagement?: InputMaybe<EngagementsBoolExp>;
  engagementId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation_id?: InputMaybe<UuidComparisonExp>;
  product?: InputMaybe<OrganisationProductsAndServicesBoolExp>;
  productId?: InputMaybe<UuidComparisonExp>;
  role?: InputMaybe<StringComparisonExp>;
  supplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  supplierId?: InputMaybe<UuidComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "internal_contacts" */
export enum InternalContactsConstraint {
  /** unique or primary key constraint on columns "id" */
  INTERNAL_CONTACTS_PKEY = 'internal_contacts_pkey'
}

/** input type for inserting data into table "internal_contacts" */
export type InternalContactsInsertInput = {
  agreementId?: InputMaybe<Scalars['uuid']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  engagement?: InputMaybe<EngagementsObjRelInsertInput>;
  engagementId?: InputMaybe<Scalars['uuid']['input']>;
  product?: InputMaybe<OrganisationProductsAndServicesObjRelInsertInput>;
  productId?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  supplierId?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** on_conflict condition type for table "internal_contacts" */
export type InternalContactsOnConflict = {
  constraint: InternalContactsConstraint;
  update_columns: Array<InternalContactsUpdateColumn>;
  where?: InputMaybe<InternalContactsBoolExp>;
};

/** update columns of table "internal_contacts" */
export enum InternalContactsUpdateColumn {
  /** column name */
  AGREEMENTID = 'agreementId',
  /** column name */
  DELETED_AT = 'deleted_at',
  /** column name */
  ENGAGEMENTID = 'engagementId',
  /** column name */
  PRODUCTID = 'productId',
  /** column name */
  ROLE = 'role',
  /** column name */
  SUPPLIERID = 'supplierId',
  /** column name */
  TITLE = 'title',
  /** column name */
  USERID = 'userId'
}

/** Boolean expression to compare columns of type "interval". All fields are combined with logical 'AND'. */
export type IntervalComparisonExp = {
  _eq?: InputMaybe<Scalars['interval']['input']>;
  _gt?: InputMaybe<Scalars['interval']['input']>;
  _gte?: InputMaybe<Scalars['interval']['input']>;
  _in?: InputMaybe<Array<Scalars['interval']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['interval']['input']>;
  _lte?: InputMaybe<Scalars['interval']['input']>;
  _neq?: InputMaybe<Scalars['interval']['input']>;
  _nin?: InputMaybe<Array<Scalars['interval']['input']>>;
};

export type JsonbCastExp = {
  String?: InputMaybe<StringComparisonExp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type JsonbComparisonExp = {
  _cast?: InputMaybe<JsonbCastExp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** columns and relationships of "line_item_types" */
export type LineItemTypes = {
  __typename?: 'line_item_types';
  archivedBy: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  coreData: CoreData;
  coreDataId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organisationId: Scalars['uuid']['output'];
  remoteId: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "line_item_types". All fields are combined with a logical 'AND'. */
export type LineItemTypesBoolExp = {
  _and?: InputMaybe<Array<LineItemTypesBoolExp>>;
  _not?: InputMaybe<LineItemTypesBoolExp>;
  _or?: InputMaybe<Array<LineItemTypesBoolExp>>;
  archivedBy?: InputMaybe<StringComparisonExp>;
  coreData?: InputMaybe<CoreDataBoolExp>;
  coreDataId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isArchived?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  remoteId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "line_item_types" */
export enum LineItemTypesConstraint {
  /** unique or primary key constraint on columns "id" */
  LINE_ITEM_TYPES_PKEY = 'line_item_types_pkey',
  /** unique or primary key constraint on columns "remote_id", "organisation_id" */
  LINE_ITEM_TYPES_REMOTE_ID_ORGANISATION_ID_KEY = 'line_item_types_remote_id_organisation_id_key'
}

/** input type for inserting data into table "line_item_types" */
export type LineItemTypesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** input type for inserting object relation for remote table "line_item_types" */
export type LineItemTypesObjRelInsertInput = {
  data: LineItemTypesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<LineItemTypesOnConflict>;
};

/** on_conflict condition type for table "line_item_types" */
export type LineItemTypesOnConflict = {
  constraint: LineItemTypesConstraint;
  update_columns: Array<LineItemTypesUpdateColumn>;
  where?: InputMaybe<LineItemTypesBoolExp>;
};

/** update columns of table "line_item_types" */
export enum LineItemTypesUpdateColumn {
  /** column name */
  ARCHIVEDBY = 'archivedBy',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  NAME = 'name',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** Boolean expression to compare columns of type "ltree". All fields are combined with logical 'AND'. */
export type LtreeComparisonExp = {
  /** is the left argument an ancestor of right (or equal)? */
  _ancestor?: InputMaybe<Scalars['ltree']['input']>;
  /** does array contain an ancestor of `ltree`? */
  _ancestor_any?: InputMaybe<Array<Scalars['ltree']['input']>>;
  /** is the left argument a descendant of right (or equal)? */
  _descendant?: InputMaybe<Scalars['ltree']['input']>;
  /** does array contain a descendant of `ltree`? */
  _descendant_any?: InputMaybe<Array<Scalars['ltree']['input']>>;
  _eq?: InputMaybe<Scalars['ltree']['input']>;
  _gt?: InputMaybe<Scalars['ltree']['input']>;
  _gte?: InputMaybe<Scalars['ltree']['input']>;
  _in?: InputMaybe<Array<Scalars['ltree']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['ltree']['input']>;
  _lte?: InputMaybe<Scalars['ltree']['input']>;
  /** does `ltree` match `lquery`? */
  _matches?: InputMaybe<Scalars['lquery']['input']>;
  /** does `ltree` match any `lquery` in array? */
  _matches_any?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does `ltree` match `ltxtquery`? */
  _matches_fulltext?: InputMaybe<Scalars['ltxtquery']['input']>;
  _neq?: InputMaybe<Scalars['ltree']['input']>;
  _nin?: InputMaybe<Array<Scalars['ltree']['input']>>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type NumericComparisonExp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** columns and relationships of "organisation_core_data_dependencies" */
export type OrganisationCoreDataDependencies = {
  __typename?: 'organisation_core_data_dependencies';
  coreDataType: Scalars['kebabCoreDataType']['output'];
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  customCoreData: Maybe<CustomCoreData>;
  customCoreDataId: Maybe<Scalars['uuid']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  dependencies: Array<CoreDataDependencies>;
  /** An aggregate relationship */
  dependencies_aggregate: CoreDataDependenciesAggregate;
  dependencyCoreDataType: Scalars['kebabDependencyType']['output'];
  /** An object relationship */
  dependencyCustomCoreData: Maybe<CustomCoreData>;
  dependencyCustomCoreDataId: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
};

/** columns and relationships of "organisation_fx_rates" */
export type OrganisationFxRates = {
  __typename?: 'organisation_fx_rates';
  archivedBy: Maybe<Scalars['String']['output']>;
  code: Scalars['organisationFxRateCode']['output'];
  /** An object relationship */
  coreData: CoreData;
  coreDataId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  displaySymbol: Maybe<Scalars['String']['output']>;
  fxRate: Scalars['numeric']['output'];
  id: Scalars['uuid']['output'];
  isArchived: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  name: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  remoteId: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "organisation_fx_rates" */
export type OrganisationFxRatesAggregate = {
  __typename?: 'organisation_fx_rates_aggregate';
  aggregate: Maybe<OrganisationFxRatesAggregateFields>;
  nodes: Array<OrganisationFxRates>;
};

export type OrganisationFxRatesAggregateBoolExp = {
  bool_and?: InputMaybe<OrganisationFxRatesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<OrganisationFxRatesAggregateBoolExpBoolOr>;
  count?: InputMaybe<OrganisationFxRatesAggregateBoolExpCount>;
};

export type OrganisationFxRatesAggregateBoolExpBoolAnd = {
  arguments: OrganisationFxRatesSelectColumnOrganisationFxRatesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<OrganisationFxRatesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type OrganisationFxRatesAggregateBoolExpBoolOr = {
  arguments: OrganisationFxRatesSelectColumnOrganisationFxRatesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<OrganisationFxRatesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type OrganisationFxRatesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<OrganisationFxRatesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<OrganisationFxRatesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "organisation_fx_rates" */
export type OrganisationFxRatesAggregateFields = {
  __typename?: 'organisation_fx_rates_aggregate_fields';
  avg: Maybe<OrganisationFxRatesAvgFields>;
  count: Scalars['Int']['output'];
  max: Maybe<OrganisationFxRatesMaxFields>;
  min: Maybe<OrganisationFxRatesMinFields>;
  stddev: Maybe<OrganisationFxRatesStddevFields>;
  stddev_pop: Maybe<OrganisationFxRatesStddevPopFields>;
  stddev_samp: Maybe<OrganisationFxRatesStddevSampFields>;
  sum: Maybe<OrganisationFxRatesSumFields>;
  var_pop: Maybe<OrganisationFxRatesVarPopFields>;
  var_samp: Maybe<OrganisationFxRatesVarSampFields>;
  variance: Maybe<OrganisationFxRatesVarianceFields>;
};

/** aggregate avg on columns */
export type OrganisationFxRatesAvgFields = {
  __typename?: 'organisation_fx_rates_avg_fields';
  fxRate: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "organisation_fx_rates". All fields are combined with a logical 'AND'. */
export type OrganisationFxRatesBoolExp = {
  _and?: InputMaybe<Array<OrganisationFxRatesBoolExp>>;
  _not?: InputMaybe<OrganisationFxRatesBoolExp>;
  _or?: InputMaybe<Array<OrganisationFxRatesBoolExp>>;
  archivedBy?: InputMaybe<StringComparisonExp>;
  code?: InputMaybe<StringComparisonExp>;
  coreData?: InputMaybe<CoreDataBoolExp>;
  coreDataId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  displaySymbol?: InputMaybe<StringComparisonExp>;
  fxRate?: InputMaybe<NumericComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isArchived?: InputMaybe<BooleanComparisonExp>;
  isVisible?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  remoteId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "organisation_fx_rates" */
export enum OrganisationFxRatesConstraint {
  /** unique or primary key constraint on columns "id" */
  ORGANISATION_CURRENCIES_PKEY = 'organisation_currencies_pkey',
  /** unique or primary key constraint on columns "remote_id", "organisation_id" */
  ORGANISATION_FX_RATES_REMOTE_ID_ORGANISATION_ID_KEY = 'organisation_fx_rates_remote_id_organisation_id_key'
}

/** input type for inserting data into table "organisation_fx_rates" */
export type OrganisationFxRatesInsertInput = {
  archivedBy?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  displaySymbol?: InputMaybe<Scalars['String']['input']>;
  fxRate?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type OrganisationFxRatesMaxFields = {
  __typename?: 'organisation_fx_rates_max_fields';
  archivedBy: Maybe<Scalars['String']['output']>;
  code: Maybe<Scalars['String']['output']>;
  coreDataId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  displaySymbol: Maybe<Scalars['String']['output']>;
  fxRate: Maybe<Scalars['numeric']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type OrganisationFxRatesMinFields = {
  __typename?: 'organisation_fx_rates_min_fields';
  archivedBy: Maybe<Scalars['String']['output']>;
  code: Maybe<Scalars['String']['output']>;
  coreDataId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  displaySymbol: Maybe<Scalars['String']['output']>;
  fxRate: Maybe<Scalars['numeric']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** input type for inserting object relation for remote table "organisation_fx_rates" */
export type OrganisationFxRatesObjRelInsertInput = {
  data: OrganisationFxRatesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganisationFxRatesOnConflict>;
};

/** on_conflict condition type for table "organisation_fx_rates" */
export type OrganisationFxRatesOnConflict = {
  constraint: OrganisationFxRatesConstraint;
  update_columns: Array<OrganisationFxRatesUpdateColumn>;
  where?: InputMaybe<OrganisationFxRatesBoolExp>;
};

/** select columns of table "organisation_fx_rates" */
export enum OrganisationFxRatesSelectColumn {
  /** column name */
  ARCHIVEDBY = 'archivedBy',
  /** column name */
  CODE = 'code',
  /** column name */
  COREDATAID = 'coreDataId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DISPLAYSYMBOL = 'displaySymbol',
  /** column name */
  FXRATE = 'fxRate',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  ISVISIBLE = 'isVisible',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** select "organisation_fx_rates_aggregate_bool_exp_bool_and_arguments_columns" columns of table "organisation_fx_rates" */
export enum OrganisationFxRatesSelectColumnOrganisationFxRatesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  ISVISIBLE = 'isVisible'
}

/** select "organisation_fx_rates_aggregate_bool_exp_bool_or_arguments_columns" columns of table "organisation_fx_rates" */
export enum OrganisationFxRatesSelectColumnOrganisationFxRatesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  ISVISIBLE = 'isVisible'
}

/** aggregate stddev on columns */
export type OrganisationFxRatesStddevFields = {
  __typename?: 'organisation_fx_rates_stddev_fields';
  fxRate: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type OrganisationFxRatesStddevPopFields = {
  __typename?: 'organisation_fx_rates_stddev_pop_fields';
  fxRate: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type OrganisationFxRatesStddevSampFields = {
  __typename?: 'organisation_fx_rates_stddev_samp_fields';
  fxRate: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type OrganisationFxRatesSumFields = {
  __typename?: 'organisation_fx_rates_sum_fields';
  fxRate: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "organisation_fx_rates" */
export enum OrganisationFxRatesUpdateColumn {
  /** column name */
  ARCHIVEDBY = 'archivedBy',
  /** column name */
  CODE = 'code',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DISPLAYSYMBOL = 'displaySymbol',
  /** column name */
  FXRATE = 'fxRate',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  NAME = 'name',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** aggregate var_pop on columns */
export type OrganisationFxRatesVarPopFields = {
  __typename?: 'organisation_fx_rates_var_pop_fields';
  fxRate: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type OrganisationFxRatesVarSampFields = {
  __typename?: 'organisation_fx_rates_var_samp_fields';
  fxRate: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type OrganisationFxRatesVarianceFields = {
  __typename?: 'organisation_fx_rates_variance_fields';
  fxRate: Maybe<Scalars['Float']['output']>;
};

/** Keeps track of which organisations have which integrations enabled */
export type OrganisationIntegrations = {
  __typename?: 'organisation_integrations';
  createdAt: Scalars['timestamptz']['output'];
  defaultSupplierState: Maybe<OrganisationSupplierStateEnum>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  integration: Scalars['globalIntegration']['output'];
  name: Maybe<Scalars['String']['output']>;
  organisationId: Scalars['uuid']['output'];
  referenceId: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "organisation_integrations". All fields are combined with a logical 'AND'. */
export type OrganisationIntegrationsBoolExp = {
  _and?: InputMaybe<Array<OrganisationIntegrationsBoolExp>>;
  _not?: InputMaybe<OrganisationIntegrationsBoolExp>;
  _or?: InputMaybe<Array<OrganisationIntegrationsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  defaultSupplierState?: InputMaybe<OrganisationSupplierStateEnumComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  integration?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  referenceId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "organisation_integrations" */
export enum OrganisationIntegrationsConstraint {
  /** unique or primary key constraint on columns "integration", "organisation_id" */
  ORGANISATION_INTEGRATIONS_ORGANISATION_ID_INTEGRATION_KEY = 'organisation_integrations_organisation_id_integration_key',
  /** unique or primary key constraint on columns "integration", "organisation_id", "name" */
  ORGANISATION_INTEGRATIONS_ORGANISATION_ID_INTEGRATION_NAME_KEY = 'organisation_integrations_organisation_id_integration_name_key',
  /** unique or primary key constraint on columns "id" */
  ORGANISATION_INTEGRATIONS_PKEY = 'organisation_integrations_pkey'
}

/** input type for inserting data into table "organisation_integrations" */
export type OrganisationIntegrationsInsertInput = {
  defaultSupplierState?: InputMaybe<OrganisationSupplierStateEnum>;
  integration: Scalars['globalIntegration']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting object relation for remote table "organisation_integrations" */
export type OrganisationIntegrationsObjRelInsertInput = {
  data: OrganisationIntegrationsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganisationIntegrationsOnConflict>;
};

/** on_conflict condition type for table "organisation_integrations" */
export type OrganisationIntegrationsOnConflict = {
  constraint: OrganisationIntegrationsConstraint;
  update_columns: Array<OrganisationIntegrationsUpdateColumn>;
  where?: InputMaybe<OrganisationIntegrationsBoolExp>;
};

/** update columns of table "organisation_integrations" */
export enum OrganisationIntegrationsUpdateColumn {
  /** column name */
  DEFAULTSUPPLIERSTATE = 'defaultSupplierState',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  NAME = 'name',
  /** column name */
  REFERENCEID = 'referenceId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** columns and relationships of "organisation_product_supplier_categories" */
export type OrganisationProductSupplierCategories = {
  __typename?: 'organisation_product_supplier_categories';
  id: Scalars['uuid']['output'];
  isTerminal: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An array relationship */
  organisation_product_supplier_categories: Array<OrganisationProductSupplierCategories>;
  /** An object relationship */
  organisation_product_supplier_category: Maybe<OrganisationProductSupplierCategories>;
  parentId: Maybe<Scalars['uuid']['output']>;
  value: Scalars['String']['output'];
};

/** input type for inserting array relation for remote table "organisation_product_supplier_categories" */
export type OrganisationProductSupplierCategoriesArrRelInsertInput = {
  data: Array<OrganisationProductSupplierCategoriesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganisationProductSupplierCategoriesOnConflict>;
};

/** Boolean expression to filter rows from the table "organisation_product_supplier_categories". All fields are combined with a logical 'AND'. */
export type OrganisationProductSupplierCategoriesBoolExp = {
  _and?: InputMaybe<Array<OrganisationProductSupplierCategoriesBoolExp>>;
  _not?: InputMaybe<OrganisationProductSupplierCategoriesBoolExp>;
  _or?: InputMaybe<Array<OrganisationProductSupplierCategoriesBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
  isTerminal?: InputMaybe<BooleanComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisation_product_supplier_categories?: InputMaybe<OrganisationProductSupplierCategoriesBoolExp>;
  organisation_product_supplier_category?: InputMaybe<OrganisationProductSupplierCategoriesBoolExp>;
  parentId?: InputMaybe<UuidComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "organisation_product_supplier_categories" */
export enum OrganisationProductSupplierCategoriesConstraint {
  /** unique or primary key constraint on columns "id" */
  ORGANISATION_PRODUCT_SUPPLIER_CATEGORIES_PKEY = 'organisation_product_supplier_categories_pkey'
}

/** input type for inserting data into table "organisation_product_supplier_categories" */
export type OrganisationProductSupplierCategoriesInsertInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  isTerminal?: InputMaybe<Scalars['Boolean']['input']>;
  organisation_product_supplier_categories?: InputMaybe<OrganisationProductSupplierCategoriesArrRelInsertInput>;
  organisation_product_supplier_category?: InputMaybe<OrganisationProductSupplierCategoriesObjRelInsertInput>;
  parentId?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting object relation for remote table "organisation_product_supplier_categories" */
export type OrganisationProductSupplierCategoriesObjRelInsertInput = {
  data: OrganisationProductSupplierCategoriesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganisationProductSupplierCategoriesOnConflict>;
};

/** on_conflict condition type for table "organisation_product_supplier_categories" */
export type OrganisationProductSupplierCategoriesOnConflict = {
  constraint: OrganisationProductSupplierCategoriesConstraint;
  update_columns: Array<OrganisationProductSupplierCategoriesUpdateColumn>;
  where?: InputMaybe<OrganisationProductSupplierCategoriesBoolExp>;
};

/** update columns of table "organisation_product_supplier_categories" */
export enum OrganisationProductSupplierCategoriesUpdateColumn {
  /** column name */
  ISTERMINAL = 'isTerminal',
  /** column name */
  PARENTID = 'parentId',
  /** column name */
  VALUE = 'value'
}

/** Links between an org and products and services */
export type OrganisationProductsAndServices = {
  __typename?: 'organisation_products_and_services';
  /** An array relationship */
  assessments: Array<Assessments>;
  /** An aggregate relationship */
  assessments_aggregate: AssessmentsAggregate;
  /** An object relationship */
  businessOwner: Maybe<Users>;
  businessOwnerId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deleted_at: Maybe<Scalars['timestamptz']['output']>;
  description: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  /** An array relationship */
  documents: Array<Documents>;
  /** An aggregate relationship */
  documents_aggregate: DocumentsAggregate;
  embedding: Maybe<Scalars['vector']['output']>;
  /** An array relationship */
  engagements: Array<Engagements>;
  /** An aggregate relationship */
  engagements_aggregate: EngagementsAggregate;
  functionalDescription: Maybe<Scalars['String']['output']>;
  functionalEmbedding: Maybe<Scalars['vector']['output']>;
  id: Scalars['uuid']['output'];
  isArchived: Scalars['Boolean']['output'];
  logoUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** An object relationship */
  organisation: Maybe<Organisations>;
  organisationProductsAndServicesBrandId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Scalars['uuid']['output'];
  /** An object relationship */
  organisation_products_and_services_brand: Maybe<OrganisationProductsAndServicesBrands>;
  /** An array relationship */
  organisation_products_and_services_requests: Array<Requests>;
  /** An aggregate relationship */
  organisation_products_and_services_requests_aggregate: RequestsAggregate;
  /** An object relationship */
  organisation_supplier: OrganisationSuppliers;
  /** An array relationship */
  renewals: Array<Renewals>;
  /** An aggregate relationship */
  renewals_aggregate: RenewalsAggregate;
  state: OrganisationProductsAndServicesStateEnum;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  website: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "organisation_products_and_services" */
export type OrganisationProductsAndServicesAggregate = {
  __typename?: 'organisation_products_and_services_aggregate';
  aggregate: Maybe<OrganisationProductsAndServicesAggregateFields>;
  nodes: Array<OrganisationProductsAndServices>;
};

export type OrganisationProductsAndServicesAggregateBoolExp = {
  bool_and?: InputMaybe<OrganisationProductsAndServicesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<OrganisationProductsAndServicesAggregateBoolExpBoolOr>;
  count?: InputMaybe<OrganisationProductsAndServicesAggregateBoolExpCount>;
};

export type OrganisationProductsAndServicesAggregateBoolExpBoolAnd = {
  arguments: OrganisationProductsAndServicesSelectColumnOrganisationProductsAndServicesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<OrganisationProductsAndServicesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type OrganisationProductsAndServicesAggregateBoolExpBoolOr = {
  arguments: OrganisationProductsAndServicesSelectColumnOrganisationProductsAndServicesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<OrganisationProductsAndServicesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type OrganisationProductsAndServicesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<OrganisationProductsAndServicesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<OrganisationProductsAndServicesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "organisation_products_and_services" */
export type OrganisationProductsAndServicesAggregateFields = {
  __typename?: 'organisation_products_and_services_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<OrganisationProductsAndServicesMaxFields>;
  min: Maybe<OrganisationProductsAndServicesMinFields>;
};

/** input type for inserting array relation for remote table "organisation_products_and_services" */
export type OrganisationProductsAndServicesArrRelInsertInput = {
  data: Array<OrganisationProductsAndServicesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganisationProductsAndServicesOnConflict>;
};

/** Boolean expression to filter rows from the table "organisation_products_and_services". All fields are combined with a logical 'AND'. */
export type OrganisationProductsAndServicesBoolExp = {
  _and?: InputMaybe<Array<OrganisationProductsAndServicesBoolExp>>;
  _not?: InputMaybe<OrganisationProductsAndServicesBoolExp>;
  _or?: InputMaybe<Array<OrganisationProductsAndServicesBoolExp>>;
  assessments?: InputMaybe<AssessmentsBoolExp>;
  assessments_aggregate?: InputMaybe<AssessmentsAggregateBoolExp>;
  businessOwner?: InputMaybe<UsersBoolExp>;
  businessOwnerId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  displayName?: InputMaybe<StringComparisonExp>;
  documents?: InputMaybe<DocumentsBoolExp>;
  documents_aggregate?: InputMaybe<DocumentsAggregateBoolExp>;
  embedding?: InputMaybe<VectorComparisonExp>;
  engagements?: InputMaybe<EngagementsBoolExp>;
  engagements_aggregate?: InputMaybe<EngagementsAggregateBoolExp>;
  functionalDescription?: InputMaybe<StringComparisonExp>;
  functionalEmbedding?: InputMaybe<VectorComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isArchived?: InputMaybe<BooleanComparisonExp>;
  logoUrl?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationProductsAndServicesBrandId?: InputMaybe<UuidComparisonExp>;
  organisationSupplierId?: InputMaybe<UuidComparisonExp>;
  organisation_products_and_services_brand?: InputMaybe<OrganisationProductsAndServicesBrandsBoolExp>;
  organisation_products_and_services_requests?: InputMaybe<RequestsBoolExp>;
  organisation_products_and_services_requests_aggregate?: InputMaybe<RequestsAggregateBoolExp>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  renewals?: InputMaybe<RenewalsBoolExp>;
  renewals_aggregate?: InputMaybe<RenewalsAggregateBoolExp>;
  state?: InputMaybe<OrganisationProductsAndServicesStateEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  website?: InputMaybe<StringComparisonExp>;
};

/** columns and relationships of "organisation_products_and_services_brands" */
export type OrganisationProductsAndServicesBrands = {
  __typename?: 'organisation_products_and_services_brands';
  /** An array relationship */
  categories: Array<OrganisationProductsAndServicesCategories>;
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  description: Maybe<Scalars['String']['output']>;
  embedding: Maybe<Scalars['vector']['output']>;
  id: Scalars['uuid']['output'];
  logoUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationSupplierBrandId: Scalars['uuid']['output'];
  /** An array relationship */
  organisation_products_and_services: Array<OrganisationProductsAndServices>;
  /** An aggregate relationship */
  organisation_products_and_services_aggregate: OrganisationProductsAndServicesAggregate;
  /** An object relationship */
  organisation_suppliers_brand: OrganisationSuppliersBrands;
  productAndServiceId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  product_catalogue_entry: Maybe<ProductCatalogueEntries>;
  /** An object relationship */
  products_and_service: Maybe<ProductsAndServices>;
  updatedAt: Scalars['timestamptz']['output'];
  website: Maybe<Scalars['String']['output']>;
};

/** input type for inserting array relation for remote table "organisation_products_and_services_brands" */
export type OrganisationProductsAndServicesBrandsArrRelInsertInput = {
  data: Array<OrganisationProductsAndServicesBrandsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganisationProductsAndServicesBrandsOnConflict>;
};

/** Boolean expression to filter rows from the table "organisation_products_and_services_brands". All fields are combined with a logical 'AND'. */
export type OrganisationProductsAndServicesBrandsBoolExp = {
  _and?: InputMaybe<Array<OrganisationProductsAndServicesBrandsBoolExp>>;
  _not?: InputMaybe<OrganisationProductsAndServicesBrandsBoolExp>;
  _or?: InputMaybe<Array<OrganisationProductsAndServicesBrandsBoolExp>>;
  categories?: InputMaybe<OrganisationProductsAndServicesCategoriesBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  embedding?: InputMaybe<VectorComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  logoUrl?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationSupplierBrandId?: InputMaybe<UuidComparisonExp>;
  organisation_products_and_services?: InputMaybe<OrganisationProductsAndServicesBoolExp>;
  organisation_products_and_services_aggregate?: InputMaybe<OrganisationProductsAndServicesAggregateBoolExp>;
  organisation_suppliers_brand?: InputMaybe<OrganisationSuppliersBrandsBoolExp>;
  productAndServiceId?: InputMaybe<UuidComparisonExp>;
  product_catalogue_entry?: InputMaybe<ProductCatalogueEntriesBoolExp>;
  products_and_service?: InputMaybe<ProductsAndServicesBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  website?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "organisation_products_and_services_brands" */
export enum OrganisationProductsAndServicesBrandsConstraint {
  /** unique or primary key constraint on columns "id" */
  ORGANISATION_PRODUCTS_AND_SERVICES_BRANDS_PKEY = 'organisation_products_and_services_brands_pkey',
  /** unique or primary key constraint on columns "organisation_id", "product_and_service_id" */
  ORGANISATION_PRODUCTS_AND_SERVICES_BRANDS_PRODUCT_AND_SERVICE_I = 'organisation_products_and_services_brands_product_and_service_i'
}

/** input type for inserting data into table "organisation_products_and_services_brands" */
export type OrganisationProductsAndServicesBrandsInsertInput = {
  categories?: InputMaybe<OrganisationProductsAndServicesCategoriesArrRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  embedding?: InputMaybe<Scalars['vector']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationSupplierBrandId?: InputMaybe<Scalars['uuid']['input']>;
  organisation_products_and_services?: InputMaybe<OrganisationProductsAndServicesArrRelInsertInput>;
  organisation_suppliers_brand?: InputMaybe<OrganisationSuppliersBrandsObjRelInsertInput>;
  productAndServiceId?: InputMaybe<Scalars['uuid']['input']>;
  product_catalogue_entry?: InputMaybe<ProductCatalogueEntriesObjRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting object relation for remote table "organisation_products_and_services_brands" */
export type OrganisationProductsAndServicesBrandsObjRelInsertInput = {
  data: OrganisationProductsAndServicesBrandsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganisationProductsAndServicesBrandsOnConflict>;
};

/** on_conflict condition type for table "organisation_products_and_services_brands" */
export type OrganisationProductsAndServicesBrandsOnConflict = {
  constraint: OrganisationProductsAndServicesBrandsConstraint;
  update_columns: Array<OrganisationProductsAndServicesBrandsUpdateColumn>;
  where?: InputMaybe<OrganisationProductsAndServicesBrandsBoolExp>;
};

/** update columns of table "organisation_products_and_services_brands" */
export enum OrganisationProductsAndServicesBrandsUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  EMBEDDING = 'embedding',
  /** column name */
  LOGOURL = 'logoUrl',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONSUPPLIERBRANDID = 'organisationSupplierBrandId',
  /** column name */
  PRODUCTANDSERVICEID = 'productAndServiceId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  WEBSITE = 'website'
}

/** columns and relationships of "organisation_products_and_services_categories" */
export type OrganisationProductsAndServicesCategories = {
  __typename?: 'organisation_products_and_services_categories';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  organisationProductsAndServicesBrandId: Scalars['uuid']['output'];
  /** An object relationship */
  organisation_product_supplier_category: OrganisationProductSupplierCategories;
  /** An object relationship */
  organisation_products_and_services_brand: OrganisationProductsAndServicesBrands;
  productSupplierCategoryId: Scalars['uuid']['output'];
};

/** input type for inserting array relation for remote table "organisation_products_and_services_categories" */
export type OrganisationProductsAndServicesCategoriesArrRelInsertInput = {
  data: Array<OrganisationProductsAndServicesCategoriesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganisationProductsAndServicesCategoriesOnConflict>;
};

/** Boolean expression to filter rows from the table "organisation_products_and_services_categories". All fields are combined with a logical 'AND'. */
export type OrganisationProductsAndServicesCategoriesBoolExp = {
  _and?: InputMaybe<Array<OrganisationProductsAndServicesCategoriesBoolExp>>;
  _not?: InputMaybe<OrganisationProductsAndServicesCategoriesBoolExp>;
  _or?: InputMaybe<Array<OrganisationProductsAndServicesCategoriesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationProductsAndServicesBrandId?: InputMaybe<UuidComparisonExp>;
  organisation_product_supplier_category?: InputMaybe<OrganisationProductSupplierCategoriesBoolExp>;
  organisation_products_and_services_brand?: InputMaybe<OrganisationProductsAndServicesBrandsBoolExp>;
  productSupplierCategoryId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "organisation_products_and_services_categories" */
export enum OrganisationProductsAndServicesCategoriesConstraint {
  /** unique or primary key constraint on columns "organisation_products_and_services_brand_id", "product_supplier_category_id" */
  ORGANISATION_PRODUCTS_AND_SERVICES_CATEGORIES_BRAND_PSC_KEY = 'organisation_products_and_services_categories_brand_psc_key',
  /** unique or primary key constraint on columns "id" */
  ORGANISATION_PRODUCTS_AND_SERVICES_CATEGORIES_PKEY = 'organisation_products_and_services_categories_pkey'
}

/** input type for inserting data into table "organisation_products_and_services_categories" */
export type OrganisationProductsAndServicesCategoriesInsertInput = {
  organisationProductsAndServicesBrandId?: InputMaybe<Scalars['uuid']['input']>;
  organisation_product_supplier_category?: InputMaybe<OrganisationProductSupplierCategoriesObjRelInsertInput>;
  organisation_products_and_services_brand?: InputMaybe<OrganisationProductsAndServicesBrandsObjRelInsertInput>;
  productSupplierCategoryId?: InputMaybe<Scalars['uuid']['input']>;
};

/** on_conflict condition type for table "organisation_products_and_services_categories" */
export type OrganisationProductsAndServicesCategoriesOnConflict = {
  constraint: OrganisationProductsAndServicesCategoriesConstraint;
  update_columns: Array<OrganisationProductsAndServicesCategoriesUpdateColumn>;
  where?: InputMaybe<OrganisationProductsAndServicesCategoriesBoolExp>;
};

/** placeholder for update columns of table "organisation_products_and_services_categories" (current role has no relevant permissions) */
export enum OrganisationProductsAndServicesCategoriesUpdateColumn {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

/** unique or primary key constraints on table "organisation_products_and_services" */
export enum OrganisationProductsAndServicesConstraint {
  /** unique or primary key constraint on columns "id" */
  ORGANISATION_SUPPLIERS_PKEY = 'organisation_suppliers_pkey'
}

/** input type for inserting data into table "organisation_products_and_services" */
export type OrganisationProductsAndServicesInsertInput = {
  assessments?: InputMaybe<AssessmentsArrRelInsertInput>;
  businessOwner?: InputMaybe<UsersObjRelInsertInput>;
  businessOwnerId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<DocumentsArrRelInsertInput>;
  embedding?: InputMaybe<Scalars['vector']['input']>;
  engagements?: InputMaybe<EngagementsArrRelInsertInput>;
  functionalDescription?: InputMaybe<Scalars['String']['input']>;
  functionalEmbedding?: InputMaybe<Scalars['vector']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationProductsAndServicesBrandId?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  organisation_products_and_services_brand?: InputMaybe<OrganisationProductsAndServicesBrandsObjRelInsertInput>;
  organisation_products_and_services_requests?: InputMaybe<RequestsArrRelInsertInput>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  renewals?: InputMaybe<RenewalsArrRelInsertInput>;
  state?: InputMaybe<OrganisationProductsAndServicesStateEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type OrganisationProductsAndServicesMaxFields = {
  __typename?: 'organisation_products_and_services_max_fields';
  businessOwnerId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deleted_at: Maybe<Scalars['timestamptz']['output']>;
  description: Maybe<Scalars['String']['output']>;
  displayName: Maybe<Scalars['String']['output']>;
  functionalDescription: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  logoUrl: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationProductsAndServicesBrandId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  website: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type OrganisationProductsAndServicesMinFields = {
  __typename?: 'organisation_products_and_services_min_fields';
  businessOwnerId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deleted_at: Maybe<Scalars['timestamptz']['output']>;
  description: Maybe<Scalars['String']['output']>;
  displayName: Maybe<Scalars['String']['output']>;
  functionalDescription: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  logoUrl: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationProductsAndServicesBrandId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  website: Maybe<Scalars['String']['output']>;
};

/** input type for inserting object relation for remote table "organisation_products_and_services" */
export type OrganisationProductsAndServicesObjRelInsertInput = {
  data: OrganisationProductsAndServicesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganisationProductsAndServicesOnConflict>;
};

/** on_conflict condition type for table "organisation_products_and_services" */
export type OrganisationProductsAndServicesOnConflict = {
  constraint: OrganisationProductsAndServicesConstraint;
  update_columns: Array<OrganisationProductsAndServicesUpdateColumn>;
  where?: InputMaybe<OrganisationProductsAndServicesBoolExp>;
};

/** select columns of table "organisation_products_and_services" */
export enum OrganisationProductsAndServicesSelectColumn {
  /** column name */
  BUSINESSOWNERID = 'businessOwnerId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETED_AT = 'deleted_at',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  DISPLAYNAME = 'displayName',
  /** column name */
  EMBEDDING = 'embedding',
  /** column name */
  FUNCTIONALDESCRIPTION = 'functionalDescription',
  /** column name */
  FUNCTIONALEMBEDDING = 'functionalEmbedding',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  LOGOURL = 'logoUrl',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONPRODUCTSANDSERVICESBRANDID = 'organisationProductsAndServicesBrandId',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  STATE = 'state',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  WEBSITE = 'website'
}

/** select "organisation_products_and_services_aggregate_bool_exp_bool_and_arguments_columns" columns of table "organisation_products_and_services" */
export enum OrganisationProductsAndServicesSelectColumnOrganisationProductsAndServicesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  ISARCHIVED = 'isArchived'
}

/** select "organisation_products_and_services_aggregate_bool_exp_bool_or_arguments_columns" columns of table "organisation_products_and_services" */
export enum OrganisationProductsAndServicesSelectColumnOrganisationProductsAndServicesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  ISARCHIVED = 'isArchived'
}

/** input type for updating data in table "organisation_products_and_services" */
export type OrganisationProductsAndServicesSetInput = {
  businessOwnerId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  embedding?: InputMaybe<Scalars['vector']['input']>;
  functionalDescription?: InputMaybe<Scalars['String']['input']>;
  functionalEmbedding?: InputMaybe<Scalars['vector']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationProductsAndServicesBrandId?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<OrganisationProductsAndServicesStateEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export enum OrganisationProductsAndServicesStateEnum {
  /** Active */
  ACTIVE = 'ACTIVE',
  /** Inactive */
  INACTIVE = 'INACTIVE',
  /** Pending */
  PENDING = 'PENDING'
}

/** Boolean expression to compare columns of type "organisation_products_and_services_state_enum". All fields are combined with logical 'AND'. */
export type OrganisationProductsAndServicesStateEnumComparisonExp = {
  _eq?: InputMaybe<OrganisationProductsAndServicesStateEnum>;
  _in?: InputMaybe<Array<OrganisationProductsAndServicesStateEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<OrganisationProductsAndServicesStateEnum>;
  _nin?: InputMaybe<Array<OrganisationProductsAndServicesStateEnum>>;
};

/** update columns of table "organisation_products_and_services" */
export enum OrganisationProductsAndServicesUpdateColumn {
  /** column name */
  BUSINESSOWNERID = 'businessOwnerId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETED_AT = 'deleted_at',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  DISPLAYNAME = 'displayName',
  /** column name */
  EMBEDDING = 'embedding',
  /** column name */
  FUNCTIONALDESCRIPTION = 'functionalDescription',
  /** column name */
  FUNCTIONALEMBEDDING = 'functionalEmbedding',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  LOGOURL = 'logoUrl',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONPRODUCTSANDSERVICESBRANDID = 'organisationProductsAndServicesBrandId',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  STATE = 'state',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  WEBSITE = 'website'
}

/** columns and relationships of "organisation_supplier_profiles" */
export type OrganisationSupplierProfiles = {
  __typename?: 'organisation_supplier_profiles';
  archivedBy: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  customFieldValues: Array<CustomFieldValues>;
  /** An aggregate relationship */
  customFieldValues_aggregate: CustomFieldValuesAggregate;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  entityBankDetails: Array<EntityBankDetails>;
  /** An aggregate relationship */
  entityBankDetails_aggregate: EntityBankDetailsAggregate;
  id: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  organisationSupplier: OrganisationSuppliers;
  organisationSupplierId: Scalars['uuid']['output'];
  /** An object relationship */
  paymentMethod: Maybe<PaymentMethods>;
  /** An object relationship */
  paymentTerm: Maybe<PaymentTerms>;
  payment_method_id: Maybe<Scalars['uuid']['output']>;
  payment_term_id: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  profileState: OrganisationSupplierState;
  remoteId: Maybe<Scalars['String']['output']>;
  remoteLink: Maybe<Scalars['String']['output']>;
  state: OrganisationSupplierStateEnum;
  /** An object relationship */
  subsidiary: Subsidiaries;
  subsidiaryId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** input type for inserting array relation for remote table "organisation_supplier_profiles" */
export type OrganisationSupplierProfilesArrRelInsertInput = {
  data: Array<OrganisationSupplierProfilesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganisationSupplierProfilesOnConflict>;
};

/** Boolean expression to filter rows from the table "organisation_supplier_profiles". All fields are combined with a logical 'AND'. */
export type OrganisationSupplierProfilesBoolExp = {
  _and?: InputMaybe<Array<OrganisationSupplierProfilesBoolExp>>;
  _not?: InputMaybe<OrganisationSupplierProfilesBoolExp>;
  _or?: InputMaybe<Array<OrganisationSupplierProfilesBoolExp>>;
  archivedBy?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customFieldValues?: InputMaybe<CustomFieldValuesBoolExp>;
  customFieldValues_aggregate?: InputMaybe<CustomFieldValuesAggregateBoolExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  entityBankDetails?: InputMaybe<EntityBankDetailsBoolExp>;
  entityBankDetails_aggregate?: InputMaybe<EntityBankDetailsAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisationSupplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  organisationSupplierId?: InputMaybe<UuidComparisonExp>;
  paymentMethod?: InputMaybe<PaymentMethodsBoolExp>;
  paymentTerm?: InputMaybe<PaymentTermsBoolExp>;
  payment_method_id?: InputMaybe<UuidComparisonExp>;
  payment_term_id?: InputMaybe<UuidComparisonExp>;
  profileState?: InputMaybe<OrganisationSupplierStateBoolExp>;
  remoteId?: InputMaybe<StringComparisonExp>;
  remoteLink?: InputMaybe<StringComparisonExp>;
  state?: InputMaybe<OrganisationSupplierStateEnumComparisonExp>;
  subsidiary?: InputMaybe<SubsidiariesBoolExp>;
  subsidiaryId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "organisation_supplier_profiles" */
export enum OrganisationSupplierProfilesConstraint {
  /** unique or primary key constraint on columns "id" */
  ORGANISATION_SUPPLIER_PROFILES_PKEY = 'organisation_supplier_profiles_pkey',
  /** unique or primary key constraint on columns "organisation_id", "subsidiary_id", "remote_id" */
  ORGANISATION_SUPPLIER_PROFILES_REMOTE_ID_SUBSIDIARY_ID_ACTIVE = 'organisation_supplier_profiles_remote_id_subsidiary_id_active',
  /** unique or primary key constraint on columns "deleted_at", "subsidiary_id", "organisation_supplier_id" */
  UNIQ_SUBSIDIARY_ID_ORGANISATION_SUPPLIER_ID_DELETED_AT = 'uniq_subsidiary_id_organisation_supplier_id_deleted_at'
}

/** input type for inserting data into table "organisation_supplier_profiles" */
export type OrganisationSupplierProfilesInsertInput = {
  archivedBy?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customFieldValues?: InputMaybe<CustomFieldValuesArrRelInsertInput>;
  entityBankDetails?: InputMaybe<EntityBankDetailsArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  paymentMethod?: InputMaybe<PaymentMethodsObjRelInsertInput>;
  paymentTerm?: InputMaybe<PaymentTermsObjRelInsertInput>;
  payment_method_id?: InputMaybe<Scalars['uuid']['input']>;
  payment_term_id?: InputMaybe<Scalars['uuid']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  remoteLink?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<OrganisationSupplierStateEnum>;
  subsidiary?: InputMaybe<SubsidiariesObjRelInsertInput>;
  subsidiaryId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** input type for inserting object relation for remote table "organisation_supplier_profiles" */
export type OrganisationSupplierProfilesObjRelInsertInput = {
  data: OrganisationSupplierProfilesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganisationSupplierProfilesOnConflict>;
};

/** on_conflict condition type for table "organisation_supplier_profiles" */
export type OrganisationSupplierProfilesOnConflict = {
  constraint: OrganisationSupplierProfilesConstraint;
  update_columns: Array<OrganisationSupplierProfilesUpdateColumn>;
  where?: InputMaybe<OrganisationSupplierProfilesBoolExp>;
};

/** update columns of table "organisation_supplier_profiles" */
export enum OrganisationSupplierProfilesUpdateColumn {
  /** column name */
  ARCHIVEDBY = 'archivedBy',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  PAYMENT_METHOD_ID = 'payment_method_id',
  /** column name */
  PAYMENT_TERM_ID = 'payment_term_id',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  REMOTELINK = 'remoteLink',
  /** column name */
  STATE = 'state',
  /** column name */
  SUBSIDIARYID = 'subsidiaryId'
}

/** columns and relationships of "organisation_supplier_state" */
export type OrganisationSupplierState = {
  __typename?: 'organisation_supplier_state';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "organisation_supplier_state". All fields are combined with a logical 'AND'. */
export type OrganisationSupplierStateBoolExp = {
  _and?: InputMaybe<Array<OrganisationSupplierStateBoolExp>>;
  _not?: InputMaybe<OrganisationSupplierStateBoolExp>;
  _or?: InputMaybe<Array<OrganisationSupplierStateBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum OrganisationSupplierStateEnum {
  /** Active */
  ACTIVE = 'ACTIVE',
  /** Archived */
  ARCHIVED = 'ARCHIVED',
  /** Inactive */
  INACTIVE = 'INACTIVE',
  /** Pending */
  PENDING = 'PENDING'
}

/** Boolean expression to compare columns of type "organisation_supplier_state_enum". All fields are combined with logical 'AND'. */
export type OrganisationSupplierStateEnumComparisonExp = {
  _eq?: InputMaybe<OrganisationSupplierStateEnum>;
  _in?: InputMaybe<Array<OrganisationSupplierStateEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<OrganisationSupplierStateEnum>;
  _nin?: InputMaybe<Array<OrganisationSupplierStateEnum>>;
};

/** columns and relationships of "organisation_supplier_tags" */
export type OrganisationSupplierTags = {
  __typename?: 'organisation_supplier_tags';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  organisationSupplierId: Scalars['uuid']['output'];
  /** An object relationship */
  organisation_supplier: OrganisationSuppliers;
  /** An object relationship */
  tag: Tags;
  tagId: Scalars['uuid']['output'];
};

/** input type for inserting array relation for remote table "organisation_supplier_tags" */
export type OrganisationSupplierTagsArrRelInsertInput = {
  data: Array<OrganisationSupplierTagsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganisationSupplierTagsOnConflict>;
};

/** Boolean expression to filter rows from the table "organisation_supplier_tags". All fields are combined with a logical 'AND'. */
export type OrganisationSupplierTagsBoolExp = {
  _and?: InputMaybe<Array<OrganisationSupplierTagsBoolExp>>;
  _not?: InputMaybe<OrganisationSupplierTagsBoolExp>;
  _or?: InputMaybe<Array<OrganisationSupplierTagsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationSupplierId?: InputMaybe<UuidComparisonExp>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  tag?: InputMaybe<TagsBoolExp>;
  tagId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "organisation_supplier_tags" */
export enum OrganisationSupplierTagsConstraint {
  /** unique or primary key constraint on columns "tag_id", "organisation_supplier_id" */
  ORGANISATION_SUPPLIER_TAGS_ORGANISATION_SUPPLIER_ID_TAG_ID_KEY = 'organisation_supplier_tags_organisation_supplier_id_tag_id_key',
  /** unique or primary key constraint on columns "id" */
  ORGANISATION_SUPPLIER_TAGS_PKEY = 'organisation_supplier_tags_pkey'
}

/** input type for inserting data into table "organisation_supplier_tags" */
export type OrganisationSupplierTagsInsertInput = {
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  tag?: InputMaybe<TagsObjRelInsertInput>;
  tagId?: InputMaybe<Scalars['uuid']['input']>;
};

/** on_conflict condition type for table "organisation_supplier_tags" */
export type OrganisationSupplierTagsOnConflict = {
  constraint: OrganisationSupplierTagsConstraint;
  update_columns: Array<OrganisationSupplierTagsUpdateColumn>;
  where?: InputMaybe<OrganisationSupplierTagsBoolExp>;
};

/** update columns of table "organisation_supplier_tags" */
export enum OrganisationSupplierTagsUpdateColumn {
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId'
}

/** columns and relationships of "organisation_suppliers" */
export type OrganisationSuppliers = {
  __typename?: 'organisation_suppliers';
  address: Maybe<Scalars['address']['output']>;
  /** An array relationship */
  agreements: Array<Agreements>;
  /** An aggregate relationship */
  agreements_aggregate: AgreementsAggregate;
  archivedBy: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  customFieldValues: Array<CustomFieldValues>;
  /** An aggregate relationship */
  customFieldValues_aggregate: CustomFieldValuesAggregate;
  deleted_at: Maybe<Scalars['timestamptz']['output']>;
  description: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  documents: Array<Documents>;
  /** An aggregate relationship */
  documents_aggregate: DocumentsAggregate;
  embedding: Maybe<Scalars['vector']['output']>;
  /** An array relationship */
  engagements: Array<Engagements>;
  /** An aggregate relationship */
  engagements_aggregate: EngagementsAggregate;
  /** An array relationship */
  entityBankDetails: Array<EntityBankDetails>;
  /** An aggregate relationship */
  entityBankDetails_aggregate: EntityBankDetailsAggregate;
  externalLink: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  externalRiskScore: Maybe<ExternalRiskScores>;
  externalRiskScoreId: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  external_contacts: Array<ExternalContacts>;
  files: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  internalContacts: Array<InternalContacts>;
  isContinuousMonitoringEnabled: Scalars['Boolean']['output'];
  isPerson: Maybe<Scalars['Boolean']['output']>;
  isPreferred: Scalars['Boolean']['output'];
  isReseller: Scalars['Boolean']['output'];
  lastAssessmentDate: Maybe<Scalars['timestamptz']['output']>;
  legalName: Maybe<Scalars['String']['output']>;
  logoUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** An object relationship */
  organisation: Organisations;
  /** An object relationship */
  organisationIntegration: Maybe<OrganisationIntegrations>;
  organisationIntegrationId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierBrandId: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  organisationSupplierProfiles: Array<OrganisationSupplierProfiles>;
  /** An array relationship */
  organisation_products_and_services: Array<OrganisationProductsAndServices>;
  /** An aggregate relationship */
  organisation_products_and_services_aggregate: OrganisationProductsAndServicesAggregate;
  /** An object relationship */
  organisation_supplier_brand: Maybe<OrganisationSuppliersBrands>;
  /** An object relationship */
  organisation_supplier_state: OrganisationSupplierState;
  /** An array relationship */
  organisation_supplier_tags: Array<OrganisationSupplierTags>;
  /** An array relationship */
  organisation_suppliers_categories: Array<OrganisationSuppliersCategories>;
  /** An array relationship */
  organisation_suppliers_requests: Array<Requests>;
  /** An aggregate relationship */
  organisation_suppliers_requests_aggregate: RequestsAggregate;
  /** An object relationship */
  paymentMethod: Maybe<PaymentMethods>;
  paymentMethodId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  paymentTerms: Maybe<PaymentTerms>;
  paymentTermsId: Maybe<Scalars['uuid']['output']>;
  publicId: Scalars['Int']['output'];
  remoteId: Maybe<Scalars['String']['output']>;
  remoteLink: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  rfx_suppliers: Array<RfxSuppliers>;
  /** An aggregate relationship */
  rfx_suppliers_aggregate: RfxSuppliersAggregate;
  /** An array relationship */
  risks: Array<Risks>;
  state: OrganisationSupplierStateEnum;
  taxNumber: Maybe<Scalars['String']['output']>;
  terminalCategoryId: Maybe<Scalars['uuid']['output']>;
  /** Total spend from engagements and agreements (with FX rates and payment interval multipliers) */
  totalSpend: Maybe<Scalars['numeric']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  website: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "organisation_suppliers" */
export type OrganisationSuppliersAggregate = {
  __typename?: 'organisation_suppliers_aggregate';
  aggregate: Maybe<OrganisationSuppliersAggregateFields>;
  nodes: Array<OrganisationSuppliers>;
};

export type OrganisationSuppliersAggregateBoolExp = {
  bool_and?: InputMaybe<OrganisationSuppliersAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<OrganisationSuppliersAggregateBoolExpBoolOr>;
  count?: InputMaybe<OrganisationSuppliersAggregateBoolExpCount>;
};

export type OrganisationSuppliersAggregateBoolExpBoolAnd = {
  arguments: OrganisationSuppliersSelectColumnOrganisationSuppliersAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<OrganisationSuppliersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type OrganisationSuppliersAggregateBoolExpBoolOr = {
  arguments: OrganisationSuppliersSelectColumnOrganisationSuppliersAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<OrganisationSuppliersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type OrganisationSuppliersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<OrganisationSuppliersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<OrganisationSuppliersBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "organisation_suppliers" */
export type OrganisationSuppliersAggregateFields = {
  __typename?: 'organisation_suppliers_aggregate_fields';
  avg: Maybe<OrganisationSuppliersAvgFields>;
  count: Scalars['Int']['output'];
  max: Maybe<OrganisationSuppliersMaxFields>;
  min: Maybe<OrganisationSuppliersMinFields>;
  stddev: Maybe<OrganisationSuppliersStddevFields>;
  stddev_pop: Maybe<OrganisationSuppliersStddevPopFields>;
  stddev_samp: Maybe<OrganisationSuppliersStddevSampFields>;
  sum: Maybe<OrganisationSuppliersSumFields>;
  var_pop: Maybe<OrganisationSuppliersVarPopFields>;
  var_samp: Maybe<OrganisationSuppliersVarSampFields>;
  variance: Maybe<OrganisationSuppliersVarianceFields>;
};

/** input type for inserting array relation for remote table "organisation_suppliers" */
export type OrganisationSuppliersArrRelInsertInput = {
  data: Array<OrganisationSuppliersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganisationSuppliersOnConflict>;
};

/** aggregate avg on columns */
export type OrganisationSuppliersAvgFields = {
  __typename?: 'organisation_suppliers_avg_fields';
  publicId: Maybe<Scalars['Float']['output']>;
  /** Total spend from engagements and agreements (with FX rates and payment interval multipliers) */
  totalSpend: Maybe<Scalars['numeric']['output']>;
};

/** Boolean expression to filter rows from the table "organisation_suppliers". All fields are combined with a logical 'AND'. */
export type OrganisationSuppliersBoolExp = {
  _and?: InputMaybe<Array<OrganisationSuppliersBoolExp>>;
  _not?: InputMaybe<OrganisationSuppliersBoolExp>;
  _or?: InputMaybe<Array<OrganisationSuppliersBoolExp>>;
  address?: InputMaybe<JsonbComparisonExp>;
  agreements?: InputMaybe<AgreementsBoolExp>;
  agreements_aggregate?: InputMaybe<AgreementsAggregateBoolExp>;
  archivedBy?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customFieldValues?: InputMaybe<CustomFieldValuesBoolExp>;
  customFieldValues_aggregate?: InputMaybe<CustomFieldValuesAggregateBoolExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  documents?: InputMaybe<DocumentsBoolExp>;
  documents_aggregate?: InputMaybe<DocumentsAggregateBoolExp>;
  embedding?: InputMaybe<VectorComparisonExp>;
  engagements?: InputMaybe<EngagementsBoolExp>;
  engagements_aggregate?: InputMaybe<EngagementsAggregateBoolExp>;
  entityBankDetails?: InputMaybe<EntityBankDetailsBoolExp>;
  entityBankDetails_aggregate?: InputMaybe<EntityBankDetailsAggregateBoolExp>;
  externalLink?: InputMaybe<StringComparisonExp>;
  externalRiskScore?: InputMaybe<ExternalRiskScoresBoolExp>;
  externalRiskScoreId?: InputMaybe<UuidComparisonExp>;
  external_contacts?: InputMaybe<ExternalContactsBoolExp>;
  files?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  internalContacts?: InputMaybe<InternalContactsBoolExp>;
  isContinuousMonitoringEnabled?: InputMaybe<BooleanComparisonExp>;
  isPerson?: InputMaybe<BooleanComparisonExp>;
  isPreferred?: InputMaybe<BooleanComparisonExp>;
  isReseller?: InputMaybe<BooleanComparisonExp>;
  lastAssessmentDate?: InputMaybe<TimestamptzComparisonExp>;
  legalName?: InputMaybe<StringComparisonExp>;
  logoUrl?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsBoolExp>;
  organisationIntegrationId?: InputMaybe<UuidComparisonExp>;
  organisationSupplierBrandId?: InputMaybe<UuidComparisonExp>;
  organisationSupplierProfiles?: InputMaybe<OrganisationSupplierProfilesBoolExp>;
  organisation_products_and_services?: InputMaybe<OrganisationProductsAndServicesBoolExp>;
  organisation_products_and_services_aggregate?: InputMaybe<OrganisationProductsAndServicesAggregateBoolExp>;
  organisation_supplier_brand?: InputMaybe<OrganisationSuppliersBrandsBoolExp>;
  organisation_supplier_state?: InputMaybe<OrganisationSupplierStateBoolExp>;
  organisation_supplier_tags?: InputMaybe<OrganisationSupplierTagsBoolExp>;
  organisation_suppliers_categories?: InputMaybe<OrganisationSuppliersCategoriesBoolExp>;
  organisation_suppliers_requests?: InputMaybe<RequestsBoolExp>;
  organisation_suppliers_requests_aggregate?: InputMaybe<RequestsAggregateBoolExp>;
  paymentMethod?: InputMaybe<PaymentMethodsBoolExp>;
  paymentMethodId?: InputMaybe<UuidComparisonExp>;
  paymentTerms?: InputMaybe<PaymentTermsBoolExp>;
  paymentTermsId?: InputMaybe<UuidComparisonExp>;
  publicId?: InputMaybe<IntComparisonExp>;
  remoteId?: InputMaybe<StringComparisonExp>;
  remoteLink?: InputMaybe<StringComparisonExp>;
  rfx_suppliers?: InputMaybe<RfxSuppliersBoolExp>;
  rfx_suppliers_aggregate?: InputMaybe<RfxSuppliersAggregateBoolExp>;
  risks?: InputMaybe<RisksBoolExp>;
  state?: InputMaybe<OrganisationSupplierStateEnumComparisonExp>;
  taxNumber?: InputMaybe<StringComparisonExp>;
  terminalCategoryId?: InputMaybe<UuidComparisonExp>;
  totalSpend?: InputMaybe<NumericComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  website?: InputMaybe<StringComparisonExp>;
};

/** columns and relationships of "organisation_suppliers_brands" */
export type OrganisationSuppliersBrands = {
  __typename?: 'organisation_suppliers_brands';
  createdAt: Scalars['timestamptz']['output'];
  description: Maybe<Scalars['String']['output']>;
  embedding: Maybe<Scalars['vector']['output']>;
  id: Scalars['uuid']['output'];
  logoUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** An object relationship */
  organisation: Organisations;
  /** An array relationship */
  organisation_products_and_services_brands: Array<OrganisationProductsAndServicesBrands>;
  /** An array relationship */
  organisation_suppliers: Array<OrganisationSuppliers>;
  /** An aggregate relationship */
  organisation_suppliers_aggregate: OrganisationSuppliersAggregate;
  ranking: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  supplier: Maybe<Suppliers>;
  supplierId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  website: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "organisation_suppliers_brands". All fields are combined with a logical 'AND'. */
export type OrganisationSuppliersBrandsBoolExp = {
  _and?: InputMaybe<Array<OrganisationSuppliersBrandsBoolExp>>;
  _not?: InputMaybe<OrganisationSuppliersBrandsBoolExp>;
  _or?: InputMaybe<Array<OrganisationSuppliersBrandsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  embedding?: InputMaybe<VectorComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  logoUrl?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisation_products_and_services_brands?: InputMaybe<OrganisationProductsAndServicesBrandsBoolExp>;
  organisation_suppliers?: InputMaybe<OrganisationSuppliersBoolExp>;
  organisation_suppliers_aggregate?: InputMaybe<OrganisationSuppliersAggregateBoolExp>;
  ranking?: InputMaybe<IntComparisonExp>;
  supplier?: InputMaybe<SuppliersBoolExp>;
  supplierId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  website?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "organisation_suppliers_brands" */
export enum OrganisationSuppliersBrandsConstraint {
  /** unique or primary key constraint on columns "organisation_id", "supplier_id" */
  ORGANISATION_SUPPLIERS_BRANDS_ORGANISATION_ID_SUPPLIER_ID_KEY = 'organisation_suppliers_brands_organisation_id_supplier_id_key',
  /** unique or primary key constraint on columns "id" */
  ORGANISATION_SUPPLIERS_BRANDS_PKEY = 'organisation_suppliers_brands_pkey'
}

/** input type for inserting data into table "organisation_suppliers_brands" */
export type OrganisationSuppliersBrandsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  embedding?: InputMaybe<Scalars['vector']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisation_products_and_services_brands?: InputMaybe<OrganisationProductsAndServicesBrandsArrRelInsertInput>;
  organisation_suppliers?: InputMaybe<OrganisationSuppliersArrRelInsertInput>;
  ranking?: InputMaybe<Scalars['Int']['input']>;
  supplierId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting object relation for remote table "organisation_suppliers_brands" */
export type OrganisationSuppliersBrandsObjRelInsertInput = {
  data: OrganisationSuppliersBrandsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganisationSuppliersBrandsOnConflict>;
};

/** on_conflict condition type for table "organisation_suppliers_brands" */
export type OrganisationSuppliersBrandsOnConflict = {
  constraint: OrganisationSuppliersBrandsConstraint;
  update_columns: Array<OrganisationSuppliersBrandsUpdateColumn>;
  where?: InputMaybe<OrganisationSuppliersBrandsBoolExp>;
};

/** update columns of table "organisation_suppliers_brands" */
export enum OrganisationSuppliersBrandsUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  EMBEDDING = 'embedding',
  /** column name */
  LOGOURL = 'logoUrl',
  /** column name */
  NAME = 'name',
  /** column name */
  RANKING = 'ranking',
  /** column name */
  SUPPLIERID = 'supplierId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  WEBSITE = 'website'
}

/** columns and relationships of "organisation_suppliers_categories" */
export type OrganisationSuppliersCategories = {
  __typename?: 'organisation_suppliers_categories';
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  organisationSupplierId: Scalars['uuid']['output'];
  /** An object relationship */
  organisation_product_supplier_category: OrganisationProductSupplierCategories;
  /** An object relationship */
  organisation_supplier: OrganisationSuppliers;
  productSupplierCategoryId: Scalars['uuid']['output'];
};

/** input type for inserting array relation for remote table "organisation_suppliers_categories" */
export type OrganisationSuppliersCategoriesArrRelInsertInput = {
  data: Array<OrganisationSuppliersCategoriesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganisationSuppliersCategoriesOnConflict>;
};

/** Boolean expression to filter rows from the table "organisation_suppliers_categories". All fields are combined with a logical 'AND'. */
export type OrganisationSuppliersCategoriesBoolExp = {
  _and?: InputMaybe<Array<OrganisationSuppliersCategoriesBoolExp>>;
  _not?: InputMaybe<OrganisationSuppliersCategoriesBoolExp>;
  _or?: InputMaybe<Array<OrganisationSuppliersCategoriesBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisationSupplierId?: InputMaybe<UuidComparisonExp>;
  organisation_product_supplier_category?: InputMaybe<OrganisationProductSupplierCategoriesBoolExp>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  productSupplierCategoryId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "organisation_suppliers_categories" */
export enum OrganisationSuppliersCategoriesConstraint {
  /** unique or primary key constraint on columns "id" */
  ORGANISATION_SUPPLIERS_CATEGORIES_PKEY = 'organisation_suppliers_categories_pkey'
}

/** input type for inserting data into table "organisation_suppliers_categories" */
export type OrganisationSuppliersCategoriesInsertInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  organisation_product_supplier_category?: InputMaybe<OrganisationProductSupplierCategoriesObjRelInsertInput>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  productSupplierCategoryId?: InputMaybe<Scalars['uuid']['input']>;
};

/** on_conflict condition type for table "organisation_suppliers_categories" */
export type OrganisationSuppliersCategoriesOnConflict = {
  constraint: OrganisationSuppliersCategoriesConstraint;
  update_columns: Array<OrganisationSuppliersCategoriesUpdateColumn>;
  where?: InputMaybe<OrganisationSuppliersCategoriesBoolExp>;
};

/** update columns of table "organisation_suppliers_categories" */
export enum OrganisationSuppliersCategoriesUpdateColumn {
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  PRODUCTSUPPLIERCATEGORYID = 'productSupplierCategoryId'
}

/** unique or primary key constraints on table "organisation_suppliers" */
export enum OrganisationSuppliersConstraint {
  /** unique or primary key constraint on columns "id" */
  ORGANISATION_SUPPLIERS_PKEY1 = 'organisation_suppliers_pkey1',
  /** unique or primary key constraint on columns "organisation_id", "public_id" */
  ORGANISATION_SUPPLIERS_PUBLIC_ID_ORGANISATION_ID_KEY = 'organisation_suppliers_public_id_organisation_id_key',
  /** unique or primary key constraint on columns "remote_id", "organisation_id" */
  ORGANISATION_SUPPLIERS_REMOTE_ID_ORGANISATION_ID_ACTIVE_UNIQUE = 'organisation_suppliers_remote_id_organisation_id_active_unique'
}

/** input type for inserting data into table "organisation_suppliers" */
export type OrganisationSuppliersInsertInput = {
  address?: InputMaybe<Scalars['jsonb']['input']>;
  agreements?: InputMaybe<AgreementsArrRelInsertInput>;
  archivedBy?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customFieldValues?: InputMaybe<CustomFieldValuesArrRelInsertInput>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<DocumentsArrRelInsertInput>;
  embedding?: InputMaybe<Scalars['vector']['input']>;
  engagements?: InputMaybe<EngagementsArrRelInsertInput>;
  entityBankDetails?: InputMaybe<EntityBankDetailsArrRelInsertInput>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  externalRiskScore?: InputMaybe<ExternalRiskScoresObjRelInsertInput>;
  externalRiskScoreId?: InputMaybe<Scalars['uuid']['input']>;
  external_contacts?: InputMaybe<ExternalContactsArrRelInsertInput>;
  files?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internalContacts?: InputMaybe<InternalContactsArrRelInsertInput>;
  isContinuousMonitoringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPerson?: InputMaybe<Scalars['Boolean']['input']>;
  isPreferred?: InputMaybe<Scalars['Boolean']['input']>;
  isReseller?: InputMaybe<Scalars['Boolean']['input']>;
  lastAssessmentDate?: InputMaybe<Scalars['timestamptz']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsObjRelInsertInput>;
  organisationIntegrationId?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierBrandId?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierProfiles?: InputMaybe<OrganisationSupplierProfilesArrRelInsertInput>;
  organisation_products_and_services?: InputMaybe<OrganisationProductsAndServicesArrRelInsertInput>;
  organisation_supplier_brand?: InputMaybe<OrganisationSuppliersBrandsObjRelInsertInput>;
  organisation_supplier_tags?: InputMaybe<OrganisationSupplierTagsArrRelInsertInput>;
  organisation_suppliers_categories?: InputMaybe<OrganisationSuppliersCategoriesArrRelInsertInput>;
  organisation_suppliers_requests?: InputMaybe<RequestsArrRelInsertInput>;
  paymentMethod?: InputMaybe<PaymentMethodsObjRelInsertInput>;
  paymentMethodId?: InputMaybe<Scalars['uuid']['input']>;
  paymentTerms?: InputMaybe<PaymentTermsObjRelInsertInput>;
  paymentTermsId?: InputMaybe<Scalars['uuid']['input']>;
  publicId?: InputMaybe<Scalars['Int']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  remoteLink?: InputMaybe<Scalars['String']['input']>;
  rfx_suppliers?: InputMaybe<RfxSuppliersArrRelInsertInput>;
  risks?: InputMaybe<RisksArrRelInsertInput>;
  state?: InputMaybe<OrganisationSupplierStateEnum>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  terminalCategoryId?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type OrganisationSuppliersMaxFields = {
  __typename?: 'organisation_suppliers_max_fields';
  archivedBy: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deleted_at: Maybe<Scalars['timestamptz']['output']>;
  description: Maybe<Scalars['String']['output']>;
  externalLink: Maybe<Scalars['String']['output']>;
  externalRiskScoreId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  lastAssessmentDate: Maybe<Scalars['timestamptz']['output']>;
  legalName: Maybe<Scalars['String']['output']>;
  logoUrl: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationIntegrationId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierBrandId: Maybe<Scalars['uuid']['output']>;
  paymentMethodId: Maybe<Scalars['uuid']['output']>;
  paymentTermsId: Maybe<Scalars['uuid']['output']>;
  publicId: Maybe<Scalars['Int']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  remoteLink: Maybe<Scalars['String']['output']>;
  taxNumber: Maybe<Scalars['String']['output']>;
  terminalCategoryId: Maybe<Scalars['uuid']['output']>;
  /** Total spend from engagements and agreements (with FX rates and payment interval multipliers) */
  totalSpend: Maybe<Scalars['numeric']['output']>;
  updated_at: Maybe<Scalars['timestamptz']['output']>;
  website: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type OrganisationSuppliersMinFields = {
  __typename?: 'organisation_suppliers_min_fields';
  archivedBy: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deleted_at: Maybe<Scalars['timestamptz']['output']>;
  description: Maybe<Scalars['String']['output']>;
  externalLink: Maybe<Scalars['String']['output']>;
  externalRiskScoreId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  lastAssessmentDate: Maybe<Scalars['timestamptz']['output']>;
  legalName: Maybe<Scalars['String']['output']>;
  logoUrl: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationIntegrationId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierBrandId: Maybe<Scalars['uuid']['output']>;
  paymentMethodId: Maybe<Scalars['uuid']['output']>;
  paymentTermsId: Maybe<Scalars['uuid']['output']>;
  publicId: Maybe<Scalars['Int']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  remoteLink: Maybe<Scalars['String']['output']>;
  taxNumber: Maybe<Scalars['String']['output']>;
  terminalCategoryId: Maybe<Scalars['uuid']['output']>;
  /** Total spend from engagements and agreements (with FX rates and payment interval multipliers) */
  totalSpend: Maybe<Scalars['numeric']['output']>;
  updated_at: Maybe<Scalars['timestamptz']['output']>;
  website: Maybe<Scalars['String']['output']>;
};

/** input type for inserting object relation for remote table "organisation_suppliers" */
export type OrganisationSuppliersObjRelInsertInput = {
  data: OrganisationSuppliersInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganisationSuppliersOnConflict>;
};

/** on_conflict condition type for table "organisation_suppliers" */
export type OrganisationSuppliersOnConflict = {
  constraint: OrganisationSuppliersConstraint;
  update_columns: Array<OrganisationSuppliersUpdateColumn>;
  where?: InputMaybe<OrganisationSuppliersBoolExp>;
};

/** select columns of table "organisation_suppliers" */
export enum OrganisationSuppliersSelectColumn {
  /** column name */
  ADDRESS = 'address',
  /** column name */
  ARCHIVEDBY = 'archivedBy',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETED_AT = 'deleted_at',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  EMBEDDING = 'embedding',
  /** column name */
  EXTERNALLINK = 'externalLink',
  /** column name */
  EXTERNALRISKSCOREID = 'externalRiskScoreId',
  /** column name */
  FILES = 'files',
  /** column name */
  ID = 'id',
  /** column name */
  ISCONTINUOUSMONITORINGENABLED = 'isContinuousMonitoringEnabled',
  /** column name */
  ISPERSON = 'isPerson',
  /** column name */
  ISPREFERRED = 'isPreferred',
  /** column name */
  ISRESELLER = 'isReseller',
  /** column name */
  LASTASSESSMENTDATE = 'lastAssessmentDate',
  /** column name */
  LEGALNAME = 'legalName',
  /** column name */
  LOGOURL = 'logoUrl',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONINTEGRATIONID = 'organisationIntegrationId',
  /** column name */
  ORGANISATIONSUPPLIERBRANDID = 'organisationSupplierBrandId',
  /** column name */
  PAYMENTMETHODID = 'paymentMethodId',
  /** column name */
  PAYMENTTERMSID = 'paymentTermsId',
  /** column name */
  PUBLICID = 'publicId',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  REMOTELINK = 'remoteLink',
  /** column name */
  STATE = 'state',
  /** column name */
  TAXNUMBER = 'taxNumber',
  /** column name */
  TERMINALCATEGORYID = 'terminalCategoryId',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  WEBSITE = 'website'
}

/** select "organisation_suppliers_aggregate_bool_exp_bool_and_arguments_columns" columns of table "organisation_suppliers" */
export enum OrganisationSuppliersSelectColumnOrganisationSuppliersAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  ISCONTINUOUSMONITORINGENABLED = 'isContinuousMonitoringEnabled',
  /** column name */
  ISPERSON = 'isPerson',
  /** column name */
  ISPREFERRED = 'isPreferred',
  /** column name */
  ISRESELLER = 'isReseller'
}

/** select "organisation_suppliers_aggregate_bool_exp_bool_or_arguments_columns" columns of table "organisation_suppliers" */
export enum OrganisationSuppliersSelectColumnOrganisationSuppliersAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  ISCONTINUOUSMONITORINGENABLED = 'isContinuousMonitoringEnabled',
  /** column name */
  ISPERSON = 'isPerson',
  /** column name */
  ISPREFERRED = 'isPreferred',
  /** column name */
  ISRESELLER = 'isReseller'
}

/** aggregate stddev on columns */
export type OrganisationSuppliersStddevFields = {
  __typename?: 'organisation_suppliers_stddev_fields';
  publicId: Maybe<Scalars['Float']['output']>;
  /** Total spend from engagements and agreements (with FX rates and payment interval multipliers) */
  totalSpend: Maybe<Scalars['numeric']['output']>;
};

/** aggregate stddev_pop on columns */
export type OrganisationSuppliersStddevPopFields = {
  __typename?: 'organisation_suppliers_stddev_pop_fields';
  publicId: Maybe<Scalars['Float']['output']>;
  /** Total spend from engagements and agreements (with FX rates and payment interval multipliers) */
  totalSpend: Maybe<Scalars['numeric']['output']>;
};

/** aggregate stddev_samp on columns */
export type OrganisationSuppliersStddevSampFields = {
  __typename?: 'organisation_suppliers_stddev_samp_fields';
  publicId: Maybe<Scalars['Float']['output']>;
  /** Total spend from engagements and agreements (with FX rates and payment interval multipliers) */
  totalSpend: Maybe<Scalars['numeric']['output']>;
};

/** aggregate sum on columns */
export type OrganisationSuppliersSumFields = {
  __typename?: 'organisation_suppliers_sum_fields';
  publicId: Maybe<Scalars['Int']['output']>;
  /** Total spend from engagements and agreements (with FX rates and payment interval multipliers) */
  totalSpend: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "organisation_suppliers" */
export enum OrganisationSuppliersUpdateColumn {
  /** column name */
  ADDRESS = 'address',
  /** column name */
  ARCHIVEDBY = 'archivedBy',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETED_AT = 'deleted_at',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  EMBEDDING = 'embedding',
  /** column name */
  EXTERNALLINK = 'externalLink',
  /** column name */
  EXTERNALRISKSCOREID = 'externalRiskScoreId',
  /** column name */
  FILES = 'files',
  /** column name */
  ID = 'id',
  /** column name */
  ISCONTINUOUSMONITORINGENABLED = 'isContinuousMonitoringEnabled',
  /** column name */
  ISPERSON = 'isPerson',
  /** column name */
  ISPREFERRED = 'isPreferred',
  /** column name */
  ISRESELLER = 'isReseller',
  /** column name */
  LASTASSESSMENTDATE = 'lastAssessmentDate',
  /** column name */
  LEGALNAME = 'legalName',
  /** column name */
  LOGOURL = 'logoUrl',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONINTEGRATIONID = 'organisationIntegrationId',
  /** column name */
  ORGANISATIONSUPPLIERBRANDID = 'organisationSupplierBrandId',
  /** column name */
  PAYMENTMETHODID = 'paymentMethodId',
  /** column name */
  PAYMENTTERMSID = 'paymentTermsId',
  /** column name */
  PUBLICID = 'publicId',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  REMOTELINK = 'remoteLink',
  /** column name */
  STATE = 'state',
  /** column name */
  TAXNUMBER = 'taxNumber',
  /** column name */
  TERMINALCATEGORYID = 'terminalCategoryId',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  WEBSITE = 'website'
}

/** aggregate var_pop on columns */
export type OrganisationSuppliersVarPopFields = {
  __typename?: 'organisation_suppliers_var_pop_fields';
  publicId: Maybe<Scalars['Float']['output']>;
  /** Total spend from engagements and agreements (with FX rates and payment interval multipliers) */
  totalSpend: Maybe<Scalars['numeric']['output']>;
};

/** aggregate var_samp on columns */
export type OrganisationSuppliersVarSampFields = {
  __typename?: 'organisation_suppliers_var_samp_fields';
  publicId: Maybe<Scalars['Float']['output']>;
  /** Total spend from engagements and agreements (with FX rates and payment interval multipliers) */
  totalSpend: Maybe<Scalars['numeric']['output']>;
};

/** aggregate variance on columns */
export type OrganisationSuppliersVarianceFields = {
  __typename?: 'organisation_suppliers_variance_fields';
  publicId: Maybe<Scalars['Float']['output']>;
  /** Total spend from engagements and agreements (with FX rates and payment interval multipliers) */
  totalSpend: Maybe<Scalars['numeric']['output']>;
};

/** columns and relationships of "organisations" */
export type Organisations = {
  __typename?: 'organisations';
  /** An array relationship */
  bank_details: Array<BankDetails>;
  /** An aggregate relationship */
  bank_details_aggregate: BankDetailsAggregate;
  domain: Scalars['String']['output'];
  /** URL of dark logo to be used in the emails. Has to PNG 2x size */
  email_logo_url_dark: Maybe<Scalars['String']['output']>;
  externalDomains: Maybe<Array<Scalars['String']['output']>>;
  hasDirectorySyncEnabled: Maybe<Scalars['Boolean']['output']>;
  hasScimEnabled: Scalars['Boolean']['output'];
  hasSsoEnabled: Maybe<Scalars['Boolean']['output']>;
  /** URL to a square icon. To be used on a light background */
  iconUrlLight: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  isQa: Scalars['Boolean']['output'];
  languagePreference: Maybe<Scalars['availableLocale']['output']>;
  /** URL to a horizontal logo. To be used on a dark background */
  logoUrlDark: Maybe<Scalars['String']['output']>;
  /** URL to a horizontal logo. To be used on a light background */
  logoUrlLight: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** An array relationship */
  organisationCurrencies: Array<OrganisationFxRates>;
  /** An aggregate relationship */
  organisationCurrencies_aggregate: OrganisationFxRatesAggregate;
  /** An array relationship */
  organisation_products_and_services: Array<OrganisationProductsAndServices>;
  /** An aggregate relationship */
  organisation_products_and_services_aggregate: OrganisationProductsAndServicesAggregate;
  /** An array relationship */
  organisation_suppliers: Array<OrganisationSuppliers>;
  /** An aggregate relationship */
  organisation_suppliers_aggregate: OrganisationSuppliersAggregate;
  /** An array relationship */
  requests: Array<Requests>;
  /** An aggregate relationship */
  requests_aggregate: RequestsAggregate;
  ssoDomains: Maybe<Array<Scalars['String']['output']>>;
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: UsersAggregate;
  website: Scalars['String']['output'];
  /** An array relationship */
  workflows: Array<Workflows>;
  workosOrganisationId: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "organisations". All fields are combined with a logical 'AND'. */
export type OrganisationsBoolExp = {
  _and?: InputMaybe<Array<OrganisationsBoolExp>>;
  _not?: InputMaybe<OrganisationsBoolExp>;
  _or?: InputMaybe<Array<OrganisationsBoolExp>>;
  bank_details?: InputMaybe<BankDetailsBoolExp>;
  bank_details_aggregate?: InputMaybe<BankDetailsAggregateBoolExp>;
  domain?: InputMaybe<StringComparisonExp>;
  email_logo_url_dark?: InputMaybe<StringComparisonExp>;
  externalDomains?: InputMaybe<StringArrayComparisonExp>;
  hasDirectorySyncEnabled?: InputMaybe<BooleanComparisonExp>;
  hasScimEnabled?: InputMaybe<BooleanComparisonExp>;
  hasSsoEnabled?: InputMaybe<BooleanComparisonExp>;
  iconUrlLight?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isQa?: InputMaybe<BooleanComparisonExp>;
  languagePreference?: InputMaybe<StringComparisonExp>;
  logoUrlDark?: InputMaybe<StringComparisonExp>;
  logoUrlLight?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisationCurrencies?: InputMaybe<OrganisationFxRatesBoolExp>;
  organisationCurrencies_aggregate?: InputMaybe<OrganisationFxRatesAggregateBoolExp>;
  organisation_products_and_services?: InputMaybe<OrganisationProductsAndServicesBoolExp>;
  organisation_products_and_services_aggregate?: InputMaybe<OrganisationProductsAndServicesAggregateBoolExp>;
  organisation_suppliers?: InputMaybe<OrganisationSuppliersBoolExp>;
  organisation_suppliers_aggregate?: InputMaybe<OrganisationSuppliersAggregateBoolExp>;
  requests?: InputMaybe<RequestsBoolExp>;
  requests_aggregate?: InputMaybe<RequestsAggregateBoolExp>;
  ssoDomains?: InputMaybe<StringArrayComparisonExp>;
  users?: InputMaybe<UsersBoolExp>;
  users_aggregate?: InputMaybe<UsersAggregateBoolExp>;
  website?: InputMaybe<StringComparisonExp>;
  workflows?: InputMaybe<WorkflowsBoolExp>;
  workosOrganisationId?: InputMaybe<StringComparisonExp>;
};

/** columns and relationships of "pause_reasons" */
export type PauseReasons = {
  __typename?: 'pause_reasons';
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  text: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "pause_reasons". All fields are combined with a logical 'AND'. */
export type PauseReasonsBoolExp = {
  _and?: InputMaybe<Array<PauseReasonsBoolExp>>;
  _not?: InputMaybe<PauseReasonsBoolExp>;
  _or?: InputMaybe<Array<PauseReasonsBoolExp>>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  text?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "pause_reasons" */
export enum PauseReasonsConstraint {
  /** unique or primary key constraint on columns "id" */
  PAUSE_REASONS_PKEY = 'pause_reasons_pkey'
}

/** input type for inserting data into table "pause_reasons" */
export type PauseReasonsInsertInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting object relation for remote table "pause_reasons" */
export type PauseReasonsObjRelInsertInput = {
  data: PauseReasonsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<PauseReasonsOnConflict>;
};

/** on_conflict condition type for table "pause_reasons" */
export type PauseReasonsOnConflict = {
  constraint: PauseReasonsConstraint;
  update_columns: Array<PauseReasonsUpdateColumn>;
  where?: InputMaybe<PauseReasonsBoolExp>;
};

/** placeholder for update columns of table "pause_reasons" (current role has no relevant permissions) */
export enum PauseReasonsUpdateColumn {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

/** columns and relationships of "payment_interval" */
export type PaymentInterval = {
  __typename?: 'payment_interval';
  description: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  financials: Array<Financials>;
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "payment_interval". All fields are combined with a logical 'AND'. */
export type PaymentIntervalBoolExp = {
  _and?: InputMaybe<Array<PaymentIntervalBoolExp>>;
  _not?: InputMaybe<PaymentIntervalBoolExp>;
  _or?: InputMaybe<Array<PaymentIntervalBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  financials?: InputMaybe<FinancialsBoolExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum PaymentIntervalEnum {
  /** Every six months */
  EVERY_SIX_MONTHS = 'EVERY_SIX_MONTHS',
  /** Every two years */
  EVERY_TWO_YEARS = 'EVERY_TWO_YEARS',
  /** Month */
  MONTH = 'MONTH',
  /** Multi year */
  MULTI_YEAR = 'MULTI_YEAR',
  /** One off */
  ONE_OFF = 'ONE_OFF',
  /** Quarter */
  QUARTER = 'QUARTER',
  /** Weekly */
  WEEK = 'WEEK',
  /** Year */
  YEAR = 'YEAR'
}

/** Boolean expression to compare columns of type "payment_interval_enum". All fields are combined with logical 'AND'. */
export type PaymentIntervalEnumComparisonExp = {
  _eq?: InputMaybe<PaymentIntervalEnum>;
  _in?: InputMaybe<Array<PaymentIntervalEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<PaymentIntervalEnum>;
  _nin?: InputMaybe<Array<PaymentIntervalEnum>>;
};

/** columns and relationships of "payment_methods" */
export type PaymentMethods = {
  __typename?: 'payment_methods';
  archivedBy: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  coreData: CoreData;
  coreDataId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organisationId: Scalars['uuid']['output'];
  remoteId: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "payment_methods". All fields are combined with a logical 'AND'. */
export type PaymentMethodsBoolExp = {
  _and?: InputMaybe<Array<PaymentMethodsBoolExp>>;
  _not?: InputMaybe<PaymentMethodsBoolExp>;
  _or?: InputMaybe<Array<PaymentMethodsBoolExp>>;
  archivedBy?: InputMaybe<StringComparisonExp>;
  coreData?: InputMaybe<CoreDataBoolExp>;
  coreDataId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isArchived?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  remoteId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "payment_methods" */
export enum PaymentMethodsConstraint {
  /** unique or primary key constraint on columns "id" */
  PAYMENT_METHODS_PKEY = 'payment_methods_pkey',
  /** unique or primary key constraint on columns "remote_id", "organisation_id" */
  PAYMENT_METHODS_REMOTE_ID_ORGANISATION_ID_KEY = 'payment_methods_remote_id_organisation_id_key'
}

/** input type for inserting data into table "payment_methods" */
export type PaymentMethodsInsertInput = {
  archivedBy?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** input type for inserting object relation for remote table "payment_methods" */
export type PaymentMethodsObjRelInsertInput = {
  data: PaymentMethodsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<PaymentMethodsOnConflict>;
};

/** on_conflict condition type for table "payment_methods" */
export type PaymentMethodsOnConflict = {
  constraint: PaymentMethodsConstraint;
  update_columns: Array<PaymentMethodsUpdateColumn>;
  where?: InputMaybe<PaymentMethodsBoolExp>;
};

/** update columns of table "payment_methods" */
export enum PaymentMethodsUpdateColumn {
  /** column name */
  ARCHIVEDBY = 'archivedBy',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  NAME = 'name',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** columns and relationships of "payment_terms" */
export type PaymentTerms = {
  __typename?: 'payment_terms';
  organisationId: Scalars['uuid']['output'];
  archivedBy: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  coreData: CoreData;
  coreDataId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  remoteId: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "payment_terms". All fields are combined with a logical 'AND'. */
export type PaymentTermsBoolExp = {
  _and?: InputMaybe<Array<PaymentTermsBoolExp>>;
  _not?: InputMaybe<PaymentTermsBoolExp>;
  _or?: InputMaybe<Array<PaymentTermsBoolExp>>;
  archivedBy?: InputMaybe<StringComparisonExp>;
  coreData?: InputMaybe<CoreDataBoolExp>;
  coreDataId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isArchived?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  remoteId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "payment_terms" */
export enum PaymentTermsConstraint {
  /** unique or primary key constraint on columns "id" */
  PAYMENT_TERMS_PKEY = 'payment_terms_pkey',
  /** unique or primary key constraint on columns "remote_id", "organisation_id" */
  PAYMENT_TERMS_REMOTE_ID_ORGANISATION_ID_KEY = 'payment_terms_remote_id_organisation_id_key'
}

/** input type for inserting data into table "payment_terms" */
export type PaymentTermsInsertInput = {
  archivedBy?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** input type for inserting object relation for remote table "payment_terms" */
export type PaymentTermsObjRelInsertInput = {
  data: PaymentTermsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<PaymentTermsOnConflict>;
};

/** on_conflict condition type for table "payment_terms" */
export type PaymentTermsOnConflict = {
  constraint: PaymentTermsConstraint;
  update_columns: Array<PaymentTermsUpdateColumn>;
  where?: InputMaybe<PaymentTermsBoolExp>;
};

/** update columns of table "payment_terms" */
export enum PaymentTermsUpdateColumn {
  /** column name */
  ARCHIVEDBY = 'archivedBy',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  NAME = 'name',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** columns and relationships of "product_catalogue_access_approvers" */
export type ProductCatalogueAccessApprovers = {
  __typename?: 'product_catalogue_access_approvers';
  /** An object relationship */
  group: Maybe<Groups>;
  groupId: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  productCatalogueEntryId: Scalars['uuid']['output'];
  /** An object relationship */
  product_catalogue_entry: ProductCatalogueEntries;
  /** An object relationship */
  user: Maybe<Users>;
  userId: Maybe<Scalars['uuid']['output']>;
};

/** input type for inserting array relation for remote table "product_catalogue_access_approvers" */
export type ProductCatalogueAccessApproversArrRelInsertInput = {
  data: Array<ProductCatalogueAccessApproversInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProductCatalogueAccessApproversOnConflict>;
};

/** Boolean expression to filter rows from the table "product_catalogue_access_approvers". All fields are combined with a logical 'AND'. */
export type ProductCatalogueAccessApproversBoolExp = {
  _and?: InputMaybe<Array<ProductCatalogueAccessApproversBoolExp>>;
  _not?: InputMaybe<ProductCatalogueAccessApproversBoolExp>;
  _or?: InputMaybe<Array<ProductCatalogueAccessApproversBoolExp>>;
  group?: InputMaybe<GroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  productCatalogueEntryId?: InputMaybe<UuidComparisonExp>;
  product_catalogue_entry?: InputMaybe<ProductCatalogueEntriesBoolExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "product_catalogue_access_approvers" */
export enum ProductCatalogueAccessApproversConstraint {
  /** unique or primary key constraint on columns "id" */
  PRODUCT_CATALOGUE_ACCESS_APPROVERS_PKEY = 'product_catalogue_access_approvers_pkey',
  /** unique or primary key constraint on columns "product_catalogue_entry_id", "group_id" */
  UNIQUE_ACCESS_APPROVER_GROUP_ENTRY = 'unique_access_approver_group_entry',
  /** unique or primary key constraint on columns "user_id", "product_catalogue_entry_id" */
  UNIQUE_ACCESS_APPROVER_USER_ENTRY = 'unique_access_approver_user_entry'
}

/** input type for inserting data into table "product_catalogue_access_approvers" */
export type ProductCatalogueAccessApproversInsertInput = {
  group?: InputMaybe<GroupsObjRelInsertInput>;
  groupId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  productCatalogueEntryId?: InputMaybe<Scalars['uuid']['input']>;
  product_catalogue_entry?: InputMaybe<ProductCatalogueEntriesObjRelInsertInput>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** on_conflict condition type for table "product_catalogue_access_approvers" */
export type ProductCatalogueAccessApproversOnConflict = {
  constraint: ProductCatalogueAccessApproversConstraint;
  update_columns: Array<ProductCatalogueAccessApproversUpdateColumn>;
  where?: InputMaybe<ProductCatalogueAccessApproversBoolExp>;
};

/** placeholder for update columns of table "product_catalogue_access_approvers" (current role has no relevant permissions) */
export enum ProductCatalogueAccessApproversUpdateColumn {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

/** columns and relationships of "product_catalogue_entries" */
export type ProductCatalogueEntries = {
  __typename?: 'product_catalogue_entries';
  accessInstructions: Maybe<Scalars['String']['output']>;
  accessType: Scalars['String']['output'];
  accessUrl: Maybe<Scalars['String']['output']>;
  accessWorkflowId: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  externalEmail: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  organisationProductsAndServicesBrandId: Scalars['uuid']['output'];
  /** An object relationship */
  organisation_products_and_services_brand: OrganisationProductsAndServicesBrands;
  /** An array relationship */
  product_catalogue_access_approvers: Array<ProductCatalogueAccessApprovers>;
  showInCatalogue: Scalars['Boolean']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  workflow: Maybe<Workflows>;
};

/** Boolean expression to filter rows from the table "product_catalogue_entries". All fields are combined with a logical 'AND'. */
export type ProductCatalogueEntriesBoolExp = {
  _and?: InputMaybe<Array<ProductCatalogueEntriesBoolExp>>;
  _not?: InputMaybe<ProductCatalogueEntriesBoolExp>;
  _or?: InputMaybe<Array<ProductCatalogueEntriesBoolExp>>;
  accessInstructions?: InputMaybe<StringComparisonExp>;
  accessType?: InputMaybe<StringComparisonExp>;
  accessUrl?: InputMaybe<StringComparisonExp>;
  accessWorkflowId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  externalEmail?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisationProductsAndServicesBrandId?: InputMaybe<UuidComparisonExp>;
  organisation_products_and_services_brand?: InputMaybe<OrganisationProductsAndServicesBrandsBoolExp>;
  product_catalogue_access_approvers?: InputMaybe<ProductCatalogueAccessApproversBoolExp>;
  showInCatalogue?: InputMaybe<BooleanComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  workflow?: InputMaybe<WorkflowsBoolExp>;
};

/** unique or primary key constraints on table "product_catalogue_entries" */
export enum ProductCatalogueEntriesConstraint {
  /** unique or primary key constraint on columns "organisation_products_and_services_brand_id" */
  PRODUCT_CATALOGUE_ENTRIES_ORGANISATION_PRODUCTS_AND_SERVICES_BR = 'product_catalogue_entries_organisation_products_and_services_br',
  /** unique or primary key constraint on columns "id" */
  PRODUCT_CATALOGUE_ENTRIES_PKEY = 'product_catalogue_entries_pkey'
}

/** input type for inserting data into table "product_catalogue_entries" */
export type ProductCatalogueEntriesInsertInput = {
  accessInstructions?: InputMaybe<Scalars['String']['input']>;
  accessType?: InputMaybe<Scalars['String']['input']>;
  accessUrl?: InputMaybe<Scalars['String']['input']>;
  accessWorkflowId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  externalEmail?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisationProductsAndServicesBrandId?: InputMaybe<Scalars['uuid']['input']>;
  organisation_products_and_services_brand?: InputMaybe<OrganisationProductsAndServicesBrandsObjRelInsertInput>;
  product_catalogue_access_approvers?: InputMaybe<ProductCatalogueAccessApproversArrRelInsertInput>;
  showInCatalogue?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  workflow?: InputMaybe<WorkflowsObjRelInsertInput>;
};

/** input type for inserting object relation for remote table "product_catalogue_entries" */
export type ProductCatalogueEntriesObjRelInsertInput = {
  data: ProductCatalogueEntriesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<ProductCatalogueEntriesOnConflict>;
};

/** on_conflict condition type for table "product_catalogue_entries" */
export type ProductCatalogueEntriesOnConflict = {
  constraint: ProductCatalogueEntriesConstraint;
  update_columns: Array<ProductCatalogueEntriesUpdateColumn>;
  where?: InputMaybe<ProductCatalogueEntriesBoolExp>;
};

/** update columns of table "product_catalogue_entries" */
export enum ProductCatalogueEntriesUpdateColumn {
  /** column name */
  ACCESSINSTRUCTIONS = 'accessInstructions',
  /** column name */
  ACCESSTYPE = 'accessType',
  /** column name */
  ACCESSURL = 'accessUrl',
  /** column name */
  ACCESSWORKFLOWID = 'accessWorkflowId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  EXTERNALEMAIL = 'externalEmail',
  /** column name */
  ORGANISATIONPRODUCTSANDSERVICESBRANDID = 'organisationProductsAndServicesBrandId',
  /** column name */
  SHOWINCATALOGUE = 'showInCatalogue',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** columns and relationships of "products_and_services" */
export type ProductsAndServices = {
  __typename?: 'products_and_services';
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  description: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  functionalDescription: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  logoUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** An array relationship */
  organisation_products_and_services_brands: Array<OrganisationProductsAndServicesBrands>;
  /** An array relationship */
  products_and_services_categories: Array<ProductsAndServicesCategories>;
  raw: Maybe<Scalars['jsonb']['output']>;
  source: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  supplier: Maybe<Suppliers>;
  supplierId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  website: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "products_and_services". All fields are combined with a logical 'AND'. */
export type ProductsAndServicesBoolExp = {
  _and?: InputMaybe<Array<ProductsAndServicesBoolExp>>;
  _not?: InputMaybe<ProductsAndServicesBoolExp>;
  _or?: InputMaybe<Array<ProductsAndServicesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  displayName?: InputMaybe<StringComparisonExp>;
  functionalDescription?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  logoUrl?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisation_products_and_services_brands?: InputMaybe<OrganisationProductsAndServicesBrandsBoolExp>;
  products_and_services_categories?: InputMaybe<ProductsAndServicesCategoriesBoolExp>;
  raw?: InputMaybe<JsonbComparisonExp>;
  source?: InputMaybe<IntComparisonExp>;
  supplier?: InputMaybe<SuppliersBoolExp>;
  supplierId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  website?: InputMaybe<StringComparisonExp>;
};

/** columns and relationships of "products_and_services_categories" */
export type ProductsAndServicesCategories = {
  __typename?: 'products_and_services_categories';
  /** An object relationship */
  category: Categories;
  categoryId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  productsAndServicesId: Scalars['uuid']['output'];
  /** An object relationship */
  products_and_service: ProductsAndServices;
};

/** Boolean expression to filter rows from the table "products_and_services_categories". All fields are combined with a logical 'AND'. */
export type ProductsAndServicesCategoriesBoolExp = {
  _and?: InputMaybe<Array<ProductsAndServicesCategoriesBoolExp>>;
  _not?: InputMaybe<ProductsAndServicesCategoriesBoolExp>;
  _or?: InputMaybe<Array<ProductsAndServicesCategoriesBoolExp>>;
  category?: InputMaybe<CategoriesBoolExp>;
  categoryId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  productsAndServicesId?: InputMaybe<UuidComparisonExp>;
  products_and_service?: InputMaybe<ProductsAndServicesBoolExp>;
};

/** Mapping table purchase_orders to line item custom_field_values */
export type PurchaseOrderLineItems = {
  __typename?: 'purchase_order_line_items';
  amount: Maybe<Scalars['numeric']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  currency: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  customFieldValues: Array<CustomFieldValues>;
  /** An aggregate relationship */
  customFieldValues_aggregate: CustomFieldValuesAggregate;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  lineItemCurrency: Maybe<OrganisationFxRates>;
  lineNumber: Scalars['Int']['output'];
  organisationId: Scalars['uuid']['output'];
  purchaseOrderId: Scalars['uuid']['output'];
  quantity: Maybe<Scalars['numeric']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  remoteStatus: Maybe<Scalars['String']['output']>;
  unitPrice: Maybe<Scalars['numeric']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** input type for inserting array relation for remote table "purchase_order_line_items" */
export type PurchaseOrderLineItemsArrRelInsertInput = {
  data: Array<PurchaseOrderLineItemsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<PurchaseOrderLineItemsOnConflict>;
};

/** Boolean expression to filter rows from the table "purchase_order_line_items". All fields are combined with a logical 'AND'. */
export type PurchaseOrderLineItemsBoolExp = {
  _and?: InputMaybe<Array<PurchaseOrderLineItemsBoolExp>>;
  _not?: InputMaybe<PurchaseOrderLineItemsBoolExp>;
  _or?: InputMaybe<Array<PurchaseOrderLineItemsBoolExp>>;
  amount?: InputMaybe<NumericComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<UuidComparisonExp>;
  customFieldValues?: InputMaybe<CustomFieldValuesBoolExp>;
  customFieldValues_aggregate?: InputMaybe<CustomFieldValuesAggregateBoolExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lineItemCurrency?: InputMaybe<OrganisationFxRatesBoolExp>;
  lineNumber?: InputMaybe<IntComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  purchaseOrderId?: InputMaybe<UuidComparisonExp>;
  quantity?: InputMaybe<NumericComparisonExp>;
  remoteId?: InputMaybe<StringComparisonExp>;
  remoteStatus?: InputMaybe<StringComparisonExp>;
  unitPrice?: InputMaybe<NumericComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "purchase_order_line_items" */
export enum PurchaseOrderLineItemsConstraint {
  /** unique or primary key constraint on columns "id" */
  PURCHASE_ORDER_LINE_ITEMS_PKEY = 'purchase_order_line_items_pkey'
}

/** input type for inserting data into table "purchase_order_line_items" */
export type PurchaseOrderLineItemsInsertInput = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  currency?: InputMaybe<Scalars['uuid']['input']>;
  customFieldValues?: InputMaybe<CustomFieldValuesArrRelInsertInput>;
  lineItemCurrency?: InputMaybe<OrganisationFxRatesObjRelInsertInput>;
  lineNumber?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrderId?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  remoteStatus?: InputMaybe<Scalars['String']['input']>;
  unitPrice?: InputMaybe<Scalars['numeric']['input']>;
};

/** on_conflict condition type for table "purchase_order_line_items" */
export type PurchaseOrderLineItemsOnConflict = {
  constraint: PurchaseOrderLineItemsConstraint;
  update_columns: Array<PurchaseOrderLineItemsUpdateColumn>;
  where?: InputMaybe<PurchaseOrderLineItemsBoolExp>;
};

/** update columns of table "purchase_order_line_items" */
export enum PurchaseOrderLineItemsUpdateColumn {
  /** column name */
  AMOUNT = 'amount',
  /** column name */
  CURRENCY = 'currency',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  LINENUMBER = 'lineNumber',
  /** column name */
  PURCHASEORDERID = 'purchaseOrderId',
  /** column name */
  QUANTITY = 'quantity',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  REMOTESTATUS = 'remoteStatus',
  /** column name */
  UNITPRICE = 'unitPrice',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** columns and relationships of "purchase_orders" */
export type PurchaseOrders = {
  __typename?: 'purchase_orders';
  contractEndDate: Maybe<Scalars['timestamptz']['output']>;
  contractStartDate: Maybe<Scalars['timestamptz']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  currency: Maybe<OrganisationFxRates>;
  currencyId: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  customFieldValues: Array<CustomFieldValues>;
  /** An aggregate relationship */
  customFieldValues_aggregate: CustomFieldValuesAggregate;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  department: Maybe<Departments>;
  departmentId: Maybe<Scalars['uuid']['output']>;
  formSubmissionId: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  isPurchaseAgreement: Scalars['Boolean']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  organisationIntegration: Maybe<OrganisationIntegrations>;
  organisationIntegrationId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  organisationSupplier: OrganisationSuppliers;
  /** An object relationship */
  paymentMethod: Maybe<PaymentMethods>;
  paymentMethodId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  paymentTerm: Maybe<PaymentTerms>;
  paymentTermId: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  purchaseOrderLineItems: Array<PurchaseOrderLineItems>;
  remoteId: Maybe<Scalars['String']['output']>;
  remoteInvoicedValue: Scalars['numeric']['output'];
  remoteLink: Maybe<Scalars['String']['output']>;
  remoteNumber: Maybe<Scalars['String']['output']>;
  remotePaidValue: Scalars['numeric']['output'];
  remoteStatus: Maybe<Scalars['String']['output']>;
  remoteTotalValue: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  request: Requests;
  /** An object relationship */
  requestFormSubmission: Maybe<RequestFormSubmissions>;
  requestId: Scalars['uuid']['output'];
  /** An object relationship */
  requestor: Maybe<Users>;
  requestorId: Maybe<Scalars['uuid']['output']>;
  status: Scalars['String']['output'];
  /** An object relationship */
  subsidiary: Maybe<Subsidiaries>;
  subsidiaryId: Maybe<Scalars['uuid']['output']>;
  supplierId: Scalars['uuid']['output'];
  totalValue: Scalars['numeric']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** input type for inserting array relation for remote table "purchase_orders" */
export type PurchaseOrdersArrRelInsertInput = {
  data: Array<PurchaseOrdersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<PurchaseOrdersOnConflict>;
};

/** Boolean expression to filter rows from the table "purchase_orders". All fields are combined with a logical 'AND'. */
export type PurchaseOrdersBoolExp = {
  _and?: InputMaybe<Array<PurchaseOrdersBoolExp>>;
  _not?: InputMaybe<PurchaseOrdersBoolExp>;
  _or?: InputMaybe<Array<PurchaseOrdersBoolExp>>;
  contractEndDate?: InputMaybe<TimestamptzComparisonExp>;
  contractStartDate?: InputMaybe<TimestamptzComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<OrganisationFxRatesBoolExp>;
  currencyId?: InputMaybe<UuidComparisonExp>;
  customFieldValues?: InputMaybe<CustomFieldValuesBoolExp>;
  customFieldValues_aggregate?: InputMaybe<CustomFieldValuesAggregateBoolExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  department?: InputMaybe<DepartmentsBoolExp>;
  departmentId?: InputMaybe<UuidComparisonExp>;
  formSubmissionId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isPurchaseAgreement?: InputMaybe<BooleanComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsBoolExp>;
  organisationIntegrationId?: InputMaybe<UuidComparisonExp>;
  organisationSupplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  paymentMethod?: InputMaybe<PaymentMethodsBoolExp>;
  paymentMethodId?: InputMaybe<UuidComparisonExp>;
  paymentTerm?: InputMaybe<PaymentTermsBoolExp>;
  paymentTermId?: InputMaybe<UuidComparisonExp>;
  purchaseOrderLineItems?: InputMaybe<PurchaseOrderLineItemsBoolExp>;
  remoteId?: InputMaybe<StringComparisonExp>;
  remoteInvoicedValue?: InputMaybe<NumericComparisonExp>;
  remoteLink?: InputMaybe<StringComparisonExp>;
  remoteNumber?: InputMaybe<StringComparisonExp>;
  remotePaidValue?: InputMaybe<NumericComparisonExp>;
  remoteStatus?: InputMaybe<StringComparisonExp>;
  remoteTotalValue?: InputMaybe<NumericComparisonExp>;
  request?: InputMaybe<RequestsBoolExp>;
  requestFormSubmission?: InputMaybe<RequestFormSubmissionsBoolExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  requestor?: InputMaybe<UsersBoolExp>;
  requestorId?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  subsidiary?: InputMaybe<SubsidiariesBoolExp>;
  subsidiaryId?: InputMaybe<UuidComparisonExp>;
  supplierId?: InputMaybe<UuidComparisonExp>;
  totalValue?: InputMaybe<NumericComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "purchase_orders" */
export enum PurchaseOrdersConstraint {
  /** unique or primary key constraint on columns "id" */
  PURCHASE_ORDERS_PKEY = 'purchase_orders_pkey',
  /** unique or primary key constraint on columns "remote_id", "organisation_id" */
  PURCHASE_ORDERS_REMOTE_ID_ORGANISATION_ID_ACTIVE_UNIQUE = 'purchase_orders_remote_id_organisation_id_active_unique'
}

/** input type for inserting data into table "purchase_orders" */
export type PurchaseOrdersInsertInput = {
  contractEndDate?: InputMaybe<Scalars['timestamptz']['input']>;
  contractStartDate?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<OrganisationFxRatesObjRelInsertInput>;
  currencyId?: InputMaybe<Scalars['uuid']['input']>;
  customFieldValues?: InputMaybe<CustomFieldValuesArrRelInsertInput>;
  department?: InputMaybe<DepartmentsObjRelInsertInput>;
  departmentId?: InputMaybe<Scalars['uuid']['input']>;
  formSubmissionId?: InputMaybe<Scalars['uuid']['input']>;
  isPurchaseAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsObjRelInsertInput>;
  organisationIntegrationId?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  paymentMethod?: InputMaybe<PaymentMethodsObjRelInsertInput>;
  paymentMethodId?: InputMaybe<Scalars['uuid']['input']>;
  paymentTerm?: InputMaybe<PaymentTermsObjRelInsertInput>;
  paymentTermId?: InputMaybe<Scalars['uuid']['input']>;
  purchaseOrderLineItems?: InputMaybe<PurchaseOrderLineItemsArrRelInsertInput>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  remoteInvoicedValue?: InputMaybe<Scalars['numeric']['input']>;
  remoteLink?: InputMaybe<Scalars['String']['input']>;
  remoteNumber?: InputMaybe<Scalars['String']['input']>;
  remotePaidValue?: InputMaybe<Scalars['numeric']['input']>;
  remoteStatus?: InputMaybe<Scalars['String']['input']>;
  remoteTotalValue?: InputMaybe<Scalars['numeric']['input']>;
  request?: InputMaybe<RequestsObjRelInsertInput>;
  requestFormSubmission?: InputMaybe<RequestFormSubmissionsObjRelInsertInput>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  requestor?: InputMaybe<UsersObjRelInsertInput>;
  requestorId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subsidiary?: InputMaybe<SubsidiariesObjRelInsertInput>;
  subsidiaryId?: InputMaybe<Scalars['uuid']['input']>;
  supplierId?: InputMaybe<Scalars['uuid']['input']>;
  totalValue?: InputMaybe<Scalars['numeric']['input']>;
};

/** on_conflict condition type for table "purchase_orders" */
export type PurchaseOrdersOnConflict = {
  constraint: PurchaseOrdersConstraint;
  update_columns: Array<PurchaseOrdersUpdateColumn>;
  where?: InputMaybe<PurchaseOrdersBoolExp>;
};

/** update columns of table "purchase_orders" */
export enum PurchaseOrdersUpdateColumn {
  /** column name */
  CONTRACTENDDATE = 'contractEndDate',
  /** column name */
  CONTRACTSTARTDATE = 'contractStartDate',
  /** column name */
  CURRENCYID = 'currencyId',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DEPARTMENTID = 'departmentId',
  /** column name */
  FORMSUBMISSIONID = 'formSubmissionId',
  /** column name */
  ISPURCHASEAGREEMENT = 'isPurchaseAgreement',
  /** column name */
  ORGANISATIONINTEGRATIONID = 'organisationIntegrationId',
  /** column name */
  PAYMENTMETHODID = 'paymentMethodId',
  /** column name */
  PAYMENTTERMID = 'paymentTermId',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  REMOTEINVOICEDVALUE = 'remoteInvoicedValue',
  /** column name */
  REMOTELINK = 'remoteLink',
  /** column name */
  REMOTENUMBER = 'remoteNumber',
  /** column name */
  REMOTEPAIDVALUE = 'remotePaidValue',
  /** column name */
  REMOTESTATUS = 'remoteStatus',
  /** column name */
  REMOTETOTALVALUE = 'remoteTotalValue',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  REQUESTORID = 'requestorId',
  /** column name */
  STATUS = 'status',
  /** column name */
  SUBSIDIARYID = 'subsidiaryId',
  /** column name */
  SUPPLIERID = 'supplierId',
  /** column name */
  TOTALVALUE = 'totalValue',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** columns and relationships of "purchase_type" */
export type PurchaseType = {
  __typename?: 'purchase_type';
  description: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  financials: Array<Financials>;
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "purchase_type". All fields are combined with a logical 'AND'. */
export type PurchaseTypeBoolExp = {
  _and?: InputMaybe<Array<PurchaseTypeBoolExp>>;
  _not?: InputMaybe<PurchaseTypeBoolExp>;
  _or?: InputMaybe<Array<PurchaseTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  financials?: InputMaybe<FinancialsBoolExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum PurchaseTypeEnum {
  /** Fixed Term Contract  */
  FIXED_TERM = 'FIXED_TERM',
  /** One-off */
  ONE_OFF = 'ONE_OFF',
  /** Rolling Contract / Subscription */
  ROLLING = 'ROLLING'
}

/** Boolean expression to compare columns of type "purchase_type_enum". All fields are combined with logical 'AND'. */
export type PurchaseTypeEnumComparisonExp = {
  _eq?: InputMaybe<PurchaseTypeEnum>;
  _in?: InputMaybe<Array<PurchaseTypeEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<PurchaseTypeEnum>;
  _nin?: InputMaybe<Array<PurchaseTypeEnum>>;
};

/** columns and relationships of "renewal_additional_users" */
export type RenewalAdditionalUsers = {
  __typename?: 'renewal_additional_users';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  renewal: Renewals;
  renewalId: Scalars['uuid']['output'];
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** input type for inserting array relation for remote table "renewal_additional_users" */
export type RenewalAdditionalUsersArrRelInsertInput = {
  data: Array<RenewalAdditionalUsersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RenewalAdditionalUsersOnConflict>;
};

/** Boolean expression to filter rows from the table "renewal_additional_users". All fields are combined with a logical 'AND'. */
export type RenewalAdditionalUsersBoolExp = {
  _and?: InputMaybe<Array<RenewalAdditionalUsersBoolExp>>;
  _not?: InputMaybe<RenewalAdditionalUsersBoolExp>;
  _or?: InputMaybe<Array<RenewalAdditionalUsersBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  renewal?: InputMaybe<RenewalsBoolExp>;
  renewalId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "renewal_additional_users" */
export enum RenewalAdditionalUsersConstraint {
  /** unique or primary key constraint on columns "id" */
  RENEWAL_ADDITIONAL_USERS_PKEY = 'renewal_additional_users_pkey',
  /** unique or primary key constraint on columns "user_id", "renewal_id" */
  RENEWAL_ID_USER_ID_KEY = 'renewal_id_user_id_key'
}

/** input type for inserting data into table "renewal_additional_users" */
export type RenewalAdditionalUsersInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  renewal?: InputMaybe<RenewalsObjRelInsertInput>;
  renewalId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** on_conflict condition type for table "renewal_additional_users" */
export type RenewalAdditionalUsersOnConflict = {
  constraint: RenewalAdditionalUsersConstraint;
  update_columns: Array<RenewalAdditionalUsersUpdateColumn>;
  where?: InputMaybe<RenewalAdditionalUsersBoolExp>;
};

/** update columns of table "renewal_additional_users" */
export enum RenewalAdditionalUsersUpdateColumn {
  /** column name */
  ID = 'id',
  /** column name */
  RENEWALID = 'renewalId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId'
}

/** columns and relationships of "renewal_tags" */
export type RenewalTags = {
  __typename?: 'renewal_tags';
  id: Scalars['uuid']['output'];
  /** An object relationship */
  renewal: Renewals;
  renewalId: Scalars['uuid']['output'];
  /** An object relationship */
  tag: Tags;
  tagId: Scalars['uuid']['output'];
};

/** input type for inserting array relation for remote table "renewal_tags" */
export type RenewalTagsArrRelInsertInput = {
  data: Array<RenewalTagsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RenewalTagsOnConflict>;
};

/** Boolean expression to filter rows from the table "renewal_tags". All fields are combined with a logical 'AND'. */
export type RenewalTagsBoolExp = {
  _and?: InputMaybe<Array<RenewalTagsBoolExp>>;
  _not?: InputMaybe<RenewalTagsBoolExp>;
  _or?: InputMaybe<Array<RenewalTagsBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
  renewal?: InputMaybe<RenewalsBoolExp>;
  renewalId?: InputMaybe<UuidComparisonExp>;
  tag?: InputMaybe<TagsBoolExp>;
  tagId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "renewal_tags" */
export enum RenewalTagsConstraint {
  /** unique or primary key constraint on columns "id" */
  RENEWAL_TAGS_PKEY = 'renewal_tags_pkey',
  /** unique or primary key constraint on columns "renewal_id", "tag_id" */
  RENEWAL_TAGS_RENEWAL_ID_TAG_ID_KEY = 'renewal_tags_renewal_id_tag_id_key'
}

/** input type for inserting data into table "renewal_tags" */
export type RenewalTagsInsertInput = {
  renewal?: InputMaybe<RenewalsObjRelInsertInput>;
  renewalId?: InputMaybe<Scalars['uuid']['input']>;
  tag?: InputMaybe<TagsObjRelInsertInput>;
  tagId?: InputMaybe<Scalars['uuid']['input']>;
};

/** on_conflict condition type for table "renewal_tags" */
export type RenewalTagsOnConflict = {
  constraint: RenewalTagsConstraint;
  update_columns: Array<RenewalTagsUpdateColumn>;
  where?: InputMaybe<RenewalTagsBoolExp>;
};

/** placeholder for update columns of table "renewal_tags" (current role has no relevant permissions) */
export enum RenewalTagsUpdateColumn {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

/** columns and relationships of "renewals" */
export type Renewals = {
  __typename?: 'renewals';
  autoStartEnabled: Scalars['Boolean']['output'];
  cancellationNoticeDayCount: Maybe<Scalars['Int']['output']>;
  cancelledAt: Maybe<Scalars['timestamptz']['output']>;
  costCurrency: Scalars['currencyCode']['output'];
  costValue: Scalars['numeric']['output'];
  /** An object relationship */
  createdAgreementTerm: Maybe<AgreementTerms>;
  createdAgreementTermId: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  department: Maybe<Departments>;
  departmentId: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  note: Maybe<Scalars['String']['output']>;
  organisationId: Scalars['uuid']['output'];
  organisationProductId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Scalars['uuid']['output'];
  /** An object relationship */
  product: Maybe<OrganisationProductsAndServices>;
  /** An array relationship */
  renewalAdditionalUsers: Array<RenewalAdditionalUsers>;
  renewalDate: Scalars['timestamptz']['output'];
  /** An array relationship */
  renewalTags: Array<RenewalTags>;
  renewedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  request: Maybe<Requests>;
  requestId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  sourceAgreementTerm: Maybe<AgreementTerms>;
  sourceAgreementTermId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  sourceRequest: Maybe<Requests>;
  sourceRequestId: Maybe<Scalars['uuid']['output']>;
  status: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  supplier: OrganisationSuppliers;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  workflow: Maybe<Workflows>;
  workflowId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  workflowInitialAssignee: Maybe<Users>;
  workflowInitialAssigneeId: Maybe<Scalars['uuid']['output']>;
  workflowStartDate: Maybe<Scalars['date']['output']>;
  workflowStartDayCount: Scalars['Int']['output'];
};

/** aggregated selection of "renewals" */
export type RenewalsAggregate = {
  __typename?: 'renewals_aggregate';
  aggregate: Maybe<RenewalsAggregateFields>;
  nodes: Array<Renewals>;
};

export type RenewalsAggregateBoolExp = {
  bool_and?: InputMaybe<RenewalsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<RenewalsAggregateBoolExpBoolOr>;
  count?: InputMaybe<RenewalsAggregateBoolExpCount>;
};

export type RenewalsAggregateBoolExpBoolAnd = {
  arguments: RenewalsSelectColumnRenewalsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RenewalsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type RenewalsAggregateBoolExpBoolOr = {
  arguments: RenewalsSelectColumnRenewalsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RenewalsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type RenewalsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RenewalsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RenewalsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "renewals" */
export type RenewalsAggregateFields = {
  __typename?: 'renewals_aggregate_fields';
  avg: Maybe<RenewalsAvgFields>;
  count: Scalars['Int']['output'];
  max: Maybe<RenewalsMaxFields>;
  min: Maybe<RenewalsMinFields>;
  stddev: Maybe<RenewalsStddevFields>;
  stddev_pop: Maybe<RenewalsStddevPopFields>;
  stddev_samp: Maybe<RenewalsStddevSampFields>;
  sum: Maybe<RenewalsSumFields>;
  var_pop: Maybe<RenewalsVarPopFields>;
  var_samp: Maybe<RenewalsVarSampFields>;
  variance: Maybe<RenewalsVarianceFields>;
};

/** input type for inserting array relation for remote table "renewals" */
export type RenewalsArrRelInsertInput = {
  data: Array<RenewalsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RenewalsOnConflict>;
};

/** aggregate avg on columns */
export type RenewalsAvgFields = {
  __typename?: 'renewals_avg_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Float']['output']>;
  costValue: Maybe<Scalars['Float']['output']>;
  workflowStartDayCount: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "renewals". All fields are combined with a logical 'AND'. */
export type RenewalsBoolExp = {
  _and?: InputMaybe<Array<RenewalsBoolExp>>;
  _not?: InputMaybe<RenewalsBoolExp>;
  _or?: InputMaybe<Array<RenewalsBoolExp>>;
  autoStartEnabled?: InputMaybe<BooleanComparisonExp>;
  cancellationNoticeDayCount?: InputMaybe<IntComparisonExp>;
  cancelledAt?: InputMaybe<TimestamptzComparisonExp>;
  costCurrency?: InputMaybe<StringComparisonExp>;
  costValue?: InputMaybe<NumericComparisonExp>;
  createdAgreementTerm?: InputMaybe<AgreementTermsBoolExp>;
  createdAgreementTermId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  department?: InputMaybe<DepartmentsBoolExp>;
  departmentId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  note?: InputMaybe<StringComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisationProductId?: InputMaybe<UuidComparisonExp>;
  organisationSupplierId?: InputMaybe<UuidComparisonExp>;
  product?: InputMaybe<OrganisationProductsAndServicesBoolExp>;
  renewalAdditionalUsers?: InputMaybe<RenewalAdditionalUsersBoolExp>;
  renewalDate?: InputMaybe<TimestamptzComparisonExp>;
  renewalTags?: InputMaybe<RenewalTagsBoolExp>;
  renewedAt?: InputMaybe<TimestamptzComparisonExp>;
  request?: InputMaybe<RequestsBoolExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  sourceAgreementTerm?: InputMaybe<AgreementTermsBoolExp>;
  sourceAgreementTermId?: InputMaybe<UuidComparisonExp>;
  sourceRequest?: InputMaybe<RequestsBoolExp>;
  sourceRequestId?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  supplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  workflow?: InputMaybe<WorkflowsBoolExp>;
  workflowId?: InputMaybe<UuidComparisonExp>;
  workflowInitialAssignee?: InputMaybe<UsersBoolExp>;
  workflowInitialAssigneeId?: InputMaybe<UuidComparisonExp>;
  workflowStartDate?: InputMaybe<DateComparisonExp>;
  workflowStartDayCount?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "renewals" */
export enum RenewalsConstraint {
  /** unique or primary key constraint on columns "request_id" */
  RENEWALS_BY_REQUEST_ID = 'renewals_by_request_id',
  /** unique or primary key constraint on columns "id" */
  RENEWALS_PKEY = 'renewals_pkey',
  /** unique or primary key constraint on columns "source_request_id" */
  RENEWALS_SOURCE_REQUEST_ID_UQ = 'renewals_source_request_id_uq'
}

/** input type for inserting data into table "renewals" */
export type RenewalsInsertInput = {
  autoStartEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  cancellationNoticeDayCount?: InputMaybe<Scalars['Int']['input']>;
  costCurrency?: InputMaybe<Scalars['String']['input']>;
  costValue?: InputMaybe<Scalars['numeric']['input']>;
  createdAgreementTerm?: InputMaybe<AgreementTermsObjRelInsertInput>;
  createdAgreementTermId?: InputMaybe<Scalars['uuid']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  department?: InputMaybe<DepartmentsObjRelInsertInput>;
  departmentId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  organisationProductId?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  product?: InputMaybe<OrganisationProductsAndServicesObjRelInsertInput>;
  renewalAdditionalUsers?: InputMaybe<RenewalAdditionalUsersArrRelInsertInput>;
  renewalDate?: InputMaybe<Scalars['timestamptz']['input']>;
  renewalTags?: InputMaybe<RenewalTagsArrRelInsertInput>;
  renewedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  request?: InputMaybe<RequestsObjRelInsertInput>;
  sourceAgreementTerm?: InputMaybe<AgreementTermsObjRelInsertInput>;
  sourceAgreementTermId?: InputMaybe<Scalars['uuid']['input']>;
  sourceRequest?: InputMaybe<RequestsObjRelInsertInput>;
  sourceRequestId?: InputMaybe<Scalars['uuid']['input']>;
  supplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  workflow?: InputMaybe<WorkflowsObjRelInsertInput>;
  workflowId?: InputMaybe<Scalars['uuid']['input']>;
  workflowInitialAssignee?: InputMaybe<UsersObjRelInsertInput>;
  workflowInitialAssigneeId?: InputMaybe<Scalars['uuid']['input']>;
  workflowStartDate?: InputMaybe<Scalars['date']['input']>;
  workflowStartDayCount?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type RenewalsMaxFields = {
  __typename?: 'renewals_max_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Int']['output']>;
  cancelledAt: Maybe<Scalars['timestamptz']['output']>;
  costCurrency: Maybe<Scalars['String']['output']>;
  costValue: Maybe<Scalars['numeric']['output']>;
  createdAgreementTermId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  departmentId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  note: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  organisationProductId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  renewalDate: Maybe<Scalars['timestamptz']['output']>;
  renewedAt: Maybe<Scalars['timestamptz']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  sourceAgreementTermId: Maybe<Scalars['uuid']['output']>;
  sourceRequestId: Maybe<Scalars['uuid']['output']>;
  status: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  workflowId: Maybe<Scalars['uuid']['output']>;
  workflowInitialAssigneeId: Maybe<Scalars['uuid']['output']>;
  workflowStartDate: Maybe<Scalars['date']['output']>;
  workflowStartDayCount: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type RenewalsMinFields = {
  __typename?: 'renewals_min_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Int']['output']>;
  cancelledAt: Maybe<Scalars['timestamptz']['output']>;
  costCurrency: Maybe<Scalars['String']['output']>;
  costValue: Maybe<Scalars['numeric']['output']>;
  createdAgreementTermId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  departmentId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  note: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  organisationProductId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  renewalDate: Maybe<Scalars['timestamptz']['output']>;
  renewedAt: Maybe<Scalars['timestamptz']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  sourceAgreementTermId: Maybe<Scalars['uuid']['output']>;
  sourceRequestId: Maybe<Scalars['uuid']['output']>;
  status: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  workflowId: Maybe<Scalars['uuid']['output']>;
  workflowInitialAssigneeId: Maybe<Scalars['uuid']['output']>;
  workflowStartDate: Maybe<Scalars['date']['output']>;
  workflowStartDayCount: Maybe<Scalars['Int']['output']>;
};

/** input type for inserting object relation for remote table "renewals" */
export type RenewalsObjRelInsertInput = {
  data: RenewalsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RenewalsOnConflict>;
};

/** on_conflict condition type for table "renewals" */
export type RenewalsOnConflict = {
  constraint: RenewalsConstraint;
  update_columns: Array<RenewalsUpdateColumn>;
  where?: InputMaybe<RenewalsBoolExp>;
};

/** select columns of table "renewals" */
export enum RenewalsSelectColumn {
  /** column name */
  AUTOSTARTENABLED = 'autoStartEnabled',
  /** column name */
  CANCELLATIONNOTICEDAYCOUNT = 'cancellationNoticeDayCount',
  /** column name */
  CANCELLEDAT = 'cancelledAt',
  /** column name */
  COSTCURRENCY = 'costCurrency',
  /** column name */
  COSTVALUE = 'costValue',
  /** column name */
  CREATEDAGREEMENTTERMID = 'createdAgreementTermId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DEPARTMENTID = 'departmentId',
  /** column name */
  ID = 'id',
  /** column name */
  NOTE = 'note',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  ORGANISATIONPRODUCTID = 'organisationProductId',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  RENEWALDATE = 'renewalDate',
  /** column name */
  RENEWEDAT = 'renewedAt',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  SOURCEAGREEMENTTERMID = 'sourceAgreementTermId',
  /** column name */
  SOURCEREQUESTID = 'sourceRequestId',
  /** column name */
  STATUS = 'status',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  WORKFLOWID = 'workflowId',
  /** column name */
  WORKFLOWINITIALASSIGNEEID = 'workflowInitialAssigneeId',
  /** column name */
  WORKFLOWSTARTDATE = 'workflowStartDate',
  /** column name */
  WORKFLOWSTARTDAYCOUNT = 'workflowStartDayCount'
}

/** select "renewals_aggregate_bool_exp_bool_and_arguments_columns" columns of table "renewals" */
export enum RenewalsSelectColumnRenewalsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  AUTOSTARTENABLED = 'autoStartEnabled'
}

/** select "renewals_aggregate_bool_exp_bool_or_arguments_columns" columns of table "renewals" */
export enum RenewalsSelectColumnRenewalsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  AUTOSTARTENABLED = 'autoStartEnabled'
}

/** aggregate stddev on columns */
export type RenewalsStddevFields = {
  __typename?: 'renewals_stddev_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Float']['output']>;
  costValue: Maybe<Scalars['Float']['output']>;
  workflowStartDayCount: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type RenewalsStddevPopFields = {
  __typename?: 'renewals_stddev_pop_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Float']['output']>;
  costValue: Maybe<Scalars['Float']['output']>;
  workflowStartDayCount: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type RenewalsStddevSampFields = {
  __typename?: 'renewals_stddev_samp_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Float']['output']>;
  costValue: Maybe<Scalars['Float']['output']>;
  workflowStartDayCount: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type RenewalsSumFields = {
  __typename?: 'renewals_sum_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Int']['output']>;
  costValue: Maybe<Scalars['numeric']['output']>;
  workflowStartDayCount: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "renewals" */
export enum RenewalsUpdateColumn {
  /** column name */
  AUTOSTARTENABLED = 'autoStartEnabled',
  /** column name */
  CANCELLATIONNOTICEDAYCOUNT = 'cancellationNoticeDayCount',
  /** column name */
  CANCELLEDAT = 'cancelledAt',
  /** column name */
  COSTCURRENCY = 'costCurrency',
  /** column name */
  COSTVALUE = 'costValue',
  /** column name */
  CREATEDAGREEMENTTERMID = 'createdAgreementTermId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DEPARTMENTID = 'departmentId',
  /** column name */
  ID = 'id',
  /** column name */
  NOTE = 'note',
  /** column name */
  ORGANISATIONPRODUCTID = 'organisationProductId',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  RENEWALDATE = 'renewalDate',
  /** column name */
  RENEWEDAT = 'renewedAt',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  SOURCEAGREEMENTTERMID = 'sourceAgreementTermId',
  /** column name */
  SOURCEREQUESTID = 'sourceRequestId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  WORKFLOWID = 'workflowId',
  /** column name */
  WORKFLOWINITIALASSIGNEEID = 'workflowInitialAssigneeId',
  /** column name */
  WORKFLOWSTARTDATE = 'workflowStartDate',
  /** column name */
  WORKFLOWSTARTDAYCOUNT = 'workflowStartDayCount'
}

/** aggregate var_pop on columns */
export type RenewalsVarPopFields = {
  __typename?: 'renewals_var_pop_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Float']['output']>;
  costValue: Maybe<Scalars['Float']['output']>;
  workflowStartDayCount: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type RenewalsVarSampFields = {
  __typename?: 'renewals_var_samp_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Float']['output']>;
  costValue: Maybe<Scalars['Float']['output']>;
  workflowStartDayCount: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type RenewalsVarianceFields = {
  __typename?: 'renewals_variance_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Float']['output']>;
  costValue: Maybe<Scalars['Float']['output']>;
  workflowStartDayCount: Maybe<Scalars['Float']['output']>;
};

/** Type of the comment under a request */
export type RequestCommentType = {
  __typename?: 'request_comment_type';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "request_comment_type". All fields are combined with a logical 'AND'. */
export type RequestCommentTypeBoolExp = {
  _and?: InputMaybe<Array<RequestCommentTypeBoolExp>>;
  _not?: InputMaybe<RequestCommentTypeBoolExp>;
  _or?: InputMaybe<Array<RequestCommentTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum RequestCommentTypeEnum {
  /** AGREEMENT */
  AGREEMENT = 'AGREEMENT',
  /** AMENDMENT_REQUEST */
  AMENDMENT_REQUEST = 'AMENDMENT_REQUEST',
  /** PAUSE */
  PAUSE = 'PAUSE',
  /** REJECTION */
  REJECTION = 'REJECTION',
  /** RESUME */
  RESUME = 'RESUME',
  /** RISK */
  RISK = 'RISK',
  /** RISK_ALERT */
  RISK_ALERT = 'RISK_ALERT',
  /** SUPPLIER */
  SUPPLIER = 'SUPPLIER',
  /** SUPPLIER_ANNOUNCEMENT */
  SUPPLIER_ANNOUNCEMENT = 'SUPPLIER_ANNOUNCEMENT',
  /** TEXT */
  TEXT = 'TEXT',
  /** UNREJECTION */
  UNREJECTION = 'UNREJECTION'
}

/** Boolean expression to compare columns of type "request_comment_type_enum". All fields are combined with logical 'AND'. */
export type RequestCommentTypeEnumComparisonExp = {
  _eq?: InputMaybe<RequestCommentTypeEnum>;
  _in?: InputMaybe<Array<RequestCommentTypeEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<RequestCommentTypeEnum>;
  _nin?: InputMaybe<Array<RequestCommentTypeEnum>>;
};

/** Comments under a request */
export type RequestComments = {
  __typename?: 'request_comments';
  agreementId: Maybe<Scalars['uuid']['output']>;
  auctionId: Maybe<Scalars['uuid']['output']>;
  auctionSupplierId: Maybe<Scalars['uuid']['output']>;
  completedAt: Maybe<Scalars['timestamptz']['output']>;
  completedBy: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  integration: Maybe<Scalars['String']['output']>;
  isInternalComment: Scalars['Boolean']['output'];
  parentCommentId: Maybe<Scalars['uuid']['output']>;
  payload: Scalars['jsonb']['output'];
  questionId: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  request: Maybe<Requests>;
  requestFormId: Maybe<Scalars['uuid']['output']>;
  requestFormTemplateId: Maybe<Scalars['uuid']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  requestStepId: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  request_comment_mentions: Array<RequestCommentsMentions>;
  /** An aggregate relationship */
  request_comment_mentions_aggregate: RequestCommentsMentionsAggregate;
  /** An object relationship */
  request_comment_type: RequestCommentType;
  /** An object relationship */
  request_form: Maybe<RequestForms>;
  /** An object relationship */
  request_form_template: Maybe<RequestFormTemplates>;
  /** An object relationship */
  rfx: Maybe<Rfx>;
  rfxId: Maybe<Scalars['uuid']['output']>;
  rfxSupplierId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  rfx_supplier: Maybe<RfxSuppliers>;
  riskAlertId: Maybe<Scalars['String']['output']>;
  riskId: Maybe<Scalars['uuid']['output']>;
  source: Scalars['String']['output'];
  summaryApprovalId: Maybe<Scalars['uuid']['output']>;
  supplierId: Maybe<Scalars['uuid']['output']>;
  taskId: Maybe<Scalars['uuid']['output']>;
  type: RequestCommentTypeEnum;
  updatedAt: Scalars['timestamptz']['output'];
  userId: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "request_comments" */
export type RequestCommentsAggregate = {
  __typename?: 'request_comments_aggregate';
  aggregate: Maybe<RequestCommentsAggregateFields>;
  nodes: Array<RequestComments>;
};

export type RequestCommentsAggregateBoolExp = {
  bool_and?: InputMaybe<RequestCommentsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<RequestCommentsAggregateBoolExpBoolOr>;
  count?: InputMaybe<RequestCommentsAggregateBoolExpCount>;
};

export type RequestCommentsAggregateBoolExpBoolAnd = {
  arguments: RequestCommentsSelectColumnRequestCommentsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RequestCommentsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type RequestCommentsAggregateBoolExpBoolOr = {
  arguments: RequestCommentsSelectColumnRequestCommentsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RequestCommentsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type RequestCommentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RequestCommentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RequestCommentsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "request_comments" */
export type RequestCommentsAggregateFields = {
  __typename?: 'request_comments_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<RequestCommentsMaxFields>;
  min: Maybe<RequestCommentsMinFields>;
};

/** input type for inserting array relation for remote table "request_comments" */
export type RequestCommentsArrRelInsertInput = {
  data: Array<RequestCommentsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestCommentsOnConflict>;
};

/** Boolean expression to filter rows from the table "request_comments". All fields are combined with a logical 'AND'. */
export type RequestCommentsBoolExp = {
  _and?: InputMaybe<Array<RequestCommentsBoolExp>>;
  _not?: InputMaybe<RequestCommentsBoolExp>;
  _or?: InputMaybe<Array<RequestCommentsBoolExp>>;
  agreementId?: InputMaybe<UuidComparisonExp>;
  auctionId?: InputMaybe<UuidComparisonExp>;
  auctionSupplierId?: InputMaybe<UuidComparisonExp>;
  completedAt?: InputMaybe<TimestamptzComparisonExp>;
  completedBy?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  integration?: InputMaybe<StringComparisonExp>;
  isInternalComment?: InputMaybe<BooleanComparisonExp>;
  parentCommentId?: InputMaybe<UuidComparisonExp>;
  payload?: InputMaybe<JsonbComparisonExp>;
  questionId?: InputMaybe<StringComparisonExp>;
  request?: InputMaybe<RequestsBoolExp>;
  requestFormId?: InputMaybe<UuidComparisonExp>;
  requestFormTemplateId?: InputMaybe<UuidComparisonExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  requestStepId?: InputMaybe<UuidComparisonExp>;
  request_comment_mentions?: InputMaybe<RequestCommentsMentionsBoolExp>;
  request_comment_mentions_aggregate?: InputMaybe<RequestCommentsMentionsAggregateBoolExp>;
  request_comment_type?: InputMaybe<RequestCommentTypeBoolExp>;
  request_form?: InputMaybe<RequestFormsBoolExp>;
  request_form_template?: InputMaybe<RequestFormTemplatesBoolExp>;
  rfx?: InputMaybe<RfxBoolExp>;
  rfxId?: InputMaybe<UuidComparisonExp>;
  rfxSupplierId?: InputMaybe<UuidComparisonExp>;
  rfx_supplier?: InputMaybe<RfxSuppliersBoolExp>;
  riskAlertId?: InputMaybe<StringComparisonExp>;
  riskId?: InputMaybe<UuidComparisonExp>;
  source?: InputMaybe<StringComparisonExp>;
  summaryApprovalId?: InputMaybe<UuidComparisonExp>;
  supplierId?: InputMaybe<UuidComparisonExp>;
  taskId?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<RequestCommentTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "request_comments" */
export enum RequestCommentsConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_COMMENTS_PKEY = 'request_comments_pkey'
}

/** input type for inserting data into table "request_comments" */
export type RequestCommentsInsertInput = {
  agreementId?: InputMaybe<Scalars['uuid']['input']>;
  auctionId?: InputMaybe<Scalars['uuid']['input']>;
  auctionSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  completedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  completedBy?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  integration?: InputMaybe<Scalars['String']['input']>;
  isInternalComment?: InputMaybe<Scalars['Boolean']['input']>;
  parentCommentId?: InputMaybe<Scalars['uuid']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  questionId?: InputMaybe<Scalars['String']['input']>;
  request?: InputMaybe<RequestsObjRelInsertInput>;
  requestFormId?: InputMaybe<Scalars['uuid']['input']>;
  requestFormTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  requestStepId?: InputMaybe<Scalars['uuid']['input']>;
  request_comment_mentions?: InputMaybe<RequestCommentsMentionsArrRelInsertInput>;
  request_form?: InputMaybe<RequestFormsObjRelInsertInput>;
  request_form_template?: InputMaybe<RequestFormTemplatesObjRelInsertInput>;
  rfx?: InputMaybe<RfxObjRelInsertInput>;
  rfxId?: InputMaybe<Scalars['uuid']['input']>;
  rfxSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  rfx_supplier?: InputMaybe<RfxSuppliersObjRelInsertInput>;
  riskAlertId?: InputMaybe<Scalars['String']['input']>;
  riskId?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  summaryApprovalId?: InputMaybe<Scalars['uuid']['input']>;
  supplierId?: InputMaybe<Scalars['uuid']['input']>;
  taskId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<RequestCommentTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type RequestCommentsMaxFields = {
  __typename?: 'request_comments_max_fields';
  agreementId: Maybe<Scalars['uuid']['output']>;
  auctionId: Maybe<Scalars['uuid']['output']>;
  auctionSupplierId: Maybe<Scalars['uuid']['output']>;
  completedAt: Maybe<Scalars['timestamptz']['output']>;
  completedBy: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  integration: Maybe<Scalars['String']['output']>;
  parentCommentId: Maybe<Scalars['uuid']['output']>;
  questionId: Maybe<Scalars['String']['output']>;
  requestFormId: Maybe<Scalars['uuid']['output']>;
  requestFormTemplateId: Maybe<Scalars['uuid']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  requestStepId: Maybe<Scalars['uuid']['output']>;
  rfxId: Maybe<Scalars['uuid']['output']>;
  rfxSupplierId: Maybe<Scalars['uuid']['output']>;
  riskAlertId: Maybe<Scalars['String']['output']>;
  riskId: Maybe<Scalars['uuid']['output']>;
  source: Maybe<Scalars['String']['output']>;
  summaryApprovalId: Maybe<Scalars['uuid']['output']>;
  supplierId: Maybe<Scalars['uuid']['output']>;
  taskId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  userId: Maybe<Scalars['uuid']['output']>;
};

/** Mentions among all comments */
export type RequestCommentsMentions = {
  __typename?: 'request_comments_mentions';
  /** An object relationship */
  agreement: Maybe<Agreements>;
  agreementId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  comment: RequestComments;
  commentId: Scalars['uuid']['output'];
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  isResolved: Scalars['Boolean']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  request: Maybe<Requests>;
  requestId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  risk: Maybe<Risks>;
  riskAlertId: Maybe<Scalars['String']['output']>;
  riskId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  supplier: Maybe<OrganisationSuppliers>;
  supplierId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  user: Maybe<Users>;
  userId: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "request_comments_mentions" */
export type RequestCommentsMentionsAggregate = {
  __typename?: 'request_comments_mentions_aggregate';
  aggregate: Maybe<RequestCommentsMentionsAggregateFields>;
  nodes: Array<RequestCommentsMentions>;
};

export type RequestCommentsMentionsAggregateBoolExp = {
  bool_and?: InputMaybe<RequestCommentsMentionsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<RequestCommentsMentionsAggregateBoolExpBoolOr>;
  count?: InputMaybe<RequestCommentsMentionsAggregateBoolExpCount>;
};

export type RequestCommentsMentionsAggregateBoolExpBoolAnd = {
  arguments: RequestCommentsMentionsSelectColumnRequestCommentsMentionsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RequestCommentsMentionsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type RequestCommentsMentionsAggregateBoolExpBoolOr = {
  arguments: RequestCommentsMentionsSelectColumnRequestCommentsMentionsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RequestCommentsMentionsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type RequestCommentsMentionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RequestCommentsMentionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RequestCommentsMentionsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "request_comments_mentions" */
export type RequestCommentsMentionsAggregateFields = {
  __typename?: 'request_comments_mentions_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<RequestCommentsMentionsMaxFields>;
  min: Maybe<RequestCommentsMentionsMinFields>;
};

/** input type for inserting array relation for remote table "request_comments_mentions" */
export type RequestCommentsMentionsArrRelInsertInput = {
  data: Array<RequestCommentsMentionsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestCommentsMentionsOnConflict>;
};

/** Boolean expression to filter rows from the table "request_comments_mentions". All fields are combined with a logical 'AND'. */
export type RequestCommentsMentionsBoolExp = {
  _and?: InputMaybe<Array<RequestCommentsMentionsBoolExp>>;
  _not?: InputMaybe<RequestCommentsMentionsBoolExp>;
  _or?: InputMaybe<Array<RequestCommentsMentionsBoolExp>>;
  agreement?: InputMaybe<AgreementsBoolExp>;
  agreementId?: InputMaybe<UuidComparisonExp>;
  comment?: InputMaybe<RequestCommentsBoolExp>;
  commentId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isResolved?: InputMaybe<BooleanComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  request?: InputMaybe<RequestsBoolExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  risk?: InputMaybe<RisksBoolExp>;
  riskAlertId?: InputMaybe<StringComparisonExp>;
  riskId?: InputMaybe<UuidComparisonExp>;
  supplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  supplierId?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "request_comments_mentions" */
export enum RequestCommentsMentionsConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_COMMENTS_MENTIONS_PKEY = 'request_comments_mentions_pkey'
}

/** input type for inserting data into table "request_comments_mentions" */
export type RequestCommentsMentionsInsertInput = {
  agreement?: InputMaybe<AgreementsObjRelInsertInput>;
  agreementId?: InputMaybe<Scalars['uuid']['input']>;
  comment?: InputMaybe<RequestCommentsObjRelInsertInput>;
  commentId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  request?: InputMaybe<RequestsObjRelInsertInput>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  risk?: InputMaybe<RisksObjRelInsertInput>;
  riskAlertId?: InputMaybe<Scalars['String']['input']>;
  riskId?: InputMaybe<Scalars['uuid']['input']>;
  supplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  supplierId?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type RequestCommentsMentionsMaxFields = {
  __typename?: 'request_comments_mentions_max_fields';
  agreementId: Maybe<Scalars['uuid']['output']>;
  commentId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  riskAlertId: Maybe<Scalars['String']['output']>;
  riskId: Maybe<Scalars['uuid']['output']>;
  supplierId: Maybe<Scalars['uuid']['output']>;
  userId: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type RequestCommentsMentionsMinFields = {
  __typename?: 'request_comments_mentions_min_fields';
  agreementId: Maybe<Scalars['uuid']['output']>;
  commentId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  riskAlertId: Maybe<Scalars['String']['output']>;
  riskId: Maybe<Scalars['uuid']['output']>;
  supplierId: Maybe<Scalars['uuid']['output']>;
  userId: Maybe<Scalars['uuid']['output']>;
};

/** on_conflict condition type for table "request_comments_mentions" */
export type RequestCommentsMentionsOnConflict = {
  constraint: RequestCommentsMentionsConstraint;
  update_columns: Array<RequestCommentsMentionsUpdateColumn>;
  where?: InputMaybe<RequestCommentsMentionsBoolExp>;
};

/** select columns of table "request_comments_mentions" */
export enum RequestCommentsMentionsSelectColumn {
  /** column name */
  AGREEMENTID = 'agreementId',
  /** column name */
  COMMENTID = 'commentId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ISRESOLVED = 'isResolved',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  RISKALERTID = 'riskAlertId',
  /** column name */
  RISKID = 'riskId',
  /** column name */
  SUPPLIERID = 'supplierId',
  /** column name */
  USERID = 'userId'
}

/** select "request_comments_mentions_aggregate_bool_exp_bool_and_arguments_columns" columns of table "request_comments_mentions" */
export enum RequestCommentsMentionsSelectColumnRequestCommentsMentionsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  ISRESOLVED = 'isResolved'
}

/** select "request_comments_mentions_aggregate_bool_exp_bool_or_arguments_columns" columns of table "request_comments_mentions" */
export enum RequestCommentsMentionsSelectColumnRequestCommentsMentionsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  ISRESOLVED = 'isResolved'
}

/** update columns of table "request_comments_mentions" */
export enum RequestCommentsMentionsUpdateColumn {
  /** column name */
  ISRESOLVED = 'isResolved'
}

/** aggregate min on columns */
export type RequestCommentsMinFields = {
  __typename?: 'request_comments_min_fields';
  agreementId: Maybe<Scalars['uuid']['output']>;
  auctionId: Maybe<Scalars['uuid']['output']>;
  auctionSupplierId: Maybe<Scalars['uuid']['output']>;
  completedAt: Maybe<Scalars['timestamptz']['output']>;
  completedBy: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  integration: Maybe<Scalars['String']['output']>;
  parentCommentId: Maybe<Scalars['uuid']['output']>;
  questionId: Maybe<Scalars['String']['output']>;
  requestFormId: Maybe<Scalars['uuid']['output']>;
  requestFormTemplateId: Maybe<Scalars['uuid']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  requestStepId: Maybe<Scalars['uuid']['output']>;
  rfxId: Maybe<Scalars['uuid']['output']>;
  rfxSupplierId: Maybe<Scalars['uuid']['output']>;
  riskAlertId: Maybe<Scalars['String']['output']>;
  riskId: Maybe<Scalars['uuid']['output']>;
  source: Maybe<Scalars['String']['output']>;
  summaryApprovalId: Maybe<Scalars['uuid']['output']>;
  supplierId: Maybe<Scalars['uuid']['output']>;
  taskId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  userId: Maybe<Scalars['uuid']['output']>;
};

/** input type for inserting object relation for remote table "request_comments" */
export type RequestCommentsObjRelInsertInput = {
  data: RequestCommentsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestCommentsOnConflict>;
};

/** on_conflict condition type for table "request_comments" */
export type RequestCommentsOnConflict = {
  constraint: RequestCommentsConstraint;
  update_columns: Array<RequestCommentsUpdateColumn>;
  where?: InputMaybe<RequestCommentsBoolExp>;
};

/** select columns of table "request_comments" */
export enum RequestCommentsSelectColumn {
  /** column name */
  AGREEMENTID = 'agreementId',
  /** column name */
  AUCTIONID = 'auctionId',
  /** column name */
  AUCTIONSUPPLIERID = 'auctionSupplierId',
  /** column name */
  COMPLETEDAT = 'completedAt',
  /** column name */
  COMPLETEDBY = 'completedBy',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ID = 'id',
  /** column name */
  INTEGRATION = 'integration',
  /** column name */
  ISINTERNALCOMMENT = 'isInternalComment',
  /** column name */
  PARENTCOMMENTID = 'parentCommentId',
  /** column name */
  PAYLOAD = 'payload',
  /** column name */
  QUESTIONID = 'questionId',
  /** column name */
  REQUESTFORMID = 'requestFormId',
  /** column name */
  REQUESTFORMTEMPLATEID = 'requestFormTemplateId',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  REQUESTSTEPID = 'requestStepId',
  /** column name */
  RFXID = 'rfxId',
  /** column name */
  RFXSUPPLIERID = 'rfxSupplierId',
  /** column name */
  RISKALERTID = 'riskAlertId',
  /** column name */
  RISKID = 'riskId',
  /** column name */
  SOURCE = 'source',
  /** column name */
  SUMMARYAPPROVALID = 'summaryApprovalId',
  /** column name */
  SUPPLIERID = 'supplierId',
  /** column name */
  TASKID = 'taskId',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId'
}

/** select "request_comments_aggregate_bool_exp_bool_and_arguments_columns" columns of table "request_comments" */
export enum RequestCommentsSelectColumnRequestCommentsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  ISINTERNALCOMMENT = 'isInternalComment'
}

/** select "request_comments_aggregate_bool_exp_bool_or_arguments_columns" columns of table "request_comments" */
export enum RequestCommentsSelectColumnRequestCommentsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  ISINTERNALCOMMENT = 'isInternalComment'
}

/** update columns of table "request_comments" */
export enum RequestCommentsUpdateColumn {
  /** column name */
  AUCTIONID = 'auctionId',
  /** column name */
  AUCTIONSUPPLIERID = 'auctionSupplierId',
  /** column name */
  COMPLETEDAT = 'completedAt',
  /** column name */
  COMPLETEDBY = 'completedBy',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ID = 'id',
  /** column name */
  ISINTERNALCOMMENT = 'isInternalComment',
  /** column name */
  PAYLOAD = 'payload',
  /** column name */
  QUESTIONID = 'questionId',
  /** column name */
  REQUESTFORMID = 'requestFormId',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  RFXID = 'rfxId',
  /** column name */
  RFXSUPPLIERID = 'rfxSupplierId',
  /** column name */
  SUMMARYAPPROVALID = 'summaryApprovalId',
  /** column name */
  TASKID = 'taskId',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId'
}

/** Properties of a request that are computed from other places including form submissions and workflow conditionality */
export type RequestComputedProperties = {
  __typename?: 'request_computed_properties';
  address: Maybe<Scalars['jsonb']['output']>;
  annualBaselineSpend: Maybe<Scalars['numeric']['output']>;
  annualNegotiatedSavings: Maybe<Scalars['numeric']['output']>;
  annualValueNumber: Maybe<Scalars['numeric']['output']>;
  baselineSpendObject: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  budgetHolder: Maybe<Users>;
  budgetHolderId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  businessOwner: Maybe<Users>;
  businessOwnerId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  buyerLegalEntity: Maybe<Subsidiaries>;
  buyerLegalEntityId: Maybe<Scalars['uuid']['output']>;
  cancelByDate: Maybe<Scalars['timestamptz']['output']>;
  cancellationNoticeDays: Maybe<Scalars['Int']['output']>;
  cancellationReason: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  category: Maybe<CustomCoreDataOptions>;
  /** Reference to category option in custom core data options */
  categoryId: Maybe<Scalars['uuid']['output']>;
  /** Reference to a line item type when the category question is sourced from line-item-types; mutually exclusive with category_id */
  categoryLineItemTypeId: Maybe<Scalars['uuid']['output']>;
  contractEndDate: Maybe<Scalars['timestamptz']['output']>;
  contractLength: Maybe<Scalars['numeric']['output']>;
  contractStartDate: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  costCenter: Maybe<Departments>;
  costCenterId: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  department: Maybe<Departments>;
  departmentId: Maybe<Scalars['uuid']['output']>;
  goLiveDate: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  inBudget: Maybe<Scalars['Boolean']['output']>;
  isAutoRenewal: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  itOwner: Maybe<Users>;
  itOwnerId: Maybe<Scalars['uuid']['output']>;
  lineItemsTotalAmount: Maybe<Scalars['numeric']['output']>;
  lineItemsTotalObject: Maybe<Scalars['jsonb']['output']>;
  lineItemsVsAgreementDeltaAmount: Maybe<Scalars['numeric']['output']>;
  lineItemsVsAgreementDeltaObject: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  market: Maybe<CustomCoreDataOptions>;
  /** Reference to market option in custom core data options */
  marketId: Maybe<Scalars['uuid']['output']>;
  negotiatedSavingsObject: Maybe<Scalars['jsonb']['output']>;
  note: Maybe<Scalars['String']['output']>;
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  paymentMethod: Maybe<PaymentMethods>;
  paymentMethodId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  paymentTerm: Maybe<PaymentTerms>;
  paymentTermId: Maybe<Scalars['uuid']['output']>;
  poNumber: Maybe<Scalars['String']['output']>;
  pricingObject: Maybe<Scalars['jsonb']['output']>;
  renewalDate: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  request: Requests;
  requestId: Scalars['uuid']['output'];
  shouldRenew: Maybe<Scalars['Boolean']['output']>;
  syncWithAccountingIntegration: Maybe<Scalars['Boolean']['output']>;
  taxNumber: Maybe<Scalars['jsonb']['output']>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** This is the value user enters (regardless of the frequency) */
  valueNumber: Maybe<Scalars['numeric']['output']>;
  valueObject: Maybe<Scalars['jsonb']['output']>;
  website: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "request_computed_properties". All fields are combined with a logical 'AND'. */
export type RequestComputedPropertiesBoolExp = {
  _and?: InputMaybe<Array<RequestComputedPropertiesBoolExp>>;
  _not?: InputMaybe<RequestComputedPropertiesBoolExp>;
  _or?: InputMaybe<Array<RequestComputedPropertiesBoolExp>>;
  address?: InputMaybe<JsonbComparisonExp>;
  annualBaselineSpend?: InputMaybe<NumericComparisonExp>;
  annualNegotiatedSavings?: InputMaybe<NumericComparisonExp>;
  annualValueNumber?: InputMaybe<NumericComparisonExp>;
  baselineSpendObject?: InputMaybe<JsonbComparisonExp>;
  budgetHolder?: InputMaybe<UsersBoolExp>;
  budgetHolderId?: InputMaybe<UuidComparisonExp>;
  businessOwner?: InputMaybe<UsersBoolExp>;
  businessOwnerId?: InputMaybe<UuidComparisonExp>;
  buyerLegalEntity?: InputMaybe<SubsidiariesBoolExp>;
  buyerLegalEntityId?: InputMaybe<UuidComparisonExp>;
  cancelByDate?: InputMaybe<TimestamptzComparisonExp>;
  cancellationNoticeDays?: InputMaybe<IntComparisonExp>;
  cancellationReason?: InputMaybe<StringComparisonExp>;
  category?: InputMaybe<CustomCoreDataOptionsBoolExp>;
  categoryId?: InputMaybe<UuidComparisonExp>;
  categoryLineItemTypeId?: InputMaybe<UuidComparisonExp>;
  contractEndDate?: InputMaybe<TimestamptzComparisonExp>;
  contractLength?: InputMaybe<NumericComparisonExp>;
  contractStartDate?: InputMaybe<TimestamptzComparisonExp>;
  costCenter?: InputMaybe<DepartmentsBoolExp>;
  costCenterId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  department?: InputMaybe<DepartmentsBoolExp>;
  departmentId?: InputMaybe<UuidComparisonExp>;
  goLiveDate?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  inBudget?: InputMaybe<BooleanComparisonExp>;
  isAutoRenewal?: InputMaybe<BooleanComparisonExp>;
  itOwner?: InputMaybe<UsersBoolExp>;
  itOwnerId?: InputMaybe<UuidComparisonExp>;
  lineItemsTotalAmount?: InputMaybe<NumericComparisonExp>;
  lineItemsTotalObject?: InputMaybe<JsonbComparisonExp>;
  lineItemsVsAgreementDeltaAmount?: InputMaybe<NumericComparisonExp>;
  lineItemsVsAgreementDeltaObject?: InputMaybe<JsonbComparisonExp>;
  market?: InputMaybe<CustomCoreDataOptionsBoolExp>;
  marketId?: InputMaybe<UuidComparisonExp>;
  negotiatedSavingsObject?: InputMaybe<JsonbComparisonExp>;
  note?: InputMaybe<StringComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  paymentMethod?: InputMaybe<PaymentMethodsBoolExp>;
  paymentMethodId?: InputMaybe<UuidComparisonExp>;
  paymentTerm?: InputMaybe<PaymentTermsBoolExp>;
  paymentTermId?: InputMaybe<UuidComparisonExp>;
  poNumber?: InputMaybe<StringComparisonExp>;
  pricingObject?: InputMaybe<JsonbComparisonExp>;
  renewalDate?: InputMaybe<TimestamptzComparisonExp>;
  request?: InputMaybe<RequestsBoolExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  shouldRenew?: InputMaybe<BooleanComparisonExp>;
  syncWithAccountingIntegration?: InputMaybe<BooleanComparisonExp>;
  taxNumber?: InputMaybe<JsonbComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  valueNumber?: InputMaybe<NumericComparisonExp>;
  valueObject?: InputMaybe<JsonbComparisonExp>;
  website?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "request_computed_properties" */
export enum RequestComputedPropertiesConstraint {
  /** unique or primary key constraint on columns "request_id" */
  REQUEST_COMPUTED_PROPERTIES_PKEY = 'request_computed_properties_pkey',
  /** unique or primary key constraint on columns "request_id" */
  REQUEST_COMPUTED_PROPERTIES_REQUEST_ID_KEY = 'request_computed_properties_request_id_key'
}

/** input type for inserting data into table "request_computed_properties" */
export type RequestComputedPropertiesInsertInput = {
  address?: InputMaybe<Scalars['jsonb']['input']>;
  annualBaselineSpend?: InputMaybe<Scalars['numeric']['input']>;
  annualNegotiatedSavings?: InputMaybe<Scalars['numeric']['input']>;
  annualValueNumber?: InputMaybe<Scalars['numeric']['input']>;
  baselineSpendObject?: InputMaybe<Scalars['jsonb']['input']>;
  budgetHolder?: InputMaybe<UsersObjRelInsertInput>;
  budgetHolderId?: InputMaybe<Scalars['uuid']['input']>;
  businessOwner?: InputMaybe<UsersObjRelInsertInput>;
  businessOwnerId?: InputMaybe<Scalars['uuid']['input']>;
  buyerLegalEntity?: InputMaybe<SubsidiariesObjRelInsertInput>;
  buyerLegalEntityId?: InputMaybe<Scalars['uuid']['input']>;
  cancelByDate?: InputMaybe<Scalars['timestamptz']['input']>;
  cancellationNoticeDays?: InputMaybe<Scalars['Int']['input']>;
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<CustomCoreDataOptionsObjRelInsertInput>;
  /** Reference to category option in custom core data options */
  categoryId?: InputMaybe<Scalars['uuid']['input']>;
  /** Reference to a line item type when the category question is sourced from line-item-types; mutually exclusive with category_id */
  categoryLineItemTypeId?: InputMaybe<Scalars['uuid']['input']>;
  contractEndDate?: InputMaybe<Scalars['timestamptz']['input']>;
  contractLength?: InputMaybe<Scalars['numeric']['input']>;
  contractStartDate?: InputMaybe<Scalars['timestamptz']['input']>;
  costCenter?: InputMaybe<DepartmentsObjRelInsertInput>;
  costCenterId?: InputMaybe<Scalars['uuid']['input']>;
  department?: InputMaybe<DepartmentsObjRelInsertInput>;
  departmentId?: InputMaybe<Scalars['uuid']['input']>;
  goLiveDate?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inBudget?: InputMaybe<Scalars['Boolean']['input']>;
  isAutoRenewal?: InputMaybe<Scalars['Boolean']['input']>;
  itOwner?: InputMaybe<UsersObjRelInsertInput>;
  itOwnerId?: InputMaybe<Scalars['uuid']['input']>;
  lineItemsTotalAmount?: InputMaybe<Scalars['numeric']['input']>;
  lineItemsTotalObject?: InputMaybe<Scalars['jsonb']['input']>;
  lineItemsVsAgreementDeltaAmount?: InputMaybe<Scalars['numeric']['input']>;
  lineItemsVsAgreementDeltaObject?: InputMaybe<Scalars['jsonb']['input']>;
  market?: InputMaybe<CustomCoreDataOptionsObjRelInsertInput>;
  /** Reference to market option in custom core data options */
  marketId?: InputMaybe<Scalars['uuid']['input']>;
  negotiatedSavingsObject?: InputMaybe<Scalars['jsonb']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<PaymentMethodsObjRelInsertInput>;
  paymentMethodId?: InputMaybe<Scalars['uuid']['input']>;
  paymentTerm?: InputMaybe<PaymentTermsObjRelInsertInput>;
  paymentTermId?: InputMaybe<Scalars['uuid']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  pricingObject?: InputMaybe<Scalars['jsonb']['input']>;
  renewalDate?: InputMaybe<Scalars['timestamptz']['input']>;
  request?: InputMaybe<RequestsObjRelInsertInput>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  shouldRenew?: InputMaybe<Scalars['Boolean']['input']>;
  syncWithAccountingIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  taxNumber?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  /** This is the value user enters (regardless of the frequency) */
  valueNumber?: InputMaybe<Scalars['numeric']['input']>;
  valueObject?: InputMaybe<Scalars['jsonb']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting object relation for remote table "request_computed_properties" */
export type RequestComputedPropertiesObjRelInsertInput = {
  data: RequestComputedPropertiesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestComputedPropertiesOnConflict>;
};

/** on_conflict condition type for table "request_computed_properties" */
export type RequestComputedPropertiesOnConflict = {
  constraint: RequestComputedPropertiesConstraint;
  update_columns: Array<RequestComputedPropertiesUpdateColumn>;
  where?: InputMaybe<RequestComputedPropertiesBoolExp>;
};

/** input type for updating data in table "request_computed_properties" */
export type RequestComputedPropertiesSetInput = {
  address?: InputMaybe<Scalars['jsonb']['input']>;
  annualBaselineSpend?: InputMaybe<Scalars['numeric']['input']>;
  annualNegotiatedSavings?: InputMaybe<Scalars['numeric']['input']>;
  annualValueNumber?: InputMaybe<Scalars['numeric']['input']>;
  baselineSpendObject?: InputMaybe<Scalars['jsonb']['input']>;
  budgetHolderId?: InputMaybe<Scalars['uuid']['input']>;
  businessOwnerId?: InputMaybe<Scalars['uuid']['input']>;
  buyerLegalEntityId?: InputMaybe<Scalars['uuid']['input']>;
  cancelByDate?: InputMaybe<Scalars['timestamptz']['input']>;
  cancellationNoticeDays?: InputMaybe<Scalars['Int']['input']>;
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  /** Reference to category option in custom core data options */
  categoryId?: InputMaybe<Scalars['uuid']['input']>;
  /** Reference to a line item type when the category question is sourced from line-item-types; mutually exclusive with category_id */
  categoryLineItemTypeId?: InputMaybe<Scalars['uuid']['input']>;
  contractEndDate?: InputMaybe<Scalars['timestamptz']['input']>;
  contractLength?: InputMaybe<Scalars['numeric']['input']>;
  contractStartDate?: InputMaybe<Scalars['timestamptz']['input']>;
  costCenterId?: InputMaybe<Scalars['uuid']['input']>;
  departmentId?: InputMaybe<Scalars['uuid']['input']>;
  goLiveDate?: InputMaybe<Scalars['timestamptz']['input']>;
  inBudget?: InputMaybe<Scalars['Boolean']['input']>;
  isAutoRenewal?: InputMaybe<Scalars['Boolean']['input']>;
  itOwnerId?: InputMaybe<Scalars['uuid']['input']>;
  lineItemsTotalAmount?: InputMaybe<Scalars['numeric']['input']>;
  lineItemsTotalObject?: InputMaybe<Scalars['jsonb']['input']>;
  lineItemsVsAgreementDeltaAmount?: InputMaybe<Scalars['numeric']['input']>;
  lineItemsVsAgreementDeltaObject?: InputMaybe<Scalars['jsonb']['input']>;
  /** Reference to market option in custom core data options */
  marketId?: InputMaybe<Scalars['uuid']['input']>;
  negotiatedSavingsObject?: InputMaybe<Scalars['jsonb']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['uuid']['input']>;
  paymentTermId?: InputMaybe<Scalars['uuid']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  pricingObject?: InputMaybe<Scalars['jsonb']['input']>;
  renewalDate?: InputMaybe<Scalars['timestamptz']['input']>;
  shouldRenew?: InputMaybe<Scalars['Boolean']['input']>;
  syncWithAccountingIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  taxNumber?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  /** This is the value user enters (regardless of the frequency) */
  valueNumber?: InputMaybe<Scalars['numeric']['input']>;
  valueObject?: InputMaybe<Scalars['jsonb']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "request_computed_properties" */
export enum RequestComputedPropertiesUpdateColumn {
  /** column name */
  ADDRESS = 'address',
  /** column name */
  ANNUALBASELINESPEND = 'annualBaselineSpend',
  /** column name */
  ANNUALNEGOTIATEDSAVINGS = 'annualNegotiatedSavings',
  /** column name */
  ANNUALVALUENUMBER = 'annualValueNumber',
  /** column name */
  BASELINESPENDOBJECT = 'baselineSpendObject',
  /** column name */
  BUDGETHOLDERID = 'budgetHolderId',
  /** column name */
  BUSINESSOWNERID = 'businessOwnerId',
  /** column name */
  BUYERLEGALENTITYID = 'buyerLegalEntityId',
  /** column name */
  CANCELBYDATE = 'cancelByDate',
  /** column name */
  CANCELLATIONNOTICEDAYS = 'cancellationNoticeDays',
  /** column name */
  CANCELLATIONREASON = 'cancellationReason',
  /** column name */
  CATEGORYID = 'categoryId',
  /** column name */
  CATEGORYLINEITEMTYPEID = 'categoryLineItemTypeId',
  /** column name */
  CONTRACTENDDATE = 'contractEndDate',
  /** column name */
  CONTRACTLENGTH = 'contractLength',
  /** column name */
  CONTRACTSTARTDATE = 'contractStartDate',
  /** column name */
  COSTCENTERID = 'costCenterId',
  /** column name */
  DEPARTMENTID = 'departmentId',
  /** column name */
  GOLIVEDATE = 'goLiveDate',
  /** column name */
  INBUDGET = 'inBudget',
  /** column name */
  ISAUTORENEWAL = 'isAutoRenewal',
  /** column name */
  ITOWNERID = 'itOwnerId',
  /** column name */
  LINEITEMSTOTALAMOUNT = 'lineItemsTotalAmount',
  /** column name */
  LINEITEMSTOTALOBJECT = 'lineItemsTotalObject',
  /** column name */
  LINEITEMSVSAGREEMENTDELTAAMOUNT = 'lineItemsVsAgreementDeltaAmount',
  /** column name */
  LINEITEMSVSAGREEMENTDELTAOBJECT = 'lineItemsVsAgreementDeltaObject',
  /** column name */
  MARKETID = 'marketId',
  /** column name */
  NEGOTIATEDSAVINGSOBJECT = 'negotiatedSavingsObject',
  /** column name */
  NOTE = 'note',
  /** column name */
  PAYMENTMETHODID = 'paymentMethodId',
  /** column name */
  PAYMENTTERMID = 'paymentTermId',
  /** column name */
  PONUMBER = 'poNumber',
  /** column name */
  PRICINGOBJECT = 'pricingObject',
  /** column name */
  RENEWALDATE = 'renewalDate',
  /** column name */
  SHOULDRENEW = 'shouldRenew',
  /** column name */
  SYNCWITHACCOUNTINGINTEGRATION = 'syncWithAccountingIntegration',
  /** column name */
  TAXNUMBER = 'taxNumber',
  /** column name */
  TYPE = 'type',
  /** column name */
  VALUENUMBER = 'valueNumber',
  /** column name */
  VALUEOBJECT = 'valueObject',
  /** column name */
  WEBSITE = 'website'
}

/** columns and relationships of "request_documents" */
export type RequestDocuments = {
  __typename?: 'request_documents';
  createdAt: Scalars['timestamptz']['output'];
  customType: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  customTypeValue: Maybe<CustomDocumentTypes>;
  deletedAt: Maybe<Scalars['date']['output']>;
  description: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  filestoreId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  request: Requests;
  requestId: Scalars['uuid']['output'];
  shouldPromoteToGlobal: Scalars['Boolean']['output'];
  source: Maybe<Scalars['requestDocumentSource']['output']>;
  /** An object relationship */
  sourceRequestForm: Maybe<RequestForms>;
  sourceRequestFormId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  uploadedBy: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  uploadedByUser: Maybe<Users>;
};

/** input type for inserting array relation for remote table "request_documents" */
export type RequestDocumentsArrRelInsertInput = {
  data: Array<RequestDocumentsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestDocumentsOnConflict>;
};

/** Boolean expression to filter rows from the table "request_documents". All fields are combined with a logical 'AND'. */
export type RequestDocumentsBoolExp = {
  _and?: InputMaybe<Array<RequestDocumentsBoolExp>>;
  _not?: InputMaybe<RequestDocumentsBoolExp>;
  _or?: InputMaybe<Array<RequestDocumentsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customType?: InputMaybe<UuidComparisonExp>;
  customTypeValue?: InputMaybe<CustomDocumentTypesBoolExp>;
  deletedAt?: InputMaybe<DateComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  fileName?: InputMaybe<StringComparisonExp>;
  filestoreId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  request?: InputMaybe<RequestsBoolExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  shouldPromoteToGlobal?: InputMaybe<BooleanComparisonExp>;
  source?: InputMaybe<StringComparisonExp>;
  sourceRequestForm?: InputMaybe<RequestFormsBoolExp>;
  sourceRequestFormId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  uploadedBy?: InputMaybe<UuidComparisonExp>;
  uploadedByUser?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "request_documents" */
export enum RequestDocumentsConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_DOCUMENTS_PKEY = 'request_documents_pkey'
}

/** input type for inserting data into table "request_documents" */
export type RequestDocumentsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customType?: InputMaybe<Scalars['uuid']['input']>;
  customTypeValue?: InputMaybe<CustomDocumentTypesObjRelInsertInput>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  filestoreId?: InputMaybe<Scalars['uuid']['input']>;
  request?: InputMaybe<RequestsObjRelInsertInput>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  shouldPromoteToGlobal?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  sourceRequestForm?: InputMaybe<RequestFormsObjRelInsertInput>;
  sourceRequestFormId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  uploadedBy?: InputMaybe<Scalars['uuid']['input']>;
  uploadedByUser?: InputMaybe<UsersObjRelInsertInput>;
};

/** input type for inserting object relation for remote table "request_documents" */
export type RequestDocumentsObjRelInsertInput = {
  data: RequestDocumentsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestDocumentsOnConflict>;
};

/** on_conflict condition type for table "request_documents" */
export type RequestDocumentsOnConflict = {
  constraint: RequestDocumentsConstraint;
  update_columns: Array<RequestDocumentsUpdateColumn>;
  where?: InputMaybe<RequestDocumentsBoolExp>;
};

/** update columns of table "request_documents" */
export enum RequestDocumentsUpdateColumn {
  /** column name */
  CUSTOMTYPE = 'customType',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  FILENAME = 'fileName',
  /** column name */
  SHOULDPROMOTETOGLOBAL = 'shouldPromoteToGlobal'
}

/** columns and relationships of "request_esign_documents" */
export type RequestEsignDocuments = {
  __typename?: 'request_esign_documents';
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  organisationId: Scalars['uuid']['output'];
  remoteId: Scalars['String']['output'];
  requestId: Scalars['uuid']['output'];
  status: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** input type for inserting array relation for remote table "request_esign_documents" */
export type RequestEsignDocumentsArrRelInsertInput = {
  data: Array<RequestEsignDocumentsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestEsignDocumentsOnConflict>;
};

/** Boolean expression to filter rows from the table "request_esign_documents". All fields are combined with a logical 'AND'. */
export type RequestEsignDocumentsBoolExp = {
  _and?: InputMaybe<Array<RequestEsignDocumentsBoolExp>>;
  _not?: InputMaybe<RequestEsignDocumentsBoolExp>;
  _or?: InputMaybe<Array<RequestEsignDocumentsBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  remoteId?: InputMaybe<StringComparisonExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  url?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "request_esign_documents" */
export enum RequestEsignDocumentsConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_ESIGN_DOCUMENTS_PKEY = 'request_esign_documents_pkey'
}

/** input type for inserting data into table "request_esign_documents" */
export type RequestEsignDocumentsInsertInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** on_conflict condition type for table "request_esign_documents" */
export type RequestEsignDocumentsOnConflict = {
  constraint: RequestEsignDocumentsConstraint;
  update_columns: Array<RequestEsignDocumentsUpdateColumn>;
  where?: InputMaybe<RequestEsignDocumentsBoolExp>;
};

/** update columns of table "request_esign_documents" */
export enum RequestEsignDocumentsUpdateColumn {
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  STATUS = 'status',
  /** column name */
  URL = 'url'
}

/** Followers of a request */
export type RequestFollowers = {
  __typename?: 'request_followers';
  assigneeType: AssigneeTypeEnum;
  /** An object relationship */
  assigneeTypeByAssigneeType: AssigneeType;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  group: Maybe<Groups>;
  groupId: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  note: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  request: Requests;
  requestId: Scalars['uuid']['output'];
  /** An object relationship */
  user: Maybe<Users>;
  userId: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "request_followers" */
export type RequestFollowersAggregate = {
  __typename?: 'request_followers_aggregate';
  aggregate: Maybe<RequestFollowersAggregateFields>;
  nodes: Array<RequestFollowers>;
};

export type RequestFollowersAggregateBoolExp = {
  count?: InputMaybe<RequestFollowersAggregateBoolExpCount>;
};

export type RequestFollowersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RequestFollowersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RequestFollowersBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "request_followers" */
export type RequestFollowersAggregateFields = {
  __typename?: 'request_followers_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<RequestFollowersMaxFields>;
  min: Maybe<RequestFollowersMinFields>;
};

/** input type for inserting array relation for remote table "request_followers" */
export type RequestFollowersArrRelInsertInput = {
  data: Array<RequestFollowersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestFollowersOnConflict>;
};

/** Boolean expression to filter rows from the table "request_followers". All fields are combined with a logical 'AND'. */
export type RequestFollowersBoolExp = {
  _and?: InputMaybe<Array<RequestFollowersBoolExp>>;
  _not?: InputMaybe<RequestFollowersBoolExp>;
  _or?: InputMaybe<Array<RequestFollowersBoolExp>>;
  assigneeType?: InputMaybe<AssigneeTypeEnumComparisonExp>;
  assigneeTypeByAssigneeType?: InputMaybe<AssigneeTypeBoolExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  group?: InputMaybe<GroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  note?: InputMaybe<StringComparisonExp>;
  request?: InputMaybe<RequestsBoolExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "request_followers" */
export enum RequestFollowersConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_FOLLOWERS_PKEY = 'request_followers_pkey'
}

/** input type for inserting data into table "request_followers" */
export type RequestFollowersInsertInput = {
  assigneeType?: InputMaybe<AssigneeTypeEnum>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  group?: InputMaybe<GroupsObjRelInsertInput>;
  groupId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  request?: InputMaybe<RequestsObjRelInsertInput>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type RequestFollowersMaxFields = {
  __typename?: 'request_followers_max_fields';
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  groupId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  note: Maybe<Scalars['String']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  userId: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type RequestFollowersMinFields = {
  __typename?: 'request_followers_min_fields';
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  groupId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  note: Maybe<Scalars['String']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  userId: Maybe<Scalars['uuid']['output']>;
};

/** on_conflict condition type for table "request_followers" */
export type RequestFollowersOnConflict = {
  constraint: RequestFollowersConstraint;
  update_columns: Array<RequestFollowersUpdateColumn>;
  where?: InputMaybe<RequestFollowersBoolExp>;
};

/** select columns of table "request_followers" */
export enum RequestFollowersSelectColumn {
  /** column name */
  ASSIGNEETYPE = 'assigneeType',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  GROUPID = 'groupId',
  /** column name */
  ID = 'id',
  /** column name */
  NOTE = 'note',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  USERID = 'userId'
}

/** update columns of table "request_followers" */
export enum RequestFollowersUpdateColumn {
  /** column name */
  ASSIGNEETYPE = 'assigneeType',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  GROUPID = 'groupId',
  /** column name */
  ID = 'id',
  /** column name */
  NOTE = 'note',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  USERID = 'userId'
}

/** columns and relationships of "request_form_question_score" */
export type RequestFormQuestionScore = {
  __typename?: 'request_form_question_score';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  questionName: Scalars['String']['output'];
  requestFormId: Scalars['uuid']['output'];
  requestFormSubmission: Scalars['uuid']['output'];
  requestStepTaskId: Scalars['uuid']['output'];
  /** An object relationship */
  request_form: RequestForms;
  /** An object relationship */
  request_form_submission: RequestFormSubmissions;
  /** An object relationship */
  request_step_task: RequestStepTasks;
  score: Scalars['Int']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** input type for inserting array relation for remote table "request_form_question_score" */
export type RequestFormQuestionScoreArrRelInsertInput = {
  data: Array<RequestFormQuestionScoreInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestFormQuestionScoreOnConflict>;
};

/** Boolean expression to filter rows from the table "request_form_question_score". All fields are combined with a logical 'AND'. */
export type RequestFormQuestionScoreBoolExp = {
  _and?: InputMaybe<Array<RequestFormQuestionScoreBoolExp>>;
  _not?: InputMaybe<RequestFormQuestionScoreBoolExp>;
  _or?: InputMaybe<Array<RequestFormQuestionScoreBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  questionName?: InputMaybe<StringComparisonExp>;
  requestFormId?: InputMaybe<UuidComparisonExp>;
  requestFormSubmission?: InputMaybe<UuidComparisonExp>;
  requestStepTaskId?: InputMaybe<UuidComparisonExp>;
  request_form?: InputMaybe<RequestFormsBoolExp>;
  request_form_submission?: InputMaybe<RequestFormSubmissionsBoolExp>;
  request_step_task?: InputMaybe<RequestStepTasksBoolExp>;
  score?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "request_form_question_score" */
export enum RequestFormQuestionScoreConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_FORM_QUESTION_SCORE_PKEY = 'request_form_question_score_pkey',
  /** unique or primary key constraint on columns "user_id", "question_name", "request_form_id" */
  REQUEST_FORM_QUESTION_SCORE_REQUEST_FORM_ID_USER_ID_QUESTIO_KEY = 'request_form_question_score_request_form_id_user_id_questio_key'
}

/** input type for inserting data into table "request_form_question_score" */
export type RequestFormQuestionScoreInsertInput = {
  questionName?: InputMaybe<Scalars['String']['input']>;
  requestFormId?: InputMaybe<Scalars['uuid']['input']>;
  requestFormSubmission?: InputMaybe<Scalars['uuid']['input']>;
  requestStepTaskId?: InputMaybe<Scalars['uuid']['input']>;
  request_form?: InputMaybe<RequestFormsObjRelInsertInput>;
  request_form_submission?: InputMaybe<RequestFormSubmissionsObjRelInsertInput>;
  request_step_task?: InputMaybe<RequestStepTasksObjRelInsertInput>;
  score?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** on_conflict condition type for table "request_form_question_score" */
export type RequestFormQuestionScoreOnConflict = {
  constraint: RequestFormQuestionScoreConstraint;
  update_columns: Array<RequestFormQuestionScoreUpdateColumn>;
  where?: InputMaybe<RequestFormQuestionScoreBoolExp>;
};

/** update columns of table "request_form_question_score" */
export enum RequestFormQuestionScoreUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  REQUESTFORMSUBMISSION = 'requestFormSubmission',
  /** column name */
  REQUESTSTEPTASKID = 'requestStepTaskId',
  /** column name */
  SCORE = 'score',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId'
}

/** columns and relationships of "request_form_submission_ai_summary" */
export type RequestFormSubmissionAiSummary = {
  __typename?: 'request_form_submission_ai_summary';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisation_id: Scalars['uuid']['output'];
  /** An object relationship */
  request_form: RequestForms;
  request_form_id: Scalars['uuid']['output'];
  /** An object relationship */
  request_form_submission: RequestFormSubmissions;
  request_form_submission_id: Scalars['uuid']['output'];
  risks: Maybe<Scalars['jsonb']['output']>;
  summary: Scalars['String']['output'];
};

/** input type for inserting array relation for remote table "request_form_submission_ai_summary" */
export type RequestFormSubmissionAiSummaryArrRelInsertInput = {
  data: Array<RequestFormSubmissionAiSummaryInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestFormSubmissionAiSummaryOnConflict>;
};

/** Boolean expression to filter rows from the table "request_form_submission_ai_summary". All fields are combined with a logical 'AND'. */
export type RequestFormSubmissionAiSummaryBoolExp = {
  _and?: InputMaybe<Array<RequestFormSubmissionAiSummaryBoolExp>>;
  _not?: InputMaybe<RequestFormSubmissionAiSummaryBoolExp>;
  _or?: InputMaybe<Array<RequestFormSubmissionAiSummaryBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisation_id?: InputMaybe<UuidComparisonExp>;
  request_form?: InputMaybe<RequestFormsBoolExp>;
  request_form_id?: InputMaybe<UuidComparisonExp>;
  request_form_submission?: InputMaybe<RequestFormSubmissionsBoolExp>;
  request_form_submission_id?: InputMaybe<UuidComparisonExp>;
  risks?: InputMaybe<JsonbComparisonExp>;
  summary?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "request_form_submission_ai_summary" */
export enum RequestFormSubmissionAiSummaryConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_FORM_SUBMISSION_AI_SUMMARY_PKEY = 'request_form_submission_ai_summary_pkey',
  /** unique or primary key constraint on columns "request_form_submission_id" */
  REQUEST_FORM_SUBMISSION_AI_SUMMARY_REQUEST_FORM_SUBMISSION_ID_K = 'request_form_submission_ai_summary_request_form_submission_id_k'
}

/** input type for inserting data into table "request_form_submission_ai_summary" */
export type RequestFormSubmissionAiSummaryInsertInput = {
  request_form?: InputMaybe<RequestFormsObjRelInsertInput>;
  request_form_id?: InputMaybe<Scalars['uuid']['input']>;
  request_form_submission?: InputMaybe<RequestFormSubmissionsObjRelInsertInput>;
  request_form_submission_id?: InputMaybe<Scalars['uuid']['input']>;
  risks?: InputMaybe<Scalars['jsonb']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting object relation for remote table "request_form_submission_ai_summary" */
export type RequestFormSubmissionAiSummaryObjRelInsertInput = {
  data: RequestFormSubmissionAiSummaryInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestFormSubmissionAiSummaryOnConflict>;
};

/** on_conflict condition type for table "request_form_submission_ai_summary" */
export type RequestFormSubmissionAiSummaryOnConflict = {
  constraint: RequestFormSubmissionAiSummaryConstraint;
  update_columns: Array<RequestFormSubmissionAiSummaryUpdateColumn>;
  where?: InputMaybe<RequestFormSubmissionAiSummaryBoolExp>;
};

/** placeholder for update columns of table "request_form_submission_ai_summary" (current role has no relevant permissions) */
export enum RequestFormSubmissionAiSummaryUpdateColumn {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

/** columns and relationships of "request_form_submission_translations" */
export type RequestFormSubmissionTranslations = {
  __typename?: 'request_form_submission_translations';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  language: Scalars['String']['output'];
  requestFormSubmissionId: Scalars['uuid']['output'];
  translatedResponse: Scalars['jsonb']['output'];
};

/** aggregated selection of "request_form_submission_translations" */
export type RequestFormSubmissionTranslationsAggregate = {
  __typename?: 'request_form_submission_translations_aggregate';
  aggregate: Maybe<RequestFormSubmissionTranslationsAggregateFields>;
  nodes: Array<RequestFormSubmissionTranslations>;
};

export type RequestFormSubmissionTranslationsAggregateBoolExp = {
  count?: InputMaybe<RequestFormSubmissionTranslationsAggregateBoolExpCount>;
};

export type RequestFormSubmissionTranslationsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RequestFormSubmissionTranslationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RequestFormSubmissionTranslationsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "request_form_submission_translations" */
export type RequestFormSubmissionTranslationsAggregateFields = {
  __typename?: 'request_form_submission_translations_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<RequestFormSubmissionTranslationsMaxFields>;
  min: Maybe<RequestFormSubmissionTranslationsMinFields>;
};

/** input type for inserting array relation for remote table "request_form_submission_translations" */
export type RequestFormSubmissionTranslationsArrRelInsertInput = {
  data: Array<RequestFormSubmissionTranslationsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestFormSubmissionTranslationsOnConflict>;
};

/** Boolean expression to filter rows from the table "request_form_submission_translations". All fields are combined with a logical 'AND'. */
export type RequestFormSubmissionTranslationsBoolExp = {
  _and?: InputMaybe<Array<RequestFormSubmissionTranslationsBoolExp>>;
  _not?: InputMaybe<RequestFormSubmissionTranslationsBoolExp>;
  _or?: InputMaybe<Array<RequestFormSubmissionTranslationsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  language?: InputMaybe<StringComparisonExp>;
  requestFormSubmissionId?: InputMaybe<UuidComparisonExp>;
  translatedResponse?: InputMaybe<JsonbComparisonExp>;
};

/** unique or primary key constraints on table "request_form_submission_translations" */
export enum RequestFormSubmissionTranslationsConstraint {
  /** unique or primary key constraint on columns "language", "request_form_submission_id" */
  REQUEST_FORM_SUBMISSION_TRANS_REQUEST_FORM_SUBMISSION_ID_LA_KEY = 'request_form_submission_trans_request_form_submission_id_la_key',
  /** unique or primary key constraint on columns "id" */
  REQUEST_FORM_SUBMISSION_TRANSLATIONS_PKEY = 'request_form_submission_translations_pkey'
}

/** input type for inserting data into table "request_form_submission_translations" */
export type RequestFormSubmissionTranslationsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  requestFormSubmissionId?: InputMaybe<Scalars['uuid']['input']>;
  translatedResponse?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type RequestFormSubmissionTranslationsMaxFields = {
  __typename?: 'request_form_submission_translations_max_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  language: Maybe<Scalars['String']['output']>;
  requestFormSubmissionId: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type RequestFormSubmissionTranslationsMinFields = {
  __typename?: 'request_form_submission_translations_min_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  language: Maybe<Scalars['String']['output']>;
  requestFormSubmissionId: Maybe<Scalars['uuid']['output']>;
};

/** on_conflict condition type for table "request_form_submission_translations" */
export type RequestFormSubmissionTranslationsOnConflict = {
  constraint: RequestFormSubmissionTranslationsConstraint;
  update_columns: Array<RequestFormSubmissionTranslationsUpdateColumn>;
  where?: InputMaybe<RequestFormSubmissionTranslationsBoolExp>;
};

/** select columns of table "request_form_submission_translations" */
export enum RequestFormSubmissionTranslationsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  LANGUAGE = 'language',
  /** column name */
  REQUESTFORMSUBMISSIONID = 'requestFormSubmissionId',
  /** column name */
  TRANSLATEDRESPONSE = 'translatedResponse'
}

/** placeholder for update columns of table "request_form_submission_translations" (current role has no relevant permissions) */
export enum RequestFormSubmissionTranslationsUpdateColumn {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

/** columns and relationships of "request_form_submissions" */
export type RequestFormSubmissions = {
  __typename?: 'request_form_submissions';
  detectedLanguage: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  requestFormId: Maybe<Scalars['uuid']['output']>;
  requestStepTaskId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  request_form: Maybe<RequestForms>;
  /** An object relationship */
  request_form_submission_ai_summary: Maybe<RequestFormSubmissionAiSummary>;
  /** An object relationship */
  request_step_task: Maybe<RequestStepTasks>;
  response: Maybe<Scalars['requestFormSubmissionResponse']['output']>;
  submittedBy: Maybe<Scalars['uuid']['output']>;
  submittedOn: Scalars['timestamptz']['output'];
  /** An array relationship */
  translations: Array<RequestFormSubmissionTranslations>;
  /** An aggregate relationship */
  translations_aggregate: RequestFormSubmissionTranslationsAggregate;
  /** An object relationship */
  user: Maybe<Users>;
};

/** aggregated selection of "request_form_submissions" */
export type RequestFormSubmissionsAggregate = {
  __typename?: 'request_form_submissions_aggregate';
  aggregate: Maybe<RequestFormSubmissionsAggregateFields>;
  nodes: Array<RequestFormSubmissions>;
};

export type RequestFormSubmissionsAggregateBoolExp = {
  count?: InputMaybe<RequestFormSubmissionsAggregateBoolExpCount>;
};

export type RequestFormSubmissionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RequestFormSubmissionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RequestFormSubmissionsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "request_form_submissions" */
export type RequestFormSubmissionsAggregateFields = {
  __typename?: 'request_form_submissions_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<RequestFormSubmissionsMaxFields>;
  min: Maybe<RequestFormSubmissionsMinFields>;
};

/** input type for inserting array relation for remote table "request_form_submissions" */
export type RequestFormSubmissionsArrRelInsertInput = {
  data: Array<RequestFormSubmissionsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestFormSubmissionsOnConflict>;
};

/** columns and relationships of "request_form_submissions_auto_saves" */
export type RequestFormSubmissionsAutoSaves = {
  __typename?: 'request_form_submissions_auto_saves';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  requestFormId: Scalars['uuid']['output'];
  requestStepTaskId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  request_form: RequestForms;
  /** An object relationship */
  request_step_task: Maybe<RequestStepTasks>;
  response: Scalars['jsonb']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "request_form_submissions_auto_saves" */
export type RequestFormSubmissionsAutoSavesAggregate = {
  __typename?: 'request_form_submissions_auto_saves_aggregate';
  aggregate: Maybe<RequestFormSubmissionsAutoSavesAggregateFields>;
  nodes: Array<RequestFormSubmissionsAutoSaves>;
};

export type RequestFormSubmissionsAutoSavesAggregateBoolExp = {
  count?: InputMaybe<RequestFormSubmissionsAutoSavesAggregateBoolExpCount>;
};

export type RequestFormSubmissionsAutoSavesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RequestFormSubmissionsAutoSavesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RequestFormSubmissionsAutoSavesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "request_form_submissions_auto_saves" */
export type RequestFormSubmissionsAutoSavesAggregateFields = {
  __typename?: 'request_form_submissions_auto_saves_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<RequestFormSubmissionsAutoSavesMaxFields>;
  min: Maybe<RequestFormSubmissionsAutoSavesMinFields>;
};

/** input type for inserting array relation for remote table "request_form_submissions_auto_saves" */
export type RequestFormSubmissionsAutoSavesArrRelInsertInput = {
  data: Array<RequestFormSubmissionsAutoSavesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestFormSubmissionsAutoSavesOnConflict>;
};

/** Boolean expression to filter rows from the table "request_form_submissions_auto_saves". All fields are combined with a logical 'AND'. */
export type RequestFormSubmissionsAutoSavesBoolExp = {
  _and?: InputMaybe<Array<RequestFormSubmissionsAutoSavesBoolExp>>;
  _not?: InputMaybe<RequestFormSubmissionsAutoSavesBoolExp>;
  _or?: InputMaybe<Array<RequestFormSubmissionsAutoSavesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  requestFormId?: InputMaybe<UuidComparisonExp>;
  requestStepTaskId?: InputMaybe<UuidComparisonExp>;
  request_form?: InputMaybe<RequestFormsBoolExp>;
  request_step_task?: InputMaybe<RequestStepTasksBoolExp>;
  response?: InputMaybe<JsonbComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "request_form_submissions_auto_saves" */
export enum RequestFormSubmissionsAutoSavesConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_FORM_SUBMISSIONS_AUTO_SAVES_PKEY = 'request_form_submissions_auto_saves_pkey',
  /** unique or primary key constraint on columns "request_step_task_id", "request_form_id" */
  REQUEST_FORM_SUBMISSIONS_AUTO_SAVES_REQUEST_FORM_ID_REQUEST_STE = 'request_form_submissions_auto_saves_request_form_id_request_ste'
}

/** input type for inserting data into table "request_form_submissions_auto_saves" */
export type RequestFormSubmissionsAutoSavesInsertInput = {
  requestFormId?: InputMaybe<Scalars['uuid']['input']>;
  requestStepTaskId?: InputMaybe<Scalars['uuid']['input']>;
  request_form?: InputMaybe<RequestFormsObjRelInsertInput>;
  request_step_task?: InputMaybe<RequestStepTasksObjRelInsertInput>;
  response?: InputMaybe<Scalars['jsonb']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type RequestFormSubmissionsAutoSavesMaxFields = {
  __typename?: 'request_form_submissions_auto_saves_max_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  requestFormId: Maybe<Scalars['uuid']['output']>;
  requestStepTaskId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  userId: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type RequestFormSubmissionsAutoSavesMinFields = {
  __typename?: 'request_form_submissions_auto_saves_min_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  requestFormId: Maybe<Scalars['uuid']['output']>;
  requestStepTaskId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  userId: Maybe<Scalars['uuid']['output']>;
};

/** on_conflict condition type for table "request_form_submissions_auto_saves" */
export type RequestFormSubmissionsAutoSavesOnConflict = {
  constraint: RequestFormSubmissionsAutoSavesConstraint;
  update_columns: Array<RequestFormSubmissionsAutoSavesUpdateColumn>;
  where?: InputMaybe<RequestFormSubmissionsAutoSavesBoolExp>;
};

/** select columns of table "request_form_submissions_auto_saves" */
export enum RequestFormSubmissionsAutoSavesSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  REQUESTFORMID = 'requestFormId',
  /** column name */
  REQUESTSTEPTASKID = 'requestStepTaskId',
  /** column name */
  RESPONSE = 'response',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId'
}

/** update columns of table "request_form_submissions_auto_saves" */
export enum RequestFormSubmissionsAutoSavesUpdateColumn {
  /** column name */
  REQUESTFORMID = 'requestFormId',
  /** column name */
  REQUESTSTEPTASKID = 'requestStepTaskId',
  /** column name */
  RESPONSE = 'response',
  /** column name */
  USERID = 'userId'
}

/** Boolean expression to filter rows from the table "request_form_submissions". All fields are combined with a logical 'AND'. */
export type RequestFormSubmissionsBoolExp = {
  _and?: InputMaybe<Array<RequestFormSubmissionsBoolExp>>;
  _not?: InputMaybe<RequestFormSubmissionsBoolExp>;
  _or?: InputMaybe<Array<RequestFormSubmissionsBoolExp>>;
  detectedLanguage?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  requestFormId?: InputMaybe<UuidComparisonExp>;
  requestStepTaskId?: InputMaybe<UuidComparisonExp>;
  request_form?: InputMaybe<RequestFormsBoolExp>;
  request_form_submission_ai_summary?: InputMaybe<RequestFormSubmissionAiSummaryBoolExp>;
  request_step_task?: InputMaybe<RequestStepTasksBoolExp>;
  response?: InputMaybe<JsonbComparisonExp>;
  submittedBy?: InputMaybe<UuidComparisonExp>;
  submittedOn?: InputMaybe<TimestamptzComparisonExp>;
  translations?: InputMaybe<RequestFormSubmissionTranslationsBoolExp>;
  translations_aggregate?: InputMaybe<RequestFormSubmissionTranslationsAggregateBoolExp>;
  user?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "request_form_submissions" */
export enum RequestFormSubmissionsConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_FORM_SUBMISSIONS_PKEY = 'request_form_submissions_pkey'
}

/** input type for inserting data into table "request_form_submissions" */
export type RequestFormSubmissionsInsertInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  requestFormId?: InputMaybe<Scalars['uuid']['input']>;
  requestStepTaskId?: InputMaybe<Scalars['uuid']['input']>;
  request_form?: InputMaybe<RequestFormsObjRelInsertInput>;
  request_form_submission_ai_summary?: InputMaybe<RequestFormSubmissionAiSummaryObjRelInsertInput>;
  request_step_task?: InputMaybe<RequestStepTasksObjRelInsertInput>;
  response?: InputMaybe<Scalars['jsonb']['input']>;
  submittedBy?: InputMaybe<Scalars['uuid']['input']>;
  submittedOn?: InputMaybe<Scalars['timestamptz']['input']>;
  translations?: InputMaybe<RequestFormSubmissionTranslationsArrRelInsertInput>;
  user?: InputMaybe<UsersObjRelInsertInput>;
};

/** aggregate max on columns */
export type RequestFormSubmissionsMaxFields = {
  __typename?: 'request_form_submissions_max_fields';
  detectedLanguage: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  requestFormId: Maybe<Scalars['uuid']['output']>;
  requestStepTaskId: Maybe<Scalars['uuid']['output']>;
  submittedBy: Maybe<Scalars['uuid']['output']>;
  submittedOn: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type RequestFormSubmissionsMinFields = {
  __typename?: 'request_form_submissions_min_fields';
  detectedLanguage: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  requestFormId: Maybe<Scalars['uuid']['output']>;
  requestStepTaskId: Maybe<Scalars['uuid']['output']>;
  submittedBy: Maybe<Scalars['uuid']['output']>;
  submittedOn: Maybe<Scalars['timestamptz']['output']>;
};

/** input type for inserting object relation for remote table "request_form_submissions" */
export type RequestFormSubmissionsObjRelInsertInput = {
  data: RequestFormSubmissionsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestFormSubmissionsOnConflict>;
};

/** on_conflict condition type for table "request_form_submissions" */
export type RequestFormSubmissionsOnConflict = {
  constraint: RequestFormSubmissionsConstraint;
  update_columns: Array<RequestFormSubmissionsUpdateColumn>;
  where?: InputMaybe<RequestFormSubmissionsBoolExp>;
};

/** select columns of table "request_form_submissions" */
export enum RequestFormSubmissionsSelectColumn {
  /** column name */
  DETECTEDLANGUAGE = 'detectedLanguage',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  REQUESTFORMID = 'requestFormId',
  /** column name */
  REQUESTSTEPTASKID = 'requestStepTaskId',
  /** column name */
  RESPONSE = 'response',
  /** column name */
  SUBMITTEDBY = 'submittedBy',
  /** column name */
  SUBMITTEDON = 'submittedOn'
}

/** update columns of table "request_form_submissions" */
export enum RequestFormSubmissionsUpdateColumn {
  /** column name */
  DETECTEDLANGUAGE = 'detectedLanguage',
  /** column name */
  ID = 'id',
  /** column name */
  REQUESTFORMID = 'requestFormId',
  /** column name */
  REQUESTSTEPTASKID = 'requestStepTaskId',
  /** column name */
  RESPONSE = 'response',
  /** column name */
  SUBMITTEDBY = 'submittedBy',
  /** column name */
  SUBMITTEDON = 'submittedOn'
}

/** Assign reviewers to request form templates */
export type RequestFormTemplateReviewers = {
  __typename?: 'request_form_template_reviewers';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  requestFormTemplateId: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** input type for inserting array relation for remote table "request_form_template_reviewers" */
export type RequestFormTemplateReviewersArrRelInsertInput = {
  data: Array<RequestFormTemplateReviewersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestFormTemplateReviewersOnConflict>;
};

/** Boolean expression to filter rows from the table "request_form_template_reviewers". All fields are combined with a logical 'AND'. */
export type RequestFormTemplateReviewersBoolExp = {
  _and?: InputMaybe<Array<RequestFormTemplateReviewersBoolExp>>;
  _not?: InputMaybe<RequestFormTemplateReviewersBoolExp>;
  _or?: InputMaybe<Array<RequestFormTemplateReviewersBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  requestFormTemplateId?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "request_form_template_reviewers" */
export enum RequestFormTemplateReviewersConstraint {
  /** unique or primary key constraint on columns "user_id", "request_form_template_id" */
  REQUEST_FORM_TEMPLATE_REVIEWE_REQUEST_FORM_TEMPLATE_ID_USER_KEY = 'request_form_template_reviewe_request_form_template_id_user_key',
  /** unique or primary key constraint on columns "id" */
  REQUEST_FORM_TEMPLATE_REVIEWERS_PKEY = 'request_form_template_reviewers_pkey'
}

/** input type for inserting data into table "request_form_template_reviewers" */
export type RequestFormTemplateReviewersInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  requestFormTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** on_conflict condition type for table "request_form_template_reviewers" */
export type RequestFormTemplateReviewersOnConflict = {
  constraint: RequestFormTemplateReviewersConstraint;
  update_columns: Array<RequestFormTemplateReviewersUpdateColumn>;
  where?: InputMaybe<RequestFormTemplateReviewersBoolExp>;
};

/** update columns of table "request_form_template_reviewers" */
export enum RequestFormTemplateReviewersUpdateColumn {
  /** column name */
  ID = 'id',
  /** column name */
  REQUESTFORMTEMPLATEID = 'requestFormTemplateId',
  /** column name */
  USERID = 'userId'
}

/** columns and relationships of "request_form_templates" */
export type RequestFormTemplates = {
  __typename?: 'request_form_templates';
  config: Scalars['jsonb']['output'];
  createdAt: Scalars['timestamptz']['output'];
  createdBy: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  created_by_user: Maybe<Users>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  description: Maybe<Scalars['String']['output']>;
  draftConfig: Maybe<Scalars['jsonb']['output']>;
  formTemplateId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  form_template: Maybe<FormTemplates>;
  /** An object relationship */
  form_type: FormType;
  id: Scalars['uuid']['output'];
  isSent: Scalars['Boolean']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  requestStepId: Scalars['uuid']['output'];
  /** An array relationship */
  request_form_template_reviewers: Array<RequestFormTemplateReviewers>;
  /** An array relationship */
  request_forms: Array<RequestForms>;
  /** An object relationship */
  request_step: RequestSteps;
  /** An array relationship */
  request_step_tasks: Array<RequestStepTasks>;
  /** An aggregate relationship */
  request_step_tasks_aggregate: RequestStepTasksAggregate;
  title: Scalars['String']['output'];
  type: FormTypeEnum;
  updatedAt: Scalars['timestamptz']['output'];
  updatedBy: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  updated_by_user: Maybe<Users>;
};

/** input type for inserting array relation for remote table "request_form_templates" */
export type RequestFormTemplatesArrRelInsertInput = {
  data: Array<RequestFormTemplatesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestFormTemplatesOnConflict>;
};

/** Boolean expression to filter rows from the table "request_form_templates". All fields are combined with a logical 'AND'. */
export type RequestFormTemplatesBoolExp = {
  _and?: InputMaybe<Array<RequestFormTemplatesBoolExp>>;
  _not?: InputMaybe<RequestFormTemplatesBoolExp>;
  _or?: InputMaybe<Array<RequestFormTemplatesBoolExp>>;
  config?: InputMaybe<JsonbComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdBy?: InputMaybe<UuidComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  draftConfig?: InputMaybe<JsonbComparisonExp>;
  formTemplateId?: InputMaybe<UuidComparisonExp>;
  form_template?: InputMaybe<FormTemplatesBoolExp>;
  form_type?: InputMaybe<FormTypeBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isSent?: InputMaybe<BooleanComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  requestStepId?: InputMaybe<UuidComparisonExp>;
  request_form_template_reviewers?: InputMaybe<RequestFormTemplateReviewersBoolExp>;
  request_forms?: InputMaybe<RequestFormsBoolExp>;
  request_step?: InputMaybe<RequestStepsBoolExp>;
  request_step_tasks?: InputMaybe<RequestStepTasksBoolExp>;
  request_step_tasks_aggregate?: InputMaybe<RequestStepTasksAggregateBoolExp>;
  title?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<FormTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedBy?: InputMaybe<UuidComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "request_form_templates" */
export enum RequestFormTemplatesConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_FORM_TEMPLATES_PKEY = 'request_form_templates_pkey'
}

/** input type for inserting data into table "request_form_templates" */
export type RequestFormTemplatesInsertInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  created_by_user?: InputMaybe<UsersObjRelInsertInput>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  draftConfig?: InputMaybe<Scalars['jsonb']['input']>;
  formTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  form_template?: InputMaybe<FormTemplatesObjRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isSent?: InputMaybe<Scalars['Boolean']['input']>;
  requestStepId?: InputMaybe<Scalars['uuid']['input']>;
  request_form_template_reviewers?: InputMaybe<RequestFormTemplateReviewersArrRelInsertInput>;
  request_forms?: InputMaybe<RequestFormsArrRelInsertInput>;
  request_step?: InputMaybe<RequestStepsObjRelInsertInput>;
  request_step_tasks?: InputMaybe<RequestStepTasksArrRelInsertInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FormTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
  updated_by_user?: InputMaybe<UsersObjRelInsertInput>;
};

/** input type for inserting object relation for remote table "request_form_templates" */
export type RequestFormTemplatesObjRelInsertInput = {
  data: RequestFormTemplatesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestFormTemplatesOnConflict>;
};

/** on_conflict condition type for table "request_form_templates" */
export type RequestFormTemplatesOnConflict = {
  constraint: RequestFormTemplatesConstraint;
  update_columns: Array<RequestFormTemplatesUpdateColumn>;
  where?: InputMaybe<RequestFormTemplatesBoolExp>;
};

/** update columns of table "request_form_templates" */
export enum RequestFormTemplatesUpdateColumn {
  /** column name */
  CONFIG = 'config',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CREATEDBY = 'createdBy',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  DRAFTCONFIG = 'draftConfig',
  /** column name */
  FORMTEMPLATEID = 'formTemplateId',
  /** column name */
  ID = 'id',
  /** column name */
  ISSENT = 'isSent',
  /** column name */
  REQUESTSTEPID = 'requestStepId',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  UPDATEDBY = 'updatedBy'
}

/** columns and relationships of "request_forms" */
export type RequestForms = {
  __typename?: 'request_forms';
  config: Scalars['formConfig']['output'];
  created_at: Scalars['timestamptz']['output'];
  description: Scalars['String']['output'];
  formTemplateId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  form_template: Maybe<FormTemplates>;
  /** An object relationship */
  form_type: FormType;
  id: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  request: Requests;
  requestId: Scalars['uuid']['output'];
  /** An array relationship */
  request_comments: Array<RequestComments>;
  /** An aggregate relationship */
  request_comments_aggregate: RequestCommentsAggregate;
  /** An array relationship */
  request_form_question_scores: Array<RequestFormQuestionScore>;
  /** An array relationship */
  request_form_submission_ai_summaries: Array<RequestFormSubmissionAiSummary>;
  /** An array relationship */
  request_form_submissions: Array<RequestFormSubmissions>;
  /** An aggregate relationship */
  request_form_submissions_aggregate: RequestFormSubmissionsAggregate;
  /** An array relationship */
  request_form_submissions_auto_saves: Array<RequestFormSubmissionsAutoSaves>;
  /** An aggregate relationship */
  request_form_submissions_auto_saves_aggregate: RequestFormSubmissionsAutoSavesAggregate;
  /** An object relationship */
  request_form_template: Maybe<RequestFormTemplates>;
  request_form_template_id: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  request_step_tasks: Array<RequestStepTasks>;
  /** An aggregate relationship */
  request_step_tasks_aggregate: RequestStepTasksAggregate;
  title: Scalars['String']['output'];
  type: FormTypeEnum;
  updated_at: Maybe<Scalars['timestamptz']['output']>;
};

/** input type for inserting array relation for remote table "request_forms" */
export type RequestFormsArrRelInsertInput = {
  data: Array<RequestFormsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestFormsOnConflict>;
};

/** Boolean expression to filter rows from the table "request_forms". All fields are combined with a logical 'AND'. */
export type RequestFormsBoolExp = {
  _and?: InputMaybe<Array<RequestFormsBoolExp>>;
  _not?: InputMaybe<RequestFormsBoolExp>;
  _or?: InputMaybe<Array<RequestFormsBoolExp>>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  formTemplateId?: InputMaybe<UuidComparisonExp>;
  form_template?: InputMaybe<FormTemplatesBoolExp>;
  form_type?: InputMaybe<FormTypeBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  request?: InputMaybe<RequestsBoolExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  request_comments?: InputMaybe<RequestCommentsBoolExp>;
  request_comments_aggregate?: InputMaybe<RequestCommentsAggregateBoolExp>;
  request_form_question_scores?: InputMaybe<RequestFormQuestionScoreBoolExp>;
  request_form_submission_ai_summaries?: InputMaybe<RequestFormSubmissionAiSummaryBoolExp>;
  request_form_submissions?: InputMaybe<RequestFormSubmissionsBoolExp>;
  request_form_submissions_aggregate?: InputMaybe<RequestFormSubmissionsAggregateBoolExp>;
  request_form_submissions_auto_saves?: InputMaybe<RequestFormSubmissionsAutoSavesBoolExp>;
  request_form_submissions_auto_saves_aggregate?: InputMaybe<RequestFormSubmissionsAutoSavesAggregateBoolExp>;
  request_form_template?: InputMaybe<RequestFormTemplatesBoolExp>;
  request_form_template_id?: InputMaybe<UuidComparisonExp>;
  request_step_tasks?: InputMaybe<RequestStepTasksBoolExp>;
  request_step_tasks_aggregate?: InputMaybe<RequestStepTasksAggregateBoolExp>;
  title?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<FormTypeEnumComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "request_forms" */
export enum RequestFormsConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_FORMS_PKEY = 'request_forms_pkey',
  /** unique or primary key constraint on columns "request_id", "form_template_id" */
  REQUEST_FORMS_REQUEST_ID_FORM_TEMPLATE_ID_KEY = 'request_forms_request_id_form_template_id_key'
}

/** input type for inserting data into table "request_forms" */
export type RequestFormsInsertInput = {
  config: Scalars['formConfig']['input'];
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  formTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  form_template?: InputMaybe<FormTemplatesObjRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  request?: InputMaybe<RequestsObjRelInsertInput>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  request_comments?: InputMaybe<RequestCommentsArrRelInsertInput>;
  request_form_question_scores?: InputMaybe<RequestFormQuestionScoreArrRelInsertInput>;
  request_form_submission_ai_summaries?: InputMaybe<RequestFormSubmissionAiSummaryArrRelInsertInput>;
  request_form_submissions?: InputMaybe<RequestFormSubmissionsArrRelInsertInput>;
  request_form_submissions_auto_saves?: InputMaybe<RequestFormSubmissionsAutoSavesArrRelInsertInput>;
  request_form_template?: InputMaybe<RequestFormTemplatesObjRelInsertInput>;
  request_form_template_id?: InputMaybe<Scalars['uuid']['input']>;
  request_step_tasks?: InputMaybe<RequestStepTasksArrRelInsertInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FormTypeEnum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** input type for inserting object relation for remote table "request_forms" */
export type RequestFormsObjRelInsertInput = {
  data: RequestFormsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestFormsOnConflict>;
};

/** on_conflict condition type for table "request_forms" */
export type RequestFormsOnConflict = {
  constraint: RequestFormsConstraint;
  update_columns: Array<RequestFormsUpdateColumn>;
  where?: InputMaybe<RequestFormsBoolExp>;
};

/** update columns of table "request_forms" */
export enum RequestFormsUpdateColumn {
  /** column name */
  CONFIG = 'config',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  FORMTEMPLATEID = 'formTemplateId',
  /** column name */
  ID = 'id',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  REQUEST_FORM_TEMPLATE_ID = 'request_form_template_id',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at'
}

/** columns and relationships of "request_groups" */
export type RequestGroups = {
  __typename?: 'request_groups';
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  group: Groups;
  groupId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  request: Requests;
  requestId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** input type for inserting array relation for remote table "request_groups" */
export type RequestGroupsArrRelInsertInput = {
  data: Array<RequestGroupsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestGroupsOnConflict>;
};

/** Boolean expression to filter rows from the table "request_groups". All fields are combined with a logical 'AND'. */
export type RequestGroupsBoolExp = {
  _and?: InputMaybe<Array<RequestGroupsBoolExp>>;
  _not?: InputMaybe<RequestGroupsBoolExp>;
  _or?: InputMaybe<Array<RequestGroupsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  group?: InputMaybe<GroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  request?: InputMaybe<RequestsBoolExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "request_groups" */
export enum RequestGroupsConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_GROUPS_PKEY = 'request_groups_pkey',
  /** unique or primary key constraint on columns "request_id", "group_id" */
  REQUEST_GROUPS_REQUEST_ID_GROUP_ID_KEY = 'request_groups_request_id_group_id_key'
}

/** input type for inserting data into table "request_groups" */
export type RequestGroupsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  group?: InputMaybe<GroupsObjRelInsertInput>;
  groupId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  request?: InputMaybe<RequestsObjRelInsertInput>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** on_conflict condition type for table "request_groups" */
export type RequestGroupsOnConflict = {
  constraint: RequestGroupsConstraint;
  update_columns: Array<RequestGroupsUpdateColumn>;
  where?: InputMaybe<RequestGroupsBoolExp>;
};

/** update columns of table "request_groups" */
export enum RequestGroupsUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  GROUPID = 'groupId',
  /** column name */
  ID = 'id',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** columns and relationships of "request_pauses" */
export type RequestPauses = {
  __typename?: 'request_pauses';
  assigneeId: Scalars['uuid']['output'];
  end: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  note: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organisation: Organisations;
  /** An object relationship */
  pause_reason: PauseReasons;
  reasonId: Scalars['uuid']['output'];
  reminderDate: Scalars['date']['output'];
  /** An object relationship */
  request: Requests;
  requestId: Scalars['uuid']['output'];
  start: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
};

/** input type for inserting array relation for remote table "request_pauses" */
export type RequestPausesArrRelInsertInput = {
  data: Array<RequestPausesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestPausesOnConflict>;
};

/** Boolean expression to filter rows from the table "request_pauses". All fields are combined with a logical 'AND'. */
export type RequestPausesBoolExp = {
  _and?: InputMaybe<Array<RequestPausesBoolExp>>;
  _not?: InputMaybe<RequestPausesBoolExp>;
  _or?: InputMaybe<Array<RequestPausesBoolExp>>;
  assigneeId?: InputMaybe<UuidComparisonExp>;
  end?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  note?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  pause_reason?: InputMaybe<PauseReasonsBoolExp>;
  reasonId?: InputMaybe<UuidComparisonExp>;
  reminderDate?: InputMaybe<DateComparisonExp>;
  request?: InputMaybe<RequestsBoolExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  start?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "request_pauses" */
export enum RequestPausesConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_PAUSES_PKEY = 'request_pauses_pkey'
}

/** input type for inserting data into table "request_pauses" */
export type RequestPausesInsertInput = {
  assigneeId?: InputMaybe<Scalars['uuid']['input']>;
  end?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  pause_reason?: InputMaybe<PauseReasonsObjRelInsertInput>;
  reasonId?: InputMaybe<Scalars['uuid']['input']>;
  reminderDate?: InputMaybe<Scalars['date']['input']>;
  request?: InputMaybe<RequestsObjRelInsertInput>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  start?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
};

/** on_conflict condition type for table "request_pauses" */
export type RequestPausesOnConflict = {
  constraint: RequestPausesConstraint;
  update_columns: Array<RequestPausesUpdateColumn>;
  where?: InputMaybe<RequestPausesBoolExp>;
};

/** update columns of table "request_pauses" */
export enum RequestPausesUpdateColumn {
  /** column name */
  END = 'end'
}

/** columns and relationships of "request_priority" */
export type RequestPriority = {
  __typename?: 'request_priority';
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "request_priority". All fields are combined with a logical 'AND'. */
export type RequestPriorityBoolExp = {
  _and?: InputMaybe<Array<RequestPriorityBoolExp>>;
  _not?: InputMaybe<RequestPriorityBoolExp>;
  _or?: InputMaybe<Array<RequestPriorityBoolExp>>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum RequestPriorityEnum {
  HIGH = 'HIGH',
  HIGHEST = 'HIGHEST',
  LOW = 'LOW',
  LOWEST = 'LOWEST',
  MEDIUM = 'MEDIUM'
}

/** Boolean expression to compare columns of type "request_priority_enum". All fields are combined with logical 'AND'. */
export type RequestPriorityEnumComparisonExp = {
  _eq?: InputMaybe<RequestPriorityEnum>;
  _in?: InputMaybe<Array<RequestPriorityEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<RequestPriorityEnum>;
  _nin?: InputMaybe<Array<RequestPriorityEnum>>;
};

/** columns and relationships of "request_request_leads" */
export type RequestRequestLeads = {
  __typename?: 'request_request_leads';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  request: Requests;
  requestId: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** input type for inserting array relation for remote table "request_request_leads" */
export type RequestRequestLeadsArrRelInsertInput = {
  data: Array<RequestRequestLeadsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestRequestLeadsOnConflict>;
};

/** Boolean expression to filter rows from the table "request_request_leads". All fields are combined with a logical 'AND'. */
export type RequestRequestLeadsBoolExp = {
  _and?: InputMaybe<Array<RequestRequestLeadsBoolExp>>;
  _not?: InputMaybe<RequestRequestLeadsBoolExp>;
  _or?: InputMaybe<Array<RequestRequestLeadsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  request?: InputMaybe<RequestsBoolExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "request_request_leads" */
export enum RequestRequestLeadsConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_REQUEST_LEADS_PKEY = 'request_request_leads_pkey',
  /** unique or primary key constraint on columns "user_id", "request_id" */
  REQUEST_REQUEST_LEADS_REQUEST_ID_USER_ID_KEY = 'request_request_leads_request_id_user_id_key'
}

/** input type for inserting data into table "request_request_leads" */
export type RequestRequestLeadsInsertInput = {
  request?: InputMaybe<RequestsObjRelInsertInput>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** on_conflict condition type for table "request_request_leads" */
export type RequestRequestLeadsOnConflict = {
  constraint: RequestRequestLeadsConstraint;
  update_columns: Array<RequestRequestLeadsUpdateColumn>;
  where?: InputMaybe<RequestRequestLeadsBoolExp>;
};

/** update columns of table "request_request_leads" */
export enum RequestRequestLeadsUpdateColumn {
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  USERID = 'userId'
}

/** columns and relationships of "request_step_groups" */
export type RequestStepGroups = {
  __typename?: 'request_step_groups';
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  group: Groups;
  groupId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  requestStepId: Scalars['uuid']['output'];
  /** An object relationship */
  request_step: RequestSteps;
  updatedAt: Scalars['timestamptz']['output'];
};

/** input type for inserting array relation for remote table "request_step_groups" */
export type RequestStepGroupsArrRelInsertInput = {
  data: Array<RequestStepGroupsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestStepGroupsOnConflict>;
};

/** Boolean expression to filter rows from the table "request_step_groups". All fields are combined with a logical 'AND'. */
export type RequestStepGroupsBoolExp = {
  _and?: InputMaybe<Array<RequestStepGroupsBoolExp>>;
  _not?: InputMaybe<RequestStepGroupsBoolExp>;
  _or?: InputMaybe<Array<RequestStepGroupsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  group?: InputMaybe<GroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  requestStepId?: InputMaybe<UuidComparisonExp>;
  request_step?: InputMaybe<RequestStepsBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "request_step_groups" */
export enum RequestStepGroupsConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_STEP_ASSIGNED_GROUPS_PKEY = 'request_step_assigned_groups_pkey',
  /** unique or primary key constraint on columns "request_step_id", "group_id" */
  REQUEST_STEP_GROUPS_REQUEST_STEP_ID_GROUP_ID_KEY = 'request_step_groups_request_step_id_group_id_key'
}

/** input type for inserting data into table "request_step_groups" */
export type RequestStepGroupsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  group?: InputMaybe<GroupsObjRelInsertInput>;
  groupId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  requestStepId?: InputMaybe<Scalars['uuid']['input']>;
  request_step?: InputMaybe<RequestStepsObjRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** on_conflict condition type for table "request_step_groups" */
export type RequestStepGroupsOnConflict = {
  constraint: RequestStepGroupsConstraint;
  update_columns: Array<RequestStepGroupsUpdateColumn>;
  where?: InputMaybe<RequestStepGroupsBoolExp>;
};

/** update columns of table "request_step_groups" */
export enum RequestStepGroupsUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  GROUPID = 'groupId',
  /** column name */
  ID = 'id',
  /** column name */
  REQUESTSTEPID = 'requestStepId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** columns and relationships of "request_step_result" */
export type RequestStepResult = {
  __typename?: 'request_step_result';
  description: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "request_step_result". All fields are combined with a logical 'AND'. */
export type RequestStepResultBoolExp = {
  _and?: InputMaybe<Array<RequestStepResultBoolExp>>;
  _not?: InputMaybe<RequestStepResultBoolExp>;
  _or?: InputMaybe<Array<RequestStepResultBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum RequestStepResultEnum {
  /** Error */
  ERROR = 'Error',
  /** Fail */
  FAIL = 'FAIL',
  /** Pass */
  PASS = 'PASS'
}

/** Boolean expression to compare columns of type "request_step_result_enum". All fields are combined with logical 'AND'. */
export type RequestStepResultEnumComparisonExp = {
  _eq?: InputMaybe<RequestStepResultEnum>;
  _in?: InputMaybe<Array<RequestStepResultEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<RequestStepResultEnum>;
  _nin?: InputMaybe<Array<RequestStepResultEnum>>;
};

export enum RequestStepStateEnum {
  /** CANCELLED */
  CANCELLED = 'CANCELLED',
  /** COMPLETE */
  COMPLETE = 'COMPLETE',
  /** PAUSED */
  PAUSED = 'PAUSED',
  /** PENDING */
  PENDING = 'PENDING',
  /** RUNNING */
  RUNNING = 'RUNNING'
}

/** Boolean expression to compare columns of type "request_step_state_enum". All fields are combined with logical 'AND'. */
export type RequestStepStateEnumComparisonExp = {
  _eq?: InputMaybe<RequestStepStateEnum>;
  _in?: InputMaybe<Array<RequestStepStateEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<RequestStepStateEnum>;
  _nin?: InputMaybe<Array<RequestStepStateEnum>>;
};

/** columns and relationships of "request_step_task_errors" */
export type RequestStepTaskErrors = {
  __typename?: 'request_step_task_errors';
  createdAt: Scalars['timestamptz']['output'];
  detail: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['uuid']['output'];
  message: Scalars['String']['output'];
  occuredAt: Scalars['timestamptz']['output'];
  organisation_id: Scalars['uuid']['output'];
  requestStepTaskId: Scalars['uuid']['output'];
  /** An object relationship */
  request_step_task: RequestStepTasks;
  resolvedAt: Maybe<Scalars['timestamptz']['output']>;
  suggestion: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

/** input type for inserting array relation for remote table "request_step_task_errors" */
export type RequestStepTaskErrorsArrRelInsertInput = {
  data: Array<RequestStepTaskErrorsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestStepTaskErrorsOnConflict>;
};

/** Boolean expression to filter rows from the table "request_step_task_errors". All fields are combined with a logical 'AND'. */
export type RequestStepTaskErrorsBoolExp = {
  _and?: InputMaybe<Array<RequestStepTaskErrorsBoolExp>>;
  _not?: InputMaybe<RequestStepTaskErrorsBoolExp>;
  _or?: InputMaybe<Array<RequestStepTaskErrorsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  detail?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  message?: InputMaybe<StringComparisonExp>;
  occuredAt?: InputMaybe<TimestamptzComparisonExp>;
  organisation_id?: InputMaybe<UuidComparisonExp>;
  requestStepTaskId?: InputMaybe<UuidComparisonExp>;
  request_step_task?: InputMaybe<RequestStepTasksBoolExp>;
  resolvedAt?: InputMaybe<TimestamptzComparisonExp>;
  suggestion?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "request_step_task_errors" */
export enum RequestStepTaskErrorsConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_STEP_TASK_ERRORS_PKEY = 'request_step_task_errors_pkey'
}

/** input type for inserting data into table "request_step_task_errors" */
export type RequestStepTaskErrorsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  detail?: InputMaybe<Scalars['jsonb']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  occuredAt?: InputMaybe<Scalars['timestamptz']['input']>;
  requestStepTaskId?: InputMaybe<Scalars['uuid']['input']>;
  request_step_task?: InputMaybe<RequestStepTasksObjRelInsertInput>;
  suggestion?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** on_conflict condition type for table "request_step_task_errors" */
export type RequestStepTaskErrorsOnConflict = {
  constraint: RequestStepTaskErrorsConstraint;
  update_columns: Array<RequestStepTaskErrorsUpdateColumn>;
  where?: InputMaybe<RequestStepTaskErrorsBoolExp>;
};

/** update columns of table "request_step_task_errors" */
export enum RequestStepTaskErrorsUpdateColumn {
  /** column name */
  RESOLVEDAT = 'resolvedAt'
}

/** columns and relationships of "request_step_task_rejections" */
export type RequestStepTaskRejections = {
  __typename?: 'request_step_task_rejections';
  createdAt: Scalars['timestamptz']['output'];
  createdBy: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  message: Scalars['String']['output'];
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  requestStepTask: RequestStepTasks;
  requestStepTaskId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "request_step_task_rejections" */
export type RequestStepTaskRejectionsAggregate = {
  __typename?: 'request_step_task_rejections_aggregate';
  aggregate: Maybe<RequestStepTaskRejectionsAggregateFields>;
  nodes: Array<RequestStepTaskRejections>;
};

export type RequestStepTaskRejectionsAggregateBoolExp = {
  count?: InputMaybe<RequestStepTaskRejectionsAggregateBoolExpCount>;
};

export type RequestStepTaskRejectionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RequestStepTaskRejectionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RequestStepTaskRejectionsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "request_step_task_rejections" */
export type RequestStepTaskRejectionsAggregateFields = {
  __typename?: 'request_step_task_rejections_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<RequestStepTaskRejectionsMaxFields>;
  min: Maybe<RequestStepTaskRejectionsMinFields>;
};

/** input type for inserting array relation for remote table "request_step_task_rejections" */
export type RequestStepTaskRejectionsArrRelInsertInput = {
  data: Array<RequestStepTaskRejectionsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestStepTaskRejectionsOnConflict>;
};

/** Boolean expression to filter rows from the table "request_step_task_rejections". All fields are combined with a logical 'AND'. */
export type RequestStepTaskRejectionsBoolExp = {
  _and?: InputMaybe<Array<RequestStepTaskRejectionsBoolExp>>;
  _not?: InputMaybe<RequestStepTaskRejectionsBoolExp>;
  _or?: InputMaybe<Array<RequestStepTaskRejectionsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdBy?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  message?: InputMaybe<StringComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  requestStepTask?: InputMaybe<RequestStepTasksBoolExp>;
  requestStepTaskId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "request_step_task_rejections" */
export enum RequestStepTaskRejectionsConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_STEP_TASK_REJECTIONS_PKEY = 'request_step_task_rejections_pkey',
  /** unique or primary key constraint on columns "request_step_task_id" */
  REQUEST_STEP_TASK_REJECTIONS_UNIQUE_TASK_ID = 'request_step_task_rejections_unique_task_id'
}

/** input type for inserting data into table "request_step_task_rejections" */
export type RequestStepTaskRejectionsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  requestStepTask?: InputMaybe<RequestStepTasksObjRelInsertInput>;
  requestStepTaskId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type RequestStepTaskRejectionsMaxFields = {
  __typename?: 'request_step_task_rejections_max_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  createdBy: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  message: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  requestStepTaskId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type RequestStepTaskRejectionsMinFields = {
  __typename?: 'request_step_task_rejections_min_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  createdBy: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  message: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  requestStepTaskId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** on_conflict condition type for table "request_step_task_rejections" */
export type RequestStepTaskRejectionsOnConflict = {
  constraint: RequestStepTaskRejectionsConstraint;
  update_columns: Array<RequestStepTaskRejectionsUpdateColumn>;
  where?: InputMaybe<RequestStepTaskRejectionsBoolExp>;
};

/** select columns of table "request_step_task_rejections" */
export enum RequestStepTaskRejectionsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CREATEDBY = 'createdBy',
  /** column name */
  ID = 'id',
  /** column name */
  MESSAGE = 'message',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  REQUESTSTEPTASKID = 'requestStepTaskId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** update columns of table "request_step_task_rejections" */
export enum RequestStepTaskRejectionsUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CREATEDBY = 'createdBy',
  /** column name */
  ID = 'id',
  /** column name */
  MESSAGE = 'message',
  /** column name */
  REQUESTSTEPTASKID = 'requestStepTaskId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** columns and relationships of "request_step_task_type" */
export type RequestStepTaskType = {
  __typename?: 'request_step_task_type';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "request_step_task_type". All fields are combined with a logical 'AND'. */
export type RequestStepTaskTypeBoolExp = {
  _and?: InputMaybe<Array<RequestStepTaskTypeBoolExp>>;
  _not?: InputMaybe<RequestStepTaskTypeBoolExp>;
  _or?: InputMaybe<Array<RequestStepTaskTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum RequestStepTaskTypeEnum {
  /** Sync supplier data in external accounting software */
  ACCOUNTING_SUPPLIER_DATA_SYNC = 'ACCOUNTING_SUPPLIER_DATA_SYNC',
  /** eSignature task */
  ESIGN_FILL_IN = 'ESIGN_FILL_IN',
  /** External Operation */
  EXTERNAL_OPERATION = 'EXTERNAL_OPERATION',
  /** Create PO in external accounting software */
  EXTERNAL_PO_CREATION = 'EXTERNAL_PO_CREATION',
  /** Fill in */
  FILL_IN = 'FILL_IN',
  /** Review */
  REVIEW = 'REVIEW',
  /** Scoring task for a particular RFX form */
  SCORE_RFX_FORM = 'SCORE_RFX_FORM',
  /** Summary approval */
  SUMMARY_APPROVAL = 'SUMMARY_APPROVAL'
}

/** Boolean expression to compare columns of type "request_step_task_type_enum". All fields are combined with logical 'AND'. */
export type RequestStepTaskTypeEnumComparisonExp = {
  _eq?: InputMaybe<RequestStepTaskTypeEnum>;
  _in?: InputMaybe<Array<RequestStepTaskTypeEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<RequestStepTaskTypeEnum>;
  _nin?: InputMaybe<Array<RequestStepTaskTypeEnum>>;
};

/** columns and relationships of "request_step_task_users" */
export type RequestStepTaskUsers = {
  __typename?: 'request_step_task_users';
  organisation_id: Scalars['uuid']['output'];
  /** An object relationship */
  request_step_task: RequestStepTasks;
  request_step_task_id: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** input type for inserting array relation for remote table "request_step_task_users" */
export type RequestStepTaskUsersArrRelInsertInput = {
  data: Array<RequestStepTaskUsersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestStepTaskUsersOnConflict>;
};

/** Boolean expression to filter rows from the table "request_step_task_users". All fields are combined with a logical 'AND'. */
export type RequestStepTaskUsersBoolExp = {
  _and?: InputMaybe<Array<RequestStepTaskUsersBoolExp>>;
  _not?: InputMaybe<RequestStepTaskUsersBoolExp>;
  _or?: InputMaybe<Array<RequestStepTaskUsersBoolExp>>;
  organisation_id?: InputMaybe<UuidComparisonExp>;
  request_step_task?: InputMaybe<RequestStepTasksBoolExp>;
  request_step_task_id?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  user_id?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "request_step_task_users" */
export enum RequestStepTaskUsersConstraint {
  /** unique or primary key constraint on columns "user_id", "organisation_id", "request_step_task_id" */
  REQUEST_STEP_TASK_USERS_PKEY = 'request_step_task_users_pkey'
}

/** input type for inserting data into table "request_step_task_users" */
export type RequestStepTaskUsersInsertInput = {
  request_step_task?: InputMaybe<RequestStepTasksObjRelInsertInput>;
  request_step_task_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** on_conflict condition type for table "request_step_task_users" */
export type RequestStepTaskUsersOnConflict = {
  constraint: RequestStepTaskUsersConstraint;
  update_columns: Array<RequestStepTaskUsersUpdateColumn>;
  where?: InputMaybe<RequestStepTaskUsersBoolExp>;
};

/** placeholder for update columns of table "request_step_task_users" (current role has no relevant permissions) */
export enum RequestStepTaskUsersUpdateColumn {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

/** columns and relationships of "request_step_tasks" */
export type RequestStepTasks = {
  __typename?: 'request_step_tasks';
  completedBy: Maybe<Scalars['uuid']['output']>;
  completedOn: Maybe<Scalars['timestamptz']['output']>;
  config: Maybe<Scalars['jsonb']['output']>;
  created_at: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  organisation_supplier: Maybe<OrganisationSuppliers>;
  requestFormId: Maybe<Scalars['uuid']['output']>;
  requestStepId: Scalars['uuid']['output'];
  /** An object relationship */
  request_form: Maybe<RequestForms>;
  /** An array relationship */
  request_form_question_scores: Array<RequestFormQuestionScore>;
  /** An array relationship */
  request_form_submissions: Array<RequestFormSubmissions>;
  /** An aggregate relationship */
  request_form_submissions_aggregate: RequestFormSubmissionsAggregate;
  /** An object relationship */
  request_form_template: Maybe<RequestFormTemplates>;
  request_form_template_id: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  request_step: RequestSteps;
  /** An array relationship */
  request_step_task_errors: Array<RequestStepTaskErrors>;
  /** An array relationship */
  request_step_task_rejections: Array<RequestStepTaskRejections>;
  /** An aggregate relationship */
  request_step_task_rejections_aggregate: RequestStepTaskRejectionsAggregate;
  /** An object relationship */
  request_step_task_type: RequestStepTaskType;
  /** An array relationship */
  request_step_task_users: Array<RequestStepTaskUsers>;
  submissionsClosedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  supplier: Maybe<OrganisationSuppliers>;
  type: RequestStepTaskTypeEnum;
};

/** aggregated selection of "request_step_tasks" */
export type RequestStepTasksAggregate = {
  __typename?: 'request_step_tasks_aggregate';
  aggregate: Maybe<RequestStepTasksAggregateFields>;
  nodes: Array<RequestStepTasks>;
};

export type RequestStepTasksAggregateBoolExp = {
  count?: InputMaybe<RequestStepTasksAggregateBoolExpCount>;
};

export type RequestStepTasksAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RequestStepTasksSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RequestStepTasksBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "request_step_tasks" */
export type RequestStepTasksAggregateFields = {
  __typename?: 'request_step_tasks_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<RequestStepTasksMaxFields>;
  min: Maybe<RequestStepTasksMinFields>;
};

/** input type for inserting array relation for remote table "request_step_tasks" */
export type RequestStepTasksArrRelInsertInput = {
  data: Array<RequestStepTasksInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestStepTasksOnConflict>;
};

/** Boolean expression to filter rows from the table "request_step_tasks". All fields are combined with a logical 'AND'. */
export type RequestStepTasksBoolExp = {
  _and?: InputMaybe<Array<RequestStepTasksBoolExp>>;
  _not?: InputMaybe<RequestStepTasksBoolExp>;
  _or?: InputMaybe<Array<RequestStepTasksBoolExp>>;
  completedBy?: InputMaybe<UuidComparisonExp>;
  completedOn?: InputMaybe<TimestamptzComparisonExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisationSupplierId?: InputMaybe<UuidComparisonExp>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  requestFormId?: InputMaybe<UuidComparisonExp>;
  requestStepId?: InputMaybe<UuidComparisonExp>;
  request_form?: InputMaybe<RequestFormsBoolExp>;
  request_form_question_scores?: InputMaybe<RequestFormQuestionScoreBoolExp>;
  request_form_submissions?: InputMaybe<RequestFormSubmissionsBoolExp>;
  request_form_submissions_aggregate?: InputMaybe<RequestFormSubmissionsAggregateBoolExp>;
  request_form_template?: InputMaybe<RequestFormTemplatesBoolExp>;
  request_form_template_id?: InputMaybe<UuidComparisonExp>;
  request_step?: InputMaybe<RequestStepsBoolExp>;
  request_step_task_errors?: InputMaybe<RequestStepTaskErrorsBoolExp>;
  request_step_task_rejections?: InputMaybe<RequestStepTaskRejectionsBoolExp>;
  request_step_task_rejections_aggregate?: InputMaybe<RequestStepTaskRejectionsAggregateBoolExp>;
  request_step_task_type?: InputMaybe<RequestStepTaskTypeBoolExp>;
  request_step_task_users?: InputMaybe<RequestStepTaskUsersBoolExp>;
  submissionsClosedAt?: InputMaybe<TimestamptzComparisonExp>;
  supplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  type?: InputMaybe<RequestStepTaskTypeEnumComparisonExp>;
};

/** unique or primary key constraints on table "request_step_tasks" */
export enum RequestStepTasksConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_STEP_TASKS_PKEY = 'request_step_tasks_pkey'
}

/** input type for inserting data into table "request_step_tasks" */
export type RequestStepTasksInsertInput = {
  completedBy?: InputMaybe<Scalars['uuid']['input']>;
  completedOn?: InputMaybe<Scalars['timestamptz']['input']>;
  config?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  requestFormId?: InputMaybe<Scalars['uuid']['input']>;
  requestStepId?: InputMaybe<Scalars['uuid']['input']>;
  request_form?: InputMaybe<RequestFormsObjRelInsertInput>;
  request_form_question_scores?: InputMaybe<RequestFormQuestionScoreArrRelInsertInput>;
  request_form_submissions?: InputMaybe<RequestFormSubmissionsArrRelInsertInput>;
  request_form_template?: InputMaybe<RequestFormTemplatesObjRelInsertInput>;
  request_form_template_id?: InputMaybe<Scalars['uuid']['input']>;
  request_step?: InputMaybe<RequestStepsObjRelInsertInput>;
  request_step_task_errors?: InputMaybe<RequestStepTaskErrorsArrRelInsertInput>;
  request_step_task_rejections?: InputMaybe<RequestStepTaskRejectionsArrRelInsertInput>;
  request_step_task_users?: InputMaybe<RequestStepTaskUsersArrRelInsertInput>;
  submissionsClosedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  supplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  type?: InputMaybe<RequestStepTaskTypeEnum>;
};

/** aggregate max on columns */
export type RequestStepTasksMaxFields = {
  __typename?: 'request_step_tasks_max_fields';
  completedBy: Maybe<Scalars['uuid']['output']>;
  completedOn: Maybe<Scalars['timestamptz']['output']>;
  created_at: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  requestFormId: Maybe<Scalars['uuid']['output']>;
  requestStepId: Maybe<Scalars['uuid']['output']>;
  request_form_template_id: Maybe<Scalars['uuid']['output']>;
  submissionsClosedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type RequestStepTasksMinFields = {
  __typename?: 'request_step_tasks_min_fields';
  completedBy: Maybe<Scalars['uuid']['output']>;
  completedOn: Maybe<Scalars['timestamptz']['output']>;
  created_at: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  requestFormId: Maybe<Scalars['uuid']['output']>;
  requestStepId: Maybe<Scalars['uuid']['output']>;
  request_form_template_id: Maybe<Scalars['uuid']['output']>;
  submissionsClosedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** input type for inserting object relation for remote table "request_step_tasks" */
export type RequestStepTasksObjRelInsertInput = {
  data: RequestStepTasksInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestStepTasksOnConflict>;
};

/** on_conflict condition type for table "request_step_tasks" */
export type RequestStepTasksOnConflict = {
  constraint: RequestStepTasksConstraint;
  update_columns: Array<RequestStepTasksUpdateColumn>;
  where?: InputMaybe<RequestStepTasksBoolExp>;
};

/** select columns of table "request_step_tasks" */
export enum RequestStepTasksSelectColumn {
  /** column name */
  COMPLETEDBY = 'completedBy',
  /** column name */
  COMPLETEDON = 'completedOn',
  /** column name */
  CONFIG = 'config',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  REQUESTFORMID = 'requestFormId',
  /** column name */
  REQUESTSTEPID = 'requestStepId',
  /** column name */
  REQUEST_FORM_TEMPLATE_ID = 'request_form_template_id',
  /** column name */
  SUBMISSIONSCLOSEDAT = 'submissionsClosedAt',
  /** column name */
  TYPE = 'type'
}

/** update columns of table "request_step_tasks" */
export enum RequestStepTasksUpdateColumn {
  /** column name */
  COMPLETEDBY = 'completedBy',
  /** column name */
  COMPLETEDON = 'completedOn',
  /** column name */
  CONFIG = 'config',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  REQUESTFORMID = 'requestFormId',
  /** column name */
  REQUESTSTEPID = 'requestStepId',
  /** column name */
  SUBMISSIONSCLOSEDAT = 'submissionsClosedAt',
  /** column name */
  TYPE = 'type'
}

/** columns and relationships of "request_step_users" */
export type RequestStepUsers = {
  __typename?: 'request_step_users';
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  requestStepId: Scalars['uuid']['output'];
  /** An object relationship */
  request_step: RequestSteps;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** input type for inserting array relation for remote table "request_step_users" */
export type RequestStepUsersArrRelInsertInput = {
  data: Array<RequestStepUsersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestStepUsersOnConflict>;
};

/** Boolean expression to filter rows from the table "request_step_users". All fields are combined with a logical 'AND'. */
export type RequestStepUsersBoolExp = {
  _and?: InputMaybe<Array<RequestStepUsersBoolExp>>;
  _not?: InputMaybe<RequestStepUsersBoolExp>;
  _or?: InputMaybe<Array<RequestStepUsersBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  requestStepId?: InputMaybe<UuidComparisonExp>;
  request_step?: InputMaybe<RequestStepsBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "request_step_users" */
export enum RequestStepUsersConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_STEP_ASSIGNED_USERS_PKEY = 'request_step_assigned_users_pkey',
  /** unique or primary key constraint on columns "user_id", "request_step_id" */
  REQUEST_STEP_USERS_REQUEST_STEP_ID_USER_ID_KEY = 'request_step_users_request_step_id_user_id_key'
}

/** input type for inserting data into table "request_step_users" */
export type RequestStepUsersInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  requestStepId?: InputMaybe<Scalars['uuid']['input']>;
  request_step?: InputMaybe<RequestStepsObjRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** on_conflict condition type for table "request_step_users" */
export type RequestStepUsersOnConflict = {
  constraint: RequestStepUsersConstraint;
  update_columns: Array<RequestStepUsersUpdateColumn>;
  where?: InputMaybe<RequestStepUsersBoolExp>;
};

/** update columns of table "request_step_users" */
export enum RequestStepUsersUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ID = 'id',
  /** column name */
  REQUESTSTEPID = 'requestStepId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId'
}

/** columns and relationships of "request_steps" */
export type RequestSteps = {
  __typename?: 'request_steps';
  actionTakenAt: Maybe<Scalars['timestamptz']['output']>;
  canvasModelId: Scalars['String']['output'];
  canvasModelParentIds: Scalars['jsonb']['output'];
  completedAt: Maybe<Scalars['timestamptz']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  data: Maybe<Scalars['jsonb']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  input: Scalars['jsonb']['output'];
  output: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  request: Requests;
  requestId: Scalars['uuid']['output'];
  /** An array relationship */
  request_form_templates: Array<RequestFormTemplates>;
  /** An array relationship */
  request_step_groups: Array<RequestStepGroups>;
  /** An object relationship */
  request_step_result: Maybe<RequestStepResult>;
  /** An array relationship */
  request_step_tasks: Array<RequestStepTasks>;
  /** An aggregate relationship */
  request_step_tasks_aggregate: RequestStepTasksAggregate;
  /** An array relationship */
  request_step_users: Array<RequestStepUsers>;
  result: Maybe<RequestStepResultEnum>;
  state: RequestStepStateEnum;
  totalPausedTime: Scalars['interval']['output'];
  totalPausedWorkingHours: Scalars['Int']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  workflow: Workflows;
  workflowId: Scalars['uuid']['output'];
};

/** aggregated selection of "request_steps" */
export type RequestStepsAggregate = {
  __typename?: 'request_steps_aggregate';
  aggregate: Maybe<RequestStepsAggregateFields>;
  nodes: Array<RequestSteps>;
};

export type RequestStepsAggregateBoolExp = {
  count?: InputMaybe<RequestStepsAggregateBoolExpCount>;
};

export type RequestStepsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RequestStepsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RequestStepsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "request_steps" */
export type RequestStepsAggregateFields = {
  __typename?: 'request_steps_aggregate_fields';
  avg: Maybe<RequestStepsAvgFields>;
  count: Scalars['Int']['output'];
  max: Maybe<RequestStepsMaxFields>;
  min: Maybe<RequestStepsMinFields>;
  stddev: Maybe<RequestStepsStddevFields>;
  stddev_pop: Maybe<RequestStepsStddevPopFields>;
  stddev_samp: Maybe<RequestStepsStddevSampFields>;
  sum: Maybe<RequestStepsSumFields>;
  var_pop: Maybe<RequestStepsVarPopFields>;
  var_samp: Maybe<RequestStepsVarSampFields>;
  variance: Maybe<RequestStepsVarianceFields>;
};

/** input type for inserting array relation for remote table "request_steps" */
export type RequestStepsArrRelInsertInput = {
  data: Array<RequestStepsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestStepsOnConflict>;
};

/** aggregate avg on columns */
export type RequestStepsAvgFields = {
  __typename?: 'request_steps_avg_fields';
  totalPausedWorkingHours: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "request_steps". All fields are combined with a logical 'AND'. */
export type RequestStepsBoolExp = {
  _and?: InputMaybe<Array<RequestStepsBoolExp>>;
  _not?: InputMaybe<RequestStepsBoolExp>;
  _or?: InputMaybe<Array<RequestStepsBoolExp>>;
  actionTakenAt?: InputMaybe<TimestamptzComparisonExp>;
  canvasModelId?: InputMaybe<StringComparisonExp>;
  canvasModelParentIds?: InputMaybe<JsonbComparisonExp>;
  completedAt?: InputMaybe<TimestamptzComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  data?: InputMaybe<JsonbComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  input?: InputMaybe<JsonbComparisonExp>;
  output?: InputMaybe<JsonbComparisonExp>;
  request?: InputMaybe<RequestsBoolExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  request_form_templates?: InputMaybe<RequestFormTemplatesBoolExp>;
  request_step_groups?: InputMaybe<RequestStepGroupsBoolExp>;
  request_step_result?: InputMaybe<RequestStepResultBoolExp>;
  request_step_tasks?: InputMaybe<RequestStepTasksBoolExp>;
  request_step_tasks_aggregate?: InputMaybe<RequestStepTasksAggregateBoolExp>;
  request_step_users?: InputMaybe<RequestStepUsersBoolExp>;
  result?: InputMaybe<RequestStepResultEnumComparisonExp>;
  state?: InputMaybe<RequestStepStateEnumComparisonExp>;
  totalPausedTime?: InputMaybe<IntervalComparisonExp>;
  totalPausedWorkingHours?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  workflow?: InputMaybe<WorkflowsBoolExp>;
  workflowId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "request_steps" */
export enum RequestStepsConstraint {
  /** unique or primary key constraint on columns "canvas_model_id", "request_id" */
  REQUEST_ID_CANVAS_ID = 'request_id_canvas_id',
  /** unique or primary key constraint on columns "id" */
  REQUEST_STEPS_PKEY = 'request_steps_pkey'
}

/** input type for inserting data into table "request_steps" */
export type RequestStepsInsertInput = {
  actionTakenAt?: InputMaybe<Scalars['timestamptz']['input']>;
  canvasModelId?: InputMaybe<Scalars['String']['input']>;
  canvasModelParentIds?: InputMaybe<Scalars['jsonb']['input']>;
  completedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  input: Scalars['requestStepGraphNode']['input'];
  output?: InputMaybe<Scalars['jsonb']['input']>;
  request?: InputMaybe<RequestsObjRelInsertInput>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  request_form_templates?: InputMaybe<RequestFormTemplatesArrRelInsertInput>;
  request_step_groups?: InputMaybe<RequestStepGroupsArrRelInsertInput>;
  request_step_tasks?: InputMaybe<RequestStepTasksArrRelInsertInput>;
  request_step_users?: InputMaybe<RequestStepUsersArrRelInsertInput>;
  result?: InputMaybe<RequestStepResultEnum>;
  state?: InputMaybe<RequestStepStateEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  workflow?: InputMaybe<WorkflowsObjRelInsertInput>;
  workflowId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type RequestStepsMaxFields = {
  __typename?: 'request_steps_max_fields';
  actionTakenAt: Maybe<Scalars['timestamptz']['output']>;
  canvasModelId: Maybe<Scalars['String']['output']>;
  completedAt: Maybe<Scalars['timestamptz']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  totalPausedWorkingHours: Maybe<Scalars['Int']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  workflowId: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type RequestStepsMinFields = {
  __typename?: 'request_steps_min_fields';
  actionTakenAt: Maybe<Scalars['timestamptz']['output']>;
  canvasModelId: Maybe<Scalars['String']['output']>;
  completedAt: Maybe<Scalars['timestamptz']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  totalPausedWorkingHours: Maybe<Scalars['Int']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  workflowId: Maybe<Scalars['uuid']['output']>;
};

/** input type for inserting object relation for remote table "request_steps" */
export type RequestStepsObjRelInsertInput = {
  data: RequestStepsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestStepsOnConflict>;
};

/** on_conflict condition type for table "request_steps" */
export type RequestStepsOnConflict = {
  constraint: RequestStepsConstraint;
  update_columns: Array<RequestStepsUpdateColumn>;
  where?: InputMaybe<RequestStepsBoolExp>;
};

/** select columns of table "request_steps" */
export enum RequestStepsSelectColumn {
  /** column name */
  ACTIONTAKENAT = 'actionTakenAt',
  /** column name */
  CANVASMODELID = 'canvasModelId',
  /** column name */
  CANVASMODELPARENTIDS = 'canvasModelParentIds',
  /** column name */
  COMPLETEDAT = 'completedAt',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DATA = 'data',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ID = 'id',
  /** column name */
  INPUT = 'input',
  /** column name */
  OUTPUT = 'output',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  RESULT = 'result',
  /** column name */
  STATE = 'state',
  /** column name */
  TOTALPAUSEDTIME = 'totalPausedTime',
  /** column name */
  TOTALPAUSEDWORKINGHOURS = 'totalPausedWorkingHours',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  WORKFLOWID = 'workflowId'
}

/** aggregate stddev on columns */
export type RequestStepsStddevFields = {
  __typename?: 'request_steps_stddev_fields';
  totalPausedWorkingHours: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type RequestStepsStddevPopFields = {
  __typename?: 'request_steps_stddev_pop_fields';
  totalPausedWorkingHours: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type RequestStepsStddevSampFields = {
  __typename?: 'request_steps_stddev_samp_fields';
  totalPausedWorkingHours: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type RequestStepsSumFields = {
  __typename?: 'request_steps_sum_fields';
  totalPausedWorkingHours: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "request_steps" */
export enum RequestStepsUpdateColumn {
  /** column name */
  ACTIONTAKENAT = 'actionTakenAt',
  /** column name */
  CANVASMODELID = 'canvasModelId',
  /** column name */
  CANVASMODELPARENTIDS = 'canvasModelParentIds',
  /** column name */
  COMPLETEDAT = 'completedAt',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DATA = 'data',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ID = 'id',
  /** column name */
  INPUT = 'input',
  /** column name */
  OUTPUT = 'output',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  RESULT = 'result',
  /** column name */
  STATE = 'state',
  /** column name */
  TOTALPAUSEDTIME = 'totalPausedTime',
  /** column name */
  TOTALPAUSEDWORKINGHOURS = 'totalPausedWorkingHours',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  WORKFLOWID = 'workflowId'
}

/** aggregate var_pop on columns */
export type RequestStepsVarPopFields = {
  __typename?: 'request_steps_var_pop_fields';
  totalPausedWorkingHours: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type RequestStepsVarSampFields = {
  __typename?: 'request_steps_var_samp_fields';
  totalPausedWorkingHours: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type RequestStepsVarianceFields = {
  __typename?: 'request_steps_variance_fields';
  totalPausedWorkingHours: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "request_tags" */
export type RequestTags = {
  __typename?: 'request_tags';
  id: Scalars['uuid']['output'];
  /** An object relationship */
  request: Requests;
  requestId: Scalars['uuid']['output'];
  /** An object relationship */
  tag: Tags;
  tagId: Scalars['uuid']['output'];
};

/** input type for inserting array relation for remote table "request_tags" */
export type RequestTagsArrRelInsertInput = {
  data: Array<RequestTagsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestTagsOnConflict>;
};

/** Boolean expression to filter rows from the table "request_tags". All fields are combined with a logical 'AND'. */
export type RequestTagsBoolExp = {
  _and?: InputMaybe<Array<RequestTagsBoolExp>>;
  _not?: InputMaybe<RequestTagsBoolExp>;
  _or?: InputMaybe<Array<RequestTagsBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
  request?: InputMaybe<RequestsBoolExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  tag?: InputMaybe<TagsBoolExp>;
  tagId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "request_tags" */
export enum RequestTagsConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_TAGS_PKEY = 'request_tags_pkey',
  /** unique or primary key constraint on columns "request_id", "tag_id" */
  REQUEST_TAGS_TAG_ID_REQUEST_ID_KEY = 'request_tags_tag_id_request_id_key'
}

/** input type for inserting data into table "request_tags" */
export type RequestTagsInsertInput = {
  request?: InputMaybe<RequestsObjRelInsertInput>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  tag?: InputMaybe<TagsObjRelInsertInput>;
  tagId?: InputMaybe<Scalars['uuid']['input']>;
};

/** on_conflict condition type for table "request_tags" */
export type RequestTagsOnConflict = {
  constraint: RequestTagsConstraint;
  update_columns: Array<RequestTagsUpdateColumn>;
  where?: InputMaybe<RequestTagsBoolExp>;
};

/** placeholder for update columns of table "request_tags" (current role has no relevant permissions) */
export enum RequestTagsUpdateColumn {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

export enum RequestTypeEnum {
  /** Access Request */
  ACCESS_REQUEST = 'ACCESS_REQUEST',
  /** Assessment */
  ASSESSMENT = 'ASSESSMENT',
  /** Catalogue Purchase */
  CATALOGUE_PURCHASE = 'CATALOGUE_PURCHASE',
  /** New Purchase */
  NEW_PURCHASE = 'NEW_PURCHASE',
  /** Renewal */
  RENEWAL = 'RENEWAL',
  /** Parallel sub-workflow request */
  SUB_REQUEST = 'SUB_REQUEST',
  /** Update Purchase */
  UPDATE_PURCHASE = 'UPDATE_PURCHASE'
}

/** Boolean expression to compare columns of type "request_type_enum". All fields are combined with logical 'AND'. */
export type RequestTypeEnumComparisonExp = {
  _eq?: InputMaybe<RequestTypeEnum>;
  _in?: InputMaybe<Array<RequestTypeEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<RequestTypeEnum>;
  _nin?: InputMaybe<Array<RequestTypeEnum>>;
};

/** Connects users to requests */
export type RequestUsers = {
  __typename?: 'request_users';
  id: Scalars['uuid']['output'];
  /** An object relationship */
  request: Requests;
  requestId: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** input type for inserting array relation for remote table "request_users" */
export type RequestUsersArrRelInsertInput = {
  data: Array<RequestUsersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestUsersOnConflict>;
};

/** Boolean expression to filter rows from the table "request_users". All fields are combined with a logical 'AND'. */
export type RequestUsersBoolExp = {
  _and?: InputMaybe<Array<RequestUsersBoolExp>>;
  _not?: InputMaybe<RequestUsersBoolExp>;
  _or?: InputMaybe<Array<RequestUsersBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
  request?: InputMaybe<RequestsBoolExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "request_users" */
export enum RequestUsersConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_USERS_PKEY = 'request_users_pkey',
  /** unique or primary key constraint on columns "user_id", "request_id" */
  REQUEST_USERS_USER_ID_REQUEST_ID_KEY = 'request_users_user_id_request_id_key'
}

/** input type for inserting data into table "request_users" */
export type RequestUsersInsertInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  request?: InputMaybe<RequestsObjRelInsertInput>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** on_conflict condition type for table "request_users" */
export type RequestUsersOnConflict = {
  constraint: RequestUsersConstraint;
  update_columns: Array<RequestUsersUpdateColumn>;
  where?: InputMaybe<RequestUsersBoolExp>;
};

/** update columns of table "request_users" */
export enum RequestUsersUpdateColumn {
  /** column name */
  ID = 'id',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  USERID = 'userId'
}

/** columns and relationships of "requests" */
export type Requests = {
  __typename?: 'requests';
  /** An object relationship */
  agreement: Maybe<Agreements>;
  /** agreementId */
  agreementId: Maybe<Scalars['uuid']['output']>;
  agreementTermId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  agreement_term: Maybe<AgreementTerms>;
  /** An object relationship */
  assessment: Maybe<Assessments>;
  /** An object relationship */
  budget: Maybe<Budgets>;
  budgetId: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  comments: Array<RequestComments>;
  /** An aggregate relationship */
  comments_aggregate: RequestCommentsAggregate;
  completedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  computedProperties: Maybe<RequestComputedProperties>;
  createdAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  createdRenewal: Array<Renewals>;
  /** An aggregate relationship */
  createdRenewal_aggregate: RenewalsAggregate;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  documents: Array<RequestDocuments>;
  /** An object relationship */
  engagement: Maybe<Engagements>;
  engagementId: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  followers: Array<RequestFollowers>;
  /** An aggregate relationship */
  followers_aggregate: RequestFollowersAggregate;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  leads: Array<RequestRequestLeads>;
  model: Scalars['requestModel']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  owner: Maybe<Users>;
  ownerId: Maybe<Scalars['uuid']['output']>;
  poNumber: Maybe<Scalars['String']['output']>;
  priority: RequestPriorityEnum;
  /** An object relationship */
  product: Maybe<OrganisationProductsAndServices>;
  publicId: Scalars['String']['output'];
  /** An array relationship */
  purchase_orders: Array<PurchaseOrders>;
  /** An object relationship */
  renewal: Maybe<Renewals>;
  /** An object relationship */
  requestPriority: RequestPriority;
  /** An array relationship */
  request_esign_documents: Array<RequestEsignDocuments>;
  /** An array relationship */
  request_forms: Array<RequestForms>;
  /** An array relationship */
  request_groups: Array<RequestGroups>;
  /** An array relationship */
  request_pauses: Array<RequestPauses>;
  request_product: Maybe<Scalars['uuid']['output']>;
  request_supplier: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  request_tags: Array<RequestTags>;
  /** An array relationship */
  request_users: Array<RequestUsers>;
  requestorUserId: Scalars['uuid']['output'];
  /** An array relationship */
  rfxes: Array<Rfx>;
  /** An aggregate relationship */
  rfxes_aggregate: RfxAggregate;
  /** An array relationship */
  risks: Array<Risks>;
  /** Request detail sidebar configuration */
  sidebarConfig: Maybe<Scalars['jsonb']['output']>;
  state: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  steps: Array<RequestSteps>;
  /** An aggregate relationship */
  steps_aggregate: RequestStepsAggregate;
  /** An object relationship */
  supplier: Maybe<OrganisationSuppliers>;
  tagIds: Maybe<Scalars['jsonb']['output']>;
  totalPausedTime: Scalars['interval']['output'];
  type: RequestTypeEnum;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  /** An object relationship */
  workflow: Workflows;
  workflowId: Scalars['uuid']['output'];
};

/** aggregated selection of "requests" */
export type RequestsAggregate = {
  __typename?: 'requests_aggregate';
  aggregate: Maybe<RequestsAggregateFields>;
  nodes: Array<Requests>;
};

export type RequestsAggregateBoolExp = {
  count?: InputMaybe<RequestsAggregateBoolExpCount>;
};

export type RequestsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RequestsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RequestsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "requests" */
export type RequestsAggregateFields = {
  __typename?: 'requests_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<RequestsMaxFields>;
  min: Maybe<RequestsMinFields>;
};

/** input type for inserting array relation for remote table "requests" */
export type RequestsArrRelInsertInput = {
  data: Array<RequestsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestsOnConflict>;
};

/** Boolean expression to filter rows from the table "requests". All fields are combined with a logical 'AND'. */
export type RequestsBoolExp = {
  _and?: InputMaybe<Array<RequestsBoolExp>>;
  _not?: InputMaybe<RequestsBoolExp>;
  _or?: InputMaybe<Array<RequestsBoolExp>>;
  agreement?: InputMaybe<AgreementsBoolExp>;
  agreementId?: InputMaybe<UuidComparisonExp>;
  agreementTermId?: InputMaybe<UuidComparisonExp>;
  agreement_term?: InputMaybe<AgreementTermsBoolExp>;
  assessment?: InputMaybe<AssessmentsBoolExp>;
  budget?: InputMaybe<BudgetsBoolExp>;
  budgetId?: InputMaybe<UuidComparisonExp>;
  comments?: InputMaybe<RequestCommentsBoolExp>;
  comments_aggregate?: InputMaybe<RequestCommentsAggregateBoolExp>;
  completedAt?: InputMaybe<TimestamptzComparisonExp>;
  computedProperties?: InputMaybe<RequestComputedPropertiesBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdRenewal?: InputMaybe<RenewalsBoolExp>;
  createdRenewal_aggregate?: InputMaybe<RenewalsAggregateBoolExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  documents?: InputMaybe<RequestDocumentsBoolExp>;
  engagement?: InputMaybe<EngagementsBoolExp>;
  engagementId?: InputMaybe<UuidComparisonExp>;
  followers?: InputMaybe<RequestFollowersBoolExp>;
  followers_aggregate?: InputMaybe<RequestFollowersAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  leads?: InputMaybe<RequestRequestLeadsBoolExp>;
  model?: InputMaybe<JsonbComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  owner?: InputMaybe<UsersBoolExp>;
  ownerId?: InputMaybe<UuidComparisonExp>;
  poNumber?: InputMaybe<StringComparisonExp>;
  priority?: InputMaybe<RequestPriorityEnumComparisonExp>;
  product?: InputMaybe<OrganisationProductsAndServicesBoolExp>;
  publicId?: InputMaybe<StringComparisonExp>;
  purchase_orders?: InputMaybe<PurchaseOrdersBoolExp>;
  renewal?: InputMaybe<RenewalsBoolExp>;
  requestPriority?: InputMaybe<RequestPriorityBoolExp>;
  request_esign_documents?: InputMaybe<RequestEsignDocumentsBoolExp>;
  request_forms?: InputMaybe<RequestFormsBoolExp>;
  request_groups?: InputMaybe<RequestGroupsBoolExp>;
  request_pauses?: InputMaybe<RequestPausesBoolExp>;
  request_product?: InputMaybe<UuidComparisonExp>;
  request_supplier?: InputMaybe<UuidComparisonExp>;
  request_tags?: InputMaybe<RequestTagsBoolExp>;
  request_users?: InputMaybe<RequestUsersBoolExp>;
  requestorUserId?: InputMaybe<UuidComparisonExp>;
  rfxes?: InputMaybe<RfxBoolExp>;
  rfxes_aggregate?: InputMaybe<RfxAggregateBoolExp>;
  risks?: InputMaybe<RisksBoolExp>;
  sidebarConfig?: InputMaybe<JsonbComparisonExp>;
  state?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  steps?: InputMaybe<RequestStepsBoolExp>;
  steps_aggregate?: InputMaybe<RequestStepsAggregateBoolExp>;
  supplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  tagIds?: InputMaybe<JsonbComparisonExp>;
  totalPausedTime?: InputMaybe<IntervalComparisonExp>;
  type?: InputMaybe<RequestTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  workflow?: InputMaybe<WorkflowsBoolExp>;
  workflowId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "requests" */
export enum RequestsConstraint {
  /** unique or primary key constraint on columns "id", "engagement_id" */
  REQUESTS_ENGAGEMENT_ID_ID_KEY = 'requests_engagement_id_id_key',
  /** unique or primary key constraint on columns "organisation_id", "public_id" */
  REQUESTS_ORGANISATION_ID_PUBLIC_ID_KEY = 'requests_organisation_id_public_id_key',
  /** unique or primary key constraint on columns "id" */
  REQUESTS_PKEY = 'requests_pkey'
}

/** input type for inserting data into table "requests" */
export type RequestsInsertInput = {
  agreement?: InputMaybe<AgreementsObjRelInsertInput>;
  /** agreementId */
  agreementId?: InputMaybe<Scalars['uuid']['input']>;
  agreement_term?: InputMaybe<AgreementTermsObjRelInsertInput>;
  assessment?: InputMaybe<AssessmentsObjRelInsertInput>;
  budget?: InputMaybe<BudgetsObjRelInsertInput>;
  budgetId?: InputMaybe<Scalars['uuid']['input']>;
  comments?: InputMaybe<RequestCommentsArrRelInsertInput>;
  completedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  computedProperties?: InputMaybe<RequestComputedPropertiesObjRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdRenewal?: InputMaybe<RenewalsArrRelInsertInput>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  documents?: InputMaybe<RequestDocumentsArrRelInsertInput>;
  engagement?: InputMaybe<EngagementsObjRelInsertInput>;
  engagementId?: InputMaybe<Scalars['uuid']['input']>;
  followers?: InputMaybe<RequestFollowersArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  leads?: InputMaybe<RequestRequestLeadsArrRelInsertInput>;
  model: Scalars['requestModel']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<UsersObjRelInsertInput>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<RequestPriorityEnum>;
  product?: InputMaybe<OrganisationProductsAndServicesObjRelInsertInput>;
  purchase_orders?: InputMaybe<PurchaseOrdersArrRelInsertInput>;
  renewal?: InputMaybe<RenewalsObjRelInsertInput>;
  request_esign_documents?: InputMaybe<RequestEsignDocumentsArrRelInsertInput>;
  request_forms?: InputMaybe<RequestFormsArrRelInsertInput>;
  request_groups?: InputMaybe<RequestGroupsArrRelInsertInput>;
  request_pauses?: InputMaybe<RequestPausesArrRelInsertInput>;
  request_product?: InputMaybe<Scalars['uuid']['input']>;
  request_supplier?: InputMaybe<Scalars['uuid']['input']>;
  request_tags?: InputMaybe<RequestTagsArrRelInsertInput>;
  request_users?: InputMaybe<RequestUsersArrRelInsertInput>;
  requestorUserId?: InputMaybe<Scalars['uuid']['input']>;
  rfxes?: InputMaybe<RfxArrRelInsertInput>;
  risks?: InputMaybe<RisksArrRelInsertInput>;
  /** Request detail sidebar configuration */
  sidebarConfig?: InputMaybe<Scalars['jsonb']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  steps?: InputMaybe<RequestStepsArrRelInsertInput>;
  supplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  tagIds?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<RequestTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  workflow?: InputMaybe<WorkflowsObjRelInsertInput>;
  workflowId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type RequestsMaxFields = {
  __typename?: 'requests_max_fields';
  /** agreementId */
  agreementId: Maybe<Scalars['uuid']['output']>;
  agreementTermId: Maybe<Scalars['uuid']['output']>;
  budgetId: Maybe<Scalars['uuid']['output']>;
  completedAt: Maybe<Scalars['timestamptz']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  engagementId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  ownerId: Maybe<Scalars['uuid']['output']>;
  poNumber: Maybe<Scalars['String']['output']>;
  publicId: Maybe<Scalars['String']['output']>;
  request_product: Maybe<Scalars['uuid']['output']>;
  request_supplier: Maybe<Scalars['uuid']['output']>;
  requestorUserId: Maybe<Scalars['uuid']['output']>;
  state: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  workflowId: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type RequestsMinFields = {
  __typename?: 'requests_min_fields';
  /** agreementId */
  agreementId: Maybe<Scalars['uuid']['output']>;
  agreementTermId: Maybe<Scalars['uuid']['output']>;
  budgetId: Maybe<Scalars['uuid']['output']>;
  completedAt: Maybe<Scalars['timestamptz']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  engagementId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  ownerId: Maybe<Scalars['uuid']['output']>;
  poNumber: Maybe<Scalars['String']['output']>;
  publicId: Maybe<Scalars['String']['output']>;
  request_product: Maybe<Scalars['uuid']['output']>;
  request_supplier: Maybe<Scalars['uuid']['output']>;
  requestorUserId: Maybe<Scalars['uuid']['output']>;
  state: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  workflowId: Maybe<Scalars['uuid']['output']>;
};

/** input type for inserting object relation for remote table "requests" */
export type RequestsObjRelInsertInput = {
  data: RequestsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestsOnConflict>;
};

/** on_conflict condition type for table "requests" */
export type RequestsOnConflict = {
  constraint: RequestsConstraint;
  update_columns: Array<RequestsUpdateColumn>;
  where?: InputMaybe<RequestsBoolExp>;
};

/** select columns of table "requests" */
export enum RequestsSelectColumn {
  /** column name */
  AGREEMENTID = 'agreementId',
  /** column name */
  AGREEMENTTERMID = 'agreementTermId',
  /** column name */
  BUDGETID = 'budgetId',
  /** column name */
  COMPLETEDAT = 'completedAt',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ENGAGEMENTID = 'engagementId',
  /** column name */
  ID = 'id',
  /** column name */
  MODEL = 'model',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  OWNERID = 'ownerId',
  /** column name */
  PONUMBER = 'poNumber',
  /** column name */
  PRIORITY = 'priority',
  /** column name */
  PUBLICID = 'publicId',
  /** column name */
  REQUEST_PRODUCT = 'request_product',
  /** column name */
  REQUEST_SUPPLIER = 'request_supplier',
  /** column name */
  REQUESTORUSERID = 'requestorUserId',
  /** column name */
  SIDEBARCONFIG = 'sidebarConfig',
  /** column name */
  STATE = 'state',
  /** column name */
  STATUS = 'status',
  /** column name */
  TAGIDS = 'tagIds',
  /** column name */
  TOTALPAUSEDTIME = 'totalPausedTime',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  WORKFLOWID = 'workflowId'
}

/** update columns of table "requests" */
export enum RequestsUpdateColumn {
  /** column name */
  AGREEMENTID = 'agreementId',
  /** column name */
  AGREEMENTTERMID = 'agreementTermId',
  /** column name */
  BUDGETID = 'budgetId',
  /** column name */
  COMPLETEDAT = 'completedAt',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ENGAGEMENTID = 'engagementId',
  /** column name */
  ID = 'id',
  /** column name */
  MODEL = 'model',
  /** column name */
  NAME = 'name',
  /** column name */
  OWNERID = 'ownerId',
  /** column name */
  PONUMBER = 'poNumber',
  /** column name */
  PRIORITY = 'priority',
  /** column name */
  PUBLICID = 'publicId',
  /** column name */
  REQUEST_PRODUCT = 'request_product',
  /** column name */
  REQUEST_SUPPLIER = 'request_supplier',
  /** column name */
  REQUESTORUSERID = 'requestorUserId',
  /** column name */
  SIDEBARCONFIG = 'sidebarConfig',
  /** column name */
  STATE = 'state',
  /** column name */
  TAGIDS = 'tagIds',
  /** column name */
  TOTALPAUSEDTIME = 'totalPausedTime',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  WORKFLOWID = 'workflowId'
}

/** columns and relationships of "rfx" */
export type Rfx = {
  __typename?: 'rfx';
  aiScoringEnabled: Scalars['Boolean']['output'];
  aiScoringVisible: Scalars['Boolean']['output'];
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  isReopened: Scalars['Boolean']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An array relationship */
  owners: Array<RfxOwners>;
  /** An object relationship */
  request: Requests;
  requestId: Scalars['uuid']['output'];
  requestStepId: Scalars['uuid']['output'];
  /** An object relationship */
  request_step: RequestSteps;
  /** An array relationship */
  rfx_confidentiality_agreements: Array<RfxConfidentialityAgreement>;
  /** An aggregate relationship */
  rfx_confidentiality_agreements_aggregate: RfxConfidentialityAgreementAggregate;
  /** An array relationship */
  rfx_suppliers: Array<RfxSuppliers>;
  /** An aggregate relationship */
  rfx_suppliers_aggregate: RfxSuppliersAggregate;
  status: Scalars['String']['output'];
  supplierInstructions: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "rfx" */
export type RfxAggregate = {
  __typename?: 'rfx_aggregate';
  aggregate: Maybe<RfxAggregateFields>;
  nodes: Array<Rfx>;
};

export type RfxAggregateBoolExp = {
  bool_and?: InputMaybe<RfxAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<RfxAggregateBoolExpBoolOr>;
  count?: InputMaybe<RfxAggregateBoolExpCount>;
};

export type RfxAggregateBoolExpBoolAnd = {
  arguments: RfxSelectColumnRfxAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RfxBoolExp>;
  predicate: BooleanComparisonExp;
};

export type RfxAggregateBoolExpBoolOr = {
  arguments: RfxSelectColumnRfxAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RfxBoolExp>;
  predicate: BooleanComparisonExp;
};

export type RfxAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RfxSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RfxBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "rfx" */
export type RfxAggregateFields = {
  __typename?: 'rfx_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<RfxMaxFields>;
  min: Maybe<RfxMinFields>;
};

export enum RfxAiScoringStatusEnum {
  /** AI scoring completed successfully */
  COMPLETE = 'COMPLETE',
  /** AI scoring failed with errors */
  FAILED = 'FAILED',
  /** AI scoring is currently in progress */
  IN_PROGRESS = 'IN_PROGRESS'
}

/** input type for inserting array relation for remote table "rfx" */
export type RfxArrRelInsertInput = {
  data: Array<RfxInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RfxOnConflict>;
};

/** Boolean expression to filter rows from the table "rfx". All fields are combined with a logical 'AND'. */
export type RfxBoolExp = {
  _and?: InputMaybe<Array<RfxBoolExp>>;
  _not?: InputMaybe<RfxBoolExp>;
  _or?: InputMaybe<Array<RfxBoolExp>>;
  aiScoringEnabled?: InputMaybe<BooleanComparisonExp>;
  aiScoringVisible?: InputMaybe<BooleanComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isReopened?: InputMaybe<BooleanComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  owners?: InputMaybe<RfxOwnersBoolExp>;
  request?: InputMaybe<RequestsBoolExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  requestStepId?: InputMaybe<UuidComparisonExp>;
  request_step?: InputMaybe<RequestStepsBoolExp>;
  rfx_confidentiality_agreements?: InputMaybe<RfxConfidentialityAgreementBoolExp>;
  rfx_confidentiality_agreements_aggregate?: InputMaybe<RfxConfidentialityAgreementAggregateBoolExp>;
  rfx_suppliers?: InputMaybe<RfxSuppliersBoolExp>;
  rfx_suppliers_aggregate?: InputMaybe<RfxSuppliersAggregateBoolExp>;
  status?: InputMaybe<StringComparisonExp>;
  supplierInstructions?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** Keep track of confidentiality agreement information for a given RFx */
export type RfxConfidentialityAgreement = {
  __typename?: 'rfx_confidentiality_agreement';
  confidentialityAgreement: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  rfx: Rfx;
  rfxId: Scalars['uuid']['output'];
  rfxSupplierId: Scalars['uuid']['output'];
  /** An object relationship */
  rfx_supplier: RfxSuppliers;
  signedAt: Maybe<Scalars['timestamptz']['output']>;
  signedBy: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  user: Maybe<Users>;
};

/** aggregated selection of "rfx_confidentiality_agreement" */
export type RfxConfidentialityAgreementAggregate = {
  __typename?: 'rfx_confidentiality_agreement_aggregate';
  aggregate: Maybe<RfxConfidentialityAgreementAggregateFields>;
  nodes: Array<RfxConfidentialityAgreement>;
};

export type RfxConfidentialityAgreementAggregateBoolExp = {
  count?: InputMaybe<RfxConfidentialityAgreementAggregateBoolExpCount>;
};

export type RfxConfidentialityAgreementAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RfxConfidentialityAgreementSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RfxConfidentialityAgreementBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "rfx_confidentiality_agreement" */
export type RfxConfidentialityAgreementAggregateFields = {
  __typename?: 'rfx_confidentiality_agreement_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<RfxConfidentialityAgreementMaxFields>;
  min: Maybe<RfxConfidentialityAgreementMinFields>;
};

/** input type for inserting array relation for remote table "rfx_confidentiality_agreement" */
export type RfxConfidentialityAgreementArrRelInsertInput = {
  data: Array<RfxConfidentialityAgreementInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RfxConfidentialityAgreementOnConflict>;
};

/** Boolean expression to filter rows from the table "rfx_confidentiality_agreement". All fields are combined with a logical 'AND'. */
export type RfxConfidentialityAgreementBoolExp = {
  _and?: InputMaybe<Array<RfxConfidentialityAgreementBoolExp>>;
  _not?: InputMaybe<RfxConfidentialityAgreementBoolExp>;
  _or?: InputMaybe<Array<RfxConfidentialityAgreementBoolExp>>;
  confidentialityAgreement?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  rfx?: InputMaybe<RfxBoolExp>;
  rfxId?: InputMaybe<UuidComparisonExp>;
  rfxSupplierId?: InputMaybe<UuidComparisonExp>;
  rfx_supplier?: InputMaybe<RfxSuppliersBoolExp>;
  signedAt?: InputMaybe<TimestamptzComparisonExp>;
  signedBy?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "rfx_confidentiality_agreement" */
export enum RfxConfidentialityAgreementConstraint {
  /** unique or primary key constraint on columns "id" */
  RFX_CONFIDENTIALITY_AGREEMENT_PKEY = 'rfx_confidentiality_agreement_pkey',
  /** unique or primary key constraint on columns "rfx_supplier_id", "rfx_id" */
  RFX_CONFIDENTIALITY_AGREEMENT_RFX_ID_RFX_SUPPLIER_ID_KEY = 'rfx_confidentiality_agreement_rfx_id_rfx_supplier_id_key'
}

/** input type for inserting data into table "rfx_confidentiality_agreement" */
export type RfxConfidentialityAgreementInsertInput = {
  confidentialityAgreement?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  rfx?: InputMaybe<RfxObjRelInsertInput>;
  rfxId?: InputMaybe<Scalars['uuid']['input']>;
  rfxSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  rfx_supplier?: InputMaybe<RfxSuppliersObjRelInsertInput>;
  signedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  signedBy?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
};

/** aggregate max on columns */
export type RfxConfidentialityAgreementMaxFields = {
  __typename?: 'rfx_confidentiality_agreement_max_fields';
  confidentialityAgreement: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  rfxId: Maybe<Scalars['uuid']['output']>;
  rfxSupplierId: Maybe<Scalars['uuid']['output']>;
  signedAt: Maybe<Scalars['timestamptz']['output']>;
  signedBy: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type RfxConfidentialityAgreementMinFields = {
  __typename?: 'rfx_confidentiality_agreement_min_fields';
  confidentialityAgreement: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  rfxId: Maybe<Scalars['uuid']['output']>;
  rfxSupplierId: Maybe<Scalars['uuid']['output']>;
  signedAt: Maybe<Scalars['timestamptz']['output']>;
  signedBy: Maybe<Scalars['uuid']['output']>;
};

/** on_conflict condition type for table "rfx_confidentiality_agreement" */
export type RfxConfidentialityAgreementOnConflict = {
  constraint: RfxConfidentialityAgreementConstraint;
  update_columns: Array<RfxConfidentialityAgreementUpdateColumn>;
  where?: InputMaybe<RfxConfidentialityAgreementBoolExp>;
};

/** select columns of table "rfx_confidentiality_agreement" */
export enum RfxConfidentialityAgreementSelectColumn {
  /** column name */
  CONFIDENTIALITYAGREEMENT = 'confidentialityAgreement',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  RFXID = 'rfxId',
  /** column name */
  RFXSUPPLIERID = 'rfxSupplierId',
  /** column name */
  SIGNEDAT = 'signedAt',
  /** column name */
  SIGNEDBY = 'signedBy'
}

/** update columns of table "rfx_confidentiality_agreement" */
export enum RfxConfidentialityAgreementUpdateColumn {
  /** column name */
  CONFIDENTIALITYAGREEMENT = 'confidentialityAgreement',
  /** column name */
  RFXID = 'rfxId',
  /** column name */
  RFXSUPPLIERID = 'rfxSupplierId',
  /** column name */
  SIGNEDAT = 'signedAt',
  /** column name */
  SIGNEDBY = 'signedBy',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** unique or primary key constraints on table "rfx" */
export enum RfxConstraint {
  /** unique or primary key constraint on columns "request_step_id" */
  RFX_ACTIVE_ROUND_PER_STEP = 'rfx_active_round_per_step',
  /** unique or primary key constraint on columns "id" */
  RFX_PKEY = 'rfx_pkey',
  /** unique or primary key constraint on columns "round", "request_step_id" */
  RFX_ROUND_PER_STEP = 'rfx_round_per_step'
}

/** columns and relationships of "rfx_external_users" */
export type RfxExternalUsers = {
  __typename?: 'rfx_external_users';
  createdAt: Scalars['timestamptz']['output'];
  externalContactId: Scalars['uuid']['output'];
  /** An object relationship */
  external_contact: ExternalContacts;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  rfxSupplierId: Scalars['uuid']['output'];
  /** An object relationship */
  rfx_supplier: RfxSuppliers;
};

/** aggregated selection of "rfx_external_users" */
export type RfxExternalUsersAggregate = {
  __typename?: 'rfx_external_users_aggregate';
  aggregate: Maybe<RfxExternalUsersAggregateFields>;
  nodes: Array<RfxExternalUsers>;
};

export type RfxExternalUsersAggregateBoolExp = {
  count?: InputMaybe<RfxExternalUsersAggregateBoolExpCount>;
};

export type RfxExternalUsersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RfxExternalUsersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RfxExternalUsersBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "rfx_external_users" */
export type RfxExternalUsersAggregateFields = {
  __typename?: 'rfx_external_users_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<RfxExternalUsersMaxFields>;
  min: Maybe<RfxExternalUsersMinFields>;
};

/** input type for inserting array relation for remote table "rfx_external_users" */
export type RfxExternalUsersArrRelInsertInput = {
  data: Array<RfxExternalUsersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RfxExternalUsersOnConflict>;
};

/** Boolean expression to filter rows from the table "rfx_external_users". All fields are combined with a logical 'AND'. */
export type RfxExternalUsersBoolExp = {
  _and?: InputMaybe<Array<RfxExternalUsersBoolExp>>;
  _not?: InputMaybe<RfxExternalUsersBoolExp>;
  _or?: InputMaybe<Array<RfxExternalUsersBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  externalContactId?: InputMaybe<UuidComparisonExp>;
  external_contact?: InputMaybe<ExternalContactsBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  rfxSupplierId?: InputMaybe<UuidComparisonExp>;
  rfx_supplier?: InputMaybe<RfxSuppliersBoolExp>;
};

/** unique or primary key constraints on table "rfx_external_users" */
export enum RfxExternalUsersConstraint {
  /** unique or primary key constraint on columns "organisation_id", "rfx_supplier_id", "external_contact_id" */
  RFX_EXTERNAL_USERS_ORGANISATION_ID_RFX_SUPPLIER_ID_EXTERNAL_CON = 'rfx_external_users_organisation_id_rfx_supplier_id_external_con',
  /** unique or primary key constraint on columns "id" */
  RFX_EXTERNAL_USERS_PKEY = 'rfx_external_users_pkey'
}

/** input type for inserting data into table "rfx_external_users" */
export type RfxExternalUsersInsertInput = {
  externalContactId?: InputMaybe<Scalars['uuid']['input']>;
  external_contact?: InputMaybe<ExternalContactsObjRelInsertInput>;
  rfxSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  rfx_supplier?: InputMaybe<RfxSuppliersObjRelInsertInput>;
};

/** aggregate max on columns */
export type RfxExternalUsersMaxFields = {
  __typename?: 'rfx_external_users_max_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  externalContactId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  rfxSupplierId: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type RfxExternalUsersMinFields = {
  __typename?: 'rfx_external_users_min_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  externalContactId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  rfxSupplierId: Maybe<Scalars['uuid']['output']>;
};

/** on_conflict condition type for table "rfx_external_users" */
export type RfxExternalUsersOnConflict = {
  constraint: RfxExternalUsersConstraint;
  update_columns: Array<RfxExternalUsersUpdateColumn>;
  where?: InputMaybe<RfxExternalUsersBoolExp>;
};

/** select columns of table "rfx_external_users" */
export enum RfxExternalUsersSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  EXTERNALCONTACTID = 'externalContactId',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  RFXSUPPLIERID = 'rfxSupplierId'
}

/** placeholder for update columns of table "rfx_external_users" (current role has no relevant permissions) */
export enum RfxExternalUsersUpdateColumn {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

/** input type for inserting data into table "rfx" */
export type RfxInsertInput = {
  aiScoringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  aiScoringVisible?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isReopened?: InputMaybe<Scalars['Boolean']['input']>;
  owners?: InputMaybe<RfxOwnersArrRelInsertInput>;
  request?: InputMaybe<RequestsObjRelInsertInput>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  requestStepId?: InputMaybe<Scalars['uuid']['input']>;
  request_step?: InputMaybe<RequestStepsObjRelInsertInput>;
  rfx_confidentiality_agreements?: InputMaybe<RfxConfidentialityAgreementArrRelInsertInput>;
  rfx_suppliers?: InputMaybe<RfxSuppliersArrRelInsertInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplierInstructions?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type RfxMaxFields = {
  __typename?: 'rfx_max_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  requestStepId: Maybe<Scalars['uuid']['output']>;
  status: Maybe<Scalars['String']['output']>;
  supplierInstructions: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type RfxMinFields = {
  __typename?: 'rfx_min_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  requestStepId: Maybe<Scalars['uuid']['output']>;
  status: Maybe<Scalars['String']['output']>;
  supplierInstructions: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** input type for inserting object relation for remote table "rfx" */
export type RfxObjRelInsertInput = {
  data: RfxInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RfxOnConflict>;
};

/** on_conflict condition type for table "rfx" */
export type RfxOnConflict = {
  constraint: RfxConstraint;
  update_columns: Array<RfxUpdateColumn>;
  where?: InputMaybe<RfxBoolExp>;
};

/** Keeps track of users assigned as owners for a given RFx */
export type RfxOwners = {
  __typename?: 'rfx_owners';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  rfxId: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** input type for inserting array relation for remote table "rfx_owners" */
export type RfxOwnersArrRelInsertInput = {
  data: Array<RfxOwnersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RfxOwnersOnConflict>;
};

/** Boolean expression to filter rows from the table "rfx_owners". All fields are combined with a logical 'AND'. */
export type RfxOwnersBoolExp = {
  _and?: InputMaybe<Array<RfxOwnersBoolExp>>;
  _not?: InputMaybe<RfxOwnersBoolExp>;
  _or?: InputMaybe<Array<RfxOwnersBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  rfxId?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "rfx_owners" */
export enum RfxOwnersConstraint {
  /** unique or primary key constraint on columns "id" */
  RFX_OWNERS_PKEY = 'rfx_owners_pkey',
  /** unique or primary key constraint on columns "user_id", "rfx_id" */
  RFX_OWNERS_RFX_ID_USER_ID_KEY = 'rfx_owners_rfx_id_user_id_key'
}

/** input type for inserting data into table "rfx_owners" */
export type RfxOwnersInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  rfxId?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** on_conflict condition type for table "rfx_owners" */
export type RfxOwnersOnConflict = {
  constraint: RfxOwnersConstraint;
  update_columns: Array<RfxOwnersUpdateColumn>;
  where?: InputMaybe<RfxOwnersBoolExp>;
};

/** update columns of table "rfx_owners" */
export enum RfxOwnersUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  RFXID = 'rfxId',
  /** column name */
  USERID = 'userId'
}

/** select columns of table "rfx" */
export enum RfxSelectColumn {
  /** column name */
  AISCORINGENABLED = 'aiScoringEnabled',
  /** column name */
  AISCORINGVISIBLE = 'aiScoringVisible',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ID = 'id',
  /** column name */
  ISREOPENED = 'isReopened',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  REQUESTSTEPID = 'requestStepId',
  /** column name */
  STATUS = 'status',
  /** column name */
  SUPPLIERINSTRUCTIONS = 'supplierInstructions',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** select "rfx_aggregate_bool_exp_bool_and_arguments_columns" columns of table "rfx" */
export enum RfxSelectColumnRfxAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  AISCORINGENABLED = 'aiScoringEnabled',
  /** column name */
  AISCORINGVISIBLE = 'aiScoringVisible',
  /** column name */
  ISREOPENED = 'isReopened'
}

/** select "rfx_aggregate_bool_exp_bool_or_arguments_columns" columns of table "rfx" */
export enum RfxSelectColumnRfxAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  AISCORINGENABLED = 'aiScoringEnabled',
  /** column name */
  AISCORINGVISIBLE = 'aiScoringVisible',
  /** column name */
  ISREOPENED = 'isReopened'
}

/** columns and relationships of "rfx_suppliers" */
export type RfxSuppliers = {
  __typename?: 'rfx_suppliers';
  createdAt: Scalars['timestamptz']['output'];
  firstSeenAt: Maybe<Scalars['timestamptz']['output']>;
  /** Indicates if this supplier has participated in the scoring phase of the RFx */
  hasParticipatedInScoring: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationProductId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Scalars['uuid']['output'];
  /** An object relationship */
  organisation_products_and_service: Maybe<OrganisationProductsAndServices>;
  /** An object relationship */
  organisation_supplier: OrganisationSuppliers;
  /** An object relationship */
  rfx: Rfx;
  rfxId: Scalars['uuid']['output'];
  /** An array relationship */
  rfx_external_users: Array<RfxExternalUsers>;
  /** An aggregate relationship */
  rfx_external_users_aggregate: RfxExternalUsersAggregate;
  status: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "rfx_suppliers" */
export type RfxSuppliersAggregate = {
  __typename?: 'rfx_suppliers_aggregate';
  aggregate: Maybe<RfxSuppliersAggregateFields>;
  nodes: Array<RfxSuppliers>;
};

export type RfxSuppliersAggregateBoolExp = {
  bool_and?: InputMaybe<RfxSuppliersAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<RfxSuppliersAggregateBoolExpBoolOr>;
  count?: InputMaybe<RfxSuppliersAggregateBoolExpCount>;
};

export type RfxSuppliersAggregateBoolExpBoolAnd = {
  arguments: RfxSuppliersSelectColumnRfxSuppliersAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RfxSuppliersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type RfxSuppliersAggregateBoolExpBoolOr = {
  arguments: RfxSuppliersSelectColumnRfxSuppliersAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RfxSuppliersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type RfxSuppliersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RfxSuppliersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RfxSuppliersBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "rfx_suppliers" */
export type RfxSuppliersAggregateFields = {
  __typename?: 'rfx_suppliers_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<RfxSuppliersMaxFields>;
  min: Maybe<RfxSuppliersMinFields>;
};

/** input type for inserting array relation for remote table "rfx_suppliers" */
export type RfxSuppliersArrRelInsertInput = {
  data: Array<RfxSuppliersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RfxSuppliersOnConflict>;
};

/** Boolean expression to filter rows from the table "rfx_suppliers". All fields are combined with a logical 'AND'. */
export type RfxSuppliersBoolExp = {
  _and?: InputMaybe<Array<RfxSuppliersBoolExp>>;
  _not?: InputMaybe<RfxSuppliersBoolExp>;
  _or?: InputMaybe<Array<RfxSuppliersBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  firstSeenAt?: InputMaybe<TimestamptzComparisonExp>;
  hasParticipatedInScoring?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationProductId?: InputMaybe<UuidComparisonExp>;
  organisationSupplierId?: InputMaybe<UuidComparisonExp>;
  organisation_products_and_service?: InputMaybe<OrganisationProductsAndServicesBoolExp>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  rfx?: InputMaybe<RfxBoolExp>;
  rfxId?: InputMaybe<UuidComparisonExp>;
  rfx_external_users?: InputMaybe<RfxExternalUsersBoolExp>;
  rfx_external_users_aggregate?: InputMaybe<RfxExternalUsersAggregateBoolExp>;
  status?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "rfx_suppliers" */
export enum RfxSuppliersConstraint {
  /** unique or primary key constraint on columns "rfx_id" */
  IDX_RFX_SUPPLIERS_UNIQUE_AWARDED = 'idx_rfx_suppliers_unique_awarded',
  /** unique or primary key constraint on columns "id" */
  RFX_SUPPLIERS_PKEY = 'rfx_suppliers_pkey'
}

/** input type for inserting data into table "rfx_suppliers" */
export type RfxSuppliersInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Indicates if this supplier has participated in the scoring phase of the RFx */
  hasParticipatedInScoring?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisationProductId?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  organisation_products_and_service?: InputMaybe<OrganisationProductsAndServicesObjRelInsertInput>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  rfx?: InputMaybe<RfxObjRelInsertInput>;
  rfxId?: InputMaybe<Scalars['uuid']['input']>;
  rfx_external_users?: InputMaybe<RfxExternalUsersArrRelInsertInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type RfxSuppliersMaxFields = {
  __typename?: 'rfx_suppliers_max_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  firstSeenAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationProductId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  rfxId: Maybe<Scalars['uuid']['output']>;
  status: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type RfxSuppliersMinFields = {
  __typename?: 'rfx_suppliers_min_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  firstSeenAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationProductId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  rfxId: Maybe<Scalars['uuid']['output']>;
  status: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** input type for inserting object relation for remote table "rfx_suppliers" */
export type RfxSuppliersObjRelInsertInput = {
  data: RfxSuppliersInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RfxSuppliersOnConflict>;
};

/** on_conflict condition type for table "rfx_suppliers" */
export type RfxSuppliersOnConflict = {
  constraint: RfxSuppliersConstraint;
  update_columns: Array<RfxSuppliersUpdateColumn>;
  where?: InputMaybe<RfxSuppliersBoolExp>;
};

/** select columns of table "rfx_suppliers" */
export enum RfxSuppliersSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  FIRSTSEENAT = 'firstSeenAt',
  /** column name */
  HASPARTICIPATEDINSCORING = 'hasParticipatedInScoring',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONPRODUCTID = 'organisationProductId',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  RFXID = 'rfxId',
  /** column name */
  STATUS = 'status',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** select "rfx_suppliers_aggregate_bool_exp_bool_and_arguments_columns" columns of table "rfx_suppliers" */
export enum RfxSuppliersSelectColumnRfxSuppliersAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  HASPARTICIPATEDINSCORING = 'hasParticipatedInScoring'
}

/** select "rfx_suppliers_aggregate_bool_exp_bool_or_arguments_columns" columns of table "rfx_suppliers" */
export enum RfxSuppliersSelectColumnRfxSuppliersAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  HASPARTICIPATEDINSCORING = 'hasParticipatedInScoring'
}

/** update columns of table "rfx_suppliers" */
export enum RfxSuppliersUpdateColumn {
  /** column name */
  FIRSTSEENAT = 'firstSeenAt',
  /** column name */
  HASPARTICIPATEDINSCORING = 'hasParticipatedInScoring',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONPRODUCTID = 'organisationProductId',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  RFXID = 'rfxId',
  /** column name */
  STATUS = 'status',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** update columns of table "rfx" */
export enum RfxUpdateColumn {
  /** column name */
  AISCORINGENABLED = 'aiScoringEnabled',
  /** column name */
  AISCORINGVISIBLE = 'aiScoringVisible',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ID = 'id',
  /** column name */
  ISREOPENED = 'isReopened',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  REQUESTSTEPID = 'requestStepId',
  /** column name */
  STATUS = 'status',
  /** column name */
  SUPPLIERINSTRUCTIONS = 'supplierInstructions',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** columns and relationships of "risk_attributes" */
export type RiskAttributes = {
  __typename?: 'risk_attributes';
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  type: RiskAttributesTypeEnum;
  updatedAt: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "risk_attributes". All fields are combined with a logical 'AND'. */
export type RiskAttributesBoolExp = {
  _and?: InputMaybe<Array<RiskAttributesBoolExp>>;
  _not?: InputMaybe<RiskAttributesBoolExp>;
  _or?: InputMaybe<Array<RiskAttributesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<RiskAttributesTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "risk_attributes" */
export enum RiskAttributesConstraint {
  /** unique or primary key constraint on columns "type", "organisation_id", "name" */
  RISK_ATTRIBUTES_ORGANISATION_ID_TYPE_NAME_KEY = 'risk_attributes_organisation_id_type_name_key',
  /** unique or primary key constraint on columns "id" */
  RISK_ATTRIBUTES_PKEY = 'risk_attributes_pkey'
}

/** input type for inserting data into table "risk_attributes" */
export type RiskAttributesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<RiskAttributesTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** input type for inserting object relation for remote table "risk_attributes" */
export type RiskAttributesObjRelInsertInput = {
  data: RiskAttributesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RiskAttributesOnConflict>;
};

/** on_conflict condition type for table "risk_attributes" */
export type RiskAttributesOnConflict = {
  constraint: RiskAttributesConstraint;
  update_columns: Array<RiskAttributesUpdateColumn>;
  where?: InputMaybe<RiskAttributesBoolExp>;
};

export enum RiskAttributesTypeEnum {
  /** Risk category, such as IT, financial, availability, geographic, etc */
  CATEGORY = 'CATEGORY',
  /** Risk stage like identification, mitigation, completed */
  STAGE = 'STAGE',
  /** Risk treatment type, like mitigation, acceptance, etc */
  TREATMENT = 'TREATMENT'
}

/** Boolean expression to compare columns of type "risk_attributes_type_enum". All fields are combined with logical 'AND'. */
export type RiskAttributesTypeEnumComparisonExp = {
  _eq?: InputMaybe<RiskAttributesTypeEnum>;
  _in?: InputMaybe<Array<RiskAttributesTypeEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<RiskAttributesTypeEnum>;
  _nin?: InputMaybe<Array<RiskAttributesTypeEnum>>;
};

/** update columns of table "risk_attributes" */
export enum RiskAttributesUpdateColumn {
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  NAME = 'name',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** Stores one-to-many mapping of risk to multiple categories */
export type RiskCategories = {
  __typename?: 'risk_categories';
  /** An object relationship */
  category: RiskAttributes;
  categoryId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  risk: Risks;
  riskId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** input type for inserting array relation for remote table "risk_categories" */
export type RiskCategoriesArrRelInsertInput = {
  data: Array<RiskCategoriesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RiskCategoriesOnConflict>;
};

/** Boolean expression to filter rows from the table "risk_categories". All fields are combined with a logical 'AND'. */
export type RiskCategoriesBoolExp = {
  _and?: InputMaybe<Array<RiskCategoriesBoolExp>>;
  _not?: InputMaybe<RiskCategoriesBoolExp>;
  _or?: InputMaybe<Array<RiskCategoriesBoolExp>>;
  category?: InputMaybe<RiskAttributesBoolExp>;
  categoryId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  risk?: InputMaybe<RisksBoolExp>;
  riskId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "risk_categories" */
export enum RiskCategoriesConstraint {
  /** unique or primary key constraint on columns "id" */
  RISK_CATEGORIES_PKEY = 'risk_categories_pkey',
  /** unique or primary key constraint on columns "risk_id", "category_id" */
  RISK_CATEGORIES_RISK_ID_CATEGORY_ID_KEY = 'risk_categories_risk_id_category_id_key'
}

/** input type for inserting data into table "risk_categories" */
export type RiskCategoriesInsertInput = {
  category?: InputMaybe<RiskAttributesObjRelInsertInput>;
  categoryId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  risk?: InputMaybe<RisksObjRelInsertInput>;
  riskId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** on_conflict condition type for table "risk_categories" */
export type RiskCategoriesOnConflict = {
  constraint: RiskCategoriesConstraint;
  update_columns: Array<RiskCategoriesUpdateColumn>;
  where?: InputMaybe<RiskCategoriesBoolExp>;
};

/** update columns of table "risk_categories" */
export enum RiskCategoriesUpdateColumn {
  /** column name */
  CATEGORYID = 'categoryId',
  /** column name */
  RISKID = 'riskId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** Keeps track of impact and probability levels and attributes for risks */
export type RiskLevels = {
  __typename?: 'risk_levels';
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  organisationId: Scalars['uuid']['output'];
  score: Scalars['Int']['output'];
  type: RiskLevelsTypeEnum;
  updatedAt: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "risk_levels". All fields are combined with a logical 'AND'. */
export type RiskLevelsBoolExp = {
  _and?: InputMaybe<Array<RiskLevelsBoolExp>>;
  _not?: InputMaybe<RiskLevelsBoolExp>;
  _or?: InputMaybe<Array<RiskLevelsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  score?: InputMaybe<IntComparisonExp>;
  type?: InputMaybe<RiskLevelsTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "risk_levels" */
export enum RiskLevelsConstraint {
  /** unique or primary key constraint on columns "score", "type", "organisation_id" */
  RISK_LEVELS_ORGANISATION_ID_TYPE_SCORE_KEY = 'risk_levels_organisation_id_type_score_key',
  /** unique or primary key constraint on columns "id" */
  RISK_LEVELS_PKEY = 'risk_levels_pkey'
}

/** input type for inserting data into table "risk_levels" */
export type RiskLevelsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<RiskLevelsTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** input type for inserting object relation for remote table "risk_levels" */
export type RiskLevelsObjRelInsertInput = {
  data: RiskLevelsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RiskLevelsOnConflict>;
};

/** on_conflict condition type for table "risk_levels" */
export type RiskLevelsOnConflict = {
  constraint: RiskLevelsConstraint;
  update_columns: Array<RiskLevelsUpdateColumn>;
  where?: InputMaybe<RiskLevelsBoolExp>;
};

export enum RiskLevelsTypeEnum {
  /** Inherent or residual risk impact, such as minor, major, critical */
  IMPACT = 'IMPACT',
  /** Name for a given numerical score in the risk matrix */
  MATRIX = 'MATRIX',
  /** Inherent or residual risk probability, e.g. zero, low, medium, high */
  PROBABILITY = 'PROBABILITY'
}

/** Boolean expression to compare columns of type "risk_levels_type_enum". All fields are combined with logical 'AND'. */
export type RiskLevelsTypeEnumComparisonExp = {
  _eq?: InputMaybe<RiskLevelsTypeEnum>;
  _in?: InputMaybe<Array<RiskLevelsTypeEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<RiskLevelsTypeEnum>;
  _nin?: InputMaybe<Array<RiskLevelsTypeEnum>>;
};

/** update columns of table "risk_levels" */
export enum RiskLevelsUpdateColumn {
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  NAME = 'name',
  /** column name */
  SCORE = 'score',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** Keeps track of scores for given combinations of risk impact and probability */
export type RiskMatrixCells = {
  __typename?: 'risk_matrix_cells';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  impactId: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  probabilityId: Scalars['uuid']['output'];
  score: Scalars['Int']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "risk_matrix_cells". All fields are combined with a logical 'AND'. */
export type RiskMatrixCellsBoolExp = {
  _and?: InputMaybe<Array<RiskMatrixCellsBoolExp>>;
  _not?: InputMaybe<RiskMatrixCellsBoolExp>;
  _or?: InputMaybe<Array<RiskMatrixCellsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  impactId?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  probabilityId?: InputMaybe<UuidComparisonExp>;
  score?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "risk_matrix_cells" */
export enum RiskMatrixCellsConstraint {
  /** unique or primary key constraint on columns "id" */
  RISK_MATRIX_CELLS_ID_KEY = 'risk_matrix_cells_id_key',
  /** unique or primary key constraint on columns "id" */
  RISK_MATRIX_CELLS_PKEY = 'risk_matrix_cells_pkey',
  /** unique or primary key constraint on columns "organisation_id", "probability_id", "impact_id" */
  RISK_MATRIX_CELLS_PROBABILITY_ID_IMPACT_ID_ORGANISATION_ID_KEY = 'risk_matrix_cells_probability_id_impact_id_organisation_id_key'
}

/** input type for inserting data into table "risk_matrix_cells" */
export type RiskMatrixCellsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  impactId?: InputMaybe<Scalars['uuid']['input']>;
  probabilityId?: InputMaybe<Scalars['uuid']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** input type for inserting object relation for remote table "risk_matrix_cells" */
export type RiskMatrixCellsObjRelInsertInput = {
  data: RiskMatrixCellsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RiskMatrixCellsOnConflict>;
};

/** on_conflict condition type for table "risk_matrix_cells" */
export type RiskMatrixCellsOnConflict = {
  constraint: RiskMatrixCellsConstraint;
  update_columns: Array<RiskMatrixCellsUpdateColumn>;
  where?: InputMaybe<RiskMatrixCellsBoolExp>;
};

/** update columns of table "risk_matrix_cells" */
export enum RiskMatrixCellsUpdateColumn {
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  SCORE = 'score',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** Keeps track of users assigned as risk owners for a given risk */
export type RiskOwners = {
  __typename?: 'risk_owners';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  risk: Risks;
  riskId: Scalars['uuid']['output'];
  type: RiskUsersTypeEnum;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** input type for inserting array relation for remote table "risk_owners" */
export type RiskOwnersArrRelInsertInput = {
  data: Array<RiskOwnersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RiskOwnersOnConflict>;
};

/** Boolean expression to filter rows from the table "risk_owners". All fields are combined with a logical 'AND'. */
export type RiskOwnersBoolExp = {
  _and?: InputMaybe<Array<RiskOwnersBoolExp>>;
  _not?: InputMaybe<RiskOwnersBoolExp>;
  _or?: InputMaybe<Array<RiskOwnersBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  risk?: InputMaybe<RisksBoolExp>;
  riskId?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<RiskUsersTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "risk_owners" */
export enum RiskOwnersConstraint {
  /** unique or primary key constraint on columns "id" */
  RISK_OWNERS_PKEY = 'risk_owners_pkey',
  /** unique or primary key constraint on columns "user_id", "type", "risk_id" */
  RISK_OWNERS_USER_ID_RISK_ID_TYPE_KEY = 'risk_owners_user_id_risk_id_type_key'
}

/** input type for inserting data into table "risk_owners" */
export type RiskOwnersInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  risk?: InputMaybe<RisksObjRelInsertInput>;
  riskId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<RiskUsersTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** on_conflict condition type for table "risk_owners" */
export type RiskOwnersOnConflict = {
  constraint: RiskOwnersConstraint;
  update_columns: Array<RiskOwnersUpdateColumn>;
  where?: InputMaybe<RiskOwnersBoolExp>;
};

/** update columns of table "risk_owners" */
export enum RiskOwnersUpdateColumn {
  /** column name */
  RISKID = 'riskId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId'
}

export enum RiskUsersTypeEnum {
  /** Risk owner */
  OWNER = 'OWNER',
  /** A user assigned to treat a risk */
  TREATMENT_ASSIGNEE = 'TREATMENT_ASSIGNEE'
}

/** Boolean expression to compare columns of type "risk_users_type_enum". All fields are combined with logical 'AND'. */
export type RiskUsersTypeEnumComparisonExp = {
  _eq?: InputMaybe<RiskUsersTypeEnum>;
  _in?: InputMaybe<Array<RiskUsersTypeEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<RiskUsersTypeEnum>;
  _nin?: InputMaybe<Array<RiskUsersTypeEnum>>;
};

/** Keep track of risks for TPRM feature */
export type Risks = {
  __typename?: 'risks';
  alertId: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  categories: Array<RiskCategories>;
  closedAt: Maybe<Scalars['timestamptz']['output']>;
  closedBy: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  closedByUser: Maybe<Users>;
  createdAt: Scalars['timestamptz']['output'];
  createdBy: Scalars['uuid']['output'];
  /** An object relationship */
  createdByUser: Users;
  deadline: Maybe<Scalars['timestamptz']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  deletedBy: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  deletedByUser: Maybe<Users>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  inherentRiskImpact: RiskLevels;
  inherentRiskImpactId: Scalars['uuid']['output'];
  /** An object relationship */
  inherentRiskMatrix: Maybe<RiskMatrixCells>;
  /** An object relationship */
  inherentRiskProbability: RiskLevels;
  inherentRiskProbabilityId: Scalars['uuid']['output'];
  isOpen: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  orgSupplierId: Maybe<Scalars['uuid']['output']>;
  organisationId: Scalars['uuid']['output'];
  questionName: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  request: Maybe<Requests>;
  /** An object relationship */
  requestForm: Maybe<RequestForms>;
  requestFormId: Maybe<Scalars['uuid']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  residualRiskImpact: RiskLevels;
  residualRiskImpactId: Scalars['uuid']['output'];
  /** An object relationship */
  residualRiskMatrix: Maybe<RiskMatrixCells>;
  /** An object relationship */
  residualRiskProbability: RiskLevels;
  residualRiskProbabilityId: Scalars['uuid']['output'];
  /** An array relationship */
  riskOwners: Array<RiskOwners>;
  sendReminderDaysBefore: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  stage: RiskAttributes;
  stageId: Scalars['uuid']['output'];
  /** An object relationship */
  supplier: Maybe<OrganisationSuppliers>;
  treatment: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  treatmentAssignees: Array<RiskOwners>;
  /** An object relationship */
  treatmentType: Maybe<RiskAttributes>;
  treatmentTypeId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  updatedBy: Scalars['uuid']['output'];
  /** An object relationship */
  updatedByUser: Users;
};

/** input type for inserting array relation for remote table "risks" */
export type RisksArrRelInsertInput = {
  data: Array<RisksInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RisksOnConflict>;
};

/** Boolean expression to filter rows from the table "risks". All fields are combined with a logical 'AND'. */
export type RisksBoolExp = {
  _and?: InputMaybe<Array<RisksBoolExp>>;
  _not?: InputMaybe<RisksBoolExp>;
  _or?: InputMaybe<Array<RisksBoolExp>>;
  alertId?: InputMaybe<StringComparisonExp>;
  categories?: InputMaybe<RiskCategoriesBoolExp>;
  closedAt?: InputMaybe<TimestamptzComparisonExp>;
  closedBy?: InputMaybe<UuidComparisonExp>;
  closedByUser?: InputMaybe<UsersBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdBy?: InputMaybe<UuidComparisonExp>;
  createdByUser?: InputMaybe<UsersBoolExp>;
  deadline?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedBy?: InputMaybe<UuidComparisonExp>;
  deletedByUser?: InputMaybe<UsersBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  inherentRiskImpact?: InputMaybe<RiskLevelsBoolExp>;
  inherentRiskImpactId?: InputMaybe<UuidComparisonExp>;
  inherentRiskMatrix?: InputMaybe<RiskMatrixCellsBoolExp>;
  inherentRiskProbability?: InputMaybe<RiskLevelsBoolExp>;
  inherentRiskProbabilityId?: InputMaybe<UuidComparisonExp>;
  isOpen?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  orgSupplierId?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  questionName?: InputMaybe<StringComparisonExp>;
  request?: InputMaybe<RequestsBoolExp>;
  requestForm?: InputMaybe<RequestFormsBoolExp>;
  requestFormId?: InputMaybe<UuidComparisonExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  residualRiskImpact?: InputMaybe<RiskLevelsBoolExp>;
  residualRiskImpactId?: InputMaybe<UuidComparisonExp>;
  residualRiskMatrix?: InputMaybe<RiskMatrixCellsBoolExp>;
  residualRiskProbability?: InputMaybe<RiskLevelsBoolExp>;
  residualRiskProbabilityId?: InputMaybe<UuidComparisonExp>;
  riskOwners?: InputMaybe<RiskOwnersBoolExp>;
  sendReminderDaysBefore?: InputMaybe<IntComparisonExp>;
  stage?: InputMaybe<RiskAttributesBoolExp>;
  stageId?: InputMaybe<UuidComparisonExp>;
  supplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  treatment?: InputMaybe<StringComparisonExp>;
  treatmentAssignees?: InputMaybe<RiskOwnersBoolExp>;
  treatmentType?: InputMaybe<RiskAttributesBoolExp>;
  treatmentTypeId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedBy?: InputMaybe<UuidComparisonExp>;
  updatedByUser?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "risks" */
export enum RisksConstraint {
  /** unique or primary key constraint on columns "id" */
  RISKS_PKEY = 'risks_pkey'
}

/** input type for inserting data into table "risks" */
export type RisksInsertInput = {
  alertId?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<RiskCategoriesArrRelInsertInput>;
  closedByUser?: InputMaybe<UsersObjRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  createdByUser?: InputMaybe<UsersObjRelInsertInput>;
  deadline?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedByUser?: InputMaybe<UsersObjRelInsertInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inherentRiskImpact?: InputMaybe<RiskLevelsObjRelInsertInput>;
  inherentRiskImpactId?: InputMaybe<Scalars['uuid']['input']>;
  inherentRiskMatrix?: InputMaybe<RiskMatrixCellsObjRelInsertInput>;
  inherentRiskProbability?: InputMaybe<RiskLevelsObjRelInsertInput>;
  inherentRiskProbabilityId?: InputMaybe<Scalars['uuid']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orgSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  questionName?: InputMaybe<Scalars['String']['input']>;
  request?: InputMaybe<RequestsObjRelInsertInput>;
  requestForm?: InputMaybe<RequestFormsObjRelInsertInput>;
  requestFormId?: InputMaybe<Scalars['uuid']['input']>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  residualRiskImpact?: InputMaybe<RiskLevelsObjRelInsertInput>;
  residualRiskImpactId?: InputMaybe<Scalars['uuid']['input']>;
  residualRiskMatrix?: InputMaybe<RiskMatrixCellsObjRelInsertInput>;
  residualRiskProbability?: InputMaybe<RiskLevelsObjRelInsertInput>;
  residualRiskProbabilityId?: InputMaybe<Scalars['uuid']['input']>;
  riskOwners?: InputMaybe<RiskOwnersArrRelInsertInput>;
  sendReminderDaysBefore?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<RiskAttributesObjRelInsertInput>;
  stageId?: InputMaybe<Scalars['uuid']['input']>;
  supplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  treatment?: InputMaybe<Scalars['String']['input']>;
  treatmentAssignees?: InputMaybe<RiskOwnersArrRelInsertInput>;
  treatmentType?: InputMaybe<RiskAttributesObjRelInsertInput>;
  treatmentTypeId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
  updatedByUser?: InputMaybe<UsersObjRelInsertInput>;
};

/** input type for inserting object relation for remote table "risks" */
export type RisksObjRelInsertInput = {
  data: RisksInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RisksOnConflict>;
};

/** on_conflict condition type for table "risks" */
export type RisksOnConflict = {
  constraint: RisksConstraint;
  update_columns: Array<RisksUpdateColumn>;
  where?: InputMaybe<RisksBoolExp>;
};

/** update columns of table "risks" */
export enum RisksUpdateColumn {
  /** column name */
  ALERTID = 'alertId',
  /** column name */
  CLOSEDAT = 'closedAt',
  /** column name */
  CLOSEDBY = 'closedBy',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DEADLINE = 'deadline',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DELETEDBY = 'deletedBy',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  INHERENTRISKIMPACTID = 'inherentRiskImpactId',
  /** column name */
  INHERENTRISKPROBABILITYID = 'inherentRiskProbabilityId',
  /** column name */
  ISOPEN = 'isOpen',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGSUPPLIERID = 'orgSupplierId',
  /** column name */
  QUESTIONNAME = 'questionName',
  /** column name */
  REQUESTFORMID = 'requestFormId',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  RESIDUALRISKIMPACTID = 'residualRiskImpactId',
  /** column name */
  RESIDUALRISKPROBABILITYID = 'residualRiskProbabilityId',
  /** column name */
  SENDREMINDERDAYSBEFORE = 'sendReminderDaysBefore',
  /** column name */
  STAGEID = 'stageId',
  /** column name */
  TREATMENT = 'treatment',
  /** column name */
  TREATMENTTYPEID = 'treatmentTypeId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  UPDATEDBY = 'updatedBy'
}

/** The customers legal entities */
export type Subsidiaries = {
  __typename?: 'subsidiaries';
  addresses: Maybe<Scalars['jsonb']['output']>;
  alias: Maybe<Scalars['String']['output']>;
  archivedBy: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  coreData: CoreData;
  coreDataId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  currency: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  isArchived: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  legalName: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organisationId: Scalars['uuid']['output'];
  remoteId: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  urls: Maybe<Scalars['jsonb']['output']>;
};

/** Boolean expression to filter rows from the table "subsidiaries". All fields are combined with a logical 'AND'. */
export type SubsidiariesBoolExp = {
  _and?: InputMaybe<Array<SubsidiariesBoolExp>>;
  _not?: InputMaybe<SubsidiariesBoolExp>;
  _or?: InputMaybe<Array<SubsidiariesBoolExp>>;
  addresses?: InputMaybe<JsonbComparisonExp>;
  alias?: InputMaybe<StringComparisonExp>;
  archivedBy?: InputMaybe<StringComparisonExp>;
  coreData?: InputMaybe<CoreDataBoolExp>;
  coreDataId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isArchived?: InputMaybe<BooleanComparisonExp>;
  isVisible?: InputMaybe<BooleanComparisonExp>;
  legalName?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  remoteId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  urls?: InputMaybe<JsonbComparisonExp>;
};

/** unique or primary key constraints on table "subsidiaries" */
export enum SubsidiariesConstraint {
  /** unique or primary key constraint on columns "id" */
  SUBSIDIARIES_PKEY = 'subsidiaries_pkey',
  /** unique or primary key constraint on columns "remote_id", "organisation_id" */
  SUBSIDIARIES_REMOTE_ID_ORGANISATION_ID_KEY = 'subsidiaries_remote_id_organisation_id_key'
}

/** input type for inserting data into table "subsidiaries" */
export type SubsidiariesInsertInput = {
  addresses?: InputMaybe<Scalars['jsonb']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  urls?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting object relation for remote table "subsidiaries" */
export type SubsidiariesObjRelInsertInput = {
  data: SubsidiariesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<SubsidiariesOnConflict>;
};

/** on_conflict condition type for table "subsidiaries" */
export type SubsidiariesOnConflict = {
  constraint: SubsidiariesConstraint;
  update_columns: Array<SubsidiariesUpdateColumn>;
  where?: InputMaybe<SubsidiariesBoolExp>;
};

/** update columns of table "subsidiaries" */
export enum SubsidiariesUpdateColumn {
  /** column name */
  ADDRESSES = 'addresses',
  /** column name */
  ALIAS = 'alias',
  /** column name */
  ARCHIVEDBY = 'archivedBy',
  /** column name */
  CURRENCY = 'currency',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  LEGALNAME = 'legalName',
  /** column name */
  NAME = 'name',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  URLS = 'urls'
}

/** columns and relationships of "suppliers" */
export type Suppliers = {
  __typename?: 'suppliers';
  created_at: Scalars['timestamptz']['output'];
  deleted_at: Maybe<Scalars['timestamptz']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  isReseller: Scalars['Boolean']['output'];
  logoUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** An array relationship */
  organisation_suppliers_brands: Array<OrganisationSuppliersBrands>;
  /** An array relationship */
  products_and_services: Array<ProductsAndServices>;
  ranking: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  website: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "suppliers". All fields are combined with a logical 'AND'. */
export type SuppliersBoolExp = {
  _and?: InputMaybe<Array<SuppliersBoolExp>>;
  _not?: InputMaybe<SuppliersBoolExp>;
  _or?: InputMaybe<Array<SuppliersBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isReseller?: InputMaybe<BooleanComparisonExp>;
  logoUrl?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisation_suppliers_brands?: InputMaybe<OrganisationSuppliersBrandsBoolExp>;
  products_and_services?: InputMaybe<ProductsAndServicesBoolExp>;
  ranking?: InputMaybe<IntComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  website?: InputMaybe<StringComparisonExp>;
};

export enum TableFilterReferenceEnum {
  /** AGREEMENT */
  AGREEMENT = 'AGREEMENT',
  /** ASSESSMENT */
  ASSESSMENT = 'ASSESSMENT',
  /** BUDGET */
  BUDGET = 'BUDGET',
  /** DOCUMENT */
  DOCUMENT = 'DOCUMENT',
  /** PRODUCT_BRANDS */
  PRODUCT_BRANDS = 'PRODUCT_BRANDS',
  /** REMINDER */
  REMINDER = 'REMINDER',
  /** RENEWAL */
  RENEWAL = 'RENEWAL',
  /** REQUEST */
  REQUEST = 'REQUEST',
  /** RISK */
  RISK = 'RISK',
  /** SUPPLIER */
  SUPPLIER = 'SUPPLIER',
  /** TASK */
  TASK = 'TASK',
  /** USER */
  USER = 'USER'
}

/** Boolean expression to compare columns of type "table_filter_reference_enum". All fields are combined with logical 'AND'. */
export type TableFilterReferenceEnumComparisonExp = {
  _eq?: InputMaybe<TableFilterReferenceEnum>;
  _in?: InputMaybe<Array<TableFilterReferenceEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<TableFilterReferenceEnum>;
  _nin?: InputMaybe<Array<TableFilterReferenceEnum>>;
};

/** columns and relationships of "table_filters" */
export type TableFilters = {
  __typename?: 'table_filters';
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  favourites: Array<FavouriteTableFilters>;
  filters: Scalars['filterModel']['output'];
  id: Scalars['uuid']['output'];
  isPublic: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  reference: TableFilterReferenceEnum;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "table_filters". All fields are combined with a logical 'AND'. */
export type TableFiltersBoolExp = {
  _and?: InputMaybe<Array<TableFiltersBoolExp>>;
  _not?: InputMaybe<TableFiltersBoolExp>;
  _or?: InputMaybe<Array<TableFiltersBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  favourites?: InputMaybe<FavouriteTableFiltersBoolExp>;
  filters?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isPublic?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  reference?: InputMaybe<TableFilterReferenceEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "table_filters" */
export enum TableFiltersConstraint {
  /** unique or primary key constraint on columns "id" */
  USER_CUSTOM_FILTERS_PKEY = 'user_custom_filters_pkey'
}

/** input type for inserting data into table "table_filters" */
export type TableFiltersInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  favourites?: InputMaybe<FavouriteTableFiltersArrRelInsertInput>;
  filters: Scalars['filterModel']['input'];
  id?: InputMaybe<Scalars['uuid']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<TableFilterReferenceEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** input type for inserting object relation for remote table "table_filters" */
export type TableFiltersObjRelInsertInput = {
  data: TableFiltersInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TableFiltersOnConflict>;
};

/** on_conflict condition type for table "table_filters" */
export type TableFiltersOnConflict = {
  constraint: TableFiltersConstraint;
  update_columns: Array<TableFiltersUpdateColumn>;
  where?: InputMaybe<TableFiltersBoolExp>;
};

/** update columns of table "table_filters" */
export enum TableFiltersUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  FILTERS = 'filters',
  /** column name */
  ID = 'id',
  /** column name */
  ISPUBLIC = 'isPublic',
  /** column name */
  NAME = 'name',
  /** column name */
  REFERENCE = 'reference',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId'
}

/** columns and relationships of "tags" */
export type Tags = {
  __typename?: 'tags';
  /** An array relationship */
  assessment_tags: Array<AssessmentTags>;
  createdAt: Scalars['date']['output'];
  deletedAt: Maybe<Scalars['date']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An array relationship */
  organisation_supplier_tags: Array<OrganisationSupplierTags>;
  /** An array relationship */
  renewal_tags: Array<RenewalTags>;
  /** An array relationship */
  request_tags: Array<RequestTags>;
};

/** Boolean expression to filter rows from the table "tags". All fields are combined with a logical 'AND'. */
export type TagsBoolExp = {
  _and?: InputMaybe<Array<TagsBoolExp>>;
  _not?: InputMaybe<TagsBoolExp>;
  _or?: InputMaybe<Array<TagsBoolExp>>;
  assessment_tags?: InputMaybe<AssessmentTagsBoolExp>;
  createdAt?: InputMaybe<DateComparisonExp>;
  deletedAt?: InputMaybe<DateComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisation_supplier_tags?: InputMaybe<OrganisationSupplierTagsBoolExp>;
  renewal_tags?: InputMaybe<RenewalTagsBoolExp>;
  request_tags?: InputMaybe<RequestTagsBoolExp>;
};

/** unique or primary key constraints on table "tags" */
export enum TagsConstraint {
  /** unique or primary key constraint on columns "organisation_id", "name" */
  TAGS_NAME_ORGANISATION_ID_KEY = 'tags_name_organisation_id_key',
  /** unique or primary key constraint on columns "id" */
  TAGS_PKEY = 'tags_pkey'
}

/** input type for inserting data into table "tags" */
export type TagsInsertInput = {
  assessment_tags?: InputMaybe<AssessmentTagsArrRelInsertInput>;
  createdAt?: InputMaybe<Scalars['date']['input']>;
  deletedAt?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisation_supplier_tags?: InputMaybe<OrganisationSupplierTagsArrRelInsertInput>;
  renewal_tags?: InputMaybe<RenewalTagsArrRelInsertInput>;
  request_tags?: InputMaybe<RequestTagsArrRelInsertInput>;
};

/** input type for inserting object relation for remote table "tags" */
export type TagsObjRelInsertInput = {
  data: TagsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TagsOnConflict>;
};

/** on_conflict condition type for table "tags" */
export type TagsOnConflict = {
  constraint: TagsConstraint;
  update_columns: Array<TagsUpdateColumn>;
  where?: InputMaybe<TagsBoolExp>;
};

/** update columns of table "tags" */
export enum TagsUpdateColumn {
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  NAME = 'name'
}

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type TimestamptzComparisonExp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** Stores the list of valid subsidiaries for each user, driving available options for selection on buyerLegalEntity question */
export type UserAllowedSubsidiaries = {
  __typename?: 'user_allowed_subsidiaries';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  organisationIntegration: Maybe<OrganisationIntegrations>;
  organisationIntegrationId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  subsidiary: Subsidiaries;
  subsidiaryId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** input type for inserting array relation for remote table "user_allowed_subsidiaries" */
export type UserAllowedSubsidiariesArrRelInsertInput = {
  data: Array<UserAllowedSubsidiariesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<UserAllowedSubsidiariesOnConflict>;
};

/** Boolean expression to filter rows from the table "user_allowed_subsidiaries". All fields are combined with a logical 'AND'. */
export type UserAllowedSubsidiariesBoolExp = {
  _and?: InputMaybe<Array<UserAllowedSubsidiariesBoolExp>>;
  _not?: InputMaybe<UserAllowedSubsidiariesBoolExp>;
  _or?: InputMaybe<Array<UserAllowedSubsidiariesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsBoolExp>;
  organisationIntegrationId?: InputMaybe<UuidComparisonExp>;
  subsidiary?: InputMaybe<SubsidiariesBoolExp>;
  subsidiaryId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_allowed_subsidiaries" */
export enum UserAllowedSubsidiariesConstraint {
  /** unique or primary key constraint on columns "id" */
  USER_ALLOWED_SUBSIDIARIES_PKEY = 'user_allowed_subsidiaries_pkey'
}

/** input type for inserting data into table "user_allowed_subsidiaries" */
export type UserAllowedSubsidiariesInsertInput = {
  organisationIntegration?: InputMaybe<OrganisationIntegrationsObjRelInsertInput>;
  organisationIntegrationId?: InputMaybe<Scalars['uuid']['input']>;
  subsidiary?: InputMaybe<SubsidiariesObjRelInsertInput>;
  subsidiaryId?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** on_conflict condition type for table "user_allowed_subsidiaries" */
export type UserAllowedSubsidiariesOnConflict = {
  constraint: UserAllowedSubsidiariesConstraint;
  update_columns: Array<UserAllowedSubsidiariesUpdateColumn>;
  where?: InputMaybe<UserAllowedSubsidiariesBoolExp>;
};

/** update columns of table "user_allowed_subsidiaries" */
export enum UserAllowedSubsidiariesUpdateColumn {
  /** column name */
  ORGANISATIONINTEGRATIONID = 'organisationIntegrationId',
  /** column name */
  SUBSIDIARYID = 'subsidiaryId',
  /** column name */
  USERID = 'userId'
}

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  createdAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  customFieldValues: Array<CustomFieldValues>;
  /** An aggregate relationship */
  customFieldValues_aggregate: CustomFieldValuesAggregate;
  dateFormatPreference: Maybe<Scalars['availableDateFormat']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  department: Maybe<Departments>;
  departmentId: Maybe<Scalars['uuid']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  /** An array relationship */
  group_users: Array<GroupUsers>;
  hasConfigPermissions: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  isArchived: Scalars['Boolean']['output'];
  isOutOfOffice: Scalars['Boolean']['output'];
  isViewOnly: Scalars['Boolean']['output'];
  languagePreference: Maybe<Scalars['availableLocale']['output']>;
  lastName: Scalars['String']['output'];
  lastRefreshedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  managerUser: Maybe<Users>;
  managerUserId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An array relationship */
  request_step_task_users: Array<RequestStepTaskUsers>;
  /** An array relationship */
  request_users: Array<RequestUsers>;
  /** An array relationship */
  requests: Array<Requests>;
  /** An aggregate relationship */
  requests_aggregate: RequestsAggregate;
  role: Scalars['String']['output'];
  /** A computed field, executes function "user_searchable_string" */
  searchableString: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  subsidiary: Maybe<Subsidiaries>;
  subsidiaryId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  userAllowedSubsidiaries: Array<UserAllowedSubsidiaries>;
  /** An array relationship */
  users_favourite_table_filters: Array<FavouriteTableFilters>;
};

/** aggregated selection of "users" */
export type UsersAggregate = {
  __typename?: 'users_aggregate';
  aggregate: Maybe<UsersAggregateFields>;
  nodes: Array<Users>;
};

export type UsersAggregateBoolExp = {
  bool_and?: InputMaybe<UsersAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<UsersAggregateBoolExpBoolOr>;
  count?: InputMaybe<UsersAggregateBoolExpCount>;
};

export type UsersAggregateBoolExpBoolAnd = {
  arguments: UsersSelectColumnUsersAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<UsersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type UsersAggregateBoolExpBoolOr = {
  arguments: UsersSelectColumnUsersAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<UsersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type UsersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UsersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<UsersBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "users" */
export type UsersAggregateFields = {
  __typename?: 'users_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<UsersMaxFields>;
  min: Maybe<UsersMinFields>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type UsersBoolExp = {
  _and?: InputMaybe<Array<UsersBoolExp>>;
  _not?: InputMaybe<UsersBoolExp>;
  _or?: InputMaybe<Array<UsersBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customFieldValues?: InputMaybe<CustomFieldValuesBoolExp>;
  customFieldValues_aggregate?: InputMaybe<CustomFieldValuesAggregateBoolExp>;
  dateFormatPreference?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  department?: InputMaybe<DepartmentsBoolExp>;
  departmentId?: InputMaybe<UuidComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  firstName?: InputMaybe<StringComparisonExp>;
  group_users?: InputMaybe<GroupUsersBoolExp>;
  hasConfigPermissions?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isArchived?: InputMaybe<BooleanComparisonExp>;
  isOutOfOffice?: InputMaybe<BooleanComparisonExp>;
  isViewOnly?: InputMaybe<BooleanComparisonExp>;
  languagePreference?: InputMaybe<StringComparisonExp>;
  lastName?: InputMaybe<StringComparisonExp>;
  lastRefreshedAt?: InputMaybe<TimestamptzComparisonExp>;
  managerUser?: InputMaybe<UsersBoolExp>;
  managerUserId?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  request_step_task_users?: InputMaybe<RequestStepTaskUsersBoolExp>;
  request_users?: InputMaybe<RequestUsersBoolExp>;
  requests?: InputMaybe<RequestsBoolExp>;
  requests_aggregate?: InputMaybe<RequestsAggregateBoolExp>;
  role?: InputMaybe<StringComparisonExp>;
  searchableString?: InputMaybe<StringComparisonExp>;
  subsidiary?: InputMaybe<SubsidiariesBoolExp>;
  subsidiaryId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userAllowedSubsidiaries?: InputMaybe<UserAllowedSubsidiariesBoolExp>;
  users_favourite_table_filters?: InputMaybe<FavouriteTableFiltersBoolExp>;
};

/** unique or primary key constraints on table "users" */
export enum UsersConstraint {
  /** unique or primary key constraint on columns "email", "organisation_id" */
  USERS_EMAIL_ORGANISATION_ID_KEY = 'users_email_organisation_id_key',
  /** unique or primary key constraint on columns "id" */
  USERS_PKEY = 'users_pkey'
}

/** input type for inserting data into table "users" */
export type UsersInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customFieldValues?: InputMaybe<CustomFieldValuesArrRelInsertInput>;
  dateFormatPreference?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  department?: InputMaybe<DepartmentsObjRelInsertInput>;
  departmentId?: InputMaybe<Scalars['uuid']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  group_users?: InputMaybe<GroupUsersArrRelInsertInput>;
  hasConfigPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isViewOnly?: InputMaybe<Scalars['Boolean']['input']>;
  languagePreference?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  managerUser?: InputMaybe<UsersObjRelInsertInput>;
  managerUserId?: InputMaybe<Scalars['uuid']['input']>;
  request_step_task_users?: InputMaybe<RequestStepTaskUsersArrRelInsertInput>;
  request_users?: InputMaybe<RequestUsersArrRelInsertInput>;
  requests?: InputMaybe<RequestsArrRelInsertInput>;
  role?: InputMaybe<Scalars['String']['input']>;
  subsidiary?: InputMaybe<SubsidiariesObjRelInsertInput>;
  subsidiaryId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userAllowedSubsidiaries?: InputMaybe<UserAllowedSubsidiariesArrRelInsertInput>;
  users_favourite_table_filters?: InputMaybe<FavouriteTableFiltersArrRelInsertInput>;
};

/** aggregate max on columns */
export type UsersMaxFields = {
  __typename?: 'users_max_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  dateFormatPreference: Maybe<Scalars['String']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  departmentId: Maybe<Scalars['uuid']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  languagePreference: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  lastRefreshedAt: Maybe<Scalars['timestamptz']['output']>;
  managerUserId: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  role: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "user_searchable_string" */
  searchableString: Maybe<Scalars['String']['output']>;
  subsidiaryId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type UsersMinFields = {
  __typename?: 'users_min_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  dateFormatPreference: Maybe<Scalars['String']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  departmentId: Maybe<Scalars['uuid']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  languagePreference: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  lastRefreshedAt: Maybe<Scalars['timestamptz']['output']>;
  managerUserId: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  role: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "user_searchable_string" */
  searchableString: Maybe<Scalars['String']['output']>;
  subsidiaryId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** input type for inserting object relation for remote table "users" */
export type UsersObjRelInsertInput = {
  data: UsersInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<UsersOnConflict>;
};

/** on_conflict condition type for table "users" */
export type UsersOnConflict = {
  constraint: UsersConstraint;
  update_columns: Array<UsersUpdateColumn>;
  where?: InputMaybe<UsersBoolExp>;
};

/** select columns of table "users" */
export enum UsersSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DATEFORMATPREFERENCE = 'dateFormatPreference',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DEPARTMENTID = 'departmentId',
  /** column name */
  EMAIL = 'email',
  /** column name */
  FIRSTNAME = 'firstName',
  /** column name */
  HASCONFIGPERMISSIONS = 'hasConfigPermissions',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  ISOUTOFOFFICE = 'isOutOfOffice',
  /** column name */
  ISVIEWONLY = 'isViewOnly',
  /** column name */
  LANGUAGEPREFERENCE = 'languagePreference',
  /** column name */
  LASTNAME = 'lastName',
  /** column name */
  LASTREFRESHEDAT = 'lastRefreshedAt',
  /** column name */
  MANAGERUSERID = 'managerUserId',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  ROLE = 'role',
  /** column name */
  SUBSIDIARYID = 'subsidiaryId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** select "users_aggregate_bool_exp_bool_and_arguments_columns" columns of table "users" */
export enum UsersSelectColumnUsersAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  HASCONFIGPERMISSIONS = 'hasConfigPermissions',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  ISOUTOFOFFICE = 'isOutOfOffice',
  /** column name */
  ISVIEWONLY = 'isViewOnly'
}

/** select "users_aggregate_bool_exp_bool_or_arguments_columns" columns of table "users" */
export enum UsersSelectColumnUsersAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  HASCONFIGPERMISSIONS = 'hasConfigPermissions',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  ISOUTOFOFFICE = 'isOutOfOffice',
  /** column name */
  ISVIEWONLY = 'isViewOnly'
}

/** update columns of table "users" */
export enum UsersUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DATEFORMATPREFERENCE = 'dateFormatPreference',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DEPARTMENTID = 'departmentId',
  /** column name */
  EMAIL = 'email',
  /** column name */
  FIRSTNAME = 'firstName',
  /** column name */
  HASCONFIGPERMISSIONS = 'hasConfigPermissions',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  ISOUTOFOFFICE = 'isOutOfOffice',
  /** column name */
  ISVIEWONLY = 'isViewOnly',
  /** column name */
  LANGUAGEPREFERENCE = 'languagePreference',
  /** column name */
  LASTNAME = 'lastName',
  /** column name */
  LASTREFRESHEDAT = 'lastRefreshedAt',
  /** column name */
  MANAGERUSERID = 'managerUserId',
  /** column name */
  ROLE = 'role',
  /** column name */
  SUBSIDIARYID = 'subsidiaryId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type UuidComparisonExp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** Boolean expression to compare columns of type "vector". All fields are combined with logical 'AND'. */
export type VectorComparisonExp = {
  _eq?: InputMaybe<Scalars['vector']['input']>;
  _gt?: InputMaybe<Scalars['vector']['input']>;
  _gte?: InputMaybe<Scalars['vector']['input']>;
  _in?: InputMaybe<Array<Scalars['vector']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['vector']['input']>;
  _lte?: InputMaybe<Scalars['vector']['input']>;
  _neq?: InputMaybe<Scalars['vector']['input']>;
  _nin?: InputMaybe<Array<Scalars['vector']['input']>>;
};

/** columns and relationships of "workflow_condition_groups" */
export type WorkflowConditionGroups = {
  __typename?: 'workflow_condition_groups';
  organisation_id: Scalars['uuid']['output'];
  condition: Maybe<Scalars['workflowConditionGroupsCondition']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  createdBy: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  created_by_user: Maybe<Users>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  precedence: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  updatedBy: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  updated_by_user: Maybe<Users>;
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
  /** An object relationship */
  workflow: Workflows;
  workflowId: Scalars['uuid']['output'];
};

/** input type for inserting array relation for remote table "workflow_condition_groups" */
export type WorkflowConditionGroupsArrRelInsertInput = {
  data: Array<WorkflowConditionGroupsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<WorkflowConditionGroupsOnConflict>;
};

/** Boolean expression to filter rows from the table "workflow_condition_groups". All fields are combined with a logical 'AND'. */
export type WorkflowConditionGroupsBoolExp = {
  _and?: InputMaybe<Array<WorkflowConditionGroupsBoolExp>>;
  _not?: InputMaybe<WorkflowConditionGroupsBoolExp>;
  _or?: InputMaybe<Array<WorkflowConditionGroupsBoolExp>>;
  condition?: InputMaybe<JsonbComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdBy?: InputMaybe<UuidComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  precedence?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedBy?: InputMaybe<UuidComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  workflow?: InputMaybe<WorkflowsBoolExp>;
  workflowId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "workflow_condition_groups" */
export enum WorkflowConditionGroupsConstraint {
  /** unique or primary key constraint on columns "id" */
  WORKFLOW_CONDITION_GROUPS_PKEY = 'workflow_condition_groups_pkey'
}

/** input type for inserting data into table "workflow_condition_groups" */
export type WorkflowConditionGroupsInsertInput = {
  condition?: InputMaybe<Scalars['workflowConditionGroupsCondition']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  created_by_user?: InputMaybe<UsersObjRelInsertInput>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  precedence?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
  updated_by_user?: InputMaybe<UsersObjRelInsertInput>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  workflow?: InputMaybe<WorkflowsObjRelInsertInput>;
  workflowId?: InputMaybe<Scalars['uuid']['input']>;
};

/** on_conflict condition type for table "workflow_condition_groups" */
export type WorkflowConditionGroupsOnConflict = {
  constraint: WorkflowConditionGroupsConstraint;
  update_columns: Array<WorkflowConditionGroupsUpdateColumn>;
  where?: InputMaybe<WorkflowConditionGroupsBoolExp>;
};

/** update columns of table "workflow_condition_groups" */
export enum WorkflowConditionGroupsUpdateColumn {
  /** column name */
  CONDITION = 'condition',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CREATEDBY = 'createdBy',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  PRECEDENCE = 'precedence',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  UPDATEDBY = 'updatedBy',
  /** column name */
  USERID = 'userId',
  /** column name */
  WORKFLOWID = 'workflowId'
}

/** Used to sort workflows without updating the workflow record */
export type WorkflowRanks = {
  __typename?: 'workflow_ranks';
  id: Scalars['uuid']['output'];
  organisation_id: Scalars['uuid']['output'];
  rank: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  updated_by_user: Maybe<Users>;
  /** An object relationship */
  workflow: Workflows;
  workflow_id: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "workflow_ranks". All fields are combined with a logical 'AND'. */
export type WorkflowRanksBoolExp = {
  _and?: InputMaybe<Array<WorkflowRanksBoolExp>>;
  _not?: InputMaybe<WorkflowRanksBoolExp>;
  _or?: InputMaybe<Array<WorkflowRanksBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation_id?: InputMaybe<UuidComparisonExp>;
  rank?: InputMaybe<IntComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<UuidComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workflow?: InputMaybe<WorkflowsBoolExp>;
  workflow_id?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "workflow_ranks" */
export enum WorkflowRanksConstraint {
  /** unique or primary key constraint on columns "id" */
  WORKFLOW_RANKS_PKEY = 'workflow_ranks_pkey',
  /** unique or primary key constraint on columns "workflow_id" */
  WORKFLOW_RANKS_WORKFLOW_ID_KEY = 'workflow_ranks_workflow_id_key'
}

/** input type for inserting data into table "workflow_ranks" */
export type WorkflowRanksInsertInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['uuid']['input']>;
  updated_by_user?: InputMaybe<UsersObjRelInsertInput>;
  workflow?: InputMaybe<WorkflowsObjRelInsertInput>;
  workflow_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** input type for inserting object relation for remote table "workflow_ranks" */
export type WorkflowRanksObjRelInsertInput = {
  data: WorkflowRanksInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<WorkflowRanksOnConflict>;
};

/** on_conflict condition type for table "workflow_ranks" */
export type WorkflowRanksOnConflict = {
  constraint: WorkflowRanksConstraint;
  update_columns: Array<WorkflowRanksUpdateColumn>;
  where?: InputMaybe<WorkflowRanksBoolExp>;
};

/** update columns of table "workflow_ranks" */
export enum WorkflowRanksUpdateColumn {
  /** column name */
  RANK = 'rank',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by',
  /** column name */
  WORKFLOW_ID = 'workflow_id'
}

export enum WorkflowStateEnum {
  /** DRAFT */
  DRAFT = 'DRAFT',
  /** Published */
  PUBLISHED = 'PUBLISHED',
  /** Workflow has been unpublished due to config errors */
  UNDER_MAINTENANCE = 'UNDER_MAINTENANCE'
}

/** Boolean expression to compare columns of type "workflow_state_enum". All fields are combined with logical 'AND'. */
export type WorkflowStateEnumComparisonExp = {
  _eq?: InputMaybe<WorkflowStateEnum>;
  _in?: InputMaybe<Array<WorkflowStateEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<WorkflowStateEnum>;
  _nin?: InputMaybe<Array<WorkflowStateEnum>>;
};

export enum WorkflowTypeEnum {
  /** Access Request */
  ACCESS_REQUEST = 'ACCESS_REQUEST',
  /** Assessment */
  ASSESSMENT = 'ASSESSMENT',
  /** Catalogue Purchase */
  CATALOGUE_PURCHASE = 'CATALOGUE_PURCHASE',
  /** External Workflow */
  EXTERNAL_WORKFLOW = 'EXTERNAL_WORKFLOW',
  /** New Purchase */
  NEW_PURCHASE = 'NEW_PURCHASE',
  /** Renewal */
  RENEWAL = 'RENEWAL',
  /** Update Purchase */
  UPDATE_PURCHASE = 'UPDATE_PURCHASE'
}

/** Boolean expression to compare columns of type "workflow_type_enum". All fields are combined with logical 'AND'. */
export type WorkflowTypeEnumComparisonExp = {
  _eq?: InputMaybe<WorkflowTypeEnum>;
  _in?: InputMaybe<Array<WorkflowTypeEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<WorkflowTypeEnum>;
  _nin?: InputMaybe<Array<WorkflowTypeEnum>>;
};

/** columns and relationships of "workflows" */
export type Workflows = {
  __typename?: 'workflows';
  canvasModelUpdatedAt: Scalars['timestamptz']['output'];
  createdAt: Scalars['timestamptz']['output'];
  createdBy: Maybe<Scalars['uuid']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  description: Scalars['String']['output'];
  expectedSLA: Maybe<Scalars['Int']['output']>;
  id: Scalars['uuid']['output'];
  isArchived: Scalars['Boolean']['output'];
  /** An object relationship */
  organisation: Maybe<Organisations>;
  organisationId: Scalars['uuid']['output'];
  /** Configuration for request sidebar display, copied to request upon request creation */
  requestSidebarConfig: Maybe<Scalars['jsonb']['output']>;
  /** An array relationship */
  requests: Array<Requests>;
  /** An aggregate relationship */
  requests_aggregate: RequestsAggregate;
  routingCanvasModel: Scalars['workflowCanvasModel']['output'];
  state: WorkflowStateEnum;
  title: Scalars['String']['output'];
  type: WorkflowTypeEnum;
  updatedAt: Scalars['timestamptz']['output'];
  updatedBy: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  updated_by_user: Maybe<Users>;
  url: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user: Maybe<Users>;
  viewModel: Maybe<Scalars['jsonb']['output']>;
  viewModelUpdatedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  workflow_condition_groups: Array<WorkflowConditionGroups>;
  /** An object relationship */
  workflow_rank: Maybe<WorkflowRanks>;
};

/** Boolean expression to filter rows from the table "workflows". All fields are combined with a logical 'AND'. */
export type WorkflowsBoolExp = {
  _and?: InputMaybe<Array<WorkflowsBoolExp>>;
  _not?: InputMaybe<WorkflowsBoolExp>;
  _or?: InputMaybe<Array<WorkflowsBoolExp>>;
  canvasModelUpdatedAt?: InputMaybe<TimestamptzComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdBy?: InputMaybe<UuidComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  expectedSLA?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isArchived?: InputMaybe<BooleanComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  requestSidebarConfig?: InputMaybe<JsonbComparisonExp>;
  requests?: InputMaybe<RequestsBoolExp>;
  requests_aggregate?: InputMaybe<RequestsAggregateBoolExp>;
  routingCanvasModel?: InputMaybe<JsonbComparisonExp>;
  state?: InputMaybe<WorkflowStateEnumComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<WorkflowTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedBy?: InputMaybe<UuidComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  url?: InputMaybe<StringComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  viewModel?: InputMaybe<JsonbComparisonExp>;
  viewModelUpdatedAt?: InputMaybe<TimestamptzComparisonExp>;
  workflow_condition_groups?: InputMaybe<WorkflowConditionGroupsBoolExp>;
  workflow_rank?: InputMaybe<WorkflowRanksBoolExp>;
};

/** unique or primary key constraints on table "workflows" */
export enum WorkflowsConstraint {
  /** unique or primary key constraint on columns "id" */
  WORKFLOWS_PKEY = 'workflows_pkey'
}

/** input type for inserting data into table "workflows" */
export type WorkflowsInsertInput = {
  canvasModelUpdatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expectedSLA?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Configuration for request sidebar display, copied to request upon request creation */
  requestSidebarConfig?: InputMaybe<Scalars['jsonb']['input']>;
  requests?: InputMaybe<RequestsArrRelInsertInput>;
  routingCanvasModel?: InputMaybe<Scalars['jsonb']['input']>;
  state?: InputMaybe<WorkflowStateEnum>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<WorkflowTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
  updated_by_user?: InputMaybe<UsersObjRelInsertInput>;
  url?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  viewModel?: InputMaybe<Scalars['jsonb']['input']>;
  viewModelUpdatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  workflow_condition_groups?: InputMaybe<WorkflowConditionGroupsArrRelInsertInput>;
  workflow_rank?: InputMaybe<WorkflowRanksObjRelInsertInput>;
};

/** input type for inserting object relation for remote table "workflows" */
export type WorkflowsObjRelInsertInput = {
  data: WorkflowsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<WorkflowsOnConflict>;
};

/** on_conflict condition type for table "workflows" */
export type WorkflowsOnConflict = {
  constraint: WorkflowsConstraint;
  update_columns: Array<WorkflowsUpdateColumn>;
  where?: InputMaybe<WorkflowsBoolExp>;
};

/** update columns of table "workflows" */
export enum WorkflowsUpdateColumn {
  /** column name */
  CANVASMODELUPDATEDAT = 'canvasModelUpdatedAt',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CREATEDBY = 'createdBy',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  EXPECTEDSLA = 'expectedSLA',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  REQUESTSIDEBARCONFIG = 'requestSidebarConfig',
  /** column name */
  ROUTINGCANVASMODEL = 'routingCanvasModel',
  /** column name */
  STATE = 'state',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  UPDATEDBY = 'updatedBy',
  /** column name */
  URL = 'url',
  /** column name */
  VIEWMODEL = 'viewModel',
  /** column name */
  VIEWMODELUPDATEDAT = 'viewModelUpdatedAt'
}

export type PurchaseOrderFragmentFragment = { __typename?: 'purchase_orders', id: string, requestId: string, organisationId: string, remoteNumber: string | null, remoteId: string | null, remoteLink: string | null, remoteStatus: string | null, remoteTotalValue: number | null, remoteInvoicedValue: number, remotePaidValue: number, currencyId: string | null, status: string };

export type BankAccountFragment = { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null, address: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> };

export type ListOrganisationIntegrationsQuery = { __typename?: 'query_root', organisation_integrations: Array<{ __typename?: 'organisation_integrations', id: string, integration: OverrideTypes["GlobalIntegration"], name: string | null, updatedAt: string, referenceId: string | null, defaultSupplierState: OrganisationSupplierStateEnum | null }> };

export type GetFormTemplateConfigsByIdsQuery = { __typename?: 'query_root', form_templates: Array<{ __typename?: 'form_templates', id: string, config: OverrideTypes["FormConfig"], title: string, type: FormTypeEnum }> };

export type GetFormTemplatesByIdsQuery = { __typename?: 'query_root', form_templates: Array<{ __typename?: 'form_templates', config: OverrideTypes["FormConfig"], description: string, id: string, internalId: string | null, state: FormTemplateStateEnum, title: string, integration: OverrideTypes["Integration"] | null, externalTitle: string | null, type: FormTypeEnum, updatedAt: string, updated_by_user: { __typename?: 'users', id: string, firstName: string, lastName: string } | null }> };

export type CoreDataDependenciesFragment = { __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null };

export type CoreDataFragment = { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null };

export type SupplierProfileFragment = { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } };

export type GetCustomCoreDataQuery = { __typename?: 'query_root', custom_core_data: Array<{ __typename?: 'custom_core_data', id: string, name: string, organisationId: string, pathLevels: Array<string> | null, archivedAt: string | null, organisationIntegration: { __typename?: 'organisation_integrations', id: string, integration: OverrideTypes["GlobalIntegration"] } | null, options: Array<{ __typename?: 'custom_core_data_options', id: string, value: string, isArchived: boolean, archivedBy: string | null, customCoreDataId: string, parentId: string | null, isTerminal: boolean, remoteId: string | null, coreDataId: string }>, numOptions: { __typename?: 'custom_core_data_options_aggregate', aggregate: { __typename?: 'custom_core_data_options_aggregate_fields', count: number } | null } }> };

export type GetOrganisationSupplierProfileBySupplierAndSubsidiaryQuery = { __typename?: 'query_root', organisation_supplier_profiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string }> };

export type AddressFragment = { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string };

export type OrganisationFxRateFragment = { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string };

export type DepartmentFragment = { __typename?: 'departments', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string, organisationId: string, remoteId: string | null, updatedAt: string, coreDataId: string };

export type LineItemTypeFragment = { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string };

export type PaymentMethodFragment = { __typename?: 'payment_methods', id: string, name: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string };

export type PaymentTermFragment = { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string };

export type GetSubsidiariesWithDependenciesQuery = { __typename?: 'query_root', subsidiaries: Array<{ __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string, coreData: { __typename?: 'core_data', id: string, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }> } }> };

export type SubsidiaryFragment = { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string };

export type GetCoreDataDependenciesFromCoreDataQuery = { __typename?: 'query_root', core_data: Array<{ __typename?: 'core_data', id: string, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }> }> };

export type GetOrgSupplierQuery = { __typename?: 'query_root', supplier: { __typename?: 'organisation_suppliers', id: string, remoteId: string | null, externalLink: string | null, remoteLink: string | null, organisationIntegrationId: string | null, name: string, legalName: string | null, website: string | null, isPerson: boolean | null, address: OverrideTypes["Address"] | null, description: string | null, state: OrganisationSupplierStateEnum, archivedBy: string | null, paymentMethodId: string | null, paymentTermsId: string | null, taxNumber: string | null, deletedAt: string | null, external_contacts: Array<{ __typename?: 'external_contacts', id: string, email: string, firstName: string | null, lastName: string | null, phoneNumber: string | null, title: string | null, isPrimary: boolean, createdAt: string, deletedAt: string | null }>, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, state: OrganisationSupplierStateEnum, archivedBy: string | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string }, entityBankDetails: Array<{ __typename?: 'entity_bank_details', isPrimary: boolean | null, bankDetails: { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null, address: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> } }> }>, entityBankDetails: Array<{ __typename?: 'entity_bank_details', isPrimary: boolean | null, bankDetails: { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null, address: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> } }> } | null };

export type OrgSupplierFragmentForDiffingFragment = { __typename?: 'organisation_suppliers', id: string, remoteId: string | null, externalLink: string | null, remoteLink: string | null, organisationIntegrationId: string | null, name: string, legalName: string | null, website: string | null, isPerson: boolean | null, address: OverrideTypes["Address"] | null, description: string | null, state: OrganisationSupplierStateEnum, archivedBy: string | null, paymentMethodId: string | null, paymentTermsId: string | null, taxNumber: string | null, deletedAt: string | null, external_contacts: Array<{ __typename?: 'external_contacts', id: string, email: string, firstName: string | null, lastName: string | null, phoneNumber: string | null, title: string | null, isPrimary: boolean, createdAt: string, deletedAt: string | null }>, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, state: OrganisationSupplierStateEnum, archivedBy: string | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string }, entityBankDetails: Array<{ __typename?: 'entity_bank_details', isPrimary: boolean | null, bankDetails: { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null, address: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> } }> }>, entityBankDetails: Array<{ __typename?: 'entity_bank_details', isPrimary: boolean | null, bankDetails: { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null, address: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> } }> };

export type GetLatestRequestFormSubmissionsQuery = { __typename?: 'query_root', forms: Array<{ __typename?: 'request_forms', id: string, type: FormTypeEnum, latestSubmissionArray: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null, submittedOn: string, request_step_task: { __typename?: 'request_step_tasks', organisationSupplierId: string | null } | null }> }>, request: { __typename?: 'requests', id: string, supplier: { __typename?: 'organisation_suppliers', id: string } | null, renewal: { __typename?: 'renewals', id: string, costCurrency: OverrideTypes["CurrencyCode"], costValue: number, renewalDate: string, cancellationNoticeDayCount: number | null, note: string | null, department: { __typename?: 'departments', id: string, name: string } | null, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, remoteLink: string | null, organisationIntegration: { __typename?: 'organisation_integrations', id: string, integration: OverrideTypes["GlobalIntegration"] } | null }, product: { __typename?: 'organisation_products_and_services', id: string, name: string, logoUrl: string | null, description: string | null, displayName: string, updatedAt: string | null, website: string | null, organisation_supplier: { __typename?: 'organisation_suppliers', id: string, name: string, logoUrl: string | null, website: string | null, isReseller: boolean } } | null } | null, assessment: { __typename?: 'assessments', id: string, businessOwnerUser: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } } | null } | null };

export type CoreDataDependenciesMetadataFragment = { __typename?: 'core_data', dependenciesPreview: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }>, numDependencies: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null } };

export type CustomCoreDataOptionFragment = { __typename?: 'custom_core_data_options', id: string, value: string, isArchived: boolean, archivedBy: string | null, customCoreDataId: string, parentId: string | null, isTerminal: boolean, remoteId: string | null, coreDataId: string };

export type CustomFieldFragment = { __typename?: 'custom_fields', id: string, title: string, type: OverrideTypes["CustomFieldsType"], externalSource: OverrideTypes["CustomFieldCoreDataSourceType"] | null, customCoreDataId: string | null, isRequired: boolean, updatedAt: string, entityType: OverrideTypes["CustomFieldsEntityType"], dependsOnCustomFieldId: string | null, organisationIntegrationId: string | null, allowUserToAddCustomOptions: boolean | null, remoteId: string | null, choices: Array<{ __typename?: 'custom_field_choices', id: string, label: string, precedence: number }>, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null };

export type InsertCustomFieldCoreDataMutation = { __typename?: 'mutation_root', insert_custom_field_core_data_one: { __typename?: 'custom_field_core_data', id: string } | null };

export type InsertCustomFieldValuesMutation = { __typename?: 'mutation_root', customFieldValues: { __typename?: 'custom_field_values_mutation_response', returning: Array<{ __typename?: 'custom_field_values', id: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, entityId: string, customFieldId: string }> } | null };

export type GetAllOrganisationCoreDataDependenciesQuery = { __typename?: 'query_root', organisationCoreDataDependencies: Array<{ __typename?: 'organisation_core_data_dependencies', id: string, coreDataType: OverrideTypes["KebabCoreDataType"], dependencyCoreDataType: OverrideTypes["KebabDependencyType"], customCoreData: { __typename?: 'custom_core_data', id: string, name: string } | null, dependencyCustomCoreData: { __typename?: 'custom_core_data', id: string, name: string } | null }> };

export type GetOrganisationSettingsByNameQuery = { __typename?: 'query_root', organisation_settings: Array<{ __typename?: 'organisation_settings', name: string, value: any }> };

export type StorePurchaseOrderLineItemFragment = { __typename?: 'purchase_order_line_items', lineNumber: number, quantity: number | null, unitPrice: number | null, amount: number | null, remoteId: string | null, remoteStatus: string | null, lineItemCurrency: { __typename?: 'organisation_fx_rates', id: string, remoteId: string | null, code: OverrideTypes["CurrencyCode"], name: string | null } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> };

export type GetOrgDepartmentsQuery = { __typename?: 'query_root', departments: Array<{ __typename?: 'departments', id: string, name: string }> };

export type GetRequestStepsQuery = { __typename?: 'query_root', request_steps: Array<{ __typename?: 'request_steps', input: any, output: any | null, data: any | null }> };

export type GetFormTemplateIdQuery = { __typename?: 'query_root', request_forms_by_pk: { __typename?: 'request_forms', id: string, type: FormTypeEnum, config: OverrideTypes["FormConfig"], request_step_tasks: Array<{ __typename?: 'request_step_tasks', request_step: { __typename?: 'request_steps', input: any } }>, request: { __typename?: 'requests', id: string, tagIds: any | null, name: string, model: OverrideTypes["RequestModel"], renewal: { __typename?: 'renewals', id: string, sourceAgreementTerm: { __typename?: 'agreement_terms', id: string, agreementId: string } | null } | null, agreement_term: { __typename?: 'agreement_terms', agreementId: string } | null, budget: { __typename?: 'budgets', id: string, name: string } | null, computedProperties: { __typename?: 'request_computed_properties', pricingObject: any | null } | null, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, website: string | null, address: OverrideTypes["Address"] | null, taxNumber: string | null, state: OrganisationSupplierStateEnum, external_contacts: Array<{ __typename?: 'external_contacts', id: string, firstName: string | null, lastName: string | null, email: string, phoneNumber: string | null, title: string | null, isPrimary: boolean }>, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerms: { __typename?: 'payment_terms', id: string, name: string } | null, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string }, entityBankDetails: Array<{ __typename?: 'entity_bank_details', isPrimary: boolean | null, bankDetails: { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null, address: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> } }> }>, entityBankDetails: Array<{ __typename?: 'entity_bank_details', isPrimary: boolean | null, bankDetails: { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null, address: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> } }> } | null, product: { __typename?: 'organisation_products_and_services', id: string, name: string, state: OrganisationProductsAndServicesStateEnum } | null, request_tags: Array<{ __typename?: 'request_tags', id: string, tag: { __typename?: 'tags', id: string, name: string } }>, workflow: { __typename?: 'workflows', id: string, title: string, type: WorkflowTypeEnum, workflow_condition_groups: Array<{ __typename?: 'workflow_condition_groups', id: string, name: string, condition: OverrideTypes["WorkflowConditionGroupCondition"] | null, createdAt: string, updatedAt: string, precedence: number | null }> } }, form_template: { __typename?: 'form_templates', id: string } | null } | null };

export type ListOrgProductsAndServicesMinimalQuery = { __typename?: 'query_root', products: Array<{ __typename?: 'organisation_products_and_services', id: string, name: string, organisationSupplierId: string }> };

export type ListDepartmentsMinimalQuery = { __typename?: 'query_root', departments: Array<{ __typename?: 'departments', id: string, name: string }> };

export type GetPaymentMethodsMinimalQuery = { __typename?: 'query_root', paymentMethods: Array<{ __typename?: 'payment_methods', id: string, name: string }> };

export type ListSubsidiariesMinimalQuery = { __typename?: 'query_root', subsidiaries: Array<{ __typename?: 'subsidiaries', id: string, name: string }> };

export type CustomFieldSchemaForRepositoryFragment = { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], externalSource: OverrideTypes["CustomFieldCoreDataSourceType"] | null, customCoreDataId: string | null, remoteId: string | null, key: string, title: string, choices: Array<{ __typename?: 'custom_field_choices', id: string, label: string, precedence: number }> };

export type OrgSupplierForRepositoryFragment = { __typename?: 'organisation_suppliers', id: string, deleted_at: string | null, name: string, legalName: string | null, state: OrganisationSupplierStateEnum, website: string | null, description: string | null, isReseller: boolean, isPerson: boolean | null, isPreferred: boolean, taxNumber: string | null, createdAt: string, updated_at: string, remoteId: string | null, remoteLink: string | null, publicId: number, address: OverrideTypes["Address"] | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, remoteId: string | null } | null, paymentTerms: { __typename?: 'payment_terms', id: string, name: string, remoteId: string | null } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }>, organisationIntegration: { __typename?: 'organisation_integrations', name: string | null, id: string, integration: OverrideTypes["GlobalIntegration"] } | null, organisation_supplier_tags: Array<{ __typename?: 'organisation_supplier_tags', tag: { __typename?: 'tags', id: string, name: string } }> };

export type GetOrgFxRatesQuery = { __typename?: 'query_root', organisation_fx_rates: Array<{ __typename?: 'organisation_fx_rates', id: string, code: OverrideTypes["CurrencyCode"], fxRate: number }> };

export type GetGroupsQuery = { __typename?: 'query_root', groups: Array<{ __typename?: 'groups', id: string, name: string, rawAttributes: any | null, organisationId: string, isArchived: boolean, group_users: Array<{ __typename?: 'group_users', user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } }> }> };

export type GetUsersQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, hasConfigPermissions: boolean, isViewOnly: boolean, deletedAt: string | null, isArchived: boolean, languagePreference: OverrideTypes["AvailableLocale"] | null, isOutOfOffice: boolean }> };